import { defineComponent as he, resolveComponent as q, openBlock as pe, createElementBlock as Tt, Fragment as si, renderSlot as ri, createVNode as ee, withCtx as Y, normalizeClass as Ze, createBlock as Ae, createSlots as $n, createElementVNode as Mt, createCommentVNode as _i, createTextVNode as r0, toDisplayString as Ss, markRaw as Ge, resolveDynamicComponent as zo, renderList as ar, withModifiers as mc, unref as Es, isRef as Ps, ref as J, watch as it, customRef as qp, getCurrentScope as o0, onScopeDispose as s0, toRefs as Bc, getCurrentInstance as Yp, onMounted as a0, nextTick as ks, computed as ht, shallowRef as zl, readonly as l0, reactive as Ue, watchEffect as Kp, h as sn, toRef as u0, normalizeStyle as _c, inject as c0, createApp as h0, Transition as f0, withDirectives as d0, vShow as p0 } from "vue";
import { DefaultOptions as io, GoogleMutantOptions as m0, MarkerOptions as _0, DrawOptions as Qu, ShapeOptions as g0 } from "./map-options.js";
const v0 = he({
  emits: ["opened", "closed", "open", "close"],
  props: {
    width: {
      type: String
    }
  },
  data() {
    return {
      dialog: !1,
      dialogOpen: !1,
      dialogOpened: !1
    };
  },
  methods: {
    open() {
      this.dialog = !0;
    },
    close() {
      this.dialog = !1;
    },
    onOpen() {
      this.dialogOpen = !0, this.$emit("open");
    },
    onClose() {
      this.$emit("close"), this.dialogOpen = !1;
    },
    onOpened() {
      this.dialogOpened = !0, this.$emit("opened");
    },
    onClosed() {
      this.$emit("closed"), this.dialogOpened = !1;
    }
  }
}), y0 = {}, Re = (t, i) => {
  const r = t.__vccOpts || t;
  for (const [h, a] of i)
    r[h] = a;
  return r;
};
function L0(t, i, r, h, a, l) {
  const f = q("el-dialog");
  return pe(), Tt(si, null, [
    ri(t.$slots, "activator", { open: t.open }),
    ee(f, {
      modelValue: t.dialog,
      "onUpdate:modelValue": i[0] || (i[0] = (m) => t.dialog = m),
      width: t.width,
      "append-to-body": "",
      "align-center": "",
      onOpen: t.onOpen,
      onClose: t.onClose,
      onOpened: t.onOpened,
      onClosed: t.onClosed
    }, {
      header: Y(() => [
        ri(t.$slots, "header")
      ]),
      default: Y(() => [
        ri(t.$slots, "default", {
          dialogOpened: t.dialogOpened,
          dialogOpen: t.dialogOpen
        })
      ]),
      footer: Y(() => [
        ri(t.$slots, "footer", { close: t.close })
      ]),
      _: 3
    }, 8, ["modelValue", "width", "onOpen", "onClose", "onOpened", "onClosed"])
  ], 64);
}
const w0 = {
  $style: y0
}, Uc = /* @__PURE__ */ Re(v0, [["render", L0], ["__cssModules", w0]]);
var ws = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function b0(t) {
  if (t.__esModule)
    return t;
  var i = t.default;
  if (typeof i == "function") {
    var r = function h() {
      if (this instanceof h) {
        var a = [null];
        a.push.apply(a, arguments);
        var l = Function.bind.apply(i, a);
        return new l();
      }
      return i.apply(this, arguments);
    };
    r.prototype = i.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(h) {
    var a = Object.getOwnPropertyDescriptor(t, h);
    Object.defineProperty(r, h, a.get ? a : {
      enumerable: !0,
      get: function() {
        return t[h];
      }
    });
  }), r;
}
var dt = {}, S0 = {
  get exports() {
    return dt;
  },
  set exports(t) {
    dt = t;
  }
};
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
(function(t, i) {
  (function() {
    var r, h = "4.17.21", a = 200, l = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", f = "Expected a function", m = "Invalid `variable` option passed into `_.template`", y = "__lodash_hash_undefined__", v = 500, C = "__lodash_placeholder__", M = 1, N = 2, I = 4, D = 1, B = 2, X = 1, le = 2, Q = 4, re = 8, ve = 16, Le = 32, Ce = 64, se = 128, Me = 256, rt = 512, Et = 30, Pt = "...", xt = 800, _n = 16, Dt = 1, gn = 2, It = 3, Kt = 1 / 0, we = 9007199254740991, gi = 17976931348623157e292, _e = 0 / 0, Be = 4294967295, Nt = Be - 1, Ht = Be >>> 1, wt = [
      ["ary", se],
      ["bind", X],
      ["bindKey", le],
      ["curry", re],
      ["curryRight", ve],
      ["flip", rt],
      ["partial", Le],
      ["partialRight", Ce],
      ["rearg", Me]
    ], $e = "[object Arguments]", ot = "[object Array]", Tn = "[object AsyncFunction]", en = "[object Boolean]", ft = "[object Date]", Mi = "[object DOMException]", Jt = "[object Error]", pt = "[object Function]", jt = "[object GeneratorFunction]", Ke = "[object Map]", bt = "[object Number]", Rt = "[object Null]", $t = "[object Object]", Xt = "[object Promise]", Ui = "[object Proxy]", Un = "[object RegExp]", kt = "[object Set]", ai = "[object String]", Oi = "[object Symbol]", Fn = "[object Undefined]", xi = "[object WeakMap]", Hn = "[object WeakSet]", Di = "[object ArrayBuffer]", tn = "[object DataView]", nn = "[object Float32Array]", vn = "[object Float64Array]", hr = "[object Int8Array]", rn = "[object Int16Array]", yn = "[object Int32Array]", un = "[object Uint8Array]", vi = "[object Uint8ClampedArray]", fr = "[object Uint16Array]", li = "[object Uint32Array]", Rs = /\b__p \+= '';/g, $s = /\b(__p \+=) '' \+/g, dr = /(__e\(.*?\)|\b__t\)) \+\n'';/g, yi = /&(?:amp|lt|gt|quot|#39);/g, ki = /[&<>"']/g, Uo = RegExp(yi.source), Fo = RegExp(ki.source), Bt = /<%-([\s\S]+?)%>/g, Ho = /<%([\s\S]+?)%>/g, so = /<%=([\s\S]+?)%>/g, zs = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Ir = /^\w*$/, Nr = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ao = /[\\^$.*+?()[\]{}|]/g, Bs = RegExp(ao.source), lo = /^\s+/, cn = /\s/, be = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, uo = /\{\n\/\* \[wrapped with (.+)\] \*/, Zo = /,? & /, co = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, pr = /[()=,{}\[\]\/\s]/, Rr = /\\(\\)?/g, Vo = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Li = /\w*$/, Wo = /^[-+]0x[0-9a-f]+$/i, jo = /^0b[01]+$/i, Go = /^\[object .+?Constructor\]$/, Us = /^0o[0-7]+$/i, Fi = /^(?:0|[1-9]\d*)$/, We = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, ce = /($^)/, $r = /['\n\r\u2028\u2029\\]/g, mr = "\\ud800-\\udfff", zr = "\\u0300-\\u036f", ho = "\\ufe20-\\ufe2f", qo = "\\u20d0-\\u20ff", Yo = zr + ho + qo, Hi = "\\u2700-\\u27bf", Zn = "a-z\\xdf-\\xf6\\xf8-\\xff", Ko = "\\xac\\xb1\\xd7\\xf7", fo = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Zi = "\\u2000-\\u206f", Qe = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", yt = "A-Z\\xc0-\\xd6\\xd8-\\xde", Vi = "\\ufe0e\\ufe0f", Vn = Ko + fo + Zi + Qe, ui = "['’]", Ut = "[" + mr + "]", ze = "[" + Vn + "]", St = "[" + Yo + "]", d = "\\d+", w = "[" + Hi + "]", _ = "[" + Zn + "]", S = "[^" + mr + Vn + d + Hi + Zn + yt + "]", E = "\\ud83c[\\udffb-\\udfff]", k = "(?:" + St + "|" + E + ")", A = "[^" + mr + "]", R = "(?:\\ud83c[\\udde6-\\uddff]){2}", F = "[\\ud800-\\udbff][\\udc00-\\udfff]", G = "[" + yt + "]", ue = "\\u200d", fe = "(?:" + _ + "|" + S + ")", ke = "(?:" + G + "|" + S + ")", Ie = "(?:" + ui + "(?:d|ll|m|re|s|t|ve))?", de = "(?:" + ui + "(?:D|LL|M|RE|S|T|VE))?", tt = k + "?", mt = "[" + Vi + "]?", Ln = "(?:" + ue + "(?:" + [A, R, F].join("|") + ")" + mt + tt + ")*", Zt = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Wi = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Jo = mt + tt + Ln, Te = "(?:" + [w, R, F].join("|") + ")" + Jo, Gt = "(?:" + [A + St + "?", St, R, F, Ut].join("|") + ")", _t = RegExp(ui, "g"), Br = RegExp(St, "g"), ji = RegExp(E + "(?=" + E + ")|" + Gt + Jo, "g"), po = RegExp([
      G + "?" + _ + "+" + Ie + "(?=" + [ze, G, "$"].join("|") + ")",
      ke + "+" + de + "(?=" + [ze, G + fe, "$"].join("|") + ")",
      G + "?" + fe + "+" + Ie,
      G + "+" + de,
      Wi,
      Zt,
      d,
      Te
    ].join("|"), "g"), Fs = RegExp("[" + ue + mr + Yo + Vi + "]"), _r = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Hs = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], mo = -1, Fe = {};
    Fe[nn] = Fe[vn] = Fe[hr] = Fe[rn] = Fe[yn] = Fe[un] = Fe[vi] = Fe[fr] = Fe[li] = !0, Fe[$e] = Fe[ot] = Fe[Di] = Fe[en] = Fe[tn] = Fe[ft] = Fe[Jt] = Fe[pt] = Fe[Ke] = Fe[bt] = Fe[$t] = Fe[Un] = Fe[kt] = Fe[ai] = Fe[xi] = !1;
    var st = {};
    st[$e] = st[ot] = st[Di] = st[tn] = st[en] = st[ft] = st[nn] = st[vn] = st[hr] = st[rn] = st[yn] = st[Ke] = st[bt] = st[$t] = st[Un] = st[kt] = st[ai] = st[Oi] = st[un] = st[vi] = st[fr] = st[li] = !0, st[Jt] = st[pt] = st[xi] = !1;
    var Ma = {
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, Oa = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, jl = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, xa = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Zs = parseFloat, Gl = parseInt, Vs = typeof ws == "object" && ws && ws.Object === Object && ws, et = typeof self == "object" && self && self.Object === Object && self, on = Vs || et || Function("return this")(), En = i && !i.nodeType && i, ci = En && !0 && t && !t.nodeType && t, Ws = ci && ci.exports === En, js = Ws && Vs.process, wn = function() {
      try {
        var H = ci && ci.require && ci.require("util").types;
        return H || js && js.binding && js.binding("util");
      } catch {
      }
    }(), Da = wn && wn.isArrayBuffer, Gs = wn && wn.isDate, ka = wn && wn.isMap, Aa = wn && wn.isRegExp, Xo = wn && wn.isSet, Ia = wn && wn.isTypedArray;
    function zt(H, K, W) {
      switch (W.length) {
        case 0:
          return H.call(K);
        case 1:
          return H.call(K, W[0]);
        case 2:
          return H.call(K, W[0], W[1]);
        case 3:
          return H.call(K, W[0], W[1], W[2]);
      }
      return H.apply(K, W);
    }
    function ql(H, K, W, ye) {
      for (var Ne = -1, lt = H == null ? 0 : H.length; ++Ne < lt; ) {
        var Vt = H[Ne];
        K(ye, Vt, W(Vt), H);
      }
      return ye;
    }
    function Pn(H, K) {
      for (var W = -1, ye = H == null ? 0 : H.length; ++W < ye && K(H[W], W, H) !== !1; )
        ;
      return H;
    }
    function Gi(H, K) {
      for (var W = H == null ? 0 : H.length; W-- && K(H[W], W, H) !== !1; )
        ;
      return H;
    }
    function qs(H, K) {
      for (var W = -1, ye = H == null ? 0 : H.length; ++W < ye; )
        if (!K(H[W], W, H))
          return !1;
      return !0;
    }
    function Ai(H, K) {
      for (var W = -1, ye = H == null ? 0 : H.length, Ne = 0, lt = []; ++W < ye; ) {
        var Vt = H[W];
        K(Vt, W, H) && (lt[Ne++] = Vt);
      }
      return lt;
    }
    function Qo(H, K) {
      var W = H == null ? 0 : H.length;
      return !!W && vr(H, K, 0) > -1;
    }
    function Ys(H, K, W) {
      for (var ye = -1, Ne = H == null ? 0 : H.length; ++ye < Ne; )
        if (W(K, H[ye]))
          return !0;
      return !1;
    }
    function Ct(H, K) {
      for (var W = -1, ye = H == null ? 0 : H.length, Ne = Array(ye); ++W < ye; )
        Ne[W] = K(H[W], W, H);
      return Ne;
    }
    function qi(H, K) {
      for (var W = -1, ye = K.length, Ne = H.length; ++W < ye; )
        H[Ne + W] = K[W];
      return H;
    }
    function es(H, K, W, ye) {
      var Ne = -1, lt = H == null ? 0 : H.length;
      for (ye && lt && (W = H[++Ne]); ++Ne < lt; )
        W = K(W, H[Ne], Ne, H);
      return W;
    }
    function Na(H, K, W, ye) {
      var Ne = H == null ? 0 : H.length;
      for (ye && Ne && (W = H[--Ne]); Ne--; )
        W = K(W, H[Ne], Ne, H);
      return W;
    }
    function Ur(H, K) {
      for (var W = -1, ye = H == null ? 0 : H.length; ++W < ye; )
        if (K(H[W], W, H))
          return !0;
      return !1;
    }
    var gr = Xs("length");
    function Yl(H) {
      return H.split("");
    }
    function _o(H) {
      return H.match(co) || [];
    }
    function Mn(H, K, W) {
      var ye;
      return W(H, function(Ne, lt, Vt) {
        if (K(Ne, lt, Vt))
          return ye = lt, !1;
      }), ye;
    }
    function go(H, K, W, ye) {
      for (var Ne = H.length, lt = W + (ye ? 1 : -1); ye ? lt-- : ++lt < Ne; )
        if (K(H[lt], lt, H))
          return lt;
      return -1;
    }
    function vr(H, K, W) {
      return K === K ? nu(H, K, W) : go(H, Ks, W);
    }
    function Kl(H, K, W, ye) {
      for (var Ne = W - 1, lt = H.length; ++Ne < lt; )
        if (ye(H[Ne], K))
          return Ne;
      return -1;
    }
    function Ks(H) {
      return H !== H;
    }
    function Js(H, K) {
      var W = H == null ? 0 : H.length;
      return W ? Qs(H, K) / W : _e;
    }
    function Xs(H) {
      return function(K) {
        return K == null ? r : K[H];
      };
    }
    function vo(H) {
      return function(K) {
        return H == null ? r : H[K];
      };
    }
    function ts(H, K, W, ye, Ne) {
      return Ne(H, function(lt, Vt, Lt) {
        W = ye ? (ye = !1, lt) : K(W, lt, Vt, Lt);
      }), W;
    }
    function Jl(H, K) {
      var W = H.length;
      for (H.sort(K); W--; )
        H[W] = H[W].value;
      return H;
    }
    function Qs(H, K) {
      for (var W, ye = -1, Ne = H.length; ++ye < Ne; ) {
        var lt = K(H[ye]);
        lt !== r && (W = W === r ? lt : W + lt);
      }
      return W;
    }
    function ns(H, K) {
      for (var W = -1, ye = Array(H); ++W < H; )
        ye[W] = K(W);
      return ye;
    }
    function Xl(H, K) {
      return Ct(K, function(W) {
        return [W, H[W]];
      });
    }
    function Wn(H) {
      return H && H.slice(0, ss(H) + 1).replace(lo, "");
    }
    function Qt(H) {
      return function(K) {
        return H(K);
      };
    }
    function ea(H, K) {
      return Ct(K, function(W) {
        return H[W];
      });
    }
    function On(H, K) {
      return H.has(K);
    }
    function Ra(H, K) {
      for (var W = -1, ye = H.length; ++W < ye && vr(K, H[W], 0) > -1; )
        ;
      return W;
    }
    function yr(H, K) {
      for (var W = H.length; W-- && vr(K, H[W], 0) > -1; )
        ;
      return W;
    }
    function Ql(H, K) {
      for (var W = H.length, ye = 0; W--; )
        H[W] === K && ++ye;
      return ye;
    }
    var yo = vo(Ma), $a = vo(Oa);
    function is(H) {
      return "\\" + xa[H];
    }
    function eu(H, K) {
      return H == null ? r : H[K];
    }
    function xn(H) {
      return Fs.test(H);
    }
    function rs(H) {
      return _r.test(H);
    }
    function tu(H) {
      for (var K, W = []; !(K = H.next()).done; )
        W.push(K.value);
      return W;
    }
    function Lo(H) {
      var K = -1, W = Array(H.size);
      return H.forEach(function(ye, Ne) {
        W[++K] = [Ne, ye];
      }), W;
    }
    function za(H, K) {
      return function(W) {
        return H(K(W));
      };
    }
    function hn(H, K) {
      for (var W = -1, ye = H.length, Ne = 0, lt = []; ++W < ye; ) {
        var Vt = H[W];
        (Vt === K || Vt === C) && (H[W] = C, lt[Ne++] = W);
      }
      return lt;
    }
    function os(H) {
      var K = -1, W = Array(H.size);
      return H.forEach(function(ye) {
        W[++K] = ye;
      }), W;
    }
    function Fr(H) {
      var K = -1, W = Array(H.size);
      return H.forEach(function(ye) {
        W[++K] = [ye, ye];
      }), W;
    }
    function nu(H, K, W) {
      for (var ye = W - 1, Ne = H.length; ++ye < Ne; )
        if (H[ye] === K)
          return ye;
      return -1;
    }
    function Ii(H, K, W) {
      for (var ye = W + 1; ye--; )
        if (H[ye] === K)
          return ye;
      return ye;
    }
    function Ni(H) {
      return xn(H) ? ta(H) : gr(H);
    }
    function jn(H) {
      return xn(H) ? ls(H) : Yl(H);
    }
    function ss(H) {
      for (var K = H.length; K-- && cn.test(H.charAt(K)); )
        ;
      return K;
    }
    var as = vo(jl);
    function ta(H) {
      for (var K = ji.lastIndex = 0; ji.test(H); )
        ++K;
      return K;
    }
    function ls(H) {
      return H.match(ji) || [];
    }
    function Hr(H) {
      return H.match(po) || [];
    }
    var us = function H(K) {
      K = K == null ? on : Yi.defaults(on.Object(), K, Yi.pick(on, Hs));
      var W = K.Array, ye = K.Date, Ne = K.Error, lt = K.Function, Vt = K.Math, Lt = K.Object, Gn = K.RegExp, cs = K.String, qn = K.TypeError, Lr = W.prototype, iu = lt.prototype, wr = Lt.prototype, hs = K["__core-js_shared__"], Ki = iu.toString, gt = wr.hasOwnProperty, Zr = 0, na = function() {
        var n = /[^.]+$/.exec(hs && hs.keys && hs.keys.IE_PROTO || "");
        return n ? "Symbol(src)_1." + n : "";
      }(), wo = wr.toString, ru = Ki.call(Lt), Ri = on._, Ba = Gn(
        "^" + Ki.call(gt).replace(ao, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), bo = Ws ? K.Buffer : r, Yn = K.Symbol, fs = K.Uint8Array, So = bo ? bo.allocUnsafe : r, Ji = za(Lt.getPrototypeOf, Lt), ia = Lt.create, ra = wr.propertyIsEnumerable, ds = Lr.splice, oa = Yn ? Yn.isConcatSpreadable : r, Vr = Yn ? Yn.iterator : r, Xi = Yn ? Yn.toStringTag : r, Co = function() {
        try {
          var n = xo(Lt, "defineProperty");
          return n({}, "", {}), n;
        } catch {
        }
      }(), Ua = K.clearTimeout !== on.clearTimeout && K.clearTimeout, ou = ye && ye.now !== on.Date.now && ye.now, Fa = K.setTimeout !== on.setTimeout && K.setTimeout, To = Vt.ceil, ps = Vt.floor, e = Lt.getOwnPropertySymbols, o = bo ? bo.isBuffer : r, u = K.isFinite, p = Lr.join, b = za(Lt.keys, Lt), P = Vt.max, $ = Vt.min, V = ye.now, j = K.parseInt, oe = Vt.random, ge = Lr.reverse, Oe = xo(K, "DataView"), Ve = xo(K, "Map"), bn = xo(K, "Promise"), Kn = xo(K, "Set"), Qi = xo(K, "WeakMap"), Jn = xo(Lt, "create"), Wr = Qi && new Qi(), jr = {}, su = Do(Oe), au = Do(Ve), Ha = Do(bn), lu = Do(Kn), Za = Do(Qi), At = Yn ? Yn.prototype : r, er = At ? At.valueOf : r, Va = At ? At.toString : r;
      function O(n) {
        if (Wt(n) && !He(n) && !(n instanceof Je)) {
          if (n instanceof Dn)
            return n;
          if (gt.call(n, "__wrapped__"))
            return af(n);
        }
        return new Dn(n);
      }
      var Gr = function() {
        function n() {
        }
        return function(s) {
          if (!Ft(s))
            return {};
          if (ia)
            return ia(s);
          n.prototype = s;
          var c = new n();
          return n.prototype = r, c;
        };
      }();
      function qr() {
      }
      function Dn(n, s) {
        this.__wrapped__ = n, this.__actions__ = [], this.__chain__ = !!s, this.__index__ = 0, this.__values__ = r;
      }
      O.templateSettings = {
        escape: Bt,
        evaluate: Ho,
        interpolate: so,
        variable: "",
        imports: {
          _: O
        }
      }, O.prototype = qr.prototype, O.prototype.constructor = O, Dn.prototype = Gr(qr.prototype), Dn.prototype.constructor = Dn;
      function Je(n) {
        this.__wrapped__ = n, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Be, this.__views__ = [];
      }
      function g_() {
        var n = new Je(this.__wrapped__);
        return n.__actions__ = Xn(this.__actions__), n.__dir__ = this.__dir__, n.__filtered__ = this.__filtered__, n.__iteratees__ = Xn(this.__iteratees__), n.__takeCount__ = this.__takeCount__, n.__views__ = Xn(this.__views__), n;
      }
      function v_() {
        if (this.__filtered__) {
          var n = new Je(this);
          n.__dir__ = -1, n.__filtered__ = !0;
        } else
          n = this.clone(), n.__dir__ *= -1;
        return n;
      }
      function y_() {
        var n = this.__wrapped__.value(), s = this.__dir__, c = He(n), g = s < 0, T = c ? n.length : 0, x = Dg(0, T, this.__views__), z = x.start, U = x.end, Z = U - z, ne = g ? U : z - 1, ie = this.__iteratees__, ae = ie.length, me = 0, Se = $(Z, this.__takeCount__);
        if (!c || !g && T == Z && Se == Z)
          return Oh(n, this.__actions__);
        var xe = [];
        e:
          for (; Z-- && me < Se; ) {
            ne += s;
            for (var qe = -1, De = n[ne]; ++qe < ae; ) {
              var Xe = ie[qe], nt = Xe.iteratee, di = Xe.type, In = nt(De);
              if (di == gn)
                De = In;
              else if (!In) {
                if (di == Dt)
                  continue e;
                break e;
              }
            }
            xe[me++] = De;
          }
        return xe;
      }
      Je.prototype = Gr(qr.prototype), Je.prototype.constructor = Je;
      function Eo(n) {
        var s = -1, c = n == null ? 0 : n.length;
        for (this.clear(); ++s < c; ) {
          var g = n[s];
          this.set(g[0], g[1]);
        }
      }
      function L_() {
        this.__data__ = Jn ? Jn(null) : {}, this.size = 0;
      }
      function w_(n) {
        var s = this.has(n) && delete this.__data__[n];
        return this.size -= s ? 1 : 0, s;
      }
      function b_(n) {
        var s = this.__data__;
        if (Jn) {
          var c = s[n];
          return c === y ? r : c;
        }
        return gt.call(s, n) ? s[n] : r;
      }
      function S_(n) {
        var s = this.__data__;
        return Jn ? s[n] !== r : gt.call(s, n);
      }
      function C_(n, s) {
        var c = this.__data__;
        return this.size += this.has(n) ? 0 : 1, c[n] = Jn && s === r ? y : s, this;
      }
      Eo.prototype.clear = L_, Eo.prototype.delete = w_, Eo.prototype.get = b_, Eo.prototype.has = S_, Eo.prototype.set = C_;
      function br(n) {
        var s = -1, c = n == null ? 0 : n.length;
        for (this.clear(); ++s < c; ) {
          var g = n[s];
          this.set(g[0], g[1]);
        }
      }
      function T_() {
        this.__data__ = [], this.size = 0;
      }
      function E_(n) {
        var s = this.__data__, c = Wa(s, n);
        if (c < 0)
          return !1;
        var g = s.length - 1;
        return c == g ? s.pop() : ds.call(s, c, 1), --this.size, !0;
      }
      function P_(n) {
        var s = this.__data__, c = Wa(s, n);
        return c < 0 ? r : s[c][1];
      }
      function M_(n) {
        return Wa(this.__data__, n) > -1;
      }
      function O_(n, s) {
        var c = this.__data__, g = Wa(c, n);
        return g < 0 ? (++this.size, c.push([n, s])) : c[g][1] = s, this;
      }
      br.prototype.clear = T_, br.prototype.delete = E_, br.prototype.get = P_, br.prototype.has = M_, br.prototype.set = O_;
      function Sr(n) {
        var s = -1, c = n == null ? 0 : n.length;
        for (this.clear(); ++s < c; ) {
          var g = n[s];
          this.set(g[0], g[1]);
        }
      }
      function x_() {
        this.size = 0, this.__data__ = {
          hash: new Eo(),
          map: new (Ve || br)(),
          string: new Eo()
        };
      }
      function D_(n) {
        var s = il(this, n).delete(n);
        return this.size -= s ? 1 : 0, s;
      }
      function k_(n) {
        return il(this, n).get(n);
      }
      function A_(n) {
        return il(this, n).has(n);
      }
      function I_(n, s) {
        var c = il(this, n), g = c.size;
        return c.set(n, s), this.size += c.size == g ? 0 : 1, this;
      }
      Sr.prototype.clear = x_, Sr.prototype.delete = D_, Sr.prototype.get = k_, Sr.prototype.has = A_, Sr.prototype.set = I_;
      function Po(n) {
        var s = -1, c = n == null ? 0 : n.length;
        for (this.__data__ = new Sr(); ++s < c; )
          this.add(n[s]);
      }
      function N_(n) {
        return this.__data__.set(n, y), this;
      }
      function R_(n) {
        return this.__data__.has(n);
      }
      Po.prototype.add = Po.prototype.push = N_, Po.prototype.has = R_;
      function $i(n) {
        var s = this.__data__ = new br(n);
        this.size = s.size;
      }
      function $_() {
        this.__data__ = new br(), this.size = 0;
      }
      function z_(n) {
        var s = this.__data__, c = s.delete(n);
        return this.size = s.size, c;
      }
      function B_(n) {
        return this.__data__.get(n);
      }
      function U_(n) {
        return this.__data__.has(n);
      }
      function F_(n, s) {
        var c = this.__data__;
        if (c instanceof br) {
          var g = c.__data__;
          if (!Ve || g.length < a - 1)
            return g.push([n, s]), this.size = ++c.size, this;
          c = this.__data__ = new Sr(g);
        }
        return c.set(n, s), this.size = c.size, this;
      }
      $i.prototype.clear = $_, $i.prototype.delete = z_, $i.prototype.get = B_, $i.prototype.has = U_, $i.prototype.set = F_;
      function sh(n, s) {
        var c = He(n), g = !c && ko(n), T = !c && !g && Qr(n), x = !c && !g && !T && vs(n), z = c || g || T || x, U = z ? ns(n.length, cs) : [], Z = U.length;
        for (var ne in n)
          (s || gt.call(n, ne)) && !(z && (ne == "length" || T && (ne == "offset" || ne == "parent") || x && (ne == "buffer" || ne == "byteLength" || ne == "byteOffset") || Pr(ne, Z))) && U.push(ne);
        return U;
      }
      function ah(n) {
        var s = n.length;
        return s ? n[yu(0, s - 1)] : r;
      }
      function H_(n, s) {
        return rl(Xn(n), Mo(s, 0, n.length));
      }
      function Z_(n) {
        return rl(Xn(n));
      }
      function uu(n, s, c) {
        (c !== r && !zi(n[s], c) || c === r && !(s in n)) && Cr(n, s, c);
      }
      function sa(n, s, c) {
        var g = n[s];
        (!(gt.call(n, s) && zi(g, c)) || c === r && !(s in n)) && Cr(n, s, c);
      }
      function Wa(n, s) {
        for (var c = n.length; c--; )
          if (zi(n[c][0], s))
            return c;
        return -1;
      }
      function V_(n, s, c, g) {
        return Yr(n, function(T, x, z) {
          s(g, T, c(T), z);
        }), g;
      }
      function lh(n, s) {
        return n && nr(s, fn(s), n);
      }
      function W_(n, s) {
        return n && nr(s, ei(s), n);
      }
      function Cr(n, s, c) {
        s == "__proto__" && Co ? Co(n, s, {
          configurable: !0,
          enumerable: !0,
          value: c,
          writable: !0
        }) : n[s] = c;
      }
      function cu(n, s) {
        for (var c = -1, g = s.length, T = W(g), x = n == null; ++c < g; )
          T[c] = x ? r : Vu(n, s[c]);
        return T;
      }
      function Mo(n, s, c) {
        return n === n && (c !== r && (n = n <= c ? n : c), s !== r && (n = n >= s ? n : s)), n;
      }
      function wi(n, s, c, g, T, x) {
        var z, U = s & M, Z = s & N, ne = s & I;
        if (c && (z = T ? c(n, g, T, x) : c(n)), z !== r)
          return z;
        if (!Ft(n))
          return n;
        var ie = He(n);
        if (ie) {
          if (z = Ag(n), !U)
            return Xn(n, z);
        } else {
          var ae = Sn(n), me = ae == pt || ae == jt;
          if (Qr(n))
            return kh(n, U);
          if (ae == $t || ae == $e || me && !T) {
            if (z = Z || me ? {} : Jh(n), !U)
              return Z ? bg(n, W_(z, n)) : wg(n, lh(z, n));
          } else {
            if (!st[ae])
              return T ? n : {};
            z = Ig(n, ae, U);
          }
        }
        x || (x = new $i());
        var Se = x.get(n);
        if (Se)
          return Se;
        x.set(n, z), Pf(n) ? n.forEach(function(De) {
          z.add(wi(De, s, c, De, n, x));
        }) : Tf(n) && n.forEach(function(De, Xe) {
          z.set(Xe, wi(De, s, c, Xe, n, x));
        });
        var xe = ne ? Z ? xu : Ou : Z ? ei : fn, qe = ie ? r : xe(n);
        return Pn(qe || n, function(De, Xe) {
          qe && (Xe = De, De = n[Xe]), sa(z, Xe, wi(De, s, c, Xe, n, x));
        }), z;
      }
      function j_(n) {
        var s = fn(n);
        return function(c) {
          return uh(c, n, s);
        };
      }
      function uh(n, s, c) {
        var g = c.length;
        if (n == null)
          return !g;
        for (n = Lt(n); g--; ) {
          var T = c[g], x = s[T], z = n[T];
          if (z === r && !(T in n) || !x(z))
            return !1;
        }
        return !0;
      }
      function ch(n, s, c) {
        if (typeof n != "function")
          throw new qn(f);
        return da(function() {
          n.apply(r, c);
        }, s);
      }
      function aa(n, s, c, g) {
        var T = -1, x = Qo, z = !0, U = n.length, Z = [], ne = s.length;
        if (!U)
          return Z;
        c && (s = Ct(s, Qt(c))), g ? (x = Ys, z = !1) : s.length >= a && (x = On, z = !1, s = new Po(s));
        e:
          for (; ++T < U; ) {
            var ie = n[T], ae = c == null ? ie : c(ie);
            if (ie = g || ie !== 0 ? ie : 0, z && ae === ae) {
              for (var me = ne; me--; )
                if (s[me] === ae)
                  continue e;
              Z.push(ie);
            } else
              x(s, ae, g) || Z.push(ie);
          }
        return Z;
      }
      var Yr = $h(tr), hh = $h(fu, !0);
      function G_(n, s) {
        var c = !0;
        return Yr(n, function(g, T, x) {
          return c = !!s(g, T, x), c;
        }), c;
      }
      function ja(n, s, c) {
        for (var g = -1, T = n.length; ++g < T; ) {
          var x = n[g], z = s(x);
          if (z != null && (U === r ? z === z && !fi(z) : c(z, U)))
            var U = z, Z = x;
        }
        return Z;
      }
      function q_(n, s, c, g) {
        var T = n.length;
        for (c = je(c), c < 0 && (c = -c > T ? 0 : T + c), g = g === r || g > T ? T : je(g), g < 0 && (g += T), g = c > g ? 0 : Of(g); c < g; )
          n[c++] = s;
        return n;
      }
      function fh(n, s) {
        var c = [];
        return Yr(n, function(g, T, x) {
          s(g, T, x) && c.push(g);
        }), c;
      }
      function pn(n, s, c, g, T) {
        var x = -1, z = n.length;
        for (c || (c = Rg), T || (T = []); ++x < z; ) {
          var U = n[x];
          s > 0 && c(U) ? s > 1 ? pn(U, s - 1, c, g, T) : qi(T, U) : g || (T[T.length] = U);
        }
        return T;
      }
      var hu = zh(), dh = zh(!0);
      function tr(n, s) {
        return n && hu(n, s, fn);
      }
      function fu(n, s) {
        return n && dh(n, s, fn);
      }
      function Ga(n, s) {
        return Ai(s, function(c) {
          return Mr(n[c]);
        });
      }
      function Oo(n, s) {
        s = Jr(s, n);
        for (var c = 0, g = s.length; n != null && c < g; )
          n = n[ir(s[c++])];
        return c && c == g ? n : r;
      }
      function ph(n, s, c) {
        var g = s(n);
        return He(n) ? g : qi(g, c(n));
      }
      function kn(n) {
        return n == null ? n === r ? Fn : Rt : Xi && Xi in Lt(n) ? xg(n) : Zg(n);
      }
      function du(n, s) {
        return n > s;
      }
      function Y_(n, s) {
        return n != null && gt.call(n, s);
      }
      function K_(n, s) {
        return n != null && s in Lt(n);
      }
      function J_(n, s, c) {
        return n >= $(s, c) && n < P(s, c);
      }
      function pu(n, s, c) {
        for (var g = c ? Ys : Qo, T = n[0].length, x = n.length, z = x, U = W(x), Z = 1 / 0, ne = []; z--; ) {
          var ie = n[z];
          z && s && (ie = Ct(ie, Qt(s))), Z = $(ie.length, Z), U[z] = !c && (s || T >= 120 && ie.length >= 120) ? new Po(z && ie) : r;
        }
        ie = n[0];
        var ae = -1, me = U[0];
        e:
          for (; ++ae < T && ne.length < Z; ) {
            var Se = ie[ae], xe = s ? s(Se) : Se;
            if (Se = c || Se !== 0 ? Se : 0, !(me ? On(me, xe) : g(ne, xe, c))) {
              for (z = x; --z; ) {
                var qe = U[z];
                if (!(qe ? On(qe, xe) : g(n[z], xe, c)))
                  continue e;
              }
              me && me.push(xe), ne.push(Se);
            }
          }
        return ne;
      }
      function X_(n, s, c, g) {
        return tr(n, function(T, x, z) {
          s(g, c(T), x, z);
        }), g;
      }
      function la(n, s, c) {
        s = Jr(s, n), n = tf(n, s);
        var g = n == null ? n : n[ir(Si(s))];
        return g == null ? r : zt(g, n, c);
      }
      function mh(n) {
        return Wt(n) && kn(n) == $e;
      }
      function Q_(n) {
        return Wt(n) && kn(n) == Di;
      }
      function eg(n) {
        return Wt(n) && kn(n) == ft;
      }
      function ua(n, s, c, g, T) {
        return n === s ? !0 : n == null || s == null || !Wt(n) && !Wt(s) ? n !== n && s !== s : tg(n, s, c, g, ua, T);
      }
      function tg(n, s, c, g, T, x) {
        var z = He(n), U = He(s), Z = z ? ot : Sn(n), ne = U ? ot : Sn(s);
        Z = Z == $e ? $t : Z, ne = ne == $e ? $t : ne;
        var ie = Z == $t, ae = ne == $t, me = Z == ne;
        if (me && Qr(n)) {
          if (!Qr(s))
            return !1;
          z = !0, ie = !1;
        }
        if (me && !ie)
          return x || (x = new $i()), z || vs(n) ? qh(n, s, c, g, T, x) : Mg(n, s, Z, c, g, T, x);
        if (!(c & D)) {
          var Se = ie && gt.call(n, "__wrapped__"), xe = ae && gt.call(s, "__wrapped__");
          if (Se || xe) {
            var qe = Se ? n.value() : n, De = xe ? s.value() : s;
            return x || (x = new $i()), T(qe, De, c, g, x);
          }
        }
        return me ? (x || (x = new $i()), Og(n, s, c, g, T, x)) : !1;
      }
      function ng(n) {
        return Wt(n) && Sn(n) == Ke;
      }
      function mu(n, s, c, g) {
        var T = c.length, x = T, z = !g;
        if (n == null)
          return !x;
        for (n = Lt(n); T--; ) {
          var U = c[T];
          if (z && U[2] ? U[1] !== n[U[0]] : !(U[0] in n))
            return !1;
        }
        for (; ++T < x; ) {
          U = c[T];
          var Z = U[0], ne = n[Z], ie = U[1];
          if (z && U[2]) {
            if (ne === r && !(Z in n))
              return !1;
          } else {
            var ae = new $i();
            if (g)
              var me = g(ne, ie, Z, n, s, ae);
            if (!(me === r ? ua(ie, ne, D | B, g, ae) : me))
              return !1;
          }
        }
        return !0;
      }
      function _h(n) {
        if (!Ft(n) || zg(n))
          return !1;
        var s = Mr(n) ? Ba : Go;
        return s.test(Do(n));
      }
      function ig(n) {
        return Wt(n) && kn(n) == Un;
      }
      function rg(n) {
        return Wt(n) && Sn(n) == kt;
      }
      function og(n) {
        return Wt(n) && cl(n.length) && !!Fe[kn(n)];
      }
      function gh(n) {
        return typeof n == "function" ? n : n == null ? ti : typeof n == "object" ? He(n) ? Lh(n[0], n[1]) : yh(n) : Uf(n);
      }
      function _u(n) {
        if (!fa(n))
          return b(n);
        var s = [];
        for (var c in Lt(n))
          gt.call(n, c) && c != "constructor" && s.push(c);
        return s;
      }
      function sg(n) {
        if (!Ft(n))
          return Hg(n);
        var s = fa(n), c = [];
        for (var g in n)
          g == "constructor" && (s || !gt.call(n, g)) || c.push(g);
        return c;
      }
      function gu(n, s) {
        return n < s;
      }
      function vh(n, s) {
        var c = -1, g = Qn(n) ? W(n.length) : [];
        return Yr(n, function(T, x, z) {
          g[++c] = s(T, x, z);
        }), g;
      }
      function yh(n) {
        var s = ku(n);
        return s.length == 1 && s[0][2] ? Qh(s[0][0], s[0][1]) : function(c) {
          return c === n || mu(c, n, s);
        };
      }
      function Lh(n, s) {
        return Iu(n) && Xh(s) ? Qh(ir(n), s) : function(c) {
          var g = Vu(c, n);
          return g === r && g === s ? Wu(c, n) : ua(s, g, D | B);
        };
      }
      function qa(n, s, c, g, T) {
        n !== s && hu(s, function(x, z) {
          if (T || (T = new $i()), Ft(x))
            ag(n, s, z, c, qa, g, T);
          else {
            var U = g ? g(Ru(n, z), x, z + "", n, s, T) : r;
            U === r && (U = x), uu(n, z, U);
          }
        }, ei);
      }
      function ag(n, s, c, g, T, x, z) {
        var U = Ru(n, c), Z = Ru(s, c), ne = z.get(Z);
        if (ne) {
          uu(n, c, ne);
          return;
        }
        var ie = x ? x(U, Z, c + "", n, s, z) : r, ae = ie === r;
        if (ae) {
          var me = He(Z), Se = !me && Qr(Z), xe = !me && !Se && vs(Z);
          ie = Z, me || Se || xe ? He(U) ? ie = U : qt(U) ? ie = Xn(U) : Se ? (ae = !1, ie = kh(Z, !0)) : xe ? (ae = !1, ie = Ah(Z, !0)) : ie = [] : pa(Z) || ko(Z) ? (ie = U, ko(U) ? ie = xf(U) : (!Ft(U) || Mr(U)) && (ie = Jh(Z))) : ae = !1;
        }
        ae && (z.set(Z, ie), T(ie, Z, g, x, z), z.delete(Z)), uu(n, c, ie);
      }
      function wh(n, s) {
        var c = n.length;
        if (c)
          return s += s < 0 ? c : 0, Pr(s, c) ? n[s] : r;
      }
      function bh(n, s, c) {
        s.length ? s = Ct(s, function(x) {
          return He(x) ? function(z) {
            return Oo(z, x.length === 1 ? x[0] : x);
          } : x;
        }) : s = [ti];
        var g = -1;
        s = Ct(s, Qt(Pe()));
        var T = vh(n, function(x, z, U) {
          var Z = Ct(s, function(ne) {
            return ne(x);
          });
          return { criteria: Z, index: ++g, value: x };
        });
        return Jl(T, function(x, z) {
          return Lg(x, z, c);
        });
      }
      function lg(n, s) {
        return Sh(n, s, function(c, g) {
          return Wu(n, g);
        });
      }
      function Sh(n, s, c) {
        for (var g = -1, T = s.length, x = {}; ++g < T; ) {
          var z = s[g], U = Oo(n, z);
          c(U, z) && ca(x, Jr(z, n), U);
        }
        return x;
      }
      function ug(n) {
        return function(s) {
          return Oo(s, n);
        };
      }
      function vu(n, s, c, g) {
        var T = g ? Kl : vr, x = -1, z = s.length, U = n;
        for (n === s && (s = Xn(s)), c && (U = Ct(n, Qt(c))); ++x < z; )
          for (var Z = 0, ne = s[x], ie = c ? c(ne) : ne; (Z = T(U, ie, Z, g)) > -1; )
            U !== n && ds.call(U, Z, 1), ds.call(n, Z, 1);
        return n;
      }
      function Ch(n, s) {
        for (var c = n ? s.length : 0, g = c - 1; c--; ) {
          var T = s[c];
          if (c == g || T !== x) {
            var x = T;
            Pr(T) ? ds.call(n, T, 1) : bu(n, T);
          }
        }
        return n;
      }
      function yu(n, s) {
        return n + ps(oe() * (s - n + 1));
      }
      function cg(n, s, c, g) {
        for (var T = -1, x = P(To((s - n) / (c || 1)), 0), z = W(x); x--; )
          z[g ? x : ++T] = n, n += c;
        return z;
      }
      function Lu(n, s) {
        var c = "";
        if (!n || s < 1 || s > we)
          return c;
        do
          s % 2 && (c += n), s = ps(s / 2), s && (n += n);
        while (s);
        return c;
      }
      function Ye(n, s) {
        return $u(ef(n, s, ti), n + "");
      }
      function hg(n) {
        return ah(ys(n));
      }
      function fg(n, s) {
        var c = ys(n);
        return rl(c, Mo(s, 0, c.length));
      }
      function ca(n, s, c, g) {
        if (!Ft(n))
          return n;
        s = Jr(s, n);
        for (var T = -1, x = s.length, z = x - 1, U = n; U != null && ++T < x; ) {
          var Z = ir(s[T]), ne = c;
          if (Z === "__proto__" || Z === "constructor" || Z === "prototype")
            return n;
          if (T != z) {
            var ie = U[Z];
            ne = g ? g(ie, Z, U) : r, ne === r && (ne = Ft(ie) ? ie : Pr(s[T + 1]) ? [] : {});
          }
          sa(U, Z, ne), U = U[Z];
        }
        return n;
      }
      var Th = Wr ? function(n, s) {
        return Wr.set(n, s), n;
      } : ti, dg = Co ? function(n, s) {
        return Co(n, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Gu(s),
          writable: !0
        });
      } : ti;
      function pg(n) {
        return rl(ys(n));
      }
      function bi(n, s, c) {
        var g = -1, T = n.length;
        s < 0 && (s = -s > T ? 0 : T + s), c = c > T ? T : c, c < 0 && (c += T), T = s > c ? 0 : c - s >>> 0, s >>>= 0;
        for (var x = W(T); ++g < T; )
          x[g] = n[g + s];
        return x;
      }
      function mg(n, s) {
        var c;
        return Yr(n, function(g, T, x) {
          return c = s(g, T, x), !c;
        }), !!c;
      }
      function Ya(n, s, c) {
        var g = 0, T = n == null ? g : n.length;
        if (typeof s == "number" && s === s && T <= Ht) {
          for (; g < T; ) {
            var x = g + T >>> 1, z = n[x];
            z !== null && !fi(z) && (c ? z <= s : z < s) ? g = x + 1 : T = x;
          }
          return T;
        }
        return wu(n, s, ti, c);
      }
      function wu(n, s, c, g) {
        var T = 0, x = n == null ? 0 : n.length;
        if (x === 0)
          return 0;
        s = c(s);
        for (var z = s !== s, U = s === null, Z = fi(s), ne = s === r; T < x; ) {
          var ie = ps((T + x) / 2), ae = c(n[ie]), me = ae !== r, Se = ae === null, xe = ae === ae, qe = fi(ae);
          if (z)
            var De = g || xe;
          else
            ne ? De = xe && (g || me) : U ? De = xe && me && (g || !Se) : Z ? De = xe && me && !Se && (g || !qe) : Se || qe ? De = !1 : De = g ? ae <= s : ae < s;
          De ? T = ie + 1 : x = ie;
        }
        return $(x, Nt);
      }
      function Eh(n, s) {
        for (var c = -1, g = n.length, T = 0, x = []; ++c < g; ) {
          var z = n[c], U = s ? s(z) : z;
          if (!c || !zi(U, Z)) {
            var Z = U;
            x[T++] = z === 0 ? 0 : z;
          }
        }
        return x;
      }
      function Ph(n) {
        return typeof n == "number" ? n : fi(n) ? _e : +n;
      }
      function hi(n) {
        if (typeof n == "string")
          return n;
        if (He(n))
          return Ct(n, hi) + "";
        if (fi(n))
          return Va ? Va.call(n) : "";
        var s = n + "";
        return s == "0" && 1 / n == -Kt ? "-0" : s;
      }
      function Kr(n, s, c) {
        var g = -1, T = Qo, x = n.length, z = !0, U = [], Z = U;
        if (c)
          z = !1, T = Ys;
        else if (x >= a) {
          var ne = s ? null : Eg(n);
          if (ne)
            return os(ne);
          z = !1, T = On, Z = new Po();
        } else
          Z = s ? [] : U;
        e:
          for (; ++g < x; ) {
            var ie = n[g], ae = s ? s(ie) : ie;
            if (ie = c || ie !== 0 ? ie : 0, z && ae === ae) {
              for (var me = Z.length; me--; )
                if (Z[me] === ae)
                  continue e;
              s && Z.push(ae), U.push(ie);
            } else
              T(Z, ae, c) || (Z !== U && Z.push(ae), U.push(ie));
          }
        return U;
      }
      function bu(n, s) {
        return s = Jr(s, n), n = tf(n, s), n == null || delete n[ir(Si(s))];
      }
      function Mh(n, s, c, g) {
        return ca(n, s, c(Oo(n, s)), g);
      }
      function Ka(n, s, c, g) {
        for (var T = n.length, x = g ? T : -1; (g ? x-- : ++x < T) && s(n[x], x, n); )
          ;
        return c ? bi(n, g ? 0 : x, g ? x + 1 : T) : bi(n, g ? x + 1 : 0, g ? T : x);
      }
      function Oh(n, s) {
        var c = n;
        return c instanceof Je && (c = c.value()), es(s, function(g, T) {
          return T.func.apply(T.thisArg, qi([g], T.args));
        }, c);
      }
      function Su(n, s, c) {
        var g = n.length;
        if (g < 2)
          return g ? Kr(n[0]) : [];
        for (var T = -1, x = W(g); ++T < g; )
          for (var z = n[T], U = -1; ++U < g; )
            U != T && (x[T] = aa(x[T] || z, n[U], s, c));
        return Kr(pn(x, 1), s, c);
      }
      function xh(n, s, c) {
        for (var g = -1, T = n.length, x = s.length, z = {}; ++g < T; ) {
          var U = g < x ? s[g] : r;
          c(z, n[g], U);
        }
        return z;
      }
      function Cu(n) {
        return qt(n) ? n : [];
      }
      function Tu(n) {
        return typeof n == "function" ? n : ti;
      }
      function Jr(n, s) {
        return He(n) ? n : Iu(n, s) ? [n] : sf(vt(n));
      }
      var _g = Ye;
      function Xr(n, s, c) {
        var g = n.length;
        return c = c === r ? g : c, !s && c >= g ? n : bi(n, s, c);
      }
      var Dh = Ua || function(n) {
        return on.clearTimeout(n);
      };
      function kh(n, s) {
        if (s)
          return n.slice();
        var c = n.length, g = So ? So(c) : new n.constructor(c);
        return n.copy(g), g;
      }
      function Eu(n) {
        var s = new n.constructor(n.byteLength);
        return new fs(s).set(new fs(n)), s;
      }
      function gg(n, s) {
        var c = s ? Eu(n.buffer) : n.buffer;
        return new n.constructor(c, n.byteOffset, n.byteLength);
      }
      function vg(n) {
        var s = new n.constructor(n.source, Li.exec(n));
        return s.lastIndex = n.lastIndex, s;
      }
      function yg(n) {
        return er ? Lt(er.call(n)) : {};
      }
      function Ah(n, s) {
        var c = s ? Eu(n.buffer) : n.buffer;
        return new n.constructor(c, n.byteOffset, n.length);
      }
      function Ih(n, s) {
        if (n !== s) {
          var c = n !== r, g = n === null, T = n === n, x = fi(n), z = s !== r, U = s === null, Z = s === s, ne = fi(s);
          if (!U && !ne && !x && n > s || x && z && Z && !U && !ne || g && z && Z || !c && Z || !T)
            return 1;
          if (!g && !x && !ne && n < s || ne && c && T && !g && !x || U && c && T || !z && T || !Z)
            return -1;
        }
        return 0;
      }
      function Lg(n, s, c) {
        for (var g = -1, T = n.criteria, x = s.criteria, z = T.length, U = c.length; ++g < z; ) {
          var Z = Ih(T[g], x[g]);
          if (Z) {
            if (g >= U)
              return Z;
            var ne = c[g];
            return Z * (ne == "desc" ? -1 : 1);
          }
        }
        return n.index - s.index;
      }
      function Nh(n, s, c, g) {
        for (var T = -1, x = n.length, z = c.length, U = -1, Z = s.length, ne = P(x - z, 0), ie = W(Z + ne), ae = !g; ++U < Z; )
          ie[U] = s[U];
        for (; ++T < z; )
          (ae || T < x) && (ie[c[T]] = n[T]);
        for (; ne--; )
          ie[U++] = n[T++];
        return ie;
      }
      function Rh(n, s, c, g) {
        for (var T = -1, x = n.length, z = -1, U = c.length, Z = -1, ne = s.length, ie = P(x - U, 0), ae = W(ie + ne), me = !g; ++T < ie; )
          ae[T] = n[T];
        for (var Se = T; ++Z < ne; )
          ae[Se + Z] = s[Z];
        for (; ++z < U; )
          (me || T < x) && (ae[Se + c[z]] = n[T++]);
        return ae;
      }
      function Xn(n, s) {
        var c = -1, g = n.length;
        for (s || (s = W(g)); ++c < g; )
          s[c] = n[c];
        return s;
      }
      function nr(n, s, c, g) {
        var T = !c;
        c || (c = {});
        for (var x = -1, z = s.length; ++x < z; ) {
          var U = s[x], Z = g ? g(c[U], n[U], U, c, n) : r;
          Z === r && (Z = n[U]), T ? Cr(c, U, Z) : sa(c, U, Z);
        }
        return c;
      }
      function wg(n, s) {
        return nr(n, Au(n), s);
      }
      function bg(n, s) {
        return nr(n, Yh(n), s);
      }
      function Ja(n, s) {
        return function(c, g) {
          var T = He(c) ? ql : V_, x = s ? s() : {};
          return T(c, n, Pe(g, 2), x);
        };
      }
      function ms(n) {
        return Ye(function(s, c) {
          var g = -1, T = c.length, x = T > 1 ? c[T - 1] : r, z = T > 2 ? c[2] : r;
          for (x = n.length > 3 && typeof x == "function" ? (T--, x) : r, z && An(c[0], c[1], z) && (x = T < 3 ? r : x, T = 1), s = Lt(s); ++g < T; ) {
            var U = c[g];
            U && n(s, U, g, x);
          }
          return s;
        });
      }
      function $h(n, s) {
        return function(c, g) {
          if (c == null)
            return c;
          if (!Qn(c))
            return n(c, g);
          for (var T = c.length, x = s ? T : -1, z = Lt(c); (s ? x-- : ++x < T) && g(z[x], x, z) !== !1; )
            ;
          return c;
        };
      }
      function zh(n) {
        return function(s, c, g) {
          for (var T = -1, x = Lt(s), z = g(s), U = z.length; U--; ) {
            var Z = z[n ? U : ++T];
            if (c(x[Z], Z, x) === !1)
              break;
          }
          return s;
        };
      }
      function Sg(n, s, c) {
        var g = s & X, T = ha(n);
        function x() {
          var z = this && this !== on && this instanceof x ? T : n;
          return z.apply(g ? c : this, arguments);
        }
        return x;
      }
      function Bh(n) {
        return function(s) {
          s = vt(s);
          var c = xn(s) ? jn(s) : r, g = c ? c[0] : s.charAt(0), T = c ? Xr(c, 1).join("") : s.slice(1);
          return g[n]() + T;
        };
      }
      function _s(n) {
        return function(s) {
          return es(zf($f(s).replace(_t, "")), n, "");
        };
      }
      function ha(n) {
        return function() {
          var s = arguments;
          switch (s.length) {
            case 0:
              return new n();
            case 1:
              return new n(s[0]);
            case 2:
              return new n(s[0], s[1]);
            case 3:
              return new n(s[0], s[1], s[2]);
            case 4:
              return new n(s[0], s[1], s[2], s[3]);
            case 5:
              return new n(s[0], s[1], s[2], s[3], s[4]);
            case 6:
              return new n(s[0], s[1], s[2], s[3], s[4], s[5]);
            case 7:
              return new n(s[0], s[1], s[2], s[3], s[4], s[5], s[6]);
          }
          var c = Gr(n.prototype), g = n.apply(c, s);
          return Ft(g) ? g : c;
        };
      }
      function Cg(n, s, c) {
        var g = ha(n);
        function T() {
          for (var x = arguments.length, z = W(x), U = x, Z = gs(T); U--; )
            z[U] = arguments[U];
          var ne = x < 3 && z[0] !== Z && z[x - 1] !== Z ? [] : hn(z, Z);
          if (x -= ne.length, x < c)
            return Vh(
              n,
              s,
              Xa,
              T.placeholder,
              r,
              z,
              ne,
              r,
              r,
              c - x
            );
          var ie = this && this !== on && this instanceof T ? g : n;
          return zt(ie, this, z);
        }
        return T;
      }
      function Uh(n) {
        return function(s, c, g) {
          var T = Lt(s);
          if (!Qn(s)) {
            var x = Pe(c, 3);
            s = fn(s), c = function(U) {
              return x(T[U], U, T);
            };
          }
          var z = n(s, c, g);
          return z > -1 ? T[x ? s[z] : z] : r;
        };
      }
      function Fh(n) {
        return Er(function(s) {
          var c = s.length, g = c, T = Dn.prototype.thru;
          for (n && s.reverse(); g--; ) {
            var x = s[g];
            if (typeof x != "function")
              throw new qn(f);
            if (T && !z && nl(x) == "wrapper")
              var z = new Dn([], !0);
          }
          for (g = z ? g : c; ++g < c; ) {
            x = s[g];
            var U = nl(x), Z = U == "wrapper" ? Du(x) : r;
            Z && Nu(Z[0]) && Z[1] == (se | re | Le | Me) && !Z[4].length && Z[9] == 1 ? z = z[nl(Z[0])].apply(z, Z[3]) : z = x.length == 1 && Nu(x) ? z[U]() : z.thru(x);
          }
          return function() {
            var ne = arguments, ie = ne[0];
            if (z && ne.length == 1 && He(ie))
              return z.plant(ie).value();
            for (var ae = 0, me = c ? s[ae].apply(this, ne) : ie; ++ae < c; )
              me = s[ae].call(this, me);
            return me;
          };
        });
      }
      function Xa(n, s, c, g, T, x, z, U, Z, ne) {
        var ie = s & se, ae = s & X, me = s & le, Se = s & (re | ve), xe = s & rt, qe = me ? r : ha(n);
        function De() {
          for (var Xe = arguments.length, nt = W(Xe), di = Xe; di--; )
            nt[di] = arguments[di];
          if (Se)
            var In = gs(De), pi = Ql(nt, In);
          if (g && (nt = Nh(nt, g, T, Se)), x && (nt = Rh(nt, x, z, Se)), Xe -= pi, Se && Xe < ne) {
            var Yt = hn(nt, In);
            return Vh(
              n,
              s,
              Xa,
              De.placeholder,
              c,
              nt,
              Yt,
              U,
              Z,
              ne - Xe
            );
          }
          var Bi = ae ? c : this, xr = me ? Bi[n] : n;
          return Xe = nt.length, U ? nt = Vg(nt, U) : xe && Xe > 1 && nt.reverse(), ie && Z < Xe && (nt.length = Z), this && this !== on && this instanceof De && (xr = qe || ha(xr)), xr.apply(Bi, nt);
        }
        return De;
      }
      function Hh(n, s) {
        return function(c, g) {
          return X_(c, n, s(g), {});
        };
      }
      function Qa(n, s) {
        return function(c, g) {
          var T;
          if (c === r && g === r)
            return s;
          if (c !== r && (T = c), g !== r) {
            if (T === r)
              return g;
            typeof c == "string" || typeof g == "string" ? (c = hi(c), g = hi(g)) : (c = Ph(c), g = Ph(g)), T = n(c, g);
          }
          return T;
        };
      }
      function Pu(n) {
        return Er(function(s) {
          return s = Ct(s, Qt(Pe())), Ye(function(c) {
            var g = this;
            return n(s, function(T) {
              return zt(T, g, c);
            });
          });
        });
      }
      function el(n, s) {
        s = s === r ? " " : hi(s);
        var c = s.length;
        if (c < 2)
          return c ? Lu(s, n) : s;
        var g = Lu(s, To(n / Ni(s)));
        return xn(s) ? Xr(jn(g), 0, n).join("") : g.slice(0, n);
      }
      function Tg(n, s, c, g) {
        var T = s & X, x = ha(n);
        function z() {
          for (var U = -1, Z = arguments.length, ne = -1, ie = g.length, ae = W(ie + Z), me = this && this !== on && this instanceof z ? x : n; ++ne < ie; )
            ae[ne] = g[ne];
          for (; Z--; )
            ae[ne++] = arguments[++U];
          return zt(me, T ? c : this, ae);
        }
        return z;
      }
      function Zh(n) {
        return function(s, c, g) {
          return g && typeof g != "number" && An(s, c, g) && (c = g = r), s = Or(s), c === r ? (c = s, s = 0) : c = Or(c), g = g === r ? s < c ? 1 : -1 : Or(g), cg(s, c, g, n);
        };
      }
      function tl(n) {
        return function(s, c) {
          return typeof s == "string" && typeof c == "string" || (s = Ci(s), c = Ci(c)), n(s, c);
        };
      }
      function Vh(n, s, c, g, T, x, z, U, Z, ne) {
        var ie = s & re, ae = ie ? z : r, me = ie ? r : z, Se = ie ? x : r, xe = ie ? r : x;
        s |= ie ? Le : Ce, s &= ~(ie ? Ce : Le), s & Q || (s &= ~(X | le));
        var qe = [
          n,
          s,
          T,
          Se,
          ae,
          xe,
          me,
          U,
          Z,
          ne
        ], De = c.apply(r, qe);
        return Nu(n) && nf(De, qe), De.placeholder = g, rf(De, n, s);
      }
      function Mu(n) {
        var s = Vt[n];
        return function(c, g) {
          if (c = Ci(c), g = g == null ? 0 : $(je(g), 292), g && u(c)) {
            var T = (vt(c) + "e").split("e"), x = s(T[0] + "e" + (+T[1] + g));
            return T = (vt(x) + "e").split("e"), +(T[0] + "e" + (+T[1] - g));
          }
          return s(c);
        };
      }
      var Eg = Kn && 1 / os(new Kn([, -0]))[1] == Kt ? function(n) {
        return new Kn(n);
      } : Ku;
      function Wh(n) {
        return function(s) {
          var c = Sn(s);
          return c == Ke ? Lo(s) : c == kt ? Fr(s) : Xl(s, n(s));
        };
      }
      function Tr(n, s, c, g, T, x, z, U) {
        var Z = s & le;
        if (!Z && typeof n != "function")
          throw new qn(f);
        var ne = g ? g.length : 0;
        if (ne || (s &= ~(Le | Ce), g = T = r), z = z === r ? z : P(je(z), 0), U = U === r ? U : je(U), ne -= T ? T.length : 0, s & Ce) {
          var ie = g, ae = T;
          g = T = r;
        }
        var me = Z ? r : Du(n), Se = [
          n,
          s,
          c,
          g,
          T,
          ie,
          ae,
          x,
          z,
          U
        ];
        if (me && Fg(Se, me), n = Se[0], s = Se[1], c = Se[2], g = Se[3], T = Se[4], U = Se[9] = Se[9] === r ? Z ? 0 : n.length : P(Se[9] - ne, 0), !U && s & (re | ve) && (s &= ~(re | ve)), !s || s == X)
          var xe = Sg(n, s, c);
        else
          s == re || s == ve ? xe = Cg(n, s, U) : (s == Le || s == (X | Le)) && !T.length ? xe = Tg(n, s, c, g) : xe = Xa.apply(r, Se);
        var qe = me ? Th : nf;
        return rf(qe(xe, Se), n, s);
      }
      function jh(n, s, c, g) {
        return n === r || zi(n, wr[c]) && !gt.call(g, c) ? s : n;
      }
      function Gh(n, s, c, g, T, x) {
        return Ft(n) && Ft(s) && (x.set(s, n), qa(n, s, r, Gh, x), x.delete(s)), n;
      }
      function Pg(n) {
        return pa(n) ? r : n;
      }
      function qh(n, s, c, g, T, x) {
        var z = c & D, U = n.length, Z = s.length;
        if (U != Z && !(z && Z > U))
          return !1;
        var ne = x.get(n), ie = x.get(s);
        if (ne && ie)
          return ne == s && ie == n;
        var ae = -1, me = !0, Se = c & B ? new Po() : r;
        for (x.set(n, s), x.set(s, n); ++ae < U; ) {
          var xe = n[ae], qe = s[ae];
          if (g)
            var De = z ? g(qe, xe, ae, s, n, x) : g(xe, qe, ae, n, s, x);
          if (De !== r) {
            if (De)
              continue;
            me = !1;
            break;
          }
          if (Se) {
            if (!Ur(s, function(Xe, nt) {
              if (!On(Se, nt) && (xe === Xe || T(xe, Xe, c, g, x)))
                return Se.push(nt);
            })) {
              me = !1;
              break;
            }
          } else if (!(xe === qe || T(xe, qe, c, g, x))) {
            me = !1;
            break;
          }
        }
        return x.delete(n), x.delete(s), me;
      }
      function Mg(n, s, c, g, T, x, z) {
        switch (c) {
          case tn:
            if (n.byteLength != s.byteLength || n.byteOffset != s.byteOffset)
              return !1;
            n = n.buffer, s = s.buffer;
          case Di:
            return !(n.byteLength != s.byteLength || !x(new fs(n), new fs(s)));
          case en:
          case ft:
          case bt:
            return zi(+n, +s);
          case Jt:
            return n.name == s.name && n.message == s.message;
          case Un:
          case ai:
            return n == s + "";
          case Ke:
            var U = Lo;
          case kt:
            var Z = g & D;
            if (U || (U = os), n.size != s.size && !Z)
              return !1;
            var ne = z.get(n);
            if (ne)
              return ne == s;
            g |= B, z.set(n, s);
            var ie = qh(U(n), U(s), g, T, x, z);
            return z.delete(n), ie;
          case Oi:
            if (er)
              return er.call(n) == er.call(s);
        }
        return !1;
      }
      function Og(n, s, c, g, T, x) {
        var z = c & D, U = Ou(n), Z = U.length, ne = Ou(s), ie = ne.length;
        if (Z != ie && !z)
          return !1;
        for (var ae = Z; ae--; ) {
          var me = U[ae];
          if (!(z ? me in s : gt.call(s, me)))
            return !1;
        }
        var Se = x.get(n), xe = x.get(s);
        if (Se && xe)
          return Se == s && xe == n;
        var qe = !0;
        x.set(n, s), x.set(s, n);
        for (var De = z; ++ae < Z; ) {
          me = U[ae];
          var Xe = n[me], nt = s[me];
          if (g)
            var di = z ? g(nt, Xe, me, s, n, x) : g(Xe, nt, me, n, s, x);
          if (!(di === r ? Xe === nt || T(Xe, nt, c, g, x) : di)) {
            qe = !1;
            break;
          }
          De || (De = me == "constructor");
        }
        if (qe && !De) {
          var In = n.constructor, pi = s.constructor;
          In != pi && "constructor" in n && "constructor" in s && !(typeof In == "function" && In instanceof In && typeof pi == "function" && pi instanceof pi) && (qe = !1);
        }
        return x.delete(n), x.delete(s), qe;
      }
      function Er(n) {
        return $u(ef(n, r, cf), n + "");
      }
      function Ou(n) {
        return ph(n, fn, Au);
      }
      function xu(n) {
        return ph(n, ei, Yh);
      }
      var Du = Wr ? function(n) {
        return Wr.get(n);
      } : Ku;
      function nl(n) {
        for (var s = n.name + "", c = jr[s], g = gt.call(jr, s) ? c.length : 0; g--; ) {
          var T = c[g], x = T.func;
          if (x == null || x == n)
            return T.name;
        }
        return s;
      }
      function gs(n) {
        var s = gt.call(O, "placeholder") ? O : n;
        return s.placeholder;
      }
      function Pe() {
        var n = O.iteratee || qu;
        return n = n === qu ? gh : n, arguments.length ? n(arguments[0], arguments[1]) : n;
      }
      function il(n, s) {
        var c = n.__data__;
        return $g(s) ? c[typeof s == "string" ? "string" : "hash"] : c.map;
      }
      function ku(n) {
        for (var s = fn(n), c = s.length; c--; ) {
          var g = s[c], T = n[g];
          s[c] = [g, T, Xh(T)];
        }
        return s;
      }
      function xo(n, s) {
        var c = eu(n, s);
        return _h(c) ? c : r;
      }
      function xg(n) {
        var s = gt.call(n, Xi), c = n[Xi];
        try {
          n[Xi] = r;
          var g = !0;
        } catch {
        }
        var T = wo.call(n);
        return g && (s ? n[Xi] = c : delete n[Xi]), T;
      }
      var Au = e ? function(n) {
        return n == null ? [] : (n = Lt(n), Ai(e(n), function(s) {
          return ra.call(n, s);
        }));
      } : Ju, Yh = e ? function(n) {
        for (var s = []; n; )
          qi(s, Au(n)), n = Ji(n);
        return s;
      } : Ju, Sn = kn;
      (Oe && Sn(new Oe(new ArrayBuffer(1))) != tn || Ve && Sn(new Ve()) != Ke || bn && Sn(bn.resolve()) != Xt || Kn && Sn(new Kn()) != kt || Qi && Sn(new Qi()) != xi) && (Sn = function(n) {
        var s = kn(n), c = s == $t ? n.constructor : r, g = c ? Do(c) : "";
        if (g)
          switch (g) {
            case su:
              return tn;
            case au:
              return Ke;
            case Ha:
              return Xt;
            case lu:
              return kt;
            case Za:
              return xi;
          }
        return s;
      });
      function Dg(n, s, c) {
        for (var g = -1, T = c.length; ++g < T; ) {
          var x = c[g], z = x.size;
          switch (x.type) {
            case "drop":
              n += z;
              break;
            case "dropRight":
              s -= z;
              break;
            case "take":
              s = $(s, n + z);
              break;
            case "takeRight":
              n = P(n, s - z);
              break;
          }
        }
        return { start: n, end: s };
      }
      function kg(n) {
        var s = n.match(uo);
        return s ? s[1].split(Zo) : [];
      }
      function Kh(n, s, c) {
        s = Jr(s, n);
        for (var g = -1, T = s.length, x = !1; ++g < T; ) {
          var z = ir(s[g]);
          if (!(x = n != null && c(n, z)))
            break;
          n = n[z];
        }
        return x || ++g != T ? x : (T = n == null ? 0 : n.length, !!T && cl(T) && Pr(z, T) && (He(n) || ko(n)));
      }
      function Ag(n) {
        var s = n.length, c = new n.constructor(s);
        return s && typeof n[0] == "string" && gt.call(n, "index") && (c.index = n.index, c.input = n.input), c;
      }
      function Jh(n) {
        return typeof n.constructor == "function" && !fa(n) ? Gr(Ji(n)) : {};
      }
      function Ig(n, s, c) {
        var g = n.constructor;
        switch (s) {
          case Di:
            return Eu(n);
          case en:
          case ft:
            return new g(+n);
          case tn:
            return gg(n, c);
          case nn:
          case vn:
          case hr:
          case rn:
          case yn:
          case un:
          case vi:
          case fr:
          case li:
            return Ah(n, c);
          case Ke:
            return new g();
          case bt:
          case ai:
            return new g(n);
          case Un:
            return vg(n);
          case kt:
            return new g();
          case Oi:
            return yg(n);
        }
      }
      function Ng(n, s) {
        var c = s.length;
        if (!c)
          return n;
        var g = c - 1;
        return s[g] = (c > 1 ? "& " : "") + s[g], s = s.join(c > 2 ? ", " : " "), n.replace(be, `{
/* [wrapped with ` + s + `] */
`);
      }
      function Rg(n) {
        return He(n) || ko(n) || !!(oa && n && n[oa]);
      }
      function Pr(n, s) {
        var c = typeof n;
        return s = s ?? we, !!s && (c == "number" || c != "symbol" && Fi.test(n)) && n > -1 && n % 1 == 0 && n < s;
      }
      function An(n, s, c) {
        if (!Ft(c))
          return !1;
        var g = typeof s;
        return (g == "number" ? Qn(c) && Pr(s, c.length) : g == "string" && s in c) ? zi(c[s], n) : !1;
      }
      function Iu(n, s) {
        if (He(n))
          return !1;
        var c = typeof n;
        return c == "number" || c == "symbol" || c == "boolean" || n == null || fi(n) ? !0 : Ir.test(n) || !zs.test(n) || s != null && n in Lt(s);
      }
      function $g(n) {
        var s = typeof n;
        return s == "string" || s == "number" || s == "symbol" || s == "boolean" ? n !== "__proto__" : n === null;
      }
      function Nu(n) {
        var s = nl(n), c = O[s];
        if (typeof c != "function" || !(s in Je.prototype))
          return !1;
        if (n === c)
          return !0;
        var g = Du(c);
        return !!g && n === g[0];
      }
      function zg(n) {
        return !!na && na in n;
      }
      var Bg = hs ? Mr : Xu;
      function fa(n) {
        var s = n && n.constructor, c = typeof s == "function" && s.prototype || wr;
        return n === c;
      }
      function Xh(n) {
        return n === n && !Ft(n);
      }
      function Qh(n, s) {
        return function(c) {
          return c == null ? !1 : c[n] === s && (s !== r || n in Lt(c));
        };
      }
      function Ug(n) {
        var s = ll(n, function(g) {
          return c.size === v && c.clear(), g;
        }), c = s.cache;
        return s;
      }
      function Fg(n, s) {
        var c = n[1], g = s[1], T = c | g, x = T < (X | le | se), z = g == se && c == re || g == se && c == Me && n[7].length <= s[8] || g == (se | Me) && s[7].length <= s[8] && c == re;
        if (!(x || z))
          return n;
        g & X && (n[2] = s[2], T |= c & X ? 0 : Q);
        var U = s[3];
        if (U) {
          var Z = n[3];
          n[3] = Z ? Nh(Z, U, s[4]) : U, n[4] = Z ? hn(n[3], C) : s[4];
        }
        return U = s[5], U && (Z = n[5], n[5] = Z ? Rh(Z, U, s[6]) : U, n[6] = Z ? hn(n[5], C) : s[6]), U = s[7], U && (n[7] = U), g & se && (n[8] = n[8] == null ? s[8] : $(n[8], s[8])), n[9] == null && (n[9] = s[9]), n[0] = s[0], n[1] = T, n;
      }
      function Hg(n) {
        var s = [];
        if (n != null)
          for (var c in Lt(n))
            s.push(c);
        return s;
      }
      function Zg(n) {
        return wo.call(n);
      }
      function ef(n, s, c) {
        return s = P(s === r ? n.length - 1 : s, 0), function() {
          for (var g = arguments, T = -1, x = P(g.length - s, 0), z = W(x); ++T < x; )
            z[T] = g[s + T];
          T = -1;
          for (var U = W(s + 1); ++T < s; )
            U[T] = g[T];
          return U[s] = c(z), zt(n, this, U);
        };
      }
      function tf(n, s) {
        return s.length < 2 ? n : Oo(n, bi(s, 0, -1));
      }
      function Vg(n, s) {
        for (var c = n.length, g = $(s.length, c), T = Xn(n); g--; ) {
          var x = s[g];
          n[g] = Pr(x, c) ? T[x] : r;
        }
        return n;
      }
      function Ru(n, s) {
        if (!(s === "constructor" && typeof n[s] == "function") && s != "__proto__")
          return n[s];
      }
      var nf = of(Th), da = Fa || function(n, s) {
        return on.setTimeout(n, s);
      }, $u = of(dg);
      function rf(n, s, c) {
        var g = s + "";
        return $u(n, Ng(g, Wg(kg(g), c)));
      }
      function of(n) {
        var s = 0, c = 0;
        return function() {
          var g = V(), T = _n - (g - c);
          if (c = g, T > 0) {
            if (++s >= xt)
              return arguments[0];
          } else
            s = 0;
          return n.apply(r, arguments);
        };
      }
      function rl(n, s) {
        var c = -1, g = n.length, T = g - 1;
        for (s = s === r ? g : s; ++c < s; ) {
          var x = yu(c, T), z = n[x];
          n[x] = n[c], n[c] = z;
        }
        return n.length = s, n;
      }
      var sf = Ug(function(n) {
        var s = [];
        return n.charCodeAt(0) === 46 && s.push(""), n.replace(Nr, function(c, g, T, x) {
          s.push(T ? x.replace(Rr, "$1") : g || c);
        }), s;
      });
      function ir(n) {
        if (typeof n == "string" || fi(n))
          return n;
        var s = n + "";
        return s == "0" && 1 / n == -Kt ? "-0" : s;
      }
      function Do(n) {
        if (n != null) {
          try {
            return Ki.call(n);
          } catch {
          }
          try {
            return n + "";
          } catch {
          }
        }
        return "";
      }
      function Wg(n, s) {
        return Pn(wt, function(c) {
          var g = "_." + c[0];
          s & c[1] && !Qo(n, g) && n.push(g);
        }), n.sort();
      }
      function af(n) {
        if (n instanceof Je)
          return n.clone();
        var s = new Dn(n.__wrapped__, n.__chain__);
        return s.__actions__ = Xn(n.__actions__), s.__index__ = n.__index__, s.__values__ = n.__values__, s;
      }
      function jg(n, s, c) {
        (c ? An(n, s, c) : s === r) ? s = 1 : s = P(je(s), 0);
        var g = n == null ? 0 : n.length;
        if (!g || s < 1)
          return [];
        for (var T = 0, x = 0, z = W(To(g / s)); T < g; )
          z[x++] = bi(n, T, T += s);
        return z;
      }
      function Gg(n) {
        for (var s = -1, c = n == null ? 0 : n.length, g = 0, T = []; ++s < c; ) {
          var x = n[s];
          x && (T[g++] = x);
        }
        return T;
      }
      function qg() {
        var n = arguments.length;
        if (!n)
          return [];
        for (var s = W(n - 1), c = arguments[0], g = n; g--; )
          s[g - 1] = arguments[g];
        return qi(He(c) ? Xn(c) : [c], pn(s, 1));
      }
      var Yg = Ye(function(n, s) {
        return qt(n) ? aa(n, pn(s, 1, qt, !0)) : [];
      }), Kg = Ye(function(n, s) {
        var c = Si(s);
        return qt(c) && (c = r), qt(n) ? aa(n, pn(s, 1, qt, !0), Pe(c, 2)) : [];
      }), Jg = Ye(function(n, s) {
        var c = Si(s);
        return qt(c) && (c = r), qt(n) ? aa(n, pn(s, 1, qt, !0), r, c) : [];
      });
      function Xg(n, s, c) {
        var g = n == null ? 0 : n.length;
        return g ? (s = c || s === r ? 1 : je(s), bi(n, s < 0 ? 0 : s, g)) : [];
      }
      function Qg(n, s, c) {
        var g = n == null ? 0 : n.length;
        return g ? (s = c || s === r ? 1 : je(s), s = g - s, bi(n, 0, s < 0 ? 0 : s)) : [];
      }
      function ev(n, s) {
        return n && n.length ? Ka(n, Pe(s, 3), !0, !0) : [];
      }
      function tv(n, s) {
        return n && n.length ? Ka(n, Pe(s, 3), !0) : [];
      }
      function nv(n, s, c, g) {
        var T = n == null ? 0 : n.length;
        return T ? (c && typeof c != "number" && An(n, s, c) && (c = 0, g = T), q_(n, s, c, g)) : [];
      }
      function lf(n, s, c) {
        var g = n == null ? 0 : n.length;
        if (!g)
          return -1;
        var T = c == null ? 0 : je(c);
        return T < 0 && (T = P(g + T, 0)), go(n, Pe(s, 3), T);
      }
      function uf(n, s, c) {
        var g = n == null ? 0 : n.length;
        if (!g)
          return -1;
        var T = g - 1;
        return c !== r && (T = je(c), T = c < 0 ? P(g + T, 0) : $(T, g - 1)), go(n, Pe(s, 3), T, !0);
      }
      function cf(n) {
        var s = n == null ? 0 : n.length;
        return s ? pn(n, 1) : [];
      }
      function iv(n) {
        var s = n == null ? 0 : n.length;
        return s ? pn(n, Kt) : [];
      }
      function rv(n, s) {
        var c = n == null ? 0 : n.length;
        return c ? (s = s === r ? 1 : je(s), pn(n, s)) : [];
      }
      function ov(n) {
        for (var s = -1, c = n == null ? 0 : n.length, g = {}; ++s < c; ) {
          var T = n[s];
          g[T[0]] = T[1];
        }
        return g;
      }
      function hf(n) {
        return n && n.length ? n[0] : r;
      }
      function sv(n, s, c) {
        var g = n == null ? 0 : n.length;
        if (!g)
          return -1;
        var T = c == null ? 0 : je(c);
        return T < 0 && (T = P(g + T, 0)), vr(n, s, T);
      }
      function av(n) {
        var s = n == null ? 0 : n.length;
        return s ? bi(n, 0, -1) : [];
      }
      var lv = Ye(function(n) {
        var s = Ct(n, Cu);
        return s.length && s[0] === n[0] ? pu(s) : [];
      }), uv = Ye(function(n) {
        var s = Si(n), c = Ct(n, Cu);
        return s === Si(c) ? s = r : c.pop(), c.length && c[0] === n[0] ? pu(c, Pe(s, 2)) : [];
      }), cv = Ye(function(n) {
        var s = Si(n), c = Ct(n, Cu);
        return s = typeof s == "function" ? s : r, s && c.pop(), c.length && c[0] === n[0] ? pu(c, r, s) : [];
      });
      function hv(n, s) {
        return n == null ? "" : p.call(n, s);
      }
      function Si(n) {
        var s = n == null ? 0 : n.length;
        return s ? n[s - 1] : r;
      }
      function fv(n, s, c) {
        var g = n == null ? 0 : n.length;
        if (!g)
          return -1;
        var T = g;
        return c !== r && (T = je(c), T = T < 0 ? P(g + T, 0) : $(T, g - 1)), s === s ? Ii(n, s, T) : go(n, Ks, T, !0);
      }
      function dv(n, s) {
        return n && n.length ? wh(n, je(s)) : r;
      }
      var pv = Ye(ff);
      function ff(n, s) {
        return n && n.length && s && s.length ? vu(n, s) : n;
      }
      function mv(n, s, c) {
        return n && n.length && s && s.length ? vu(n, s, Pe(c, 2)) : n;
      }
      function _v(n, s, c) {
        return n && n.length && s && s.length ? vu(n, s, r, c) : n;
      }
      var gv = Er(function(n, s) {
        var c = n == null ? 0 : n.length, g = cu(n, s);
        return Ch(n, Ct(s, function(T) {
          return Pr(T, c) ? +T : T;
        }).sort(Ih)), g;
      });
      function vv(n, s) {
        var c = [];
        if (!(n && n.length))
          return c;
        var g = -1, T = [], x = n.length;
        for (s = Pe(s, 3); ++g < x; ) {
          var z = n[g];
          s(z, g, n) && (c.push(z), T.push(g));
        }
        return Ch(n, T), c;
      }
      function zu(n) {
        return n == null ? n : ge.call(n);
      }
      function yv(n, s, c) {
        var g = n == null ? 0 : n.length;
        return g ? (c && typeof c != "number" && An(n, s, c) ? (s = 0, c = g) : (s = s == null ? 0 : je(s), c = c === r ? g : je(c)), bi(n, s, c)) : [];
      }
      function Lv(n, s) {
        return Ya(n, s);
      }
      function wv(n, s, c) {
        return wu(n, s, Pe(c, 2));
      }
      function bv(n, s) {
        var c = n == null ? 0 : n.length;
        if (c) {
          var g = Ya(n, s);
          if (g < c && zi(n[g], s))
            return g;
        }
        return -1;
      }
      function Sv(n, s) {
        return Ya(n, s, !0);
      }
      function Cv(n, s, c) {
        return wu(n, s, Pe(c, 2), !0);
      }
      function Tv(n, s) {
        var c = n == null ? 0 : n.length;
        if (c) {
          var g = Ya(n, s, !0) - 1;
          if (zi(n[g], s))
            return g;
        }
        return -1;
      }
      function Ev(n) {
        return n && n.length ? Eh(n) : [];
      }
      function Pv(n, s) {
        return n && n.length ? Eh(n, Pe(s, 2)) : [];
      }
      function Mv(n) {
        var s = n == null ? 0 : n.length;
        return s ? bi(n, 1, s) : [];
      }
      function Ov(n, s, c) {
        return n && n.length ? (s = c || s === r ? 1 : je(s), bi(n, 0, s < 0 ? 0 : s)) : [];
      }
      function xv(n, s, c) {
        var g = n == null ? 0 : n.length;
        return g ? (s = c || s === r ? 1 : je(s), s = g - s, bi(n, s < 0 ? 0 : s, g)) : [];
      }
      function Dv(n, s) {
        return n && n.length ? Ka(n, Pe(s, 3), !1, !0) : [];
      }
      function kv(n, s) {
        return n && n.length ? Ka(n, Pe(s, 3)) : [];
      }
      var Av = Ye(function(n) {
        return Kr(pn(n, 1, qt, !0));
      }), Iv = Ye(function(n) {
        var s = Si(n);
        return qt(s) && (s = r), Kr(pn(n, 1, qt, !0), Pe(s, 2));
      }), Nv = Ye(function(n) {
        var s = Si(n);
        return s = typeof s == "function" ? s : r, Kr(pn(n, 1, qt, !0), r, s);
      });
      function Rv(n) {
        return n && n.length ? Kr(n) : [];
      }
      function $v(n, s) {
        return n && n.length ? Kr(n, Pe(s, 2)) : [];
      }
      function zv(n, s) {
        return s = typeof s == "function" ? s : r, n && n.length ? Kr(n, r, s) : [];
      }
      function Bu(n) {
        if (!(n && n.length))
          return [];
        var s = 0;
        return n = Ai(n, function(c) {
          if (qt(c))
            return s = P(c.length, s), !0;
        }), ns(s, function(c) {
          return Ct(n, Xs(c));
        });
      }
      function df(n, s) {
        if (!(n && n.length))
          return [];
        var c = Bu(n);
        return s == null ? c : Ct(c, function(g) {
          return zt(s, r, g);
        });
      }
      var Bv = Ye(function(n, s) {
        return qt(n) ? aa(n, s) : [];
      }), Uv = Ye(function(n) {
        return Su(Ai(n, qt));
      }), Fv = Ye(function(n) {
        var s = Si(n);
        return qt(s) && (s = r), Su(Ai(n, qt), Pe(s, 2));
      }), Hv = Ye(function(n) {
        var s = Si(n);
        return s = typeof s == "function" ? s : r, Su(Ai(n, qt), r, s);
      }), Zv = Ye(Bu);
      function Vv(n, s) {
        return xh(n || [], s || [], sa);
      }
      function Wv(n, s) {
        return xh(n || [], s || [], ca);
      }
      var jv = Ye(function(n) {
        var s = n.length, c = s > 1 ? n[s - 1] : r;
        return c = typeof c == "function" ? (n.pop(), c) : r, df(n, c);
      });
      function pf(n) {
        var s = O(n);
        return s.__chain__ = !0, s;
      }
      function Gv(n, s) {
        return s(n), n;
      }
      function ol(n, s) {
        return s(n);
      }
      var qv = Er(function(n) {
        var s = n.length, c = s ? n[0] : 0, g = this.__wrapped__, T = function(x) {
          return cu(x, n);
        };
        return s > 1 || this.__actions__.length || !(g instanceof Je) || !Pr(c) ? this.thru(T) : (g = g.slice(c, +c + (s ? 1 : 0)), g.__actions__.push({
          func: ol,
          args: [T],
          thisArg: r
        }), new Dn(g, this.__chain__).thru(function(x) {
          return s && !x.length && x.push(r), x;
        }));
      });
      function Yv() {
        return pf(this);
      }
      function Kv() {
        return new Dn(this.value(), this.__chain__);
      }
      function Jv() {
        this.__values__ === r && (this.__values__ = Mf(this.value()));
        var n = this.__index__ >= this.__values__.length, s = n ? r : this.__values__[this.__index__++];
        return { done: n, value: s };
      }
      function Xv() {
        return this;
      }
      function Qv(n) {
        for (var s, c = this; c instanceof qr; ) {
          var g = af(c);
          g.__index__ = 0, g.__values__ = r, s ? T.__wrapped__ = g : s = g;
          var T = g;
          c = c.__wrapped__;
        }
        return T.__wrapped__ = n, s;
      }
      function ey() {
        var n = this.__wrapped__;
        if (n instanceof Je) {
          var s = n;
          return this.__actions__.length && (s = new Je(this)), s = s.reverse(), s.__actions__.push({
            func: ol,
            args: [zu],
            thisArg: r
          }), new Dn(s, this.__chain__);
        }
        return this.thru(zu);
      }
      function ty() {
        return Oh(this.__wrapped__, this.__actions__);
      }
      var ny = Ja(function(n, s, c) {
        gt.call(n, c) ? ++n[c] : Cr(n, c, 1);
      });
      function iy(n, s, c) {
        var g = He(n) ? qs : G_;
        return c && An(n, s, c) && (s = r), g(n, Pe(s, 3));
      }
      function ry(n, s) {
        var c = He(n) ? Ai : fh;
        return c(n, Pe(s, 3));
      }
      var oy = Uh(lf), sy = Uh(uf);
      function ay(n, s) {
        return pn(sl(n, s), 1);
      }
      function ly(n, s) {
        return pn(sl(n, s), Kt);
      }
      function uy(n, s, c) {
        return c = c === r ? 1 : je(c), pn(sl(n, s), c);
      }
      function mf(n, s) {
        var c = He(n) ? Pn : Yr;
        return c(n, Pe(s, 3));
      }
      function _f(n, s) {
        var c = He(n) ? Gi : hh;
        return c(n, Pe(s, 3));
      }
      var cy = Ja(function(n, s, c) {
        gt.call(n, c) ? n[c].push(s) : Cr(n, c, [s]);
      });
      function hy(n, s, c, g) {
        n = Qn(n) ? n : ys(n), c = c && !g ? je(c) : 0;
        var T = n.length;
        return c < 0 && (c = P(T + c, 0)), hl(n) ? c <= T && n.indexOf(s, c) > -1 : !!T && vr(n, s, c) > -1;
      }
      var fy = Ye(function(n, s, c) {
        var g = -1, T = typeof s == "function", x = Qn(n) ? W(n.length) : [];
        return Yr(n, function(z) {
          x[++g] = T ? zt(s, z, c) : la(z, s, c);
        }), x;
      }), dy = Ja(function(n, s, c) {
        Cr(n, c, s);
      });
      function sl(n, s) {
        var c = He(n) ? Ct : vh;
        return c(n, Pe(s, 3));
      }
      function py(n, s, c, g) {
        return n == null ? [] : (He(s) || (s = s == null ? [] : [s]), c = g ? r : c, He(c) || (c = c == null ? [] : [c]), bh(n, s, c));
      }
      var my = Ja(function(n, s, c) {
        n[c ? 0 : 1].push(s);
      }, function() {
        return [[], []];
      });
      function _y(n, s, c) {
        var g = He(n) ? es : ts, T = arguments.length < 3;
        return g(n, Pe(s, 4), c, T, Yr);
      }
      function gy(n, s, c) {
        var g = He(n) ? Na : ts, T = arguments.length < 3;
        return g(n, Pe(s, 4), c, T, hh);
      }
      function vy(n, s) {
        var c = He(n) ? Ai : fh;
        return c(n, ul(Pe(s, 3)));
      }
      function yy(n) {
        var s = He(n) ? ah : hg;
        return s(n);
      }
      function Ly(n, s, c) {
        (c ? An(n, s, c) : s === r) ? s = 1 : s = je(s);
        var g = He(n) ? H_ : fg;
        return g(n, s);
      }
      function wy(n) {
        var s = He(n) ? Z_ : pg;
        return s(n);
      }
      function by(n) {
        if (n == null)
          return 0;
        if (Qn(n))
          return hl(n) ? Ni(n) : n.length;
        var s = Sn(n);
        return s == Ke || s == kt ? n.size : _u(n).length;
      }
      function Sy(n, s, c) {
        var g = He(n) ? Ur : mg;
        return c && An(n, s, c) && (s = r), g(n, Pe(s, 3));
      }
      var Cy = Ye(function(n, s) {
        if (n == null)
          return [];
        var c = s.length;
        return c > 1 && An(n, s[0], s[1]) ? s = [] : c > 2 && An(s[0], s[1], s[2]) && (s = [s[0]]), bh(n, pn(s, 1), []);
      }), al = ou || function() {
        return on.Date.now();
      };
      function Ty(n, s) {
        if (typeof s != "function")
          throw new qn(f);
        return n = je(n), function() {
          if (--n < 1)
            return s.apply(this, arguments);
        };
      }
      function gf(n, s, c) {
        return s = c ? r : s, s = n && s == null ? n.length : s, Tr(n, se, r, r, r, r, s);
      }
      function vf(n, s) {
        var c;
        if (typeof s != "function")
          throw new qn(f);
        return n = je(n), function() {
          return --n > 0 && (c = s.apply(this, arguments)), n <= 1 && (s = r), c;
        };
      }
      var Uu = Ye(function(n, s, c) {
        var g = X;
        if (c.length) {
          var T = hn(c, gs(Uu));
          g |= Le;
        }
        return Tr(n, g, s, c, T);
      }), yf = Ye(function(n, s, c) {
        var g = X | le;
        if (c.length) {
          var T = hn(c, gs(yf));
          g |= Le;
        }
        return Tr(s, g, n, c, T);
      });
      function Lf(n, s, c) {
        s = c ? r : s;
        var g = Tr(n, re, r, r, r, r, r, s);
        return g.placeholder = Lf.placeholder, g;
      }
      function wf(n, s, c) {
        s = c ? r : s;
        var g = Tr(n, ve, r, r, r, r, r, s);
        return g.placeholder = wf.placeholder, g;
      }
      function bf(n, s, c) {
        var g, T, x, z, U, Z, ne = 0, ie = !1, ae = !1, me = !0;
        if (typeof n != "function")
          throw new qn(f);
        s = Ci(s) || 0, Ft(c) && (ie = !!c.leading, ae = "maxWait" in c, x = ae ? P(Ci(c.maxWait) || 0, s) : x, me = "trailing" in c ? !!c.trailing : me);
        function Se(Yt) {
          var Bi = g, xr = T;
          return g = T = r, ne = Yt, z = n.apply(xr, Bi), z;
        }
        function xe(Yt) {
          return ne = Yt, U = da(Xe, s), ie ? Se(Yt) : z;
        }
        function qe(Yt) {
          var Bi = Yt - Z, xr = Yt - ne, Ff = s - Bi;
          return ae ? $(Ff, x - xr) : Ff;
        }
        function De(Yt) {
          var Bi = Yt - Z, xr = Yt - ne;
          return Z === r || Bi >= s || Bi < 0 || ae && xr >= x;
        }
        function Xe() {
          var Yt = al();
          if (De(Yt))
            return nt(Yt);
          U = da(Xe, qe(Yt));
        }
        function nt(Yt) {
          return U = r, me && g ? Se(Yt) : (g = T = r, z);
        }
        function di() {
          U !== r && Dh(U), ne = 0, g = Z = T = U = r;
        }
        function In() {
          return U === r ? z : nt(al());
        }
        function pi() {
          var Yt = al(), Bi = De(Yt);
          if (g = arguments, T = this, Z = Yt, Bi) {
            if (U === r)
              return xe(Z);
            if (ae)
              return Dh(U), U = da(Xe, s), Se(Z);
          }
          return U === r && (U = da(Xe, s)), z;
        }
        return pi.cancel = di, pi.flush = In, pi;
      }
      var Ey = Ye(function(n, s) {
        return ch(n, 1, s);
      }), Py = Ye(function(n, s, c) {
        return ch(n, Ci(s) || 0, c);
      });
      function My(n) {
        return Tr(n, rt);
      }
      function ll(n, s) {
        if (typeof n != "function" || s != null && typeof s != "function")
          throw new qn(f);
        var c = function() {
          var g = arguments, T = s ? s.apply(this, g) : g[0], x = c.cache;
          if (x.has(T))
            return x.get(T);
          var z = n.apply(this, g);
          return c.cache = x.set(T, z) || x, z;
        };
        return c.cache = new (ll.Cache || Sr)(), c;
      }
      ll.Cache = Sr;
      function ul(n) {
        if (typeof n != "function")
          throw new qn(f);
        return function() {
          var s = arguments;
          switch (s.length) {
            case 0:
              return !n.call(this);
            case 1:
              return !n.call(this, s[0]);
            case 2:
              return !n.call(this, s[0], s[1]);
            case 3:
              return !n.call(this, s[0], s[1], s[2]);
          }
          return !n.apply(this, s);
        };
      }
      function Oy(n) {
        return vf(2, n);
      }
      var xy = _g(function(n, s) {
        s = s.length == 1 && He(s[0]) ? Ct(s[0], Qt(Pe())) : Ct(pn(s, 1), Qt(Pe()));
        var c = s.length;
        return Ye(function(g) {
          for (var T = -1, x = $(g.length, c); ++T < x; )
            g[T] = s[T].call(this, g[T]);
          return zt(n, this, g);
        });
      }), Fu = Ye(function(n, s) {
        var c = hn(s, gs(Fu));
        return Tr(n, Le, r, s, c);
      }), Sf = Ye(function(n, s) {
        var c = hn(s, gs(Sf));
        return Tr(n, Ce, r, s, c);
      }), Dy = Er(function(n, s) {
        return Tr(n, Me, r, r, r, s);
      });
      function ky(n, s) {
        if (typeof n != "function")
          throw new qn(f);
        return s = s === r ? s : je(s), Ye(n, s);
      }
      function Ay(n, s) {
        if (typeof n != "function")
          throw new qn(f);
        return s = s == null ? 0 : P(je(s), 0), Ye(function(c) {
          var g = c[s], T = Xr(c, 0, s);
          return g && qi(T, g), zt(n, this, T);
        });
      }
      function Iy(n, s, c) {
        var g = !0, T = !0;
        if (typeof n != "function")
          throw new qn(f);
        return Ft(c) && (g = "leading" in c ? !!c.leading : g, T = "trailing" in c ? !!c.trailing : T), bf(n, s, {
          leading: g,
          maxWait: s,
          trailing: T
        });
      }
      function Ny(n) {
        return gf(n, 1);
      }
      function Ry(n, s) {
        return Fu(Tu(s), n);
      }
      function $y() {
        if (!arguments.length)
          return [];
        var n = arguments[0];
        return He(n) ? n : [n];
      }
      function zy(n) {
        return wi(n, I);
      }
      function By(n, s) {
        return s = typeof s == "function" ? s : r, wi(n, I, s);
      }
      function Uy(n) {
        return wi(n, M | I);
      }
      function Fy(n, s) {
        return s = typeof s == "function" ? s : r, wi(n, M | I, s);
      }
      function Hy(n, s) {
        return s == null || uh(n, s, fn(s));
      }
      function zi(n, s) {
        return n === s || n !== n && s !== s;
      }
      var Zy = tl(du), Vy = tl(function(n, s) {
        return n >= s;
      }), ko = mh(function() {
        return arguments;
      }()) ? mh : function(n) {
        return Wt(n) && gt.call(n, "callee") && !ra.call(n, "callee");
      }, He = W.isArray, Wy = Da ? Qt(Da) : Q_;
      function Qn(n) {
        return n != null && cl(n.length) && !Mr(n);
      }
      function qt(n) {
        return Wt(n) && Qn(n);
      }
      function jy(n) {
        return n === !0 || n === !1 || Wt(n) && kn(n) == en;
      }
      var Qr = o || Xu, Gy = Gs ? Qt(Gs) : eg;
      function qy(n) {
        return Wt(n) && n.nodeType === 1 && !pa(n);
      }
      function Yy(n) {
        if (n == null)
          return !0;
        if (Qn(n) && (He(n) || typeof n == "string" || typeof n.splice == "function" || Qr(n) || vs(n) || ko(n)))
          return !n.length;
        var s = Sn(n);
        if (s == Ke || s == kt)
          return !n.size;
        if (fa(n))
          return !_u(n).length;
        for (var c in n)
          if (gt.call(n, c))
            return !1;
        return !0;
      }
      function Ky(n, s) {
        return ua(n, s);
      }
      function Jy(n, s, c) {
        c = typeof c == "function" ? c : r;
        var g = c ? c(n, s) : r;
        return g === r ? ua(n, s, r, c) : !!g;
      }
      function Hu(n) {
        if (!Wt(n))
          return !1;
        var s = kn(n);
        return s == Jt || s == Mi || typeof n.message == "string" && typeof n.name == "string" && !pa(n);
      }
      function Xy(n) {
        return typeof n == "number" && u(n);
      }
      function Mr(n) {
        if (!Ft(n))
          return !1;
        var s = kn(n);
        return s == pt || s == jt || s == Tn || s == Ui;
      }
      function Cf(n) {
        return typeof n == "number" && n == je(n);
      }
      function cl(n) {
        return typeof n == "number" && n > -1 && n % 1 == 0 && n <= we;
      }
      function Ft(n) {
        var s = typeof n;
        return n != null && (s == "object" || s == "function");
      }
      function Wt(n) {
        return n != null && typeof n == "object";
      }
      var Tf = ka ? Qt(ka) : ng;
      function Qy(n, s) {
        return n === s || mu(n, s, ku(s));
      }
      function eL(n, s, c) {
        return c = typeof c == "function" ? c : r, mu(n, s, ku(s), c);
      }
      function tL(n) {
        return Ef(n) && n != +n;
      }
      function nL(n) {
        if (Bg(n))
          throw new Ne(l);
        return _h(n);
      }
      function iL(n) {
        return n === null;
      }
      function rL(n) {
        return n == null;
      }
      function Ef(n) {
        return typeof n == "number" || Wt(n) && kn(n) == bt;
      }
      function pa(n) {
        if (!Wt(n) || kn(n) != $t)
          return !1;
        var s = Ji(n);
        if (s === null)
          return !0;
        var c = gt.call(s, "constructor") && s.constructor;
        return typeof c == "function" && c instanceof c && Ki.call(c) == ru;
      }
      var Zu = Aa ? Qt(Aa) : ig;
      function oL(n) {
        return Cf(n) && n >= -we && n <= we;
      }
      var Pf = Xo ? Qt(Xo) : rg;
      function hl(n) {
        return typeof n == "string" || !He(n) && Wt(n) && kn(n) == ai;
      }
      function fi(n) {
        return typeof n == "symbol" || Wt(n) && kn(n) == Oi;
      }
      var vs = Ia ? Qt(Ia) : og;
      function sL(n) {
        return n === r;
      }
      function aL(n) {
        return Wt(n) && Sn(n) == xi;
      }
      function lL(n) {
        return Wt(n) && kn(n) == Hn;
      }
      var uL = tl(gu), cL = tl(function(n, s) {
        return n <= s;
      });
      function Mf(n) {
        if (!n)
          return [];
        if (Qn(n))
          return hl(n) ? jn(n) : Xn(n);
        if (Vr && n[Vr])
          return tu(n[Vr]());
        var s = Sn(n), c = s == Ke ? Lo : s == kt ? os : ys;
        return c(n);
      }
      function Or(n) {
        if (!n)
          return n === 0 ? n : 0;
        if (n = Ci(n), n === Kt || n === -Kt) {
          var s = n < 0 ? -1 : 1;
          return s * gi;
        }
        return n === n ? n : 0;
      }
      function je(n) {
        var s = Or(n), c = s % 1;
        return s === s ? c ? s - c : s : 0;
      }
      function Of(n) {
        return n ? Mo(je(n), 0, Be) : 0;
      }
      function Ci(n) {
        if (typeof n == "number")
          return n;
        if (fi(n))
          return _e;
        if (Ft(n)) {
          var s = typeof n.valueOf == "function" ? n.valueOf() : n;
          n = Ft(s) ? s + "" : s;
        }
        if (typeof n != "string")
          return n === 0 ? n : +n;
        n = Wn(n);
        var c = jo.test(n);
        return c || Us.test(n) ? Gl(n.slice(2), c ? 2 : 8) : Wo.test(n) ? _e : +n;
      }
      function xf(n) {
        return nr(n, ei(n));
      }
      function hL(n) {
        return n ? Mo(je(n), -we, we) : n === 0 ? n : 0;
      }
      function vt(n) {
        return n == null ? "" : hi(n);
      }
      var fL = ms(function(n, s) {
        if (fa(s) || Qn(s)) {
          nr(s, fn(s), n);
          return;
        }
        for (var c in s)
          gt.call(s, c) && sa(n, c, s[c]);
      }), Df = ms(function(n, s) {
        nr(s, ei(s), n);
      }), fl = ms(function(n, s, c, g) {
        nr(s, ei(s), n, g);
      }), dL = ms(function(n, s, c, g) {
        nr(s, fn(s), n, g);
      }), pL = Er(cu);
      function mL(n, s) {
        var c = Gr(n);
        return s == null ? c : lh(c, s);
      }
      var _L = Ye(function(n, s) {
        n = Lt(n);
        var c = -1, g = s.length, T = g > 2 ? s[2] : r;
        for (T && An(s[0], s[1], T) && (g = 1); ++c < g; )
          for (var x = s[c], z = ei(x), U = -1, Z = z.length; ++U < Z; ) {
            var ne = z[U], ie = n[ne];
            (ie === r || zi(ie, wr[ne]) && !gt.call(n, ne)) && (n[ne] = x[ne]);
          }
        return n;
      }), gL = Ye(function(n) {
        return n.push(r, Gh), zt(kf, r, n);
      });
      function vL(n, s) {
        return Mn(n, Pe(s, 3), tr);
      }
      function yL(n, s) {
        return Mn(n, Pe(s, 3), fu);
      }
      function LL(n, s) {
        return n == null ? n : hu(n, Pe(s, 3), ei);
      }
      function wL(n, s) {
        return n == null ? n : dh(n, Pe(s, 3), ei);
      }
      function bL(n, s) {
        return n && tr(n, Pe(s, 3));
      }
      function SL(n, s) {
        return n && fu(n, Pe(s, 3));
      }
      function CL(n) {
        return n == null ? [] : Ga(n, fn(n));
      }
      function TL(n) {
        return n == null ? [] : Ga(n, ei(n));
      }
      function Vu(n, s, c) {
        var g = n == null ? r : Oo(n, s);
        return g === r ? c : g;
      }
      function EL(n, s) {
        return n != null && Kh(n, s, Y_);
      }
      function Wu(n, s) {
        return n != null && Kh(n, s, K_);
      }
      var PL = Hh(function(n, s, c) {
        s != null && typeof s.toString != "function" && (s = wo.call(s)), n[s] = c;
      }, Gu(ti)), ML = Hh(function(n, s, c) {
        s != null && typeof s.toString != "function" && (s = wo.call(s)), gt.call(n, s) ? n[s].push(c) : n[s] = [c];
      }, Pe), OL = Ye(la);
      function fn(n) {
        return Qn(n) ? sh(n) : _u(n);
      }
      function ei(n) {
        return Qn(n) ? sh(n, !0) : sg(n);
      }
      function xL(n, s) {
        var c = {};
        return s = Pe(s, 3), tr(n, function(g, T, x) {
          Cr(c, s(g, T, x), g);
        }), c;
      }
      function DL(n, s) {
        var c = {};
        return s = Pe(s, 3), tr(n, function(g, T, x) {
          Cr(c, T, s(g, T, x));
        }), c;
      }
      var kL = ms(function(n, s, c) {
        qa(n, s, c);
      }), kf = ms(function(n, s, c, g) {
        qa(n, s, c, g);
      }), AL = Er(function(n, s) {
        var c = {};
        if (n == null)
          return c;
        var g = !1;
        s = Ct(s, function(x) {
          return x = Jr(x, n), g || (g = x.length > 1), x;
        }), nr(n, xu(n), c), g && (c = wi(c, M | N | I, Pg));
        for (var T = s.length; T--; )
          bu(c, s[T]);
        return c;
      });
      function IL(n, s) {
        return Af(n, ul(Pe(s)));
      }
      var NL = Er(function(n, s) {
        return n == null ? {} : lg(n, s);
      });
      function Af(n, s) {
        if (n == null)
          return {};
        var c = Ct(xu(n), function(g) {
          return [g];
        });
        return s = Pe(s), Sh(n, c, function(g, T) {
          return s(g, T[0]);
        });
      }
      function RL(n, s, c) {
        s = Jr(s, n);
        var g = -1, T = s.length;
        for (T || (T = 1, n = r); ++g < T; ) {
          var x = n == null ? r : n[ir(s[g])];
          x === r && (g = T, x = c), n = Mr(x) ? x.call(n) : x;
        }
        return n;
      }
      function $L(n, s, c) {
        return n == null ? n : ca(n, s, c);
      }
      function zL(n, s, c, g) {
        return g = typeof g == "function" ? g : r, n == null ? n : ca(n, s, c, g);
      }
      var If = Wh(fn), Nf = Wh(ei);
      function BL(n, s, c) {
        var g = He(n), T = g || Qr(n) || vs(n);
        if (s = Pe(s, 4), c == null) {
          var x = n && n.constructor;
          T ? c = g ? new x() : [] : Ft(n) ? c = Mr(x) ? Gr(Ji(n)) : {} : c = {};
        }
        return (T ? Pn : tr)(n, function(z, U, Z) {
          return s(c, z, U, Z);
        }), c;
      }
      function UL(n, s) {
        return n == null ? !0 : bu(n, s);
      }
      function FL(n, s, c) {
        return n == null ? n : Mh(n, s, Tu(c));
      }
      function HL(n, s, c, g) {
        return g = typeof g == "function" ? g : r, n == null ? n : Mh(n, s, Tu(c), g);
      }
      function ys(n) {
        return n == null ? [] : ea(n, fn(n));
      }
      function ZL(n) {
        return n == null ? [] : ea(n, ei(n));
      }
      function VL(n, s, c) {
        return c === r && (c = s, s = r), c !== r && (c = Ci(c), c = c === c ? c : 0), s !== r && (s = Ci(s), s = s === s ? s : 0), Mo(Ci(n), s, c);
      }
      function WL(n, s, c) {
        return s = Or(s), c === r ? (c = s, s = 0) : c = Or(c), n = Ci(n), J_(n, s, c);
      }
      function jL(n, s, c) {
        if (c && typeof c != "boolean" && An(n, s, c) && (s = c = r), c === r && (typeof s == "boolean" ? (c = s, s = r) : typeof n == "boolean" && (c = n, n = r)), n === r && s === r ? (n = 0, s = 1) : (n = Or(n), s === r ? (s = n, n = 0) : s = Or(s)), n > s) {
          var g = n;
          n = s, s = g;
        }
        if (c || n % 1 || s % 1) {
          var T = oe();
          return $(n + T * (s - n + Zs("1e-" + ((T + "").length - 1))), s);
        }
        return yu(n, s);
      }
      var GL = _s(function(n, s, c) {
        return s = s.toLowerCase(), n + (c ? Rf(s) : s);
      });
      function Rf(n) {
        return ju(vt(n).toLowerCase());
      }
      function $f(n) {
        return n = vt(n), n && n.replace(We, yo).replace(Br, "");
      }
      function qL(n, s, c) {
        n = vt(n), s = hi(s);
        var g = n.length;
        c = c === r ? g : Mo(je(c), 0, g);
        var T = c;
        return c -= s.length, c >= 0 && n.slice(c, T) == s;
      }
      function YL(n) {
        return n = vt(n), n && Fo.test(n) ? n.replace(ki, $a) : n;
      }
      function KL(n) {
        return n = vt(n), n && Bs.test(n) ? n.replace(ao, "\\$&") : n;
      }
      var JL = _s(function(n, s, c) {
        return n + (c ? "-" : "") + s.toLowerCase();
      }), XL = _s(function(n, s, c) {
        return n + (c ? " " : "") + s.toLowerCase();
      }), QL = Bh("toLowerCase");
      function ew(n, s, c) {
        n = vt(n), s = je(s);
        var g = s ? Ni(n) : 0;
        if (!s || g >= s)
          return n;
        var T = (s - g) / 2;
        return el(ps(T), c) + n + el(To(T), c);
      }
      function tw(n, s, c) {
        n = vt(n), s = je(s);
        var g = s ? Ni(n) : 0;
        return s && g < s ? n + el(s - g, c) : n;
      }
      function nw(n, s, c) {
        n = vt(n), s = je(s);
        var g = s ? Ni(n) : 0;
        return s && g < s ? el(s - g, c) + n : n;
      }
      function iw(n, s, c) {
        return c || s == null ? s = 0 : s && (s = +s), j(vt(n).replace(lo, ""), s || 0);
      }
      function rw(n, s, c) {
        return (c ? An(n, s, c) : s === r) ? s = 1 : s = je(s), Lu(vt(n), s);
      }
      function ow() {
        var n = arguments, s = vt(n[0]);
        return n.length < 3 ? s : s.replace(n[1], n[2]);
      }
      var sw = _s(function(n, s, c) {
        return n + (c ? "_" : "") + s.toLowerCase();
      });
      function aw(n, s, c) {
        return c && typeof c != "number" && An(n, s, c) && (s = c = r), c = c === r ? Be : c >>> 0, c ? (n = vt(n), n && (typeof s == "string" || s != null && !Zu(s)) && (s = hi(s), !s && xn(n)) ? Xr(jn(n), 0, c) : n.split(s, c)) : [];
      }
      var lw = _s(function(n, s, c) {
        return n + (c ? " " : "") + ju(s);
      });
      function uw(n, s, c) {
        return n = vt(n), c = c == null ? 0 : Mo(je(c), 0, n.length), s = hi(s), n.slice(c, c + s.length) == s;
      }
      function cw(n, s, c) {
        var g = O.templateSettings;
        c && An(n, s, c) && (s = r), n = vt(n), s = fl({}, s, g, jh);
        var T = fl({}, s.imports, g.imports, jh), x = fn(T), z = ea(T, x), U, Z, ne = 0, ie = s.interpolate || ce, ae = "__p += '", me = Gn(
          (s.escape || ce).source + "|" + ie.source + "|" + (ie === so ? Vo : ce).source + "|" + (s.evaluate || ce).source + "|$",
          "g"
        ), Se = "//# sourceURL=" + (gt.call(s, "sourceURL") ? (s.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++mo + "]") + `
`;
        n.replace(me, function(De, Xe, nt, di, In, pi) {
          return nt || (nt = di), ae += n.slice(ne, pi).replace($r, is), Xe && (U = !0, ae += `' +
__e(` + Xe + `) +
'`), In && (Z = !0, ae += `';
` + In + `;
__p += '`), nt && (ae += `' +
((__t = (` + nt + `)) == null ? '' : __t) +
'`), ne = pi + De.length, De;
        }), ae += `';
`;
        var xe = gt.call(s, "variable") && s.variable;
        if (!xe)
          ae = `with (obj) {
` + ae + `
}
`;
        else if (pr.test(xe))
          throw new Ne(m);
        ae = (Z ? ae.replace(Rs, "") : ae).replace($s, "$1").replace(dr, "$1;"), ae = "function(" + (xe || "obj") + `) {
` + (xe ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (U ? ", __e = _.escape" : "") + (Z ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + ae + `return __p
}`;
        var qe = Bf(function() {
          return lt(x, Se + "return " + ae).apply(r, z);
        });
        if (qe.source = ae, Hu(qe))
          throw qe;
        return qe;
      }
      function hw(n) {
        return vt(n).toLowerCase();
      }
      function fw(n) {
        return vt(n).toUpperCase();
      }
      function dw(n, s, c) {
        if (n = vt(n), n && (c || s === r))
          return Wn(n);
        if (!n || !(s = hi(s)))
          return n;
        var g = jn(n), T = jn(s), x = Ra(g, T), z = yr(g, T) + 1;
        return Xr(g, x, z).join("");
      }
      function pw(n, s, c) {
        if (n = vt(n), n && (c || s === r))
          return n.slice(0, ss(n) + 1);
        if (!n || !(s = hi(s)))
          return n;
        var g = jn(n), T = yr(g, jn(s)) + 1;
        return Xr(g, 0, T).join("");
      }
      function mw(n, s, c) {
        if (n = vt(n), n && (c || s === r))
          return n.replace(lo, "");
        if (!n || !(s = hi(s)))
          return n;
        var g = jn(n), T = Ra(g, jn(s));
        return Xr(g, T).join("");
      }
      function _w(n, s) {
        var c = Et, g = Pt;
        if (Ft(s)) {
          var T = "separator" in s ? s.separator : T;
          c = "length" in s ? je(s.length) : c, g = "omission" in s ? hi(s.omission) : g;
        }
        n = vt(n);
        var x = n.length;
        if (xn(n)) {
          var z = jn(n);
          x = z.length;
        }
        if (c >= x)
          return n;
        var U = c - Ni(g);
        if (U < 1)
          return g;
        var Z = z ? Xr(z, 0, U).join("") : n.slice(0, U);
        if (T === r)
          return Z + g;
        if (z && (U += Z.length - U), Zu(T)) {
          if (n.slice(U).search(T)) {
            var ne, ie = Z;
            for (T.global || (T = Gn(T.source, vt(Li.exec(T)) + "g")), T.lastIndex = 0; ne = T.exec(ie); )
              var ae = ne.index;
            Z = Z.slice(0, ae === r ? U : ae);
          }
        } else if (n.indexOf(hi(T), U) != U) {
          var me = Z.lastIndexOf(T);
          me > -1 && (Z = Z.slice(0, me));
        }
        return Z + g;
      }
      function gw(n) {
        return n = vt(n), n && Uo.test(n) ? n.replace(yi, as) : n;
      }
      var vw = _s(function(n, s, c) {
        return n + (c ? " " : "") + s.toUpperCase();
      }), ju = Bh("toUpperCase");
      function zf(n, s, c) {
        return n = vt(n), s = c ? r : s, s === r ? rs(n) ? Hr(n) : _o(n) : n.match(s) || [];
      }
      var Bf = Ye(function(n, s) {
        try {
          return zt(n, r, s);
        } catch (c) {
          return Hu(c) ? c : new Ne(c);
        }
      }), yw = Er(function(n, s) {
        return Pn(s, function(c) {
          c = ir(c), Cr(n, c, Uu(n[c], n));
        }), n;
      });
      function Lw(n) {
        var s = n == null ? 0 : n.length, c = Pe();
        return n = s ? Ct(n, function(g) {
          if (typeof g[1] != "function")
            throw new qn(f);
          return [c(g[0]), g[1]];
        }) : [], Ye(function(g) {
          for (var T = -1; ++T < s; ) {
            var x = n[T];
            if (zt(x[0], this, g))
              return zt(x[1], this, g);
          }
        });
      }
      function ww(n) {
        return j_(wi(n, M));
      }
      function Gu(n) {
        return function() {
          return n;
        };
      }
      function bw(n, s) {
        return n == null || n !== n ? s : n;
      }
      var Sw = Fh(), Cw = Fh(!0);
      function ti(n) {
        return n;
      }
      function qu(n) {
        return gh(typeof n == "function" ? n : wi(n, M));
      }
      function Tw(n) {
        return yh(wi(n, M));
      }
      function Ew(n, s) {
        return Lh(n, wi(s, M));
      }
      var Pw = Ye(function(n, s) {
        return function(c) {
          return la(c, n, s);
        };
      }), Mw = Ye(function(n, s) {
        return function(c) {
          return la(n, c, s);
        };
      });
      function Yu(n, s, c) {
        var g = fn(s), T = Ga(s, g);
        c == null && !(Ft(s) && (T.length || !g.length)) && (c = s, s = n, n = this, T = Ga(s, fn(s)));
        var x = !(Ft(c) && "chain" in c) || !!c.chain, z = Mr(n);
        return Pn(T, function(U) {
          var Z = s[U];
          n[U] = Z, z && (n.prototype[U] = function() {
            var ne = this.__chain__;
            if (x || ne) {
              var ie = n(this.__wrapped__), ae = ie.__actions__ = Xn(this.__actions__);
              return ae.push({ func: Z, args: arguments, thisArg: n }), ie.__chain__ = ne, ie;
            }
            return Z.apply(n, qi([this.value()], arguments));
          });
        }), n;
      }
      function Ow() {
        return on._ === this && (on._ = Ri), this;
      }
      function Ku() {
      }
      function xw(n) {
        return n = je(n), Ye(function(s) {
          return wh(s, n);
        });
      }
      var Dw = Pu(Ct), kw = Pu(qs), Aw = Pu(Ur);
      function Uf(n) {
        return Iu(n) ? Xs(ir(n)) : ug(n);
      }
      function Iw(n) {
        return function(s) {
          return n == null ? r : Oo(n, s);
        };
      }
      var Nw = Zh(), Rw = Zh(!0);
      function Ju() {
        return [];
      }
      function Xu() {
        return !1;
      }
      function $w() {
        return {};
      }
      function zw() {
        return "";
      }
      function Bw() {
        return !0;
      }
      function Uw(n, s) {
        if (n = je(n), n < 1 || n > we)
          return [];
        var c = Be, g = $(n, Be);
        s = Pe(s), n -= Be;
        for (var T = ns(g, s); ++c < n; )
          s(c);
        return T;
      }
      function Fw(n) {
        return He(n) ? Ct(n, ir) : fi(n) ? [n] : Xn(sf(vt(n)));
      }
      function Hw(n) {
        var s = ++Zr;
        return vt(n) + s;
      }
      var Zw = Qa(function(n, s) {
        return n + s;
      }, 0), Vw = Mu("ceil"), Ww = Qa(function(n, s) {
        return n / s;
      }, 1), jw = Mu("floor");
      function Gw(n) {
        return n && n.length ? ja(n, ti, du) : r;
      }
      function qw(n, s) {
        return n && n.length ? ja(n, Pe(s, 2), du) : r;
      }
      function Yw(n) {
        return Js(n, ti);
      }
      function Kw(n, s) {
        return Js(n, Pe(s, 2));
      }
      function Jw(n) {
        return n && n.length ? ja(n, ti, gu) : r;
      }
      function Xw(n, s) {
        return n && n.length ? ja(n, Pe(s, 2), gu) : r;
      }
      var Qw = Qa(function(n, s) {
        return n * s;
      }, 1), e0 = Mu("round"), t0 = Qa(function(n, s) {
        return n - s;
      }, 0);
      function n0(n) {
        return n && n.length ? Qs(n, ti) : 0;
      }
      function i0(n, s) {
        return n && n.length ? Qs(n, Pe(s, 2)) : 0;
      }
      return O.after = Ty, O.ary = gf, O.assign = fL, O.assignIn = Df, O.assignInWith = fl, O.assignWith = dL, O.at = pL, O.before = vf, O.bind = Uu, O.bindAll = yw, O.bindKey = yf, O.castArray = $y, O.chain = pf, O.chunk = jg, O.compact = Gg, O.concat = qg, O.cond = Lw, O.conforms = ww, O.constant = Gu, O.countBy = ny, O.create = mL, O.curry = Lf, O.curryRight = wf, O.debounce = bf, O.defaults = _L, O.defaultsDeep = gL, O.defer = Ey, O.delay = Py, O.difference = Yg, O.differenceBy = Kg, O.differenceWith = Jg, O.drop = Xg, O.dropRight = Qg, O.dropRightWhile = ev, O.dropWhile = tv, O.fill = nv, O.filter = ry, O.flatMap = ay, O.flatMapDeep = ly, O.flatMapDepth = uy, O.flatten = cf, O.flattenDeep = iv, O.flattenDepth = rv, O.flip = My, O.flow = Sw, O.flowRight = Cw, O.fromPairs = ov, O.functions = CL, O.functionsIn = TL, O.groupBy = cy, O.initial = av, O.intersection = lv, O.intersectionBy = uv, O.intersectionWith = cv, O.invert = PL, O.invertBy = ML, O.invokeMap = fy, O.iteratee = qu, O.keyBy = dy, O.keys = fn, O.keysIn = ei, O.map = sl, O.mapKeys = xL, O.mapValues = DL, O.matches = Tw, O.matchesProperty = Ew, O.memoize = ll, O.merge = kL, O.mergeWith = kf, O.method = Pw, O.methodOf = Mw, O.mixin = Yu, O.negate = ul, O.nthArg = xw, O.omit = AL, O.omitBy = IL, O.once = Oy, O.orderBy = py, O.over = Dw, O.overArgs = xy, O.overEvery = kw, O.overSome = Aw, O.partial = Fu, O.partialRight = Sf, O.partition = my, O.pick = NL, O.pickBy = Af, O.property = Uf, O.propertyOf = Iw, O.pull = pv, O.pullAll = ff, O.pullAllBy = mv, O.pullAllWith = _v, O.pullAt = gv, O.range = Nw, O.rangeRight = Rw, O.rearg = Dy, O.reject = vy, O.remove = vv, O.rest = ky, O.reverse = zu, O.sampleSize = Ly, O.set = $L, O.setWith = zL, O.shuffle = wy, O.slice = yv, O.sortBy = Cy, O.sortedUniq = Ev, O.sortedUniqBy = Pv, O.split = aw, O.spread = Ay, O.tail = Mv, O.take = Ov, O.takeRight = xv, O.takeRightWhile = Dv, O.takeWhile = kv, O.tap = Gv, O.throttle = Iy, O.thru = ol, O.toArray = Mf, O.toPairs = If, O.toPairsIn = Nf, O.toPath = Fw, O.toPlainObject = xf, O.transform = BL, O.unary = Ny, O.union = Av, O.unionBy = Iv, O.unionWith = Nv, O.uniq = Rv, O.uniqBy = $v, O.uniqWith = zv, O.unset = UL, O.unzip = Bu, O.unzipWith = df, O.update = FL, O.updateWith = HL, O.values = ys, O.valuesIn = ZL, O.without = Bv, O.words = zf, O.wrap = Ry, O.xor = Uv, O.xorBy = Fv, O.xorWith = Hv, O.zip = Zv, O.zipObject = Vv, O.zipObjectDeep = Wv, O.zipWith = jv, O.entries = If, O.entriesIn = Nf, O.extend = Df, O.extendWith = fl, Yu(O, O), O.add = Zw, O.attempt = Bf, O.camelCase = GL, O.capitalize = Rf, O.ceil = Vw, O.clamp = VL, O.clone = zy, O.cloneDeep = Uy, O.cloneDeepWith = Fy, O.cloneWith = By, O.conformsTo = Hy, O.deburr = $f, O.defaultTo = bw, O.divide = Ww, O.endsWith = qL, O.eq = zi, O.escape = YL, O.escapeRegExp = KL, O.every = iy, O.find = oy, O.findIndex = lf, O.findKey = vL, O.findLast = sy, O.findLastIndex = uf, O.findLastKey = yL, O.floor = jw, O.forEach = mf, O.forEachRight = _f, O.forIn = LL, O.forInRight = wL, O.forOwn = bL, O.forOwnRight = SL, O.get = Vu, O.gt = Zy, O.gte = Vy, O.has = EL, O.hasIn = Wu, O.head = hf, O.identity = ti, O.includes = hy, O.indexOf = sv, O.inRange = WL, O.invoke = OL, O.isArguments = ko, O.isArray = He, O.isArrayBuffer = Wy, O.isArrayLike = Qn, O.isArrayLikeObject = qt, O.isBoolean = jy, O.isBuffer = Qr, O.isDate = Gy, O.isElement = qy, O.isEmpty = Yy, O.isEqual = Ky, O.isEqualWith = Jy, O.isError = Hu, O.isFinite = Xy, O.isFunction = Mr, O.isInteger = Cf, O.isLength = cl, O.isMap = Tf, O.isMatch = Qy, O.isMatchWith = eL, O.isNaN = tL, O.isNative = nL, O.isNil = rL, O.isNull = iL, O.isNumber = Ef, O.isObject = Ft, O.isObjectLike = Wt, O.isPlainObject = pa, O.isRegExp = Zu, O.isSafeInteger = oL, O.isSet = Pf, O.isString = hl, O.isSymbol = fi, O.isTypedArray = vs, O.isUndefined = sL, O.isWeakMap = aL, O.isWeakSet = lL, O.join = hv, O.kebabCase = JL, O.last = Si, O.lastIndexOf = fv, O.lowerCase = XL, O.lowerFirst = QL, O.lt = uL, O.lte = cL, O.max = Gw, O.maxBy = qw, O.mean = Yw, O.meanBy = Kw, O.min = Jw, O.minBy = Xw, O.stubArray = Ju, O.stubFalse = Xu, O.stubObject = $w, O.stubString = zw, O.stubTrue = Bw, O.multiply = Qw, O.nth = dv, O.noConflict = Ow, O.noop = Ku, O.now = al, O.pad = ew, O.padEnd = tw, O.padStart = nw, O.parseInt = iw, O.random = jL, O.reduce = _y, O.reduceRight = gy, O.repeat = rw, O.replace = ow, O.result = RL, O.round = e0, O.runInContext = H, O.sample = yy, O.size = by, O.snakeCase = sw, O.some = Sy, O.sortedIndex = Lv, O.sortedIndexBy = wv, O.sortedIndexOf = bv, O.sortedLastIndex = Sv, O.sortedLastIndexBy = Cv, O.sortedLastIndexOf = Tv, O.startCase = lw, O.startsWith = uw, O.subtract = t0, O.sum = n0, O.sumBy = i0, O.template = cw, O.times = Uw, O.toFinite = Or, O.toInteger = je, O.toLength = Of, O.toLower = hw, O.toNumber = Ci, O.toSafeInteger = hL, O.toString = vt, O.toUpper = fw, O.trim = dw, O.trimEnd = pw, O.trimStart = mw, O.truncate = _w, O.unescape = gw, O.uniqueId = Hw, O.upperCase = vw, O.upperFirst = ju, O.each = mf, O.eachRight = _f, O.first = hf, Yu(O, function() {
        var n = {};
        return tr(O, function(s, c) {
          gt.call(O.prototype, c) || (n[c] = s);
        }), n;
      }(), { chain: !1 }), O.VERSION = h, Pn(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(n) {
        O[n].placeholder = O;
      }), Pn(["drop", "take"], function(n, s) {
        Je.prototype[n] = function(c) {
          c = c === r ? 1 : P(je(c), 0);
          var g = this.__filtered__ && !s ? new Je(this) : this.clone();
          return g.__filtered__ ? g.__takeCount__ = $(c, g.__takeCount__) : g.__views__.push({
            size: $(c, Be),
            type: n + (g.__dir__ < 0 ? "Right" : "")
          }), g;
        }, Je.prototype[n + "Right"] = function(c) {
          return this.reverse()[n](c).reverse();
        };
      }), Pn(["filter", "map", "takeWhile"], function(n, s) {
        var c = s + 1, g = c == Dt || c == It;
        Je.prototype[n] = function(T) {
          var x = this.clone();
          return x.__iteratees__.push({
            iteratee: Pe(T, 3),
            type: c
          }), x.__filtered__ = x.__filtered__ || g, x;
        };
      }), Pn(["head", "last"], function(n, s) {
        var c = "take" + (s ? "Right" : "");
        Je.prototype[n] = function() {
          return this[c](1).value()[0];
        };
      }), Pn(["initial", "tail"], function(n, s) {
        var c = "drop" + (s ? "" : "Right");
        Je.prototype[n] = function() {
          return this.__filtered__ ? new Je(this) : this[c](1);
        };
      }), Je.prototype.compact = function() {
        return this.filter(ti);
      }, Je.prototype.find = function(n) {
        return this.filter(n).head();
      }, Je.prototype.findLast = function(n) {
        return this.reverse().find(n);
      }, Je.prototype.invokeMap = Ye(function(n, s) {
        return typeof n == "function" ? new Je(this) : this.map(function(c) {
          return la(c, n, s);
        });
      }), Je.prototype.reject = function(n) {
        return this.filter(ul(Pe(n)));
      }, Je.prototype.slice = function(n, s) {
        n = je(n);
        var c = this;
        return c.__filtered__ && (n > 0 || s < 0) ? new Je(c) : (n < 0 ? c = c.takeRight(-n) : n && (c = c.drop(n)), s !== r && (s = je(s), c = s < 0 ? c.dropRight(-s) : c.take(s - n)), c);
      }, Je.prototype.takeRightWhile = function(n) {
        return this.reverse().takeWhile(n).reverse();
      }, Je.prototype.toArray = function() {
        return this.take(Be);
      }, tr(Je.prototype, function(n, s) {
        var c = /^(?:filter|find|map|reject)|While$/.test(s), g = /^(?:head|last)$/.test(s), T = O[g ? "take" + (s == "last" ? "Right" : "") : s], x = g || /^find/.test(s);
        T && (O.prototype[s] = function() {
          var z = this.__wrapped__, U = g ? [1] : arguments, Z = z instanceof Je, ne = U[0], ie = Z || He(z), ae = function(Xe) {
            var nt = T.apply(O, qi([Xe], U));
            return g && me ? nt[0] : nt;
          };
          ie && c && typeof ne == "function" && ne.length != 1 && (Z = ie = !1);
          var me = this.__chain__, Se = !!this.__actions__.length, xe = x && !me, qe = Z && !Se;
          if (!x && ie) {
            z = qe ? z : new Je(this);
            var De = n.apply(z, U);
            return De.__actions__.push({ func: ol, args: [ae], thisArg: r }), new Dn(De, me);
          }
          return xe && qe ? n.apply(this, U) : (De = this.thru(ae), xe ? g ? De.value()[0] : De.value() : De);
        });
      }), Pn(["pop", "push", "shift", "sort", "splice", "unshift"], function(n) {
        var s = Lr[n], c = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru", g = /^(?:pop|shift)$/.test(n);
        O.prototype[n] = function() {
          var T = arguments;
          if (g && !this.__chain__) {
            var x = this.value();
            return s.apply(He(x) ? x : [], T);
          }
          return this[c](function(z) {
            return s.apply(He(z) ? z : [], T);
          });
        };
      }), tr(Je.prototype, function(n, s) {
        var c = O[s];
        if (c) {
          var g = c.name + "";
          gt.call(jr, g) || (jr[g] = []), jr[g].push({ name: s, func: c });
        }
      }), jr[Xa(r, le).name] = [{
        name: "wrapper",
        func: r
      }], Je.prototype.clone = g_, Je.prototype.reverse = v_, Je.prototype.value = y_, O.prototype.at = qv, O.prototype.chain = Yv, O.prototype.commit = Kv, O.prototype.next = Jv, O.prototype.plant = Qv, O.prototype.reverse = ey, O.prototype.toJSON = O.prototype.valueOf = O.prototype.value = ty, O.prototype.first = O.prototype.head, Vr && (O.prototype[Vr] = Xv), O;
    }, Yi = us();
    ci ? ((ci.exports = Yi)._ = Yi, En._ = Yi) : on._ = Yi;
  }).call(ws);
})(S0, dt);
const ii = {
  button: "Button",
  control: "Control",
  layout: "Layout",
  tabs: "Tabs",
  text: "Text",
  watcher: "Watcher"
}, Hf = {
  horizontal: "Horizontal",
  vertical: "Vertical"
}, dl = {
  alert: "Alert",
  description: "Description",
  headline: "Headline",
  label: "Label"
}, Zf = {
  mapSelect: "MapSelect",
  submit: "Submit"
}, Nn = {
  arrayStrings: "ArrayStrings",
  checkbox: "Checkbox",
  date: "Date",
  editor: "Editor",
  mapDraw: "MapDraw",
  number: "Number",
  radio: "Radio",
  select: "Select",
  selectRemote: "SelectRemote",
  selectSearch: "SelectSearch",
  selectTree: "SelectTree",
  string: "String",
  switch: "Switch",
  textarea: "Textarea",
  time: "Time"
}, C0 = {
  and: "and",
  or: "or"
}, pl = {
  equal: "equal",
  notEqual: "notEqual",
  less: "less",
  greater: "greater"
}, Sa = he({
  props: {
    modelValue: {
      type: Object,
      required: !0
    },
    schema: {
      type: Object,
      required: !0
    },
    locale: {
      type: String,
      required: !0
    }
  },
  computed: {
    isShown() {
      var t, i;
      if (((i = (t = this.schema.properties) == null ? void 0 : t.conditions) == null ? void 0 : i.length) > 0) {
        const { conditions: r, logicalCondition: h } = this.schema.properties;
        return h === C0.and ? r.every(this.checkOperator) : r.some(this.checkOperator);
      }
      return !0;
    }
  },
  methods: {
    checkOperator({ scope: t, operator: i, value: r }) {
      return i ? i === pl.equal ? dt.get(this.modelValue, t) === r : i === pl.notEqual ? dt.get(this.modelValue, t) !== r : dt.isNumber(r) && i === pl.less ? dt.get(this.modelValue, t) < r : dt.isNumber(r) && i === pl.greater ? dt.get(this.modelValue, t) > r : null : Boolean(dt.get(this.modelValue, t));
    }
  }
}), T0 = "_component_1ezca_1", E0 = "_component__slot_1ezca_12", P0 = {
  component: T0,
  component__slot: E0
}, M0 = {};
function O0(t, i) {
  return pe(), Tt("div", {
    class: Ze(t.$style.component)
  }, [
    ri(t.$slots, "default", {
      className: t.$style.component__slot
    })
  ], 2);
}
const x0 = {
  $style: P0
}, D0 = /* @__PURE__ */ Re(M0, [["render", O0], ["__cssModules", x0]]), k0 = "_component_1lm9k_1", A0 = {
  component: k0
}, I0 = {};
function N0(t, i) {
  return pe(), Tt("div", {
    class: Ze(t.$style.component)
  }, [
    ri(t.$slots, "default")
  ], 2);
}
const R0 = {
  $style: A0
}, $0 = /* @__PURE__ */ Re(I0, [["render", N0], ["__cssModules", R0]]);
var Pl = {}, z0 = {
  get exports() {
    return Pl;
  },
  set exports(t) {
    Pl = t;
  }
};
/* @preserve
 * Leaflet 1.9.3, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2022 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */
(function(t, i) {
  (function(r, h) {
    h(i);
  })(ws, function(r) {
    var h = "1.9.3";
    function a(e) {
      var o, u, p, b;
      for (u = 1, p = arguments.length; u < p; u++) {
        b = arguments[u];
        for (o in b)
          e[o] = b[o];
      }
      return e;
    }
    var l = Object.create || function() {
      function e() {
      }
      return function(o) {
        return e.prototype = o, new e();
      };
    }();
    function f(e, o) {
      var u = Array.prototype.slice;
      if (e.bind)
        return e.bind.apply(e, u.call(arguments, 1));
      var p = u.call(arguments, 2);
      return function() {
        return e.apply(o, p.length ? p.concat(u.call(arguments)) : arguments);
      };
    }
    var m = 0;
    function y(e) {
      return "_leaflet_id" in e || (e._leaflet_id = ++m), e._leaflet_id;
    }
    function v(e, o, u) {
      var p, b, P, $;
      return $ = function() {
        p = !1, b && (P.apply(u, b), b = !1);
      }, P = function() {
        p ? b = arguments : (e.apply(u, arguments), setTimeout($, o), p = !0);
      }, P;
    }
    function C(e, o, u) {
      var p = o[1], b = o[0], P = p - b;
      return e === p && u ? e : ((e - b) % P + P) % P + b;
    }
    function M() {
      return !1;
    }
    function N(e, o) {
      if (o === !1)
        return e;
      var u = Math.pow(10, o === void 0 ? 6 : o);
      return Math.round(e * u) / u;
    }
    function I(e) {
      return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
    }
    function D(e) {
      return I(e).split(/\s+/);
    }
    function B(e, o) {
      Object.prototype.hasOwnProperty.call(e, "options") || (e.options = e.options ? l(e.options) : {});
      for (var u in o)
        e.options[u] = o[u];
      return e.options;
    }
    function X(e, o, u) {
      var p = [];
      for (var b in e)
        p.push(encodeURIComponent(u ? b.toUpperCase() : b) + "=" + encodeURIComponent(e[b]));
      return (!o || o.indexOf("?") === -1 ? "?" : "&") + p.join("&");
    }
    var le = /\{ *([\w_ -]+) *\}/g;
    function Q(e, o) {
      return e.replace(le, function(u, p) {
        var b = o[p];
        if (b === void 0)
          throw new Error("No value provided for variable " + u);
        return typeof b == "function" && (b = b(o)), b;
      });
    }
    var re = Array.isArray || function(e) {
      return Object.prototype.toString.call(e) === "[object Array]";
    };
    function ve(e, o) {
      for (var u = 0; u < e.length; u++)
        if (e[u] === o)
          return u;
      return -1;
    }
    var Le = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
    function Ce(e) {
      return window["webkit" + e] || window["moz" + e] || window["ms" + e];
    }
    var se = 0;
    function Me(e) {
      var o = +new Date(), u = Math.max(0, 16 - (o - se));
      return se = o + u, window.setTimeout(e, u);
    }
    var rt = window.requestAnimationFrame || Ce("RequestAnimationFrame") || Me, Et = window.cancelAnimationFrame || Ce("CancelAnimationFrame") || Ce("CancelRequestAnimationFrame") || function(e) {
      window.clearTimeout(e);
    };
    function Pt(e, o, u) {
      if (u && rt === Me)
        e.call(o);
      else
        return rt.call(window, f(e, o));
    }
    function xt(e) {
      e && Et.call(window, e);
    }
    var _n = {
      __proto__: null,
      extend: a,
      create: l,
      bind: f,
      get lastId() {
        return m;
      },
      stamp: y,
      throttle: v,
      wrapNum: C,
      falseFn: M,
      formatNum: N,
      trim: I,
      splitWords: D,
      setOptions: B,
      getParamString: X,
      template: Q,
      isArray: re,
      indexOf: ve,
      emptyImageUrl: Le,
      requestFn: rt,
      cancelFn: Et,
      requestAnimFrame: Pt,
      cancelAnimFrame: xt
    };
    function Dt() {
    }
    Dt.extend = function(e) {
      var o = function() {
        B(this), this.initialize && this.initialize.apply(this, arguments), this.callInitHooks();
      }, u = o.__super__ = this.prototype, p = l(u);
      p.constructor = o, o.prototype = p;
      for (var b in this)
        Object.prototype.hasOwnProperty.call(this, b) && b !== "prototype" && b !== "__super__" && (o[b] = this[b]);
      return e.statics && a(o, e.statics), e.includes && (gn(e.includes), a.apply(null, [p].concat(e.includes))), a(p, e), delete p.statics, delete p.includes, p.options && (p.options = u.options ? l(u.options) : {}, a(p.options, e.options)), p._initHooks = [], p.callInitHooks = function() {
        if (!this._initHooksCalled) {
          u.callInitHooks && u.callInitHooks.call(this), this._initHooksCalled = !0;
          for (var P = 0, $ = p._initHooks.length; P < $; P++)
            p._initHooks[P].call(this);
        }
      }, o;
    }, Dt.include = function(e) {
      var o = this.prototype.options;
      return a(this.prototype, e), e.options && (this.prototype.options = o, this.mergeOptions(e.options)), this;
    }, Dt.mergeOptions = function(e) {
      return a(this.prototype.options, e), this;
    }, Dt.addInitHook = function(e) {
      var o = Array.prototype.slice.call(arguments, 1), u = typeof e == "function" ? e : function() {
        this[e].apply(this, o);
      };
      return this.prototype._initHooks = this.prototype._initHooks || [], this.prototype._initHooks.push(u), this;
    };
    function gn(e) {
      if (!(typeof L > "u" || !L || !L.Mixin)) {
        e = re(e) ? e : [e];
        for (var o = 0; o < e.length; o++)
          e[o] === L.Mixin.Events && console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
      }
    }
    var It = {
      on: function(e, o, u) {
        if (typeof e == "object")
          for (var p in e)
            this._on(p, e[p], o);
        else {
          e = D(e);
          for (var b = 0, P = e.length; b < P; b++)
            this._on(e[b], o, u);
        }
        return this;
      },
      off: function(e, o, u) {
        if (!arguments.length)
          delete this._events;
        else if (typeof e == "object")
          for (var p in e)
            this._off(p, e[p], o);
        else {
          e = D(e);
          for (var b = arguments.length === 1, P = 0, $ = e.length; P < $; P++)
            b ? this._off(e[P]) : this._off(e[P], o, u);
        }
        return this;
      },
      _on: function(e, o, u, p) {
        if (typeof o != "function") {
          console.warn("wrong listener type: " + typeof o);
          return;
        }
        if (this._listens(e, o, u) === !1) {
          u === this && (u = void 0);
          var b = { fn: o, ctx: u };
          p && (b.once = !0), this._events = this._events || {}, this._events[e] = this._events[e] || [], this._events[e].push(b);
        }
      },
      _off: function(e, o, u) {
        var p, b, P;
        if (this._events && (p = this._events[e], !!p)) {
          if (arguments.length === 1) {
            if (this._firingCount)
              for (b = 0, P = p.length; b < P; b++)
                p[b].fn = M;
            delete this._events[e];
            return;
          }
          if (typeof o != "function") {
            console.warn("wrong listener type: " + typeof o);
            return;
          }
          var $ = this._listens(e, o, u);
          if ($ !== !1) {
            var V = p[$];
            this._firingCount && (V.fn = M, this._events[e] = p = p.slice()), p.splice($, 1);
          }
        }
      },
      fire: function(e, o, u) {
        if (!this.listens(e, u))
          return this;
        var p = a({}, o, {
          type: e,
          target: this,
          sourceTarget: o && o.sourceTarget || this
        });
        if (this._events) {
          var b = this._events[e];
          if (b) {
            this._firingCount = this._firingCount + 1 || 1;
            for (var P = 0, $ = b.length; P < $; P++) {
              var V = b[P], j = V.fn;
              V.once && this.off(e, j, V.ctx), j.call(V.ctx || this, p);
            }
            this._firingCount--;
          }
        }
        return u && this._propagateEvent(p), this;
      },
      listens: function(e, o, u, p) {
        typeof e != "string" && console.warn('"string" type argument expected');
        var b = o;
        typeof o != "function" && (p = !!o, b = void 0, u = void 0);
        var P = this._events && this._events[e];
        if (P && P.length && this._listens(e, b, u) !== !1)
          return !0;
        if (p) {
          for (var $ in this._eventParents)
            if (this._eventParents[$].listens(e, o, u, p))
              return !0;
        }
        return !1;
      },
      _listens: function(e, o, u) {
        if (!this._events)
          return !1;
        var p = this._events[e] || [];
        if (!o)
          return !!p.length;
        u === this && (u = void 0);
        for (var b = 0, P = p.length; b < P; b++)
          if (p[b].fn === o && p[b].ctx === u)
            return b;
        return !1;
      },
      once: function(e, o, u) {
        if (typeof e == "object")
          for (var p in e)
            this._on(p, e[p], o, !0);
        else {
          e = D(e);
          for (var b = 0, P = e.length; b < P; b++)
            this._on(e[b], o, u, !0);
        }
        return this;
      },
      addEventParent: function(e) {
        return this._eventParents = this._eventParents || {}, this._eventParents[y(e)] = e, this;
      },
      removeEventParent: function(e) {
        return this._eventParents && delete this._eventParents[y(e)], this;
      },
      _propagateEvent: function(e) {
        for (var o in this._eventParents)
          this._eventParents[o].fire(e.type, a({
            layer: e.target,
            propagatedFrom: e.target
          }, e), !0);
      }
    };
    It.addEventListener = It.on, It.removeEventListener = It.clearAllEventListeners = It.off, It.addOneTimeEventListener = It.once, It.fireEvent = It.fire, It.hasEventListeners = It.listens;
    var Kt = Dt.extend(It);
    function we(e, o, u) {
      this.x = u ? Math.round(e) : e, this.y = u ? Math.round(o) : o;
    }
    var gi = Math.trunc || function(e) {
      return e > 0 ? Math.floor(e) : Math.ceil(e);
    };
    we.prototype = {
      clone: function() {
        return new we(this.x, this.y);
      },
      add: function(e) {
        return this.clone()._add(_e(e));
      },
      _add: function(e) {
        return this.x += e.x, this.y += e.y, this;
      },
      subtract: function(e) {
        return this.clone()._subtract(_e(e));
      },
      _subtract: function(e) {
        return this.x -= e.x, this.y -= e.y, this;
      },
      divideBy: function(e) {
        return this.clone()._divideBy(e);
      },
      _divideBy: function(e) {
        return this.x /= e, this.y /= e, this;
      },
      multiplyBy: function(e) {
        return this.clone()._multiplyBy(e);
      },
      _multiplyBy: function(e) {
        return this.x *= e, this.y *= e, this;
      },
      scaleBy: function(e) {
        return new we(this.x * e.x, this.y * e.y);
      },
      unscaleBy: function(e) {
        return new we(this.x / e.x, this.y / e.y);
      },
      round: function() {
        return this.clone()._round();
      },
      _round: function() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
      },
      floor: function() {
        return this.clone()._floor();
      },
      _floor: function() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
      },
      ceil: function() {
        return this.clone()._ceil();
      },
      _ceil: function() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
      },
      trunc: function() {
        return this.clone()._trunc();
      },
      _trunc: function() {
        return this.x = gi(this.x), this.y = gi(this.y), this;
      },
      distanceTo: function(e) {
        e = _e(e);
        var o = e.x - this.x, u = e.y - this.y;
        return Math.sqrt(o * o + u * u);
      },
      equals: function(e) {
        return e = _e(e), e.x === this.x && e.y === this.y;
      },
      contains: function(e) {
        return e = _e(e), Math.abs(e.x) <= Math.abs(this.x) && Math.abs(e.y) <= Math.abs(this.y);
      },
      toString: function() {
        return "Point(" + N(this.x) + ", " + N(this.y) + ")";
      }
    };
    function _e(e, o, u) {
      return e instanceof we ? e : re(e) ? new we(e[0], e[1]) : e == null ? e : typeof e == "object" && "x" in e && "y" in e ? new we(e.x, e.y) : new we(e, o, u);
    }
    function Be(e, o) {
      if (e)
        for (var u = o ? [e, o] : e, p = 0, b = u.length; p < b; p++)
          this.extend(u[p]);
    }
    Be.prototype = {
      extend: function(e) {
        var o, u;
        if (!e)
          return this;
        if (e instanceof we || typeof e[0] == "number" || "x" in e)
          o = u = _e(e);
        else if (e = Nt(e), o = e.min, u = e.max, !o || !u)
          return this;
        return !this.min && !this.max ? (this.min = o.clone(), this.max = u.clone()) : (this.min.x = Math.min(o.x, this.min.x), this.max.x = Math.max(u.x, this.max.x), this.min.y = Math.min(o.y, this.min.y), this.max.y = Math.max(u.y, this.max.y)), this;
      },
      getCenter: function(e) {
        return _e(
          (this.min.x + this.max.x) / 2,
          (this.min.y + this.max.y) / 2,
          e
        );
      },
      getBottomLeft: function() {
        return _e(this.min.x, this.max.y);
      },
      getTopRight: function() {
        return _e(this.max.x, this.min.y);
      },
      getTopLeft: function() {
        return this.min;
      },
      getBottomRight: function() {
        return this.max;
      },
      getSize: function() {
        return this.max.subtract(this.min);
      },
      contains: function(e) {
        var o, u;
        return typeof e[0] == "number" || e instanceof we ? e = _e(e) : e = Nt(e), e instanceof Be ? (o = e.min, u = e.max) : o = u = e, o.x >= this.min.x && u.x <= this.max.x && o.y >= this.min.y && u.y <= this.max.y;
      },
      intersects: function(e) {
        e = Nt(e);
        var o = this.min, u = this.max, p = e.min, b = e.max, P = b.x >= o.x && p.x <= u.x, $ = b.y >= o.y && p.y <= u.y;
        return P && $;
      },
      overlaps: function(e) {
        e = Nt(e);
        var o = this.min, u = this.max, p = e.min, b = e.max, P = b.x > o.x && p.x < u.x, $ = b.y > o.y && p.y < u.y;
        return P && $;
      },
      isValid: function() {
        return !!(this.min && this.max);
      },
      pad: function(e) {
        var o = this.min, u = this.max, p = Math.abs(o.x - u.x) * e, b = Math.abs(o.y - u.y) * e;
        return Nt(
          _e(o.x - p, o.y - b),
          _e(u.x + p, u.y + b)
        );
      },
      equals: function(e) {
        return e ? (e = Nt(e), this.min.equals(e.getTopLeft()) && this.max.equals(e.getBottomRight())) : !1;
      }
    };
    function Nt(e, o) {
      return !e || e instanceof Be ? e : new Be(e, o);
    }
    function Ht(e, o) {
      if (e)
        for (var u = o ? [e, o] : e, p = 0, b = u.length; p < b; p++)
          this.extend(u[p]);
    }
    Ht.prototype = {
      extend: function(e) {
        var o = this._southWest, u = this._northEast, p, b;
        if (e instanceof $e)
          p = e, b = e;
        else if (e instanceof Ht) {
          if (p = e._southWest, b = e._northEast, !p || !b)
            return this;
        } else
          return e ? this.extend(ot(e) || wt(e)) : this;
        return !o && !u ? (this._southWest = new $e(p.lat, p.lng), this._northEast = new $e(b.lat, b.lng)) : (o.lat = Math.min(p.lat, o.lat), o.lng = Math.min(p.lng, o.lng), u.lat = Math.max(b.lat, u.lat), u.lng = Math.max(b.lng, u.lng)), this;
      },
      pad: function(e) {
        var o = this._southWest, u = this._northEast, p = Math.abs(o.lat - u.lat) * e, b = Math.abs(o.lng - u.lng) * e;
        return new Ht(
          new $e(o.lat - p, o.lng - b),
          new $e(u.lat + p, u.lng + b)
        );
      },
      getCenter: function() {
        return new $e(
          (this._southWest.lat + this._northEast.lat) / 2,
          (this._southWest.lng + this._northEast.lng) / 2
        );
      },
      getSouthWest: function() {
        return this._southWest;
      },
      getNorthEast: function() {
        return this._northEast;
      },
      getNorthWest: function() {
        return new $e(this.getNorth(), this.getWest());
      },
      getSouthEast: function() {
        return new $e(this.getSouth(), this.getEast());
      },
      getWest: function() {
        return this._southWest.lng;
      },
      getSouth: function() {
        return this._southWest.lat;
      },
      getEast: function() {
        return this._northEast.lng;
      },
      getNorth: function() {
        return this._northEast.lat;
      },
      contains: function(e) {
        typeof e[0] == "number" || e instanceof $e || "lat" in e ? e = ot(e) : e = wt(e);
        var o = this._southWest, u = this._northEast, p, b;
        return e instanceof Ht ? (p = e.getSouthWest(), b = e.getNorthEast()) : p = b = e, p.lat >= o.lat && b.lat <= u.lat && p.lng >= o.lng && b.lng <= u.lng;
      },
      intersects: function(e) {
        e = wt(e);
        var o = this._southWest, u = this._northEast, p = e.getSouthWest(), b = e.getNorthEast(), P = b.lat >= o.lat && p.lat <= u.lat, $ = b.lng >= o.lng && p.lng <= u.lng;
        return P && $;
      },
      overlaps: function(e) {
        e = wt(e);
        var o = this._southWest, u = this._northEast, p = e.getSouthWest(), b = e.getNorthEast(), P = b.lat > o.lat && p.lat < u.lat, $ = b.lng > o.lng && p.lng < u.lng;
        return P && $;
      },
      toBBoxString: function() {
        return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(",");
      },
      equals: function(e, o) {
        return e ? (e = wt(e), this._southWest.equals(e.getSouthWest(), o) && this._northEast.equals(e.getNorthEast(), o)) : !1;
      },
      isValid: function() {
        return !!(this._southWest && this._northEast);
      }
    };
    function wt(e, o) {
      return e instanceof Ht ? e : new Ht(e, o);
    }
    function $e(e, o, u) {
      if (isNaN(e) || isNaN(o))
        throw new Error("Invalid LatLng object: (" + e + ", " + o + ")");
      this.lat = +e, this.lng = +o, u !== void 0 && (this.alt = +u);
    }
    $e.prototype = {
      equals: function(e, o) {
        if (!e)
          return !1;
        e = ot(e);
        var u = Math.max(
          Math.abs(this.lat - e.lat),
          Math.abs(this.lng - e.lng)
        );
        return u <= (o === void 0 ? 1e-9 : o);
      },
      toString: function(e) {
        return "LatLng(" + N(this.lat, e) + ", " + N(this.lng, e) + ")";
      },
      distanceTo: function(e) {
        return en.distance(this, ot(e));
      },
      wrap: function() {
        return en.wrapLatLng(this);
      },
      toBounds: function(e) {
        var o = 180 * e / 40075017, u = o / Math.cos(Math.PI / 180 * this.lat);
        return wt(
          [this.lat - o, this.lng - u],
          [this.lat + o, this.lng + u]
        );
      },
      clone: function() {
        return new $e(this.lat, this.lng, this.alt);
      }
    };
    function ot(e, o, u) {
      return e instanceof $e ? e : re(e) && typeof e[0] != "object" ? e.length === 3 ? new $e(e[0], e[1], e[2]) : e.length === 2 ? new $e(e[0], e[1]) : null : e == null ? e : typeof e == "object" && "lat" in e ? new $e(e.lat, "lng" in e ? e.lng : e.lon, e.alt) : o === void 0 ? null : new $e(e, o, u);
    }
    var Tn = {
      latLngToPoint: function(e, o) {
        var u = this.projection.project(e), p = this.scale(o);
        return this.transformation._transform(u, p);
      },
      pointToLatLng: function(e, o) {
        var u = this.scale(o), p = this.transformation.untransform(e, u);
        return this.projection.unproject(p);
      },
      project: function(e) {
        return this.projection.project(e);
      },
      unproject: function(e) {
        return this.projection.unproject(e);
      },
      scale: function(e) {
        return 256 * Math.pow(2, e);
      },
      zoom: function(e) {
        return Math.log(e / 256) / Math.LN2;
      },
      getProjectedBounds: function(e) {
        if (this.infinite)
          return null;
        var o = this.projection.bounds, u = this.scale(e), p = this.transformation.transform(o.min, u), b = this.transformation.transform(o.max, u);
        return new Be(p, b);
      },
      infinite: !1,
      wrapLatLng: function(e) {
        var o = this.wrapLng ? C(e.lng, this.wrapLng, !0) : e.lng, u = this.wrapLat ? C(e.lat, this.wrapLat, !0) : e.lat, p = e.alt;
        return new $e(u, o, p);
      },
      wrapLatLngBounds: function(e) {
        var o = e.getCenter(), u = this.wrapLatLng(o), p = o.lat - u.lat, b = o.lng - u.lng;
        if (p === 0 && b === 0)
          return e;
        var P = e.getSouthWest(), $ = e.getNorthEast(), V = new $e(P.lat - p, P.lng - b), j = new $e($.lat - p, $.lng - b);
        return new Ht(V, j);
      }
    }, en = a({}, Tn, {
      wrapLng: [-180, 180],
      R: 6371e3,
      distance: function(e, o) {
        var u = Math.PI / 180, p = e.lat * u, b = o.lat * u, P = Math.sin((o.lat - e.lat) * u / 2), $ = Math.sin((o.lng - e.lng) * u / 2), V = P * P + Math.cos(p) * Math.cos(b) * $ * $, j = 2 * Math.atan2(Math.sqrt(V), Math.sqrt(1 - V));
        return this.R * j;
      }
    }), ft = 6378137, Mi = {
      R: ft,
      MAX_LATITUDE: 85.0511287798,
      project: function(e) {
        var o = Math.PI / 180, u = this.MAX_LATITUDE, p = Math.max(Math.min(u, e.lat), -u), b = Math.sin(p * o);
        return new we(
          this.R * e.lng * o,
          this.R * Math.log((1 + b) / (1 - b)) / 2
        );
      },
      unproject: function(e) {
        var o = 180 / Math.PI;
        return new $e(
          (2 * Math.atan(Math.exp(e.y / this.R)) - Math.PI / 2) * o,
          e.x * o / this.R
        );
      },
      bounds: function() {
        var e = ft * Math.PI;
        return new Be([-e, -e], [e, e]);
      }()
    };
    function Jt(e, o, u, p) {
      if (re(e)) {
        this._a = e[0], this._b = e[1], this._c = e[2], this._d = e[3];
        return;
      }
      this._a = e, this._b = o, this._c = u, this._d = p;
    }
    Jt.prototype = {
      transform: function(e, o) {
        return this._transform(e.clone(), o);
      },
      _transform: function(e, o) {
        return o = o || 1, e.x = o * (this._a * e.x + this._b), e.y = o * (this._c * e.y + this._d), e;
      },
      untransform: function(e, o) {
        return o = o || 1, new we(
          (e.x / o - this._b) / this._a,
          (e.y / o - this._d) / this._c
        );
      }
    };
    function pt(e, o, u, p) {
      return new Jt(e, o, u, p);
    }
    var jt = a({}, en, {
      code: "EPSG:3857",
      projection: Mi,
      transformation: function() {
        var e = 0.5 / (Math.PI * Mi.R);
        return pt(e, 0.5, -e, 0.5);
      }()
    }), Ke = a({}, jt, {
      code: "EPSG:900913"
    });
    function bt(e) {
      return document.createElementNS("http://www.w3.org/2000/svg", e);
    }
    function Rt(e, o) {
      var u = "", p, b, P, $, V, j;
      for (p = 0, P = e.length; p < P; p++) {
        for (V = e[p], b = 0, $ = V.length; b < $; b++)
          j = V[b], u += (b ? "L" : "M") + j.x + " " + j.y;
        u += o ? be.svg ? "z" : "x" : "";
      }
      return u || "M0 0";
    }
    var $t = document.documentElement.style, Xt = "ActiveXObject" in window, Ui = Xt && !document.addEventListener, Un = "msLaunchUri" in navigator && !("documentMode" in document), kt = cn("webkit"), ai = cn("android"), Oi = cn("android 2") || cn("android 3"), Fn = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10), xi = ai && cn("Google") && Fn < 537 && !("AudioNode" in window), Hn = !!window.opera, Di = !Un && cn("chrome"), tn = cn("gecko") && !kt && !Hn && !Xt, nn = !Di && cn("safari"), vn = cn("phantom"), hr = "OTransition" in $t, rn = navigator.platform.indexOf("Win") === 0, yn = Xt && "transition" in $t, un = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !Oi, vi = "MozPerspective" in $t, fr = !window.L_DISABLE_3D && (yn || un || vi) && !hr && !vn, li = typeof orientation < "u" || cn("mobile"), Rs = li && kt, $s = li && un, dr = !window.PointerEvent && window.MSPointerEvent, yi = !!(window.PointerEvent || dr), ki = "ontouchstart" in window || !!window.TouchEvent, Uo = !window.L_NO_TOUCH && (ki || yi), Fo = li && Hn, Bt = li && tn, Ho = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1, so = function() {
      var e = !1;
      try {
        var o = Object.defineProperty({}, "passive", {
          get: function() {
            e = !0;
          }
        });
        window.addEventListener("testPassiveEventSupport", M, o), window.removeEventListener("testPassiveEventSupport", M, o);
      } catch {
      }
      return e;
    }(), zs = function() {
      return !!document.createElement("canvas").getContext;
    }(), Ir = !!(document.createElementNS && bt("svg").createSVGRect), Nr = !!Ir && function() {
      var e = document.createElement("div");
      return e.innerHTML = "<svg/>", (e.firstChild && e.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
    }(), ao = !Ir && function() {
      try {
        var e = document.createElement("div");
        e.innerHTML = '<v:shape adj="1"/>';
        var o = e.firstChild;
        return o.style.behavior = "url(#default#VML)", o && typeof o.adj == "object";
      } catch {
        return !1;
      }
    }(), Bs = navigator.platform.indexOf("Mac") === 0, lo = navigator.platform.indexOf("Linux") === 0;
    function cn(e) {
      return navigator.userAgent.toLowerCase().indexOf(e) >= 0;
    }
    var be = {
      ie: Xt,
      ielt9: Ui,
      edge: Un,
      webkit: kt,
      android: ai,
      android23: Oi,
      androidStock: xi,
      opera: Hn,
      chrome: Di,
      gecko: tn,
      safari: nn,
      phantom: vn,
      opera12: hr,
      win: rn,
      ie3d: yn,
      webkit3d: un,
      gecko3d: vi,
      any3d: fr,
      mobile: li,
      mobileWebkit: Rs,
      mobileWebkit3d: $s,
      msPointer: dr,
      pointer: yi,
      touch: Uo,
      touchNative: ki,
      mobileOpera: Fo,
      mobileGecko: Bt,
      retina: Ho,
      passiveEvents: so,
      canvas: zs,
      svg: Ir,
      vml: ao,
      inlineSvg: Nr,
      mac: Bs,
      linux: lo
    }, uo = be.msPointer ? "MSPointerDown" : "pointerdown", Zo = be.msPointer ? "MSPointerMove" : "pointermove", co = be.msPointer ? "MSPointerUp" : "pointerup", pr = be.msPointer ? "MSPointerCancel" : "pointercancel", Rr = {
      touchstart: uo,
      touchmove: Zo,
      touchend: co,
      touchcancel: pr
    }, Vo = {
      touchstart: mr,
      touchmove: $r,
      touchend: $r,
      touchcancel: $r
    }, Li = {}, Wo = !1;
    function jo(e, o, u) {
      return o === "touchstart" && ce(), Vo[o] ? (u = Vo[o].bind(this, u), e.addEventListener(Rr[o], u, !1), u) : (console.warn("wrong event specified:", o), M);
    }
    function Go(e, o, u) {
      if (!Rr[o]) {
        console.warn("wrong event specified:", o);
        return;
      }
      e.removeEventListener(Rr[o], u, !1);
    }
    function Us(e) {
      Li[e.pointerId] = e;
    }
    function Fi(e) {
      Li[e.pointerId] && (Li[e.pointerId] = e);
    }
    function We(e) {
      delete Li[e.pointerId];
    }
    function ce() {
      Wo || (document.addEventListener(uo, Us, !0), document.addEventListener(Zo, Fi, !0), document.addEventListener(co, We, !0), document.addEventListener(pr, We, !0), Wo = !0);
    }
    function $r(e, o) {
      if (o.pointerType !== (o.MSPOINTER_TYPE_MOUSE || "mouse")) {
        o.touches = [];
        for (var u in Li)
          o.touches.push(Li[u]);
        o.changedTouches = [o], e(o);
      }
    }
    function mr(e, o) {
      o.MSPOINTER_TYPE_TOUCH && o.pointerType === o.MSPOINTER_TYPE_TOUCH && Fe(o), $r(e, o);
    }
    function zr(e) {
      var o = {}, u, p;
      for (p in e)
        u = e[p], o[p] = u && u.bind ? u.bind(e) : u;
      return e = o, o.type = "dblclick", o.detail = 2, o.isTrusted = !1, o._simulated = !0, o;
    }
    var ho = 200;
    function qo(e, o) {
      e.addEventListener("dblclick", o);
      var u = 0, p;
      function b(P) {
        if (P.detail !== 1) {
          p = P.detail;
          return;
        }
        if (!(P.pointerType === "mouse" || P.sourceCapabilities && !P.sourceCapabilities.firesTouchEvents)) {
          var $ = Ma(P);
          if (!($.some(function(j) {
            return j instanceof HTMLLabelElement && j.attributes.for;
          }) && !$.some(function(j) {
            return j instanceof HTMLInputElement || j instanceof HTMLSelectElement;
          }))) {
            var V = Date.now();
            V - u <= ho ? (p++, p === 2 && o(zr(P))) : p = 1, u = V;
          }
        }
      }
      return e.addEventListener("click", b), {
        dblclick: o,
        simDblclick: b
      };
    }
    function Yo(e, o) {
      e.removeEventListener("dblclick", o.dblclick), e.removeEventListener("click", o.simDblclick);
    }
    var Hi = E(
      ["transform", "webkitTransform", "OTransform", "MozTransform", "msTransform"]
    ), Zn = E(
      ["webkitTransition", "transition", "OTransition", "MozTransition", "msTransition"]
    ), Ko = Zn === "webkitTransition" || Zn === "OTransition" ? Zn + "End" : "transitionend";
    function fo(e) {
      return typeof e == "string" ? document.getElementById(e) : e;
    }
    function Zi(e, o) {
      var u = e.style[o] || e.currentStyle && e.currentStyle[o];
      if ((!u || u === "auto") && document.defaultView) {
        var p = document.defaultView.getComputedStyle(e, null);
        u = p ? p[o] : null;
      }
      return u === "auto" ? null : u;
    }
    function Qe(e, o, u) {
      var p = document.createElement(e);
      return p.className = o || "", u && u.appendChild(p), p;
    }
    function yt(e) {
      var o = e.parentNode;
      o && o.removeChild(e);
    }
    function Vi(e) {
      for (; e.firstChild; )
        e.removeChild(e.firstChild);
    }
    function Vn(e) {
      var o = e.parentNode;
      o && o.lastChild !== e && o.appendChild(e);
    }
    function ui(e) {
      var o = e.parentNode;
      o && o.firstChild !== e && o.insertBefore(e, o.firstChild);
    }
    function Ut(e, o) {
      if (e.classList !== void 0)
        return e.classList.contains(o);
      var u = w(e);
      return u.length > 0 && new RegExp("(^|\\s)" + o + "(\\s|$)").test(u);
    }
    function ze(e, o) {
      if (e.classList !== void 0)
        for (var u = D(o), p = 0, b = u.length; p < b; p++)
          e.classList.add(u[p]);
      else if (!Ut(e, o)) {
        var P = w(e);
        d(e, (P ? P + " " : "") + o);
      }
    }
    function St(e, o) {
      e.classList !== void 0 ? e.classList.remove(o) : d(e, I((" " + w(e) + " ").replace(" " + o + " ", " ")));
    }
    function d(e, o) {
      e.className.baseVal === void 0 ? e.className = o : e.className.baseVal = o;
    }
    function w(e) {
      return e.correspondingElement && (e = e.correspondingElement), e.className.baseVal === void 0 ? e.className : e.className.baseVal;
    }
    function _(e, o) {
      "opacity" in e.style ? e.style.opacity = o : "filter" in e.style && S(e, o);
    }
    function S(e, o) {
      var u = !1, p = "DXImageTransform.Microsoft.Alpha";
      try {
        u = e.filters.item(p);
      } catch {
        if (o === 1)
          return;
      }
      o = Math.round(o * 100), u ? (u.Enabled = o !== 100, u.Opacity = o) : e.style.filter += " progid:" + p + "(opacity=" + o + ")";
    }
    function E(e) {
      for (var o = document.documentElement.style, u = 0; u < e.length; u++)
        if (e[u] in o)
          return e[u];
      return !1;
    }
    function k(e, o, u) {
      var p = o || new we(0, 0);
      e.style[Hi] = (be.ie3d ? "translate(" + p.x + "px," + p.y + "px)" : "translate3d(" + p.x + "px," + p.y + "px,0)") + (u ? " scale(" + u + ")" : "");
    }
    function A(e, o) {
      e._leaflet_pos = o, be.any3d ? k(e, o) : (e.style.left = o.x + "px", e.style.top = o.y + "px");
    }
    function R(e) {
      return e._leaflet_pos || new we(0, 0);
    }
    var F, G, ue;
    if ("onselectstart" in document)
      F = function() {
        Te(window, "selectstart", Fe);
      }, G = function() {
        _t(window, "selectstart", Fe);
      };
    else {
      var fe = E(
        ["userSelect", "WebkitUserSelect", "OUserSelect", "MozUserSelect", "msUserSelect"]
      );
      F = function() {
        if (fe) {
          var e = document.documentElement.style;
          ue = e[fe], e[fe] = "none";
        }
      }, G = function() {
        fe && (document.documentElement.style[fe] = ue, ue = void 0);
      };
    }
    function ke() {
      Te(window, "dragstart", Fe);
    }
    function Ie() {
      _t(window, "dragstart", Fe);
    }
    var de, tt;
    function mt(e) {
      for (; e.tabIndex === -1; )
        e = e.parentNode;
      e.style && (Ln(), de = e, tt = e.style.outline, e.style.outline = "none", Te(window, "keydown", Ln));
    }
    function Ln() {
      de && (de.style.outline = tt, de = void 0, tt = void 0, _t(window, "keydown", Ln));
    }
    function Zt(e) {
      do
        e = e.parentNode;
      while ((!e.offsetWidth || !e.offsetHeight) && e !== document.body);
      return e;
    }
    function Wi(e) {
      var o = e.getBoundingClientRect();
      return {
        x: o.width / e.offsetWidth || 1,
        y: o.height / e.offsetHeight || 1,
        boundingClientRect: o
      };
    }
    var Jo = {
      __proto__: null,
      TRANSFORM: Hi,
      TRANSITION: Zn,
      TRANSITION_END: Ko,
      get: fo,
      getStyle: Zi,
      create: Qe,
      remove: yt,
      empty: Vi,
      toFront: Vn,
      toBack: ui,
      hasClass: Ut,
      addClass: ze,
      removeClass: St,
      setClass: d,
      getClass: w,
      setOpacity: _,
      testProp: E,
      setTransform: k,
      setPosition: A,
      getPosition: R,
      get disableTextSelection() {
        return F;
      },
      get enableTextSelection() {
        return G;
      },
      disableImageDrag: ke,
      enableImageDrag: Ie,
      preventOutline: mt,
      restoreOutline: Ln,
      getSizedParentNode: Zt,
      getScale: Wi
    };
    function Te(e, o, u, p) {
      if (o && typeof o == "object")
        for (var b in o)
          po(e, b, o[b], u);
      else {
        o = D(o);
        for (var P = 0, $ = o.length; P < $; P++)
          po(e, o[P], u, p);
      }
      return this;
    }
    var Gt = "_leaflet_events";
    function _t(e, o, u, p) {
      if (arguments.length === 1)
        Br(e), delete e[Gt];
      else if (o && typeof o == "object")
        for (var b in o)
          Fs(e, b, o[b], u);
      else if (o = D(o), arguments.length === 2)
        Br(e, function(V) {
          return ve(o, V) !== -1;
        });
      else
        for (var P = 0, $ = o.length; P < $; P++)
          Fs(e, o[P], u, p);
      return this;
    }
    function Br(e, o) {
      for (var u in e[Gt]) {
        var p = u.split(/\d/)[0];
        (!o || o(p)) && Fs(e, p, null, null, u);
      }
    }
    var ji = {
      mouseenter: "mouseover",
      mouseleave: "mouseout",
      wheel: !("onwheel" in window) && "mousewheel"
    };
    function po(e, o, u, p) {
      var b = o + y(u) + (p ? "_" + y(p) : "");
      if (e[Gt] && e[Gt][b])
        return this;
      var P = function(V) {
        return u.call(p || e, V || window.event);
      }, $ = P;
      !be.touchNative && be.pointer && o.indexOf("touch") === 0 ? P = jo(e, o, P) : be.touch && o === "dblclick" ? P = qo(e, P) : "addEventListener" in e ? o === "touchstart" || o === "touchmove" || o === "wheel" || o === "mousewheel" ? e.addEventListener(ji[o] || o, P, be.passiveEvents ? { passive: !1 } : !1) : o === "mouseenter" || o === "mouseleave" ? (P = function(V) {
        V = V || window.event, Zs(e, V) && $(V);
      }, e.addEventListener(ji[o], P, !1)) : e.addEventListener(o, $, !1) : e.attachEvent("on" + o, P), e[Gt] = e[Gt] || {}, e[Gt][b] = P;
    }
    function Fs(e, o, u, p, b) {
      b = b || o + y(u) + (p ? "_" + y(p) : "");
      var P = e[Gt] && e[Gt][b];
      if (!P)
        return this;
      !be.touchNative && be.pointer && o.indexOf("touch") === 0 ? Go(e, o, P) : be.touch && o === "dblclick" ? Yo(e, P) : "removeEventListener" in e ? e.removeEventListener(ji[o] || o, P, !1) : e.detachEvent("on" + o, P), e[Gt][b] = null;
    }
    function _r(e) {
      return e.stopPropagation ? e.stopPropagation() : e.originalEvent ? e.originalEvent._stopped = !0 : e.cancelBubble = !0, this;
    }
    function Hs(e) {
      return po(e, "wheel", _r), this;
    }
    function mo(e) {
      return Te(e, "mousedown touchstart dblclick contextmenu", _r), e._leaflet_disable_click = !0, this;
    }
    function Fe(e) {
      return e.preventDefault ? e.preventDefault() : e.returnValue = !1, this;
    }
    function st(e) {
      return Fe(e), _r(e), this;
    }
    function Ma(e) {
      if (e.composedPath)
        return e.composedPath();
      for (var o = [], u = e.target; u; )
        o.push(u), u = u.parentNode;
      return o;
    }
    function Oa(e, o) {
      if (!o)
        return new we(e.clientX, e.clientY);
      var u = Wi(o), p = u.boundingClientRect;
      return new we(
        (e.clientX - p.left) / u.x - o.clientLeft,
        (e.clientY - p.top) / u.y - o.clientTop
      );
    }
    var jl = be.linux && be.chrome ? window.devicePixelRatio : be.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    function xa(e) {
      return be.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / jl : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    function Zs(e, o) {
      var u = o.relatedTarget;
      if (!u)
        return !0;
      try {
        for (; u && u !== e; )
          u = u.parentNode;
      } catch {
        return !1;
      }
      return u !== e;
    }
    var Gl = {
      __proto__: null,
      on: Te,
      off: _t,
      stopPropagation: _r,
      disableScrollPropagation: Hs,
      disableClickPropagation: mo,
      preventDefault: Fe,
      stop: st,
      getPropagationPath: Ma,
      getMousePosition: Oa,
      getWheelDelta: xa,
      isExternalTarget: Zs,
      addListener: Te,
      removeListener: _t
    }, Vs = Kt.extend({
      run: function(e, o, u, p) {
        this.stop(), this._el = e, this._inProgress = !0, this._duration = u || 0.25, this._easeOutPower = 1 / Math.max(p || 0.5, 0.2), this._startPos = R(e), this._offset = o.subtract(this._startPos), this._startTime = +new Date(), this.fire("start"), this._animate();
      },
      stop: function() {
        this._inProgress && (this._step(!0), this._complete());
      },
      _animate: function() {
        this._animId = Pt(this._animate, this), this._step();
      },
      _step: function(e) {
        var o = +new Date() - this._startTime, u = this._duration * 1e3;
        o < u ? this._runFrame(this._easeOut(o / u), e) : (this._runFrame(1), this._complete());
      },
      _runFrame: function(e, o) {
        var u = this._startPos.add(this._offset.multiplyBy(e));
        o && u._round(), A(this._el, u), this.fire("step");
      },
      _complete: function() {
        xt(this._animId), this._inProgress = !1, this.fire("end");
      },
      _easeOut: function(e) {
        return 1 - Math.pow(1 - e, this._easeOutPower);
      }
    }), et = Kt.extend({
      options: {
        crs: jt,
        center: void 0,
        zoom: void 0,
        minZoom: void 0,
        maxZoom: void 0,
        layers: [],
        maxBounds: void 0,
        renderer: void 0,
        zoomAnimation: !0,
        zoomAnimationThreshold: 4,
        fadeAnimation: !0,
        markerZoomAnimation: !0,
        transform3DLimit: 8388608,
        zoomSnap: 1,
        zoomDelta: 1,
        trackResize: !0
      },
      initialize: function(e, o) {
        o = B(this, o), this._handlers = [], this._layers = {}, this._zoomBoundLayers = {}, this._sizeChanged = !0, this._initContainer(e), this._initLayout(), this._onResize = f(this._onResize, this), this._initEvents(), o.maxBounds && this.setMaxBounds(o.maxBounds), o.zoom !== void 0 && (this._zoom = this._limitZoom(o.zoom)), o.center && o.zoom !== void 0 && this.setView(ot(o.center), o.zoom, { reset: !0 }), this.callInitHooks(), this._zoomAnimated = Zn && be.any3d && !be.mobileOpera && this.options.zoomAnimation, this._zoomAnimated && (this._createAnimProxy(), Te(this._proxy, Ko, this._catchTransitionEnd, this)), this._addLayers(this.options.layers);
      },
      setView: function(e, o, u) {
        if (o = o === void 0 ? this._zoom : this._limitZoom(o), e = this._limitCenter(ot(e), o, this.options.maxBounds), u = u || {}, this._stop(), this._loaded && !u.reset && u !== !0) {
          u.animate !== void 0 && (u.zoom = a({ animate: u.animate }, u.zoom), u.pan = a({ animate: u.animate, duration: u.duration }, u.pan));
          var p = this._zoom !== o ? this._tryAnimatedZoom && this._tryAnimatedZoom(e, o, u.zoom) : this._tryAnimatedPan(e, u.pan);
          if (p)
            return clearTimeout(this._sizeTimer), this;
        }
        return this._resetView(e, o, u.pan && u.pan.noMoveStart), this;
      },
      setZoom: function(e, o) {
        return this._loaded ? this.setView(this.getCenter(), e, { zoom: o }) : (this._zoom = e, this);
      },
      zoomIn: function(e, o) {
        return e = e || (be.any3d ? this.options.zoomDelta : 1), this.setZoom(this._zoom + e, o);
      },
      zoomOut: function(e, o) {
        return e = e || (be.any3d ? this.options.zoomDelta : 1), this.setZoom(this._zoom - e, o);
      },
      setZoomAround: function(e, o, u) {
        var p = this.getZoomScale(o), b = this.getSize().divideBy(2), P = e instanceof we ? e : this.latLngToContainerPoint(e), $ = P.subtract(b).multiplyBy(1 - 1 / p), V = this.containerPointToLatLng(b.add($));
        return this.setView(V, o, { zoom: u });
      },
      _getBoundsCenterZoom: function(e, o) {
        o = o || {}, e = e.getBounds ? e.getBounds() : wt(e);
        var u = _e(o.paddingTopLeft || o.padding || [0, 0]), p = _e(o.paddingBottomRight || o.padding || [0, 0]), b = this.getBoundsZoom(e, !1, u.add(p));
        if (b = typeof o.maxZoom == "number" ? Math.min(o.maxZoom, b) : b, b === 1 / 0)
          return {
            center: e.getCenter(),
            zoom: b
          };
        var P = p.subtract(u).divideBy(2), $ = this.project(e.getSouthWest(), b), V = this.project(e.getNorthEast(), b), j = this.unproject($.add(V).divideBy(2).add(P), b);
        return {
          center: j,
          zoom: b
        };
      },
      fitBounds: function(e, o) {
        if (e = wt(e), !e.isValid())
          throw new Error("Bounds are not valid.");
        var u = this._getBoundsCenterZoom(e, o);
        return this.setView(u.center, u.zoom, o);
      },
      fitWorld: function(e) {
        return this.fitBounds([[-90, -180], [90, 180]], e);
      },
      panTo: function(e, o) {
        return this.setView(e, this._zoom, { pan: o });
      },
      panBy: function(e, o) {
        if (e = _e(e).round(), o = o || {}, !e.x && !e.y)
          return this.fire("moveend");
        if (o.animate !== !0 && !this.getSize().contains(e))
          return this._resetView(this.unproject(this.project(this.getCenter()).add(e)), this.getZoom()), this;
        if (this._panAnim || (this._panAnim = new Vs(), this._panAnim.on({
          step: this._onPanTransitionStep,
          end: this._onPanTransitionEnd
        }, this)), o.noMoveStart || this.fire("movestart"), o.animate !== !1) {
          ze(this._mapPane, "leaflet-pan-anim");
          var u = this._getMapPanePos().subtract(e).round();
          this._panAnim.run(this._mapPane, u, o.duration || 0.25, o.easeLinearity);
        } else
          this._rawPanBy(e), this.fire("move").fire("moveend");
        return this;
      },
      flyTo: function(e, o, u) {
        if (u = u || {}, u.animate === !1 || !be.any3d)
          return this.setView(e, o, u);
        this._stop();
        var p = this.project(this.getCenter()), b = this.project(e), P = this.getSize(), $ = this._zoom;
        e = ot(e), o = o === void 0 ? $ : o;
        var V = Math.max(P.x, P.y), j = V * this.getZoomScale($, o), oe = b.distanceTo(p) || 1, ge = 1.42, Oe = ge * ge;
        function Ve(At) {
          var er = At ? -1 : 1, Va = At ? j : V, O = j * j - V * V + er * Oe * Oe * oe * oe, Gr = 2 * Va * Oe * oe, qr = O / Gr, Dn = Math.sqrt(qr * qr + 1) - qr, Je = Dn < 1e-9 ? -18 : Math.log(Dn);
          return Je;
        }
        function bn(At) {
          return (Math.exp(At) - Math.exp(-At)) / 2;
        }
        function Kn(At) {
          return (Math.exp(At) + Math.exp(-At)) / 2;
        }
        function Qi(At) {
          return bn(At) / Kn(At);
        }
        var Jn = Ve(0);
        function Wr(At) {
          return V * (Kn(Jn) / Kn(Jn + ge * At));
        }
        function jr(At) {
          return V * (Kn(Jn) * Qi(Jn + ge * At) - bn(Jn)) / Oe;
        }
        function su(At) {
          return 1 - Math.pow(1 - At, 1.5);
        }
        var au = Date.now(), Ha = (Ve(1) - Jn) / ge, lu = u.duration ? 1e3 * u.duration : 1e3 * Ha * 0.8;
        function Za() {
          var At = (Date.now() - au) / lu, er = su(At) * Ha;
          At <= 1 ? (this._flyToFrame = Pt(Za, this), this._move(
            this.unproject(p.add(b.subtract(p).multiplyBy(jr(er) / oe)), $),
            this.getScaleZoom(V / Wr(er), $),
            { flyTo: !0 }
          )) : this._move(e, o)._moveEnd(!0);
        }
        return this._moveStart(!0, u.noMoveStart), Za.call(this), this;
      },
      flyToBounds: function(e, o) {
        var u = this._getBoundsCenterZoom(e, o);
        return this.flyTo(u.center, u.zoom, o);
      },
      setMaxBounds: function(e) {
        return e = wt(e), this.listens("moveend", this._panInsideMaxBounds) && this.off("moveend", this._panInsideMaxBounds), e.isValid() ? (this.options.maxBounds = e, this._loaded && this._panInsideMaxBounds(), this.on("moveend", this._panInsideMaxBounds)) : (this.options.maxBounds = null, this);
      },
      setMinZoom: function(e) {
        var o = this.options.minZoom;
        return this.options.minZoom = e, this._loaded && o !== e && (this.fire("zoomlevelschange"), this.getZoom() < this.options.minZoom) ? this.setZoom(e) : this;
      },
      setMaxZoom: function(e) {
        var o = this.options.maxZoom;
        return this.options.maxZoom = e, this._loaded && o !== e && (this.fire("zoomlevelschange"), this.getZoom() > this.options.maxZoom) ? this.setZoom(e) : this;
      },
      panInsideBounds: function(e, o) {
        this._enforcingBounds = !0;
        var u = this.getCenter(), p = this._limitCenter(u, this._zoom, wt(e));
        return u.equals(p) || this.panTo(p, o), this._enforcingBounds = !1, this;
      },
      panInside: function(e, o) {
        o = o || {};
        var u = _e(o.paddingTopLeft || o.padding || [0, 0]), p = _e(o.paddingBottomRight || o.padding || [0, 0]), b = this.project(this.getCenter()), P = this.project(e), $ = this.getPixelBounds(), V = Nt([$.min.add(u), $.max.subtract(p)]), j = V.getSize();
        if (!V.contains(P)) {
          this._enforcingBounds = !0;
          var oe = P.subtract(V.getCenter()), ge = V.extend(P).getSize().subtract(j);
          b.x += oe.x < 0 ? -ge.x : ge.x, b.y += oe.y < 0 ? -ge.y : ge.y, this.panTo(this.unproject(b), o), this._enforcingBounds = !1;
        }
        return this;
      },
      invalidateSize: function(e) {
        if (!this._loaded)
          return this;
        e = a({
          animate: !1,
          pan: !0
        }, e === !0 ? { animate: !0 } : e);
        var o = this.getSize();
        this._sizeChanged = !0, this._lastCenter = null;
        var u = this.getSize(), p = o.divideBy(2).round(), b = u.divideBy(2).round(), P = p.subtract(b);
        return !P.x && !P.y ? this : (e.animate && e.pan ? this.panBy(P) : (e.pan && this._rawPanBy(P), this.fire("move"), e.debounceMoveend ? (clearTimeout(this._sizeTimer), this._sizeTimer = setTimeout(f(this.fire, this, "moveend"), 200)) : this.fire("moveend")), this.fire("resize", {
          oldSize: o,
          newSize: u
        }));
      },
      stop: function() {
        return this.setZoom(this._limitZoom(this._zoom)), this.options.zoomSnap || this.fire("viewreset"), this._stop();
      },
      locate: function(e) {
        if (e = this._locateOptions = a({
          timeout: 1e4,
          watch: !1
        }, e), !("geolocation" in navigator))
          return this._handleGeolocationError({
            code: 0,
            message: "Geolocation not supported."
          }), this;
        var o = f(this._handleGeolocationResponse, this), u = f(this._handleGeolocationError, this);
        return e.watch ? this._locationWatchId = navigator.geolocation.watchPosition(o, u, e) : navigator.geolocation.getCurrentPosition(o, u, e), this;
      },
      stopLocate: function() {
        return navigator.geolocation && navigator.geolocation.clearWatch && navigator.geolocation.clearWatch(this._locationWatchId), this._locateOptions && (this._locateOptions.setView = !1), this;
      },
      _handleGeolocationError: function(e) {
        if (this._container._leaflet_id) {
          var o = e.code, u = e.message || (o === 1 ? "permission denied" : o === 2 ? "position unavailable" : "timeout");
          this._locateOptions.setView && !this._loaded && this.fitWorld(), this.fire("locationerror", {
            code: o,
            message: "Geolocation error: " + u + "."
          });
        }
      },
      _handleGeolocationResponse: function(e) {
        if (this._container._leaflet_id) {
          var o = e.coords.latitude, u = e.coords.longitude, p = new $e(o, u), b = p.toBounds(e.coords.accuracy * 2), P = this._locateOptions;
          if (P.setView) {
            var $ = this.getBoundsZoom(b);
            this.setView(p, P.maxZoom ? Math.min($, P.maxZoom) : $);
          }
          var V = {
            latlng: p,
            bounds: b,
            timestamp: e.timestamp
          };
          for (var j in e.coords)
            typeof e.coords[j] == "number" && (V[j] = e.coords[j]);
          this.fire("locationfound", V);
        }
      },
      addHandler: function(e, o) {
        if (!o)
          return this;
        var u = this[e] = new o(this);
        return this._handlers.push(u), this.options[e] && u.enable(), this;
      },
      remove: function() {
        if (this._initEvents(!0), this.options.maxBounds && this.off("moveend", this._panInsideMaxBounds), this._containerId !== this._container._leaflet_id)
          throw new Error("Map container is being reused by another instance");
        try {
          delete this._container._leaflet_id, delete this._containerId;
        } catch {
          this._container._leaflet_id = void 0, this._containerId = void 0;
        }
        this._locationWatchId !== void 0 && this.stopLocate(), this._stop(), yt(this._mapPane), this._clearControlPos && this._clearControlPos(), this._resizeRequest && (xt(this._resizeRequest), this._resizeRequest = null), this._clearHandlers(), this._loaded && this.fire("unload");
        var e;
        for (e in this._layers)
          this._layers[e].remove();
        for (e in this._panes)
          yt(this._panes[e]);
        return this._layers = [], this._panes = [], delete this._mapPane, delete this._renderer, this;
      },
      createPane: function(e, o) {
        var u = "leaflet-pane" + (e ? " leaflet-" + e.replace("Pane", "") + "-pane" : ""), p = Qe("div", u, o || this._mapPane);
        return e && (this._panes[e] = p), p;
      },
      getCenter: function() {
        return this._checkIfLoaded(), this._lastCenter && !this._moved() ? this._lastCenter.clone() : this.layerPointToLatLng(this._getCenterLayerPoint());
      },
      getZoom: function() {
        return this._zoom;
      },
      getBounds: function() {
        var e = this.getPixelBounds(), o = this.unproject(e.getBottomLeft()), u = this.unproject(e.getTopRight());
        return new Ht(o, u);
      },
      getMinZoom: function() {
        return this.options.minZoom === void 0 ? this._layersMinZoom || 0 : this.options.minZoom;
      },
      getMaxZoom: function() {
        return this.options.maxZoom === void 0 ? this._layersMaxZoom === void 0 ? 1 / 0 : this._layersMaxZoom : this.options.maxZoom;
      },
      getBoundsZoom: function(e, o, u) {
        e = wt(e), u = _e(u || [0, 0]);
        var p = this.getZoom() || 0, b = this.getMinZoom(), P = this.getMaxZoom(), $ = e.getNorthWest(), V = e.getSouthEast(), j = this.getSize().subtract(u), oe = Nt(this.project(V, p), this.project($, p)).getSize(), ge = be.any3d ? this.options.zoomSnap : 1, Oe = j.x / oe.x, Ve = j.y / oe.y, bn = o ? Math.max(Oe, Ve) : Math.min(Oe, Ve);
        return p = this.getScaleZoom(bn, p), ge && (p = Math.round(p / (ge / 100)) * (ge / 100), p = o ? Math.ceil(p / ge) * ge : Math.floor(p / ge) * ge), Math.max(b, Math.min(P, p));
      },
      getSize: function() {
        return (!this._size || this._sizeChanged) && (this._size = new we(
          this._container.clientWidth || 0,
          this._container.clientHeight || 0
        ), this._sizeChanged = !1), this._size.clone();
      },
      getPixelBounds: function(e, o) {
        var u = this._getTopLeftPoint(e, o);
        return new Be(u, u.add(this.getSize()));
      },
      getPixelOrigin: function() {
        return this._checkIfLoaded(), this._pixelOrigin;
      },
      getPixelWorldBounds: function(e) {
        return this.options.crs.getProjectedBounds(e === void 0 ? this.getZoom() : e);
      },
      getPane: function(e) {
        return typeof e == "string" ? this._panes[e] : e;
      },
      getPanes: function() {
        return this._panes;
      },
      getContainer: function() {
        return this._container;
      },
      getZoomScale: function(e, o) {
        var u = this.options.crs;
        return o = o === void 0 ? this._zoom : o, u.scale(e) / u.scale(o);
      },
      getScaleZoom: function(e, o) {
        var u = this.options.crs;
        o = o === void 0 ? this._zoom : o;
        var p = u.zoom(e * u.scale(o));
        return isNaN(p) ? 1 / 0 : p;
      },
      project: function(e, o) {
        return o = o === void 0 ? this._zoom : o, this.options.crs.latLngToPoint(ot(e), o);
      },
      unproject: function(e, o) {
        return o = o === void 0 ? this._zoom : o, this.options.crs.pointToLatLng(_e(e), o);
      },
      layerPointToLatLng: function(e) {
        var o = _e(e).add(this.getPixelOrigin());
        return this.unproject(o);
      },
      latLngToLayerPoint: function(e) {
        var o = this.project(ot(e))._round();
        return o._subtract(this.getPixelOrigin());
      },
      wrapLatLng: function(e) {
        return this.options.crs.wrapLatLng(ot(e));
      },
      wrapLatLngBounds: function(e) {
        return this.options.crs.wrapLatLngBounds(wt(e));
      },
      distance: function(e, o) {
        return this.options.crs.distance(ot(e), ot(o));
      },
      containerPointToLayerPoint: function(e) {
        return _e(e).subtract(this._getMapPanePos());
      },
      layerPointToContainerPoint: function(e) {
        return _e(e).add(this._getMapPanePos());
      },
      containerPointToLatLng: function(e) {
        var o = this.containerPointToLayerPoint(_e(e));
        return this.layerPointToLatLng(o);
      },
      latLngToContainerPoint: function(e) {
        return this.layerPointToContainerPoint(this.latLngToLayerPoint(ot(e)));
      },
      mouseEventToContainerPoint: function(e) {
        return Oa(e, this._container);
      },
      mouseEventToLayerPoint: function(e) {
        return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
      },
      mouseEventToLatLng: function(e) {
        return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
      },
      _initContainer: function(e) {
        var o = this._container = fo(e);
        if (o) {
          if (o._leaflet_id)
            throw new Error("Map container is already initialized.");
        } else
          throw new Error("Map container not found.");
        Te(o, "scroll", this._onScroll, this), this._containerId = y(o);
      },
      _initLayout: function() {
        var e = this._container;
        this._fadeAnimated = this.options.fadeAnimation && be.any3d, ze(e, "leaflet-container" + (be.touch ? " leaflet-touch" : "") + (be.retina ? " leaflet-retina" : "") + (be.ielt9 ? " leaflet-oldie" : "") + (be.safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
        var o = Zi(e, "position");
        o !== "absolute" && o !== "relative" && o !== "fixed" && o !== "sticky" && (e.style.position = "relative"), this._initPanes(), this._initControlPos && this._initControlPos();
      },
      _initPanes: function() {
        var e = this._panes = {};
        this._paneRenderers = {}, this._mapPane = this.createPane("mapPane", this._container), A(this._mapPane, new we(0, 0)), this.createPane("tilePane"), this.createPane("overlayPane"), this.createPane("shadowPane"), this.createPane("markerPane"), this.createPane("tooltipPane"), this.createPane("popupPane"), this.options.markerZoomAnimation || (ze(e.markerPane, "leaflet-zoom-hide"), ze(e.shadowPane, "leaflet-zoom-hide"));
      },
      _resetView: function(e, o, u) {
        A(this._mapPane, new we(0, 0));
        var p = !this._loaded;
        this._loaded = !0, o = this._limitZoom(o), this.fire("viewprereset");
        var b = this._zoom !== o;
        this._moveStart(b, u)._move(e, o)._moveEnd(b), this.fire("viewreset"), p && this.fire("load");
      },
      _moveStart: function(e, o) {
        return e && this.fire("zoomstart"), o || this.fire("movestart"), this;
      },
      _move: function(e, o, u, p) {
        o === void 0 && (o = this._zoom);
        var b = this._zoom !== o;
        return this._zoom = o, this._lastCenter = e, this._pixelOrigin = this._getNewPixelOrigin(e), p ? u && u.pinch && this.fire("zoom", u) : ((b || u && u.pinch) && this.fire("zoom", u), this.fire("move", u)), this;
      },
      _moveEnd: function(e) {
        return e && this.fire("zoomend"), this.fire("moveend");
      },
      _stop: function() {
        return xt(this._flyToFrame), this._panAnim && this._panAnim.stop(), this;
      },
      _rawPanBy: function(e) {
        A(this._mapPane, this._getMapPanePos().subtract(e));
      },
      _getZoomSpan: function() {
        return this.getMaxZoom() - this.getMinZoom();
      },
      _panInsideMaxBounds: function() {
        this._enforcingBounds || this.panInsideBounds(this.options.maxBounds);
      },
      _checkIfLoaded: function() {
        if (!this._loaded)
          throw new Error("Set map center and zoom first.");
      },
      _initEvents: function(e) {
        this._targets = {}, this._targets[y(this._container)] = this;
        var o = e ? _t : Te;
        o(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this), this.options.trackResize && o(window, "resize", this._onResize, this), be.any3d && this.options.transform3DLimit && (e ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
      },
      _onResize: function() {
        xt(this._resizeRequest), this._resizeRequest = Pt(
          function() {
            this.invalidateSize({ debounceMoveend: !0 });
          },
          this
        );
      },
      _onScroll: function() {
        this._container.scrollTop = 0, this._container.scrollLeft = 0;
      },
      _onMoveEnd: function() {
        var e = this._getMapPanePos();
        Math.max(Math.abs(e.x), Math.abs(e.y)) >= this.options.transform3DLimit && this._resetView(this.getCenter(), this.getZoom());
      },
      _findEventTargets: function(e, o) {
        for (var u = [], p, b = o === "mouseout" || o === "mouseover", P = e.target || e.srcElement, $ = !1; P; ) {
          if (p = this._targets[y(P)], p && (o === "click" || o === "preclick") && this._draggableMoved(p)) {
            $ = !0;
            break;
          }
          if (p && p.listens(o, !0) && (b && !Zs(P, e) || (u.push(p), b)) || P === this._container)
            break;
          P = P.parentNode;
        }
        return !u.length && !$ && !b && this.listens(o, !0) && (u = [this]), u;
      },
      _isClickDisabled: function(e) {
        for (; e && e !== this._container; ) {
          if (e._leaflet_disable_click)
            return !0;
          e = e.parentNode;
        }
      },
      _handleDOMEvent: function(e) {
        var o = e.target || e.srcElement;
        if (!(!this._loaded || o._leaflet_disable_events || e.type === "click" && this._isClickDisabled(o))) {
          var u = e.type;
          u === "mousedown" && mt(o), this._fireDOMEvent(e, u);
        }
      },
      _mouseEvents: ["click", "dblclick", "mouseover", "mouseout", "contextmenu"],
      _fireDOMEvent: function(e, o, u) {
        if (e.type === "click") {
          var p = a({}, e);
          p.type = "preclick", this._fireDOMEvent(p, p.type, u);
        }
        var b = this._findEventTargets(e, o);
        if (u) {
          for (var P = [], $ = 0; $ < u.length; $++)
            u[$].listens(o, !0) && P.push(u[$]);
          b = P.concat(b);
        }
        if (b.length) {
          o === "contextmenu" && Fe(e);
          var V = b[0], j = {
            originalEvent: e
          };
          if (e.type !== "keypress" && e.type !== "keydown" && e.type !== "keyup") {
            var oe = V.getLatLng && (!V._radius || V._radius <= 10);
            j.containerPoint = oe ? this.latLngToContainerPoint(V.getLatLng()) : this.mouseEventToContainerPoint(e), j.layerPoint = this.containerPointToLayerPoint(j.containerPoint), j.latlng = oe ? V.getLatLng() : this.layerPointToLatLng(j.layerPoint);
          }
          for ($ = 0; $ < b.length; $++)
            if (b[$].fire(o, j, !0), j.originalEvent._stopped || b[$].options.bubblingMouseEvents === !1 && ve(this._mouseEvents, o) !== -1)
              return;
        }
      },
      _draggableMoved: function(e) {
        return e = e.dragging && e.dragging.enabled() ? e : this, e.dragging && e.dragging.moved() || this.boxZoom && this.boxZoom.moved();
      },
      _clearHandlers: function() {
        for (var e = 0, o = this._handlers.length; e < o; e++)
          this._handlers[e].disable();
      },
      whenReady: function(e, o) {
        return this._loaded ? e.call(o || this, { target: this }) : this.on("load", e, o), this;
      },
      _getMapPanePos: function() {
        return R(this._mapPane) || new we(0, 0);
      },
      _moved: function() {
        var e = this._getMapPanePos();
        return e && !e.equals([0, 0]);
      },
      _getTopLeftPoint: function(e, o) {
        var u = e && o !== void 0 ? this._getNewPixelOrigin(e, o) : this.getPixelOrigin();
        return u.subtract(this._getMapPanePos());
      },
      _getNewPixelOrigin: function(e, o) {
        var u = this.getSize()._divideBy(2);
        return this.project(e, o)._subtract(u)._add(this._getMapPanePos())._round();
      },
      _latLngToNewLayerPoint: function(e, o, u) {
        var p = this._getNewPixelOrigin(u, o);
        return this.project(e, o)._subtract(p);
      },
      _latLngBoundsToNewLayerBounds: function(e, o, u) {
        var p = this._getNewPixelOrigin(u, o);
        return Nt([
          this.project(e.getSouthWest(), o)._subtract(p),
          this.project(e.getNorthWest(), o)._subtract(p),
          this.project(e.getSouthEast(), o)._subtract(p),
          this.project(e.getNorthEast(), o)._subtract(p)
        ]);
      },
      _getCenterLayerPoint: function() {
        return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
      },
      _getCenterOffset: function(e) {
        return this.latLngToLayerPoint(e).subtract(this._getCenterLayerPoint());
      },
      _limitCenter: function(e, o, u) {
        if (!u)
          return e;
        var p = this.project(e, o), b = this.getSize().divideBy(2), P = new Be(p.subtract(b), p.add(b)), $ = this._getBoundsOffset(P, u, o);
        return Math.abs($.x) <= 1 && Math.abs($.y) <= 1 ? e : this.unproject(p.add($), o);
      },
      _limitOffset: function(e, o) {
        if (!o)
          return e;
        var u = this.getPixelBounds(), p = new Be(u.min.add(e), u.max.add(e));
        return e.add(this._getBoundsOffset(p, o));
      },
      _getBoundsOffset: function(e, o, u) {
        var p = Nt(
          this.project(o.getNorthEast(), u),
          this.project(o.getSouthWest(), u)
        ), b = p.min.subtract(e.min), P = p.max.subtract(e.max), $ = this._rebound(b.x, -P.x), V = this._rebound(b.y, -P.y);
        return new we($, V);
      },
      _rebound: function(e, o) {
        return e + o > 0 ? Math.round(e - o) / 2 : Math.max(0, Math.ceil(e)) - Math.max(0, Math.floor(o));
      },
      _limitZoom: function(e) {
        var o = this.getMinZoom(), u = this.getMaxZoom(), p = be.any3d ? this.options.zoomSnap : 1;
        return p && (e = Math.round(e / p) * p), Math.max(o, Math.min(u, e));
      },
      _onPanTransitionStep: function() {
        this.fire("move");
      },
      _onPanTransitionEnd: function() {
        St(this._mapPane, "leaflet-pan-anim"), this.fire("moveend");
      },
      _tryAnimatedPan: function(e, o) {
        var u = this._getCenterOffset(e)._trunc();
        return (o && o.animate) !== !0 && !this.getSize().contains(u) ? !1 : (this.panBy(u, o), !0);
      },
      _createAnimProxy: function() {
        var e = this._proxy = Qe("div", "leaflet-proxy leaflet-zoom-animated");
        this._panes.mapPane.appendChild(e), this.on("zoomanim", function(o) {
          var u = Hi, p = this._proxy.style[u];
          k(this._proxy, this.project(o.center, o.zoom), this.getZoomScale(o.zoom, 1)), p === this._proxy.style[u] && this._animatingZoom && this._onZoomTransitionEnd();
        }, this), this.on("load moveend", this._animMoveEnd, this), this._on("unload", this._destroyAnimProxy, this);
      },
      _destroyAnimProxy: function() {
        yt(this._proxy), this.off("load moveend", this._animMoveEnd, this), delete this._proxy;
      },
      _animMoveEnd: function() {
        var e = this.getCenter(), o = this.getZoom();
        k(this._proxy, this.project(e, o), this.getZoomScale(o, 1));
      },
      _catchTransitionEnd: function(e) {
        this._animatingZoom && e.propertyName.indexOf("transform") >= 0 && this._onZoomTransitionEnd();
      },
      _nothingToAnimate: function() {
        return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
      },
      _tryAnimatedZoom: function(e, o, u) {
        if (this._animatingZoom)
          return !0;
        if (u = u || {}, !this._zoomAnimated || u.animate === !1 || this._nothingToAnimate() || Math.abs(o - this._zoom) > this.options.zoomAnimationThreshold)
          return !1;
        var p = this.getZoomScale(o), b = this._getCenterOffset(e)._divideBy(1 - 1 / p);
        return u.animate !== !0 && !this.getSize().contains(b) ? !1 : (Pt(function() {
          this._moveStart(!0, !1)._animateZoom(e, o, !0);
        }, this), !0);
      },
      _animateZoom: function(e, o, u, p) {
        this._mapPane && (u && (this._animatingZoom = !0, this._animateToCenter = e, this._animateToZoom = o, ze(this._mapPane, "leaflet-zoom-anim")), this.fire("zoomanim", {
          center: e,
          zoom: o,
          noUpdate: p
        }), this._tempFireZoomEvent || (this._tempFireZoomEvent = this._zoom !== this._animateToZoom), this._move(this._animateToCenter, this._animateToZoom, void 0, !0), setTimeout(f(this._onZoomTransitionEnd, this), 250));
      },
      _onZoomTransitionEnd: function() {
        this._animatingZoom && (this._mapPane && St(this._mapPane, "leaflet-zoom-anim"), this._animatingZoom = !1, this._move(this._animateToCenter, this._animateToZoom, void 0, !0), this._tempFireZoomEvent && this.fire("zoom"), delete this._tempFireZoomEvent, this.fire("move"), this._moveEnd(!0));
      }
    });
    function on(e, o) {
      return new et(e, o);
    }
    var En = Dt.extend({
      options: {
        position: "topright"
      },
      initialize: function(e) {
        B(this, e);
      },
      getPosition: function() {
        return this.options.position;
      },
      setPosition: function(e) {
        var o = this._map;
        return o && o.removeControl(this), this.options.position = e, o && o.addControl(this), this;
      },
      getContainer: function() {
        return this._container;
      },
      addTo: function(e) {
        this.remove(), this._map = e;
        var o = this._container = this.onAdd(e), u = this.getPosition(), p = e._controlCorners[u];
        return ze(o, "leaflet-control"), u.indexOf("bottom") !== -1 ? p.insertBefore(o, p.firstChild) : p.appendChild(o), this._map.on("unload", this.remove, this), this;
      },
      remove: function() {
        return this._map ? (yt(this._container), this.onRemove && this.onRemove(this._map), this._map.off("unload", this.remove, this), this._map = null, this) : this;
      },
      _refocusOnMap: function(e) {
        this._map && e && e.screenX > 0 && e.screenY > 0 && this._map.getContainer().focus();
      }
    }), ci = function(e) {
      return new En(e);
    };
    et.include({
      addControl: function(e) {
        return e.addTo(this), this;
      },
      removeControl: function(e) {
        return e.remove(), this;
      },
      _initControlPos: function() {
        var e = this._controlCorners = {}, o = "leaflet-", u = this._controlContainer = Qe("div", o + "control-container", this._container);
        function p(b, P) {
          var $ = o + b + " " + o + P;
          e[b + P] = Qe("div", $, u);
        }
        p("top", "left"), p("top", "right"), p("bottom", "left"), p("bottom", "right");
      },
      _clearControlPos: function() {
        for (var e in this._controlCorners)
          yt(this._controlCorners[e]);
        yt(this._controlContainer), delete this._controlCorners, delete this._controlContainer;
      }
    });
    var Ws = En.extend({
      options: {
        collapsed: !0,
        position: "topright",
        autoZIndex: !0,
        hideSingleBase: !1,
        sortLayers: !1,
        sortFunction: function(e, o, u, p) {
          return u < p ? -1 : p < u ? 1 : 0;
        }
      },
      initialize: function(e, o, u) {
        B(this, u), this._layerControlInputs = [], this._layers = [], this._lastZIndex = 0, this._handlingClick = !1;
        for (var p in e)
          this._addLayer(e[p], p);
        for (p in o)
          this._addLayer(o[p], p, !0);
      },
      onAdd: function(e) {
        this._initLayout(), this._update(), this._map = e, e.on("zoomend", this._checkDisabledLayers, this);
        for (var o = 0; o < this._layers.length; o++)
          this._layers[o].layer.on("add remove", this._onLayerChange, this);
        return this._container;
      },
      addTo: function(e) {
        return En.prototype.addTo.call(this, e), this._expandIfNotCollapsed();
      },
      onRemove: function() {
        this._map.off("zoomend", this._checkDisabledLayers, this);
        for (var e = 0; e < this._layers.length; e++)
          this._layers[e].layer.off("add remove", this._onLayerChange, this);
      },
      addBaseLayer: function(e, o) {
        return this._addLayer(e, o), this._map ? this._update() : this;
      },
      addOverlay: function(e, o) {
        return this._addLayer(e, o, !0), this._map ? this._update() : this;
      },
      removeLayer: function(e) {
        e.off("add remove", this._onLayerChange, this);
        var o = this._getLayer(y(e));
        return o && this._layers.splice(this._layers.indexOf(o), 1), this._map ? this._update() : this;
      },
      expand: function() {
        ze(this._container, "leaflet-control-layers-expanded"), this._section.style.height = null;
        var e = this._map.getSize().y - (this._container.offsetTop + 50);
        return e < this._section.clientHeight ? (ze(this._section, "leaflet-control-layers-scrollbar"), this._section.style.height = e + "px") : St(this._section, "leaflet-control-layers-scrollbar"), this._checkDisabledLayers(), this;
      },
      collapse: function() {
        return St(this._container, "leaflet-control-layers-expanded"), this;
      },
      _initLayout: function() {
        var e = "leaflet-control-layers", o = this._container = Qe("div", e), u = this.options.collapsed;
        o.setAttribute("aria-haspopup", !0), mo(o), Hs(o);
        var p = this._section = Qe("section", e + "-list");
        u && (this._map.on("click", this.collapse, this), Te(o, {
          mouseenter: this._expandSafely,
          mouseleave: this.collapse
        }, this));
        var b = this._layersLink = Qe("a", e + "-toggle", o);
        b.href = "#", b.title = "Layers", b.setAttribute("role", "button"), Te(b, {
          keydown: function(P) {
            P.keyCode === 13 && this._expandSafely();
          },
          click: function(P) {
            Fe(P), this._expandSafely();
          }
        }, this), u || this.expand(), this._baseLayersList = Qe("div", e + "-base", p), this._separator = Qe("div", e + "-separator", p), this._overlaysList = Qe("div", e + "-overlays", p), o.appendChild(p);
      },
      _getLayer: function(e) {
        for (var o = 0; o < this._layers.length; o++)
          if (this._layers[o] && y(this._layers[o].layer) === e)
            return this._layers[o];
      },
      _addLayer: function(e, o, u) {
        this._map && e.on("add remove", this._onLayerChange, this), this._layers.push({
          layer: e,
          name: o,
          overlay: u
        }), this.options.sortLayers && this._layers.sort(f(function(p, b) {
          return this.options.sortFunction(p.layer, b.layer, p.name, b.name);
        }, this)), this.options.autoZIndex && e.setZIndex && (this._lastZIndex++, e.setZIndex(this._lastZIndex)), this._expandIfNotCollapsed();
      },
      _update: function() {
        if (!this._container)
          return this;
        Vi(this._baseLayersList), Vi(this._overlaysList), this._layerControlInputs = [];
        var e, o, u, p, b = 0;
        for (u = 0; u < this._layers.length; u++)
          p = this._layers[u], this._addItem(p), o = o || p.overlay, e = e || !p.overlay, b += p.overlay ? 0 : 1;
        return this.options.hideSingleBase && (e = e && b > 1, this._baseLayersList.style.display = e ? "" : "none"), this._separator.style.display = o && e ? "" : "none", this;
      },
      _onLayerChange: function(e) {
        this._handlingClick || this._update();
        var o = this._getLayer(y(e.target)), u = o.overlay ? e.type === "add" ? "overlayadd" : "overlayremove" : e.type === "add" ? "baselayerchange" : null;
        u && this._map.fire(u, o);
      },
      _createRadioElement: function(e, o) {
        var u = '<input type="radio" class="leaflet-control-layers-selector" name="' + e + '"' + (o ? ' checked="checked"' : "") + "/>", p = document.createElement("div");
        return p.innerHTML = u, p.firstChild;
      },
      _addItem: function(e) {
        var o = document.createElement("label"), u = this._map.hasLayer(e.layer), p;
        e.overlay ? (p = document.createElement("input"), p.type = "checkbox", p.className = "leaflet-control-layers-selector", p.defaultChecked = u) : p = this._createRadioElement("leaflet-base-layers_" + y(this), u), this._layerControlInputs.push(p), p.layerId = y(e.layer), Te(p, "click", this._onInputClick, this);
        var b = document.createElement("span");
        b.innerHTML = " " + e.name;
        var P = document.createElement("span");
        o.appendChild(P), P.appendChild(p), P.appendChild(b);
        var $ = e.overlay ? this._overlaysList : this._baseLayersList;
        return $.appendChild(o), this._checkDisabledLayers(), o;
      },
      _onInputClick: function() {
        var e = this._layerControlInputs, o, u, p = [], b = [];
        this._handlingClick = !0;
        for (var P = e.length - 1; P >= 0; P--)
          o = e[P], u = this._getLayer(o.layerId).layer, o.checked ? p.push(u) : o.checked || b.push(u);
        for (P = 0; P < b.length; P++)
          this._map.hasLayer(b[P]) && this._map.removeLayer(b[P]);
        for (P = 0; P < p.length; P++)
          this._map.hasLayer(p[P]) || this._map.addLayer(p[P]);
        this._handlingClick = !1, this._refocusOnMap();
      },
      _checkDisabledLayers: function() {
        for (var e = this._layerControlInputs, o, u, p = this._map.getZoom(), b = e.length - 1; b >= 0; b--)
          o = e[b], u = this._getLayer(o.layerId).layer, o.disabled = u.options.minZoom !== void 0 && p < u.options.minZoom || u.options.maxZoom !== void 0 && p > u.options.maxZoom;
      },
      _expandIfNotCollapsed: function() {
        return this._map && !this.options.collapsed && this.expand(), this;
      },
      _expandSafely: function() {
        var e = this._section;
        Te(e, "click", Fe), this.expand(), setTimeout(function() {
          _t(e, "click", Fe);
        });
      }
    }), js = function(e, o, u) {
      return new Ws(e, o, u);
    }, wn = En.extend({
      options: {
        position: "topleft",
        zoomInText: '<span aria-hidden="true">+</span>',
        zoomInTitle: "Zoom in",
        zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
        zoomOutTitle: "Zoom out"
      },
      onAdd: function(e) {
        var o = "leaflet-control-zoom", u = Qe("div", o + " leaflet-bar"), p = this.options;
        return this._zoomInButton = this._createButton(
          p.zoomInText,
          p.zoomInTitle,
          o + "-in",
          u,
          this._zoomIn
        ), this._zoomOutButton = this._createButton(
          p.zoomOutText,
          p.zoomOutTitle,
          o + "-out",
          u,
          this._zoomOut
        ), this._updateDisabled(), e.on("zoomend zoomlevelschange", this._updateDisabled, this), u;
      },
      onRemove: function(e) {
        e.off("zoomend zoomlevelschange", this._updateDisabled, this);
      },
      disable: function() {
        return this._disabled = !0, this._updateDisabled(), this;
      },
      enable: function() {
        return this._disabled = !1, this._updateDisabled(), this;
      },
      _zoomIn: function(e) {
        !this._disabled && this._map._zoom < this._map.getMaxZoom() && this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
      },
      _zoomOut: function(e) {
        !this._disabled && this._map._zoom > this._map.getMinZoom() && this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
      },
      _createButton: function(e, o, u, p, b) {
        var P = Qe("a", u, p);
        return P.innerHTML = e, P.href = "#", P.title = o, P.setAttribute("role", "button"), P.setAttribute("aria-label", o), mo(P), Te(P, "click", st), Te(P, "click", b, this), Te(P, "click", this._refocusOnMap, this), P;
      },
      _updateDisabled: function() {
        var e = this._map, o = "leaflet-disabled";
        St(this._zoomInButton, o), St(this._zoomOutButton, o), this._zoomInButton.setAttribute("aria-disabled", "false"), this._zoomOutButton.setAttribute("aria-disabled", "false"), (this._disabled || e._zoom === e.getMinZoom()) && (ze(this._zoomOutButton, o), this._zoomOutButton.setAttribute("aria-disabled", "true")), (this._disabled || e._zoom === e.getMaxZoom()) && (ze(this._zoomInButton, o), this._zoomInButton.setAttribute("aria-disabled", "true"));
      }
    });
    et.mergeOptions({
      zoomControl: !0
    }), et.addInitHook(function() {
      this.options.zoomControl && (this.zoomControl = new wn(), this.addControl(this.zoomControl));
    });
    var Da = function(e) {
      return new wn(e);
    }, Gs = En.extend({
      options: {
        position: "bottomleft",
        maxWidth: 100,
        metric: !0,
        imperial: !0
      },
      onAdd: function(e) {
        var o = "leaflet-control-scale", u = Qe("div", o), p = this.options;
        return this._addScales(p, o + "-line", u), e.on(p.updateWhenIdle ? "moveend" : "move", this._update, this), e.whenReady(this._update, this), u;
      },
      onRemove: function(e) {
        e.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
      },
      _addScales: function(e, o, u) {
        e.metric && (this._mScale = Qe("div", o, u)), e.imperial && (this._iScale = Qe("div", o, u));
      },
      _update: function() {
        var e = this._map, o = e.getSize().y / 2, u = e.distance(
          e.containerPointToLatLng([0, o]),
          e.containerPointToLatLng([this.options.maxWidth, o])
        );
        this._updateScales(u);
      },
      _updateScales: function(e) {
        this.options.metric && e && this._updateMetric(e), this.options.imperial && e && this._updateImperial(e);
      },
      _updateMetric: function(e) {
        var o = this._getRoundNum(e), u = o < 1e3 ? o + " m" : o / 1e3 + " km";
        this._updateScale(this._mScale, u, o / e);
      },
      _updateImperial: function(e) {
        var o = e * 3.2808399, u, p, b;
        o > 5280 ? (u = o / 5280, p = this._getRoundNum(u), this._updateScale(this._iScale, p + " mi", p / u)) : (b = this._getRoundNum(o), this._updateScale(this._iScale, b + " ft", b / o));
      },
      _updateScale: function(e, o, u) {
        e.style.width = Math.round(this.options.maxWidth * u) + "px", e.innerHTML = o;
      },
      _getRoundNum: function(e) {
        var o = Math.pow(10, (Math.floor(e) + "").length - 1), u = e / o;
        return u = u >= 10 ? 10 : u >= 5 ? 5 : u >= 3 ? 3 : u >= 2 ? 2 : 1, o * u;
      }
    }), ka = function(e) {
      return new Gs(e);
    }, Aa = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>', Xo = En.extend({
      options: {
        position: "bottomright",
        prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (be.inlineSvg ? Aa + " " : "") + "Leaflet</a>"
      },
      initialize: function(e) {
        B(this, e), this._attributions = {};
      },
      onAdd: function(e) {
        e.attributionControl = this, this._container = Qe("div", "leaflet-control-attribution"), mo(this._container);
        for (var o in e._layers)
          e._layers[o].getAttribution && this.addAttribution(e._layers[o].getAttribution());
        return this._update(), e.on("layeradd", this._addAttribution, this), this._container;
      },
      onRemove: function(e) {
        e.off("layeradd", this._addAttribution, this);
      },
      _addAttribution: function(e) {
        e.layer.getAttribution && (this.addAttribution(e.layer.getAttribution()), e.layer.once("remove", function() {
          this.removeAttribution(e.layer.getAttribution());
        }, this));
      },
      setPrefix: function(e) {
        return this.options.prefix = e, this._update(), this;
      },
      addAttribution: function(e) {
        return e ? (this._attributions[e] || (this._attributions[e] = 0), this._attributions[e]++, this._update(), this) : this;
      },
      removeAttribution: function(e) {
        return e ? (this._attributions[e] && (this._attributions[e]--, this._update()), this) : this;
      },
      _update: function() {
        if (this._map) {
          var e = [];
          for (var o in this._attributions)
            this._attributions[o] && e.push(o);
          var u = [];
          this.options.prefix && u.push(this.options.prefix), e.length && u.push(e.join(", ")), this._container.innerHTML = u.join(' <span aria-hidden="true">|</span> ');
        }
      }
    });
    et.mergeOptions({
      attributionControl: !0
    }), et.addInitHook(function() {
      this.options.attributionControl && new Xo().addTo(this);
    });
    var Ia = function(e) {
      return new Xo(e);
    };
    En.Layers = Ws, En.Zoom = wn, En.Scale = Gs, En.Attribution = Xo, ci.layers = js, ci.zoom = Da, ci.scale = ka, ci.attribution = Ia;
    var zt = Dt.extend({
      initialize: function(e) {
        this._map = e;
      },
      enable: function() {
        return this._enabled ? this : (this._enabled = !0, this.addHooks(), this);
      },
      disable: function() {
        return this._enabled ? (this._enabled = !1, this.removeHooks(), this) : this;
      },
      enabled: function() {
        return !!this._enabled;
      }
    });
    zt.addTo = function(e, o) {
      return e.addHandler(o, this), this;
    };
    var ql = { Events: It }, Pn = be.touch ? "touchstart mousedown" : "mousedown", Gi = Kt.extend({
      options: {
        clickTolerance: 3
      },
      initialize: function(e, o, u, p) {
        B(this, p), this._element = e, this._dragStartTarget = o || e, this._preventOutline = u;
      },
      enable: function() {
        this._enabled || (Te(this._dragStartTarget, Pn, this._onDown, this), this._enabled = !0);
      },
      disable: function() {
        this._enabled && (Gi._dragging === this && this.finishDrag(!0), _t(this._dragStartTarget, Pn, this._onDown, this), this._enabled = !1, this._moved = !1);
      },
      _onDown: function(e) {
        if (this._enabled && (this._moved = !1, !Ut(this._element, "leaflet-zoom-anim"))) {
          if (e.touches && e.touches.length !== 1) {
            Gi._dragging === this && this.finishDrag();
            return;
          }
          if (!(Gi._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) && (Gi._dragging = this, this._preventOutline && mt(this._element), ke(), F(), !this._moving)) {
            this.fire("down");
            var o = e.touches ? e.touches[0] : e, u = Zt(this._element);
            this._startPoint = new we(o.clientX, o.clientY), this._startPos = R(this._element), this._parentScale = Wi(u);
            var p = e.type === "mousedown";
            Te(document, p ? "mousemove" : "touchmove", this._onMove, this), Te(document, p ? "mouseup" : "touchend touchcancel", this._onUp, this);
          }
        }
      },
      _onMove: function(e) {
        if (this._enabled) {
          if (e.touches && e.touches.length > 1) {
            this._moved = !0;
            return;
          }
          var o = e.touches && e.touches.length === 1 ? e.touches[0] : e, u = new we(o.clientX, o.clientY)._subtract(this._startPoint);
          !u.x && !u.y || Math.abs(u.x) + Math.abs(u.y) < this.options.clickTolerance || (u.x /= this._parentScale.x, u.y /= this._parentScale.y, Fe(e), this._moved || (this.fire("dragstart"), this._moved = !0, ze(document.body, "leaflet-dragging"), this._lastTarget = e.target || e.srcElement, window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance && (this._lastTarget = this._lastTarget.correspondingUseElement), ze(this._lastTarget, "leaflet-drag-target")), this._newPos = this._startPos.add(u), this._moving = !0, this._lastEvent = e, this._updatePosition());
        }
      },
      _updatePosition: function() {
        var e = { originalEvent: this._lastEvent };
        this.fire("predrag", e), A(this._element, this._newPos), this.fire("drag", e);
      },
      _onUp: function() {
        this._enabled && this.finishDrag();
      },
      finishDrag: function(e) {
        St(document.body, "leaflet-dragging"), this._lastTarget && (St(this._lastTarget, "leaflet-drag-target"), this._lastTarget = null), _t(document, "mousemove touchmove", this._onMove, this), _t(document, "mouseup touchend touchcancel", this._onUp, this), Ie(), G(), this._moved && this._moving && this.fire("dragend", {
          noInertia: e,
          distance: this._newPos.distanceTo(this._startPos)
        }), this._moving = !1, Gi._dragging = !1;
      }
    });
    function qs(e, o) {
      if (!o || !e.length)
        return e.slice();
      var u = o * o;
      return e = qi(e, u), e = Ys(e, u), e;
    }
    function Ai(e, o, u) {
      return Math.sqrt(_o(e, o, u, !0));
    }
    function Qo(e, o, u) {
      return _o(e, o, u);
    }
    function Ys(e, o) {
      var u = e.length, p = typeof Uint8Array != void 0 + "" ? Uint8Array : Array, b = new p(u);
      b[0] = b[u - 1] = 1, Ct(e, b, o, 0, u - 1);
      var P, $ = [];
      for (P = 0; P < u; P++)
        b[P] && $.push(e[P]);
      return $;
    }
    function Ct(e, o, u, p, b) {
      var P = 0, $, V, j;
      for (V = p + 1; V <= b - 1; V++)
        j = _o(e[V], e[p], e[b], !0), j > P && ($ = V, P = j);
      P > u && (o[$] = 1, Ct(e, o, u, p, $), Ct(e, o, u, $, b));
    }
    function qi(e, o) {
      for (var u = [e[0]], p = 1, b = 0, P = e.length; p < P; p++)
        Yl(e[p], e[b]) > o && (u.push(e[p]), b = p);
      return b < P - 1 && u.push(e[P - 1]), u;
    }
    var es;
    function Na(e, o, u, p, b) {
      var P = p ? es : gr(e, u), $ = gr(o, u), V, j, oe;
      for (es = $; ; ) {
        if (!(P | $))
          return [e, o];
        if (P & $)
          return !1;
        V = P || $, j = Ur(e, o, V, u, b), oe = gr(j, u), V === P ? (e = j, P = oe) : (o = j, $ = oe);
      }
    }
    function Ur(e, o, u, p, b) {
      var P = o.x - e.x, $ = o.y - e.y, V = p.min, j = p.max, oe, ge;
      return u & 8 ? (oe = e.x + P * (j.y - e.y) / $, ge = j.y) : u & 4 ? (oe = e.x + P * (V.y - e.y) / $, ge = V.y) : u & 2 ? (oe = j.x, ge = e.y + $ * (j.x - e.x) / P) : u & 1 && (oe = V.x, ge = e.y + $ * (V.x - e.x) / P), new we(oe, ge, b);
    }
    function gr(e, o) {
      var u = 0;
      return e.x < o.min.x ? u |= 1 : e.x > o.max.x && (u |= 2), e.y < o.min.y ? u |= 4 : e.y > o.max.y && (u |= 8), u;
    }
    function Yl(e, o) {
      var u = o.x - e.x, p = o.y - e.y;
      return u * u + p * p;
    }
    function _o(e, o, u, p) {
      var b = o.x, P = o.y, $ = u.x - b, V = u.y - P, j = $ * $ + V * V, oe;
      return j > 0 && (oe = ((e.x - b) * $ + (e.y - P) * V) / j, oe > 1 ? (b = u.x, P = u.y) : oe > 0 && (b += $ * oe, P += V * oe)), $ = e.x - b, V = e.y - P, p ? $ * $ + V * V : new we(b, P);
    }
    function Mn(e) {
      return !re(e[0]) || typeof e[0][0] != "object" && typeof e[0][0] < "u";
    }
    function go(e) {
      return console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead."), Mn(e);
    }
    function vr(e, o) {
      var u, p, b, P, $, V, j, oe;
      if (!e || e.length === 0)
        throw new Error("latlngs not passed");
      Mn(e) || (console.warn("latlngs are not flat! Only the first ring will be used"), e = e[0]);
      var ge = [];
      for (var Oe in e)
        ge.push(o.project(ot(e[Oe])));
      var Ve = ge.length;
      for (u = 0, p = 0; u < Ve - 1; u++)
        p += ge[u].distanceTo(ge[u + 1]) / 2;
      if (p === 0)
        oe = ge[0];
      else
        for (u = 0, P = 0; u < Ve - 1; u++)
          if ($ = ge[u], V = ge[u + 1], b = $.distanceTo(V), P += b, P > p) {
            j = (P - p) / b, oe = [
              V.x - j * (V.x - $.x),
              V.y - j * (V.y - $.y)
            ];
            break;
          }
      return o.unproject(_e(oe));
    }
    var Kl = {
      __proto__: null,
      simplify: qs,
      pointToSegmentDistance: Ai,
      closestPointOnSegment: Qo,
      clipSegment: Na,
      _getEdgeIntersection: Ur,
      _getBitCode: gr,
      _sqClosestPointOnSegment: _o,
      isFlat: Mn,
      _flat: go,
      polylineCenter: vr
    };
    function Ks(e, o, u) {
      var p, b = [1, 4, 2, 8], P, $, V, j, oe, ge, Oe, Ve;
      for (P = 0, ge = e.length; P < ge; P++)
        e[P]._code = gr(e[P], o);
      for (V = 0; V < 4; V++) {
        for (Oe = b[V], p = [], P = 0, ge = e.length, $ = ge - 1; P < ge; $ = P++)
          j = e[P], oe = e[$], j._code & Oe ? oe._code & Oe || (Ve = Ur(oe, j, Oe, o, u), Ve._code = gr(Ve, o), p.push(Ve)) : (oe._code & Oe && (Ve = Ur(oe, j, Oe, o, u), Ve._code = gr(Ve, o), p.push(Ve)), p.push(j));
        e = p;
      }
      return e;
    }
    function Js(e, o) {
      var u, p, b, P, $, V, j, oe, ge;
      if (!e || e.length === 0)
        throw new Error("latlngs not passed");
      Mn(e) || (console.warn("latlngs are not flat! Only the first ring will be used"), e = e[0]);
      var Oe = [];
      for (var Ve in e)
        Oe.push(o.project(ot(e[Ve])));
      var bn = Oe.length;
      for (V = j = oe = 0, u = 0, p = bn - 1; u < bn; p = u++)
        b = Oe[u], P = Oe[p], $ = b.y * P.x - P.y * b.x, j += (b.x + P.x) * $, oe += (b.y + P.y) * $, V += $ * 3;
      return V === 0 ? ge = Oe[0] : ge = [j / V, oe / V], o.unproject(_e(ge));
    }
    var Xs = {
      __proto__: null,
      clipPolygon: Ks,
      polygonCenter: Js
    }, vo = {
      project: function(e) {
        return new we(e.lng, e.lat);
      },
      unproject: function(e) {
        return new $e(e.y, e.x);
      },
      bounds: new Be([-180, -90], [180, 90])
    }, ts = {
      R: 6378137,
      R_MINOR: 6356752314245179e-9,
      bounds: new Be([-2003750834279e-5, -1549657073972e-5], [2003750834279e-5, 1876465623138e-5]),
      project: function(e) {
        var o = Math.PI / 180, u = this.R, p = e.lat * o, b = this.R_MINOR / u, P = Math.sqrt(1 - b * b), $ = P * Math.sin(p), V = Math.tan(Math.PI / 4 - p / 2) / Math.pow((1 - $) / (1 + $), P / 2);
        return p = -u * Math.log(Math.max(V, 1e-10)), new we(e.lng * o * u, p);
      },
      unproject: function(e) {
        for (var o = 180 / Math.PI, u = this.R, p = this.R_MINOR / u, b = Math.sqrt(1 - p * p), P = Math.exp(-e.y / u), $ = Math.PI / 2 - 2 * Math.atan(P), V = 0, j = 0.1, oe; V < 15 && Math.abs(j) > 1e-7; V++)
          oe = b * Math.sin($), oe = Math.pow((1 - oe) / (1 + oe), b / 2), j = Math.PI / 2 - 2 * Math.atan(P * oe) - $, $ += j;
        return new $e($ * o, e.x * o / u);
      }
    }, Jl = {
      __proto__: null,
      LonLat: vo,
      Mercator: ts,
      SphericalMercator: Mi
    }, Qs = a({}, en, {
      code: "EPSG:3395",
      projection: ts,
      transformation: function() {
        var e = 0.5 / (Math.PI * ts.R);
        return pt(e, 0.5, -e, 0.5);
      }()
    }), ns = a({}, en, {
      code: "EPSG:4326",
      projection: vo,
      transformation: pt(1 / 180, 1, -1 / 180, 0.5)
    }), Xl = a({}, Tn, {
      projection: vo,
      transformation: pt(1, 0, -1, 0),
      scale: function(e) {
        return Math.pow(2, e);
      },
      zoom: function(e) {
        return Math.log(e) / Math.LN2;
      },
      distance: function(e, o) {
        var u = o.lng - e.lng, p = o.lat - e.lat;
        return Math.sqrt(u * u + p * p);
      },
      infinite: !0
    });
    Tn.Earth = en, Tn.EPSG3395 = Qs, Tn.EPSG3857 = jt, Tn.EPSG900913 = Ke, Tn.EPSG4326 = ns, Tn.Simple = Xl;
    var Wn = Kt.extend({
      options: {
        pane: "overlayPane",
        attribution: null,
        bubblingMouseEvents: !0
      },
      addTo: function(e) {
        return e.addLayer(this), this;
      },
      remove: function() {
        return this.removeFrom(this._map || this._mapToAdd);
      },
      removeFrom: function(e) {
        return e && e.removeLayer(this), this;
      },
      getPane: function(e) {
        return this._map.getPane(e ? this.options[e] || e : this.options.pane);
      },
      addInteractiveTarget: function(e) {
        return this._map._targets[y(e)] = this, this;
      },
      removeInteractiveTarget: function(e) {
        return delete this._map._targets[y(e)], this;
      },
      getAttribution: function() {
        return this.options.attribution;
      },
      _layerAdd: function(e) {
        var o = e.target;
        if (o.hasLayer(this)) {
          if (this._map = o, this._zoomAnimated = o._zoomAnimated, this.getEvents) {
            var u = this.getEvents();
            o.on(u, this), this.once("remove", function() {
              o.off(u, this);
            }, this);
          }
          this.onAdd(o), this.fire("add"), o.fire("layeradd", { layer: this });
        }
      }
    });
    et.include({
      addLayer: function(e) {
        if (!e._layerAdd)
          throw new Error("The provided object is not a Layer.");
        var o = y(e);
        return this._layers[o] ? this : (this._layers[o] = e, e._mapToAdd = this, e.beforeAdd && e.beforeAdd(this), this.whenReady(e._layerAdd, e), this);
      },
      removeLayer: function(e) {
        var o = y(e);
        return this._layers[o] ? (this._loaded && e.onRemove(this), delete this._layers[o], this._loaded && (this.fire("layerremove", { layer: e }), e.fire("remove")), e._map = e._mapToAdd = null, this) : this;
      },
      hasLayer: function(e) {
        return y(e) in this._layers;
      },
      eachLayer: function(e, o) {
        for (var u in this._layers)
          e.call(o, this._layers[u]);
        return this;
      },
      _addLayers: function(e) {
        e = e ? re(e) ? e : [e] : [];
        for (var o = 0, u = e.length; o < u; o++)
          this.addLayer(e[o]);
      },
      _addZoomLimit: function(e) {
        (!isNaN(e.options.maxZoom) || !isNaN(e.options.minZoom)) && (this._zoomBoundLayers[y(e)] = e, this._updateZoomLevels());
      },
      _removeZoomLimit: function(e) {
        var o = y(e);
        this._zoomBoundLayers[o] && (delete this._zoomBoundLayers[o], this._updateZoomLevels());
      },
      _updateZoomLevels: function() {
        var e = 1 / 0, o = -1 / 0, u = this._getZoomSpan();
        for (var p in this._zoomBoundLayers) {
          var b = this._zoomBoundLayers[p].options;
          e = b.minZoom === void 0 ? e : Math.min(e, b.minZoom), o = b.maxZoom === void 0 ? o : Math.max(o, b.maxZoom);
        }
        this._layersMaxZoom = o === -1 / 0 ? void 0 : o, this._layersMinZoom = e === 1 / 0 ? void 0 : e, u !== this._getZoomSpan() && this.fire("zoomlevelschange"), this.options.maxZoom === void 0 && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom && this.setZoom(this._layersMaxZoom), this.options.minZoom === void 0 && this._layersMinZoom && this.getZoom() < this._layersMinZoom && this.setZoom(this._layersMinZoom);
      }
    });
    var Qt = Wn.extend({
      initialize: function(e, o) {
        B(this, o), this._layers = {};
        var u, p;
        if (e)
          for (u = 0, p = e.length; u < p; u++)
            this.addLayer(e[u]);
      },
      addLayer: function(e) {
        var o = this.getLayerId(e);
        return this._layers[o] = e, this._map && this._map.addLayer(e), this;
      },
      removeLayer: function(e) {
        var o = e in this._layers ? e : this.getLayerId(e);
        return this._map && this._layers[o] && this._map.removeLayer(this._layers[o]), delete this._layers[o], this;
      },
      hasLayer: function(e) {
        var o = typeof e == "number" ? e : this.getLayerId(e);
        return o in this._layers;
      },
      clearLayers: function() {
        return this.eachLayer(this.removeLayer, this);
      },
      invoke: function(e) {
        var o = Array.prototype.slice.call(arguments, 1), u, p;
        for (u in this._layers)
          p = this._layers[u], p[e] && p[e].apply(p, o);
        return this;
      },
      onAdd: function(e) {
        this.eachLayer(e.addLayer, e);
      },
      onRemove: function(e) {
        this.eachLayer(e.removeLayer, e);
      },
      eachLayer: function(e, o) {
        for (var u in this._layers)
          e.call(o, this._layers[u]);
        return this;
      },
      getLayer: function(e) {
        return this._layers[e];
      },
      getLayers: function() {
        var e = [];
        return this.eachLayer(e.push, e), e;
      },
      setZIndex: function(e) {
        return this.invoke("setZIndex", e);
      },
      getLayerId: function(e) {
        return y(e);
      }
    }), ea = function(e, o) {
      return new Qt(e, o);
    }, On = Qt.extend({
      addLayer: function(e) {
        return this.hasLayer(e) ? this : (e.addEventParent(this), Qt.prototype.addLayer.call(this, e), this.fire("layeradd", { layer: e }));
      },
      removeLayer: function(e) {
        return this.hasLayer(e) ? (e in this._layers && (e = this._layers[e]), e.removeEventParent(this), Qt.prototype.removeLayer.call(this, e), this.fire("layerremove", { layer: e })) : this;
      },
      setStyle: function(e) {
        return this.invoke("setStyle", e);
      },
      bringToFront: function() {
        return this.invoke("bringToFront");
      },
      bringToBack: function() {
        return this.invoke("bringToBack");
      },
      getBounds: function() {
        var e = new Ht();
        for (var o in this._layers) {
          var u = this._layers[o];
          e.extend(u.getBounds ? u.getBounds() : u.getLatLng());
        }
        return e;
      }
    }), Ra = function(e, o) {
      return new On(e, o);
    }, yr = Dt.extend({
      options: {
        popupAnchor: [0, 0],
        tooltipAnchor: [0, 0],
        crossOrigin: !1
      },
      initialize: function(e) {
        B(this, e);
      },
      createIcon: function(e) {
        return this._createIcon("icon", e);
      },
      createShadow: function(e) {
        return this._createIcon("shadow", e);
      },
      _createIcon: function(e, o) {
        var u = this._getIconUrl(e);
        if (!u) {
          if (e === "icon")
            throw new Error("iconUrl not set in Icon options (see the docs).");
          return null;
        }
        var p = this._createImg(u, o && o.tagName === "IMG" ? o : null);
        return this._setIconStyles(p, e), (this.options.crossOrigin || this.options.crossOrigin === "") && (p.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), p;
      },
      _setIconStyles: function(e, o) {
        var u = this.options, p = u[o + "Size"];
        typeof p == "number" && (p = [p, p]);
        var b = _e(p), P = _e(o === "shadow" && u.shadowAnchor || u.iconAnchor || b && b.divideBy(2, !0));
        e.className = "leaflet-marker-" + o + " " + (u.className || ""), P && (e.style.marginLeft = -P.x + "px", e.style.marginTop = -P.y + "px"), b && (e.style.width = b.x + "px", e.style.height = b.y + "px");
      },
      _createImg: function(e, o) {
        return o = o || document.createElement("img"), o.src = e, o;
      },
      _getIconUrl: function(e) {
        return be.retina && this.options[e + "RetinaUrl"] || this.options[e + "Url"];
      }
    });
    function Ql(e) {
      return new yr(e);
    }
    var yo = yr.extend({
      options: {
        iconUrl: "marker-icon.png",
        iconRetinaUrl: "marker-icon-2x.png",
        shadowUrl: "marker-shadow.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowSize: [41, 41]
      },
      _getIconUrl: function(e) {
        return typeof yo.imagePath != "string" && (yo.imagePath = this._detectIconPath()), (this.options.imagePath || yo.imagePath) + yr.prototype._getIconUrl.call(this, e);
      },
      _stripUrl: function(e) {
        var o = function(u, p, b) {
          var P = p.exec(u);
          return P && P[b];
        };
        return e = o(e, /^url\((['"])?(.+)\1\)$/, 2), e && o(e, /^(.*)marker-icon\.png$/, 1);
      },
      _detectIconPath: function() {
        var e = Qe("div", "leaflet-default-icon-path", document.body), o = Zi(e, "background-image") || Zi(e, "backgroundImage");
        if (document.body.removeChild(e), o = this._stripUrl(o), o)
          return o;
        var u = document.querySelector('link[href$="leaflet.css"]');
        return u ? u.href.substring(0, u.href.length - 11 - 1) : "";
      }
    }), $a = zt.extend({
      initialize: function(e) {
        this._marker = e;
      },
      addHooks: function() {
        var e = this._marker._icon;
        this._draggable || (this._draggable = new Gi(e, e, !0)), this._draggable.on({
          dragstart: this._onDragStart,
          predrag: this._onPreDrag,
          drag: this._onDrag,
          dragend: this._onDragEnd
        }, this).enable(), ze(e, "leaflet-marker-draggable");
      },
      removeHooks: function() {
        this._draggable.off({
          dragstart: this._onDragStart,
          predrag: this._onPreDrag,
          drag: this._onDrag,
          dragend: this._onDragEnd
        }, this).disable(), this._marker._icon && St(this._marker._icon, "leaflet-marker-draggable");
      },
      moved: function() {
        return this._draggable && this._draggable._moved;
      },
      _adjustPan: function(e) {
        var o = this._marker, u = o._map, p = this._marker.options.autoPanSpeed, b = this._marker.options.autoPanPadding, P = R(o._icon), $ = u.getPixelBounds(), V = u.getPixelOrigin(), j = Nt(
          $.min._subtract(V).add(b),
          $.max._subtract(V).subtract(b)
        );
        if (!j.contains(P)) {
          var oe = _e(
            (Math.max(j.max.x, P.x) - j.max.x) / ($.max.x - j.max.x) - (Math.min(j.min.x, P.x) - j.min.x) / ($.min.x - j.min.x),
            (Math.max(j.max.y, P.y) - j.max.y) / ($.max.y - j.max.y) - (Math.min(j.min.y, P.y) - j.min.y) / ($.min.y - j.min.y)
          ).multiplyBy(p);
          u.panBy(oe, { animate: !1 }), this._draggable._newPos._add(oe), this._draggable._startPos._add(oe), A(o._icon, this._draggable._newPos), this._onDrag(e), this._panRequest = Pt(this._adjustPan.bind(this, e));
        }
      },
      _onDragStart: function() {
        this._oldLatLng = this._marker.getLatLng(), this._marker.closePopup && this._marker.closePopup(), this._marker.fire("movestart").fire("dragstart");
      },
      _onPreDrag: function(e) {
        this._marker.options.autoPan && (xt(this._panRequest), this._panRequest = Pt(this._adjustPan.bind(this, e)));
      },
      _onDrag: function(e) {
        var o = this._marker, u = o._shadow, p = R(o._icon), b = o._map.layerPointToLatLng(p);
        u && A(u, p), o._latlng = b, e.latlng = b, e.oldLatLng = this._oldLatLng, o.fire("move", e).fire("drag", e);
      },
      _onDragEnd: function(e) {
        xt(this._panRequest), delete this._oldLatLng, this._marker.fire("moveend").fire("dragend", e);
      }
    }), is = Wn.extend({
      options: {
        icon: new yo(),
        interactive: !0,
        keyboard: !0,
        title: "",
        alt: "Marker",
        zIndexOffset: 0,
        opacity: 1,
        riseOnHover: !1,
        riseOffset: 250,
        pane: "markerPane",
        shadowPane: "shadowPane",
        bubblingMouseEvents: !1,
        autoPanOnFocus: !0,
        draggable: !1,
        autoPan: !1,
        autoPanPadding: [50, 50],
        autoPanSpeed: 10
      },
      initialize: function(e, o) {
        B(this, o), this._latlng = ot(e);
      },
      onAdd: function(e) {
        this._zoomAnimated = this._zoomAnimated && e.options.markerZoomAnimation, this._zoomAnimated && e.on("zoomanim", this._animateZoom, this), this._initIcon(), this.update();
      },
      onRemove: function(e) {
        this.dragging && this.dragging.enabled() && (this.options.draggable = !0, this.dragging.removeHooks()), delete this.dragging, this._zoomAnimated && e.off("zoomanim", this._animateZoom, this), this._removeIcon(), this._removeShadow();
      },
      getEvents: function() {
        return {
          zoom: this.update,
          viewreset: this.update
        };
      },
      getLatLng: function() {
        return this._latlng;
      },
      setLatLng: function(e) {
        var o = this._latlng;
        return this._latlng = ot(e), this.update(), this.fire("move", { oldLatLng: o, latlng: this._latlng });
      },
      setZIndexOffset: function(e) {
        return this.options.zIndexOffset = e, this.update();
      },
      getIcon: function() {
        return this.options.icon;
      },
      setIcon: function(e) {
        return this.options.icon = e, this._map && (this._initIcon(), this.update()), this._popup && this.bindPopup(this._popup, this._popup.options), this;
      },
      getElement: function() {
        return this._icon;
      },
      update: function() {
        if (this._icon && this._map) {
          var e = this._map.latLngToLayerPoint(this._latlng).round();
          this._setPos(e);
        }
        return this;
      },
      _initIcon: function() {
        var e = this.options, o = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide"), u = e.icon.createIcon(this._icon), p = !1;
        u !== this._icon && (this._icon && this._removeIcon(), p = !0, e.title && (u.title = e.title), u.tagName === "IMG" && (u.alt = e.alt || "")), ze(u, o), e.keyboard && (u.tabIndex = "0", u.setAttribute("role", "button")), this._icon = u, e.riseOnHover && this.on({
          mouseover: this._bringToFront,
          mouseout: this._resetZIndex
        }), this.options.autoPanOnFocus && Te(u, "focus", this._panOnFocus, this);
        var b = e.icon.createShadow(this._shadow), P = !1;
        b !== this._shadow && (this._removeShadow(), P = !0), b && (ze(b, o), b.alt = ""), this._shadow = b, e.opacity < 1 && this._updateOpacity(), p && this.getPane().appendChild(this._icon), this._initInteraction(), b && P && this.getPane(e.shadowPane).appendChild(this._shadow);
      },
      _removeIcon: function() {
        this.options.riseOnHover && this.off({
          mouseover: this._bringToFront,
          mouseout: this._resetZIndex
        }), this.options.autoPanOnFocus && _t(this._icon, "focus", this._panOnFocus, this), yt(this._icon), this.removeInteractiveTarget(this._icon), this._icon = null;
      },
      _removeShadow: function() {
        this._shadow && yt(this._shadow), this._shadow = null;
      },
      _setPos: function(e) {
        this._icon && A(this._icon, e), this._shadow && A(this._shadow, e), this._zIndex = e.y + this.options.zIndexOffset, this._resetZIndex();
      },
      _updateZIndex: function(e) {
        this._icon && (this._icon.style.zIndex = this._zIndex + e);
      },
      _animateZoom: function(e) {
        var o = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center).round();
        this._setPos(o);
      },
      _initInteraction: function() {
        if (this.options.interactive && (ze(this._icon, "leaflet-interactive"), this.addInteractiveTarget(this._icon), $a)) {
          var e = this.options.draggable;
          this.dragging && (e = this.dragging.enabled(), this.dragging.disable()), this.dragging = new $a(this), e && this.dragging.enable();
        }
      },
      setOpacity: function(e) {
        return this.options.opacity = e, this._map && this._updateOpacity(), this;
      },
      _updateOpacity: function() {
        var e = this.options.opacity;
        this._icon && _(this._icon, e), this._shadow && _(this._shadow, e);
      },
      _bringToFront: function() {
        this._updateZIndex(this.options.riseOffset);
      },
      _resetZIndex: function() {
        this._updateZIndex(0);
      },
      _panOnFocus: function() {
        var e = this._map;
        if (e) {
          var o = this.options.icon.options, u = o.iconSize ? _e(o.iconSize) : _e(0, 0), p = o.iconAnchor ? _e(o.iconAnchor) : _e(0, 0);
          e.panInside(this._latlng, {
            paddingTopLeft: p,
            paddingBottomRight: u.subtract(p)
          });
        }
      },
      _getPopupAnchor: function() {
        return this.options.icon.options.popupAnchor;
      },
      _getTooltipAnchor: function() {
        return this.options.icon.options.tooltipAnchor;
      }
    });
    function eu(e, o) {
      return new is(e, o);
    }
    var xn = Wn.extend({
      options: {
        stroke: !0,
        color: "#3388ff",
        weight: 3,
        opacity: 1,
        lineCap: "round",
        lineJoin: "round",
        dashArray: null,
        dashOffset: null,
        fill: !1,
        fillColor: null,
        fillOpacity: 0.2,
        fillRule: "evenodd",
        interactive: !0,
        bubblingMouseEvents: !0
      },
      beforeAdd: function(e) {
        this._renderer = e.getRenderer(this);
      },
      onAdd: function() {
        this._renderer._initPath(this), this._reset(), this._renderer._addPath(this);
      },
      onRemove: function() {
        this._renderer._removePath(this);
      },
      redraw: function() {
        return this._map && this._renderer._updatePath(this), this;
      },
      setStyle: function(e) {
        return B(this, e), this._renderer && (this._renderer._updateStyle(this), this.options.stroke && e && Object.prototype.hasOwnProperty.call(e, "weight") && this._updateBounds()), this;
      },
      bringToFront: function() {
        return this._renderer && this._renderer._bringToFront(this), this;
      },
      bringToBack: function() {
        return this._renderer && this._renderer._bringToBack(this), this;
      },
      getElement: function() {
        return this._path;
      },
      _reset: function() {
        this._project(), this._update();
      },
      _clickTolerance: function() {
        return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
      }
    }), rs = xn.extend({
      options: {
        fill: !0,
        radius: 10
      },
      initialize: function(e, o) {
        B(this, o), this._latlng = ot(e), this._radius = this.options.radius;
      },
      setLatLng: function(e) {
        var o = this._latlng;
        return this._latlng = ot(e), this.redraw(), this.fire("move", { oldLatLng: o, latlng: this._latlng });
      },
      getLatLng: function() {
        return this._latlng;
      },
      setRadius: function(e) {
        return this.options.radius = this._radius = e, this.redraw();
      },
      getRadius: function() {
        return this._radius;
      },
      setStyle: function(e) {
        var o = e && e.radius || this._radius;
        return xn.prototype.setStyle.call(this, e), this.setRadius(o), this;
      },
      _project: function() {
        this._point = this._map.latLngToLayerPoint(this._latlng), this._updateBounds();
      },
      _updateBounds: function() {
        var e = this._radius, o = this._radiusY || e, u = this._clickTolerance(), p = [e + u, o + u];
        this._pxBounds = new Be(this._point.subtract(p), this._point.add(p));
      },
      _update: function() {
        this._map && this._updatePath();
      },
      _updatePath: function() {
        this._renderer._updateCircle(this);
      },
      _empty: function() {
        return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
      },
      _containsPoint: function(e) {
        return e.distanceTo(this._point) <= this._radius + this._clickTolerance();
      }
    });
    function tu(e, o) {
      return new rs(e, o);
    }
    var Lo = rs.extend({
      initialize: function(e, o, u) {
        if (typeof o == "number" && (o = a({}, u, { radius: o })), B(this, o), this._latlng = ot(e), isNaN(this.options.radius))
          throw new Error("Circle radius cannot be NaN");
        this._mRadius = this.options.radius;
      },
      setRadius: function(e) {
        return this._mRadius = e, this.redraw();
      },
      getRadius: function() {
        return this._mRadius;
      },
      getBounds: function() {
        var e = [this._radius, this._radiusY || this._radius];
        return new Ht(
          this._map.layerPointToLatLng(this._point.subtract(e)),
          this._map.layerPointToLatLng(this._point.add(e))
        );
      },
      setStyle: xn.prototype.setStyle,
      _project: function() {
        var e = this._latlng.lng, o = this._latlng.lat, u = this._map, p = u.options.crs;
        if (p.distance === en.distance) {
          var b = Math.PI / 180, P = this._mRadius / en.R / b, $ = u.project([o + P, e]), V = u.project([o - P, e]), j = $.add(V).divideBy(2), oe = u.unproject(j).lat, ge = Math.acos((Math.cos(P * b) - Math.sin(o * b) * Math.sin(oe * b)) / (Math.cos(o * b) * Math.cos(oe * b))) / b;
          (isNaN(ge) || ge === 0) && (ge = P / Math.cos(Math.PI / 180 * o)), this._point = j.subtract(u.getPixelOrigin()), this._radius = isNaN(ge) ? 0 : j.x - u.project([oe, e - ge]).x, this._radiusY = j.y - $.y;
        } else {
          var Oe = p.unproject(p.project(this._latlng).subtract([this._mRadius, 0]));
          this._point = u.latLngToLayerPoint(this._latlng), this._radius = this._point.x - u.latLngToLayerPoint(Oe).x;
        }
        this._updateBounds();
      }
    });
    function za(e, o, u) {
      return new Lo(e, o, u);
    }
    var hn = xn.extend({
      options: {
        smoothFactor: 1,
        noClip: !1
      },
      initialize: function(e, o) {
        B(this, o), this._setLatLngs(e);
      },
      getLatLngs: function() {
        return this._latlngs;
      },
      setLatLngs: function(e) {
        return this._setLatLngs(e), this.redraw();
      },
      isEmpty: function() {
        return !this._latlngs.length;
      },
      closestLayerPoint: function(e) {
        for (var o = 1 / 0, u = null, p = _o, b, P, $ = 0, V = this._parts.length; $ < V; $++)
          for (var j = this._parts[$], oe = 1, ge = j.length; oe < ge; oe++) {
            b = j[oe - 1], P = j[oe];
            var Oe = p(e, b, P, !0);
            Oe < o && (o = Oe, u = p(e, b, P));
          }
        return u && (u.distance = Math.sqrt(o)), u;
      },
      getCenter: function() {
        if (!this._map)
          throw new Error("Must add layer to map before using getCenter()");
        return vr(this._defaultShape(), this._map.options.crs);
      },
      getBounds: function() {
        return this._bounds;
      },
      addLatLng: function(e, o) {
        return o = o || this._defaultShape(), e = ot(e), o.push(e), this._bounds.extend(e), this.redraw();
      },
      _setLatLngs: function(e) {
        this._bounds = new Ht(), this._latlngs = this._convertLatLngs(e);
      },
      _defaultShape: function() {
        return Mn(this._latlngs) ? this._latlngs : this._latlngs[0];
      },
      _convertLatLngs: function(e) {
        for (var o = [], u = Mn(e), p = 0, b = e.length; p < b; p++)
          u ? (o[p] = ot(e[p]), this._bounds.extend(o[p])) : o[p] = this._convertLatLngs(e[p]);
        return o;
      },
      _project: function() {
        var e = new Be();
        this._rings = [], this._projectLatlngs(this._latlngs, this._rings, e), this._bounds.isValid() && e.isValid() && (this._rawPxBounds = e, this._updateBounds());
      },
      _updateBounds: function() {
        var e = this._clickTolerance(), o = new we(e, e);
        this._rawPxBounds && (this._pxBounds = new Be([
          this._rawPxBounds.min.subtract(o),
          this._rawPxBounds.max.add(o)
        ]));
      },
      _projectLatlngs: function(e, o, u) {
        var p = e[0] instanceof $e, b = e.length, P, $;
        if (p) {
          for ($ = [], P = 0; P < b; P++)
            $[P] = this._map.latLngToLayerPoint(e[P]), u.extend($[P]);
          o.push($);
        } else
          for (P = 0; P < b; P++)
            this._projectLatlngs(e[P], o, u);
      },
      _clipPoints: function() {
        var e = this._renderer._bounds;
        if (this._parts = [], !(!this._pxBounds || !this._pxBounds.intersects(e))) {
          if (this.options.noClip) {
            this._parts = this._rings;
            return;
          }
          var o = this._parts, u, p, b, P, $, V, j;
          for (u = 0, b = 0, P = this._rings.length; u < P; u++)
            for (j = this._rings[u], p = 0, $ = j.length; p < $ - 1; p++)
              V = Na(j[p], j[p + 1], e, p, !0), V && (o[b] = o[b] || [], o[b].push(V[0]), (V[1] !== j[p + 1] || p === $ - 2) && (o[b].push(V[1]), b++));
        }
      },
      _simplifyPoints: function() {
        for (var e = this._parts, o = this.options.smoothFactor, u = 0, p = e.length; u < p; u++)
          e[u] = qs(e[u], o);
      },
      _update: function() {
        this._map && (this._clipPoints(), this._simplifyPoints(), this._updatePath());
      },
      _updatePath: function() {
        this._renderer._updatePoly(this);
      },
      _containsPoint: function(e, o) {
        var u, p, b, P, $, V, j = this._clickTolerance();
        if (!this._pxBounds || !this._pxBounds.contains(e))
          return !1;
        for (u = 0, P = this._parts.length; u < P; u++)
          for (V = this._parts[u], p = 0, $ = V.length, b = $ - 1; p < $; b = p++)
            if (!(!o && p === 0) && Ai(e, V[b], V[p]) <= j)
              return !0;
        return !1;
      }
    });
    function os(e, o) {
      return new hn(e, o);
    }
    hn._flat = go;
    var Fr = hn.extend({
      options: {
        fill: !0
      },
      isEmpty: function() {
        return !this._latlngs.length || !this._latlngs[0].length;
      },
      getCenter: function() {
        if (!this._map)
          throw new Error("Must add layer to map before using getCenter()");
        return Js(this._defaultShape(), this._map.options.crs);
      },
      _convertLatLngs: function(e) {
        var o = hn.prototype._convertLatLngs.call(this, e), u = o.length;
        return u >= 2 && o[0] instanceof $e && o[0].equals(o[u - 1]) && o.pop(), o;
      },
      _setLatLngs: function(e) {
        hn.prototype._setLatLngs.call(this, e), Mn(this._latlngs) && (this._latlngs = [this._latlngs]);
      },
      _defaultShape: function() {
        return Mn(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
      },
      _clipPoints: function() {
        var e = this._renderer._bounds, o = this.options.weight, u = new we(o, o);
        if (e = new Be(e.min.subtract(u), e.max.add(u)), this._parts = [], !(!this._pxBounds || !this._pxBounds.intersects(e))) {
          if (this.options.noClip) {
            this._parts = this._rings;
            return;
          }
          for (var p = 0, b = this._rings.length, P; p < b; p++)
            P = Ks(this._rings[p], e, !0), P.length && this._parts.push(P);
        }
      },
      _updatePath: function() {
        this._renderer._updatePoly(this, !0);
      },
      _containsPoint: function(e) {
        var o = !1, u, p, b, P, $, V, j, oe;
        if (!this._pxBounds || !this._pxBounds.contains(e))
          return !1;
        for (P = 0, j = this._parts.length; P < j; P++)
          for (u = this._parts[P], $ = 0, oe = u.length, V = oe - 1; $ < oe; V = $++)
            p = u[$], b = u[V], p.y > e.y != b.y > e.y && e.x < (b.x - p.x) * (e.y - p.y) / (b.y - p.y) + p.x && (o = !o);
        return o || hn.prototype._containsPoint.call(this, e, !0);
      }
    });
    function nu(e, o) {
      return new Fr(e, o);
    }
    var Ii = On.extend({
      initialize: function(e, o) {
        B(this, o), this._layers = {}, e && this.addData(e);
      },
      addData: function(e) {
        var o = re(e) ? e : e.features, u, p, b;
        if (o) {
          for (u = 0, p = o.length; u < p; u++)
            b = o[u], (b.geometries || b.geometry || b.features || b.coordinates) && this.addData(b);
          return this;
        }
        var P = this.options;
        if (P.filter && !P.filter(e))
          return this;
        var $ = Ni(e, P);
        return $ ? ($.feature = us(e), $.defaultOptions = $.options, this.resetStyle($), P.onEachFeature && P.onEachFeature(e, $), this.addLayer($)) : this;
      },
      resetStyle: function(e) {
        return e === void 0 ? this.eachLayer(this.resetStyle, this) : (e.options = a({}, e.defaultOptions), this._setLayerStyle(e, this.options.style), this);
      },
      setStyle: function(e) {
        return this.eachLayer(function(o) {
          this._setLayerStyle(o, e);
        }, this);
      },
      _setLayerStyle: function(e, o) {
        e.setStyle && (typeof o == "function" && (o = o(e.feature)), e.setStyle(o));
      }
    });
    function Ni(e, o) {
      var u = e.type === "Feature" ? e.geometry : e, p = u ? u.coordinates : null, b = [], P = o && o.pointToLayer, $ = o && o.coordsToLatLng || ss, V, j, oe, ge;
      if (!p && !u)
        return null;
      switch (u.type) {
        case "Point":
          return V = $(p), jn(P, e, V, o);
        case "MultiPoint":
          for (oe = 0, ge = p.length; oe < ge; oe++)
            V = $(p[oe]), b.push(jn(P, e, V, o));
          return new On(b);
        case "LineString":
        case "MultiLineString":
          return j = as(p, u.type === "LineString" ? 0 : 1, $), new hn(j, o);
        case "Polygon":
        case "MultiPolygon":
          return j = as(p, u.type === "Polygon" ? 1 : 2, $), new Fr(j, o);
        case "GeometryCollection":
          for (oe = 0, ge = u.geometries.length; oe < ge; oe++) {
            var Oe = Ni({
              geometry: u.geometries[oe],
              type: "Feature",
              properties: e.properties
            }, o);
            Oe && b.push(Oe);
          }
          return new On(b);
        case "FeatureCollection":
          for (oe = 0, ge = u.features.length; oe < ge; oe++) {
            var Ve = Ni(u.features[oe], o);
            Ve && b.push(Ve);
          }
          return new On(b);
        default:
          throw new Error("Invalid GeoJSON object.");
      }
    }
    function jn(e, o, u, p) {
      return e ? e(o, u) : new is(u, p && p.markersInheritOptions && p);
    }
    function ss(e) {
      return new $e(e[1], e[0], e[2]);
    }
    function as(e, o, u) {
      for (var p = [], b = 0, P = e.length, $; b < P; b++)
        $ = o ? as(e[b], o - 1, u) : (u || ss)(e[b]), p.push($);
      return p;
    }
    function ta(e, o) {
      return e = ot(e), e.alt !== void 0 ? [N(e.lng, o), N(e.lat, o), N(e.alt, o)] : [N(e.lng, o), N(e.lat, o)];
    }
    function ls(e, o, u, p) {
      for (var b = [], P = 0, $ = e.length; P < $; P++)
        b.push(o ? ls(e[P], Mn(e[P]) ? 0 : o - 1, u, p) : ta(e[P], p));
      return !o && u && b.push(b[0].slice()), b;
    }
    function Hr(e, o) {
      return e.feature ? a({}, e.feature, { geometry: o }) : us(o);
    }
    function us(e) {
      return e.type === "Feature" || e.type === "FeatureCollection" ? e : {
        type: "Feature",
        properties: {},
        geometry: e
      };
    }
    var Yi = {
      toGeoJSON: function(e) {
        return Hr(this, {
          type: "Point",
          coordinates: ta(this.getLatLng(), e)
        });
      }
    };
    is.include(Yi), Lo.include(Yi), rs.include(Yi), hn.include({
      toGeoJSON: function(e) {
        var o = !Mn(this._latlngs), u = ls(this._latlngs, o ? 1 : 0, !1, e);
        return Hr(this, {
          type: (o ? "Multi" : "") + "LineString",
          coordinates: u
        });
      }
    }), Fr.include({
      toGeoJSON: function(e) {
        var o = !Mn(this._latlngs), u = o && !Mn(this._latlngs[0]), p = ls(this._latlngs, u ? 2 : o ? 1 : 0, !0, e);
        return o || (p = [p]), Hr(this, {
          type: (u ? "Multi" : "") + "Polygon",
          coordinates: p
        });
      }
    }), Qt.include({
      toMultiPoint: function(e) {
        var o = [];
        return this.eachLayer(function(u) {
          o.push(u.toGeoJSON(e).geometry.coordinates);
        }), Hr(this, {
          type: "MultiPoint",
          coordinates: o
        });
      },
      toGeoJSON: function(e) {
        var o = this.feature && this.feature.geometry && this.feature.geometry.type;
        if (o === "MultiPoint")
          return this.toMultiPoint(e);
        var u = o === "GeometryCollection", p = [];
        return this.eachLayer(function(b) {
          if (b.toGeoJSON) {
            var P = b.toGeoJSON(e);
            if (u)
              p.push(P.geometry);
            else {
              var $ = us(P);
              $.type === "FeatureCollection" ? p.push.apply(p, $.features) : p.push($);
            }
          }
        }), u ? Hr(this, {
          geometries: p,
          type: "GeometryCollection"
        }) : {
          type: "FeatureCollection",
          features: p
        };
      }
    });
    function H(e, o) {
      return new Ii(e, o);
    }
    var K = H, W = Wn.extend({
      options: {
        opacity: 1,
        alt: "",
        interactive: !1,
        crossOrigin: !1,
        errorOverlayUrl: "",
        zIndex: 1,
        className: ""
      },
      initialize: function(e, o, u) {
        this._url = e, this._bounds = wt(o), B(this, u);
      },
      onAdd: function() {
        this._image || (this._initImage(), this.options.opacity < 1 && this._updateOpacity()), this.options.interactive && (ze(this._image, "leaflet-interactive"), this.addInteractiveTarget(this._image)), this.getPane().appendChild(this._image), this._reset();
      },
      onRemove: function() {
        yt(this._image), this.options.interactive && this.removeInteractiveTarget(this._image);
      },
      setOpacity: function(e) {
        return this.options.opacity = e, this._image && this._updateOpacity(), this;
      },
      setStyle: function(e) {
        return e.opacity && this.setOpacity(e.opacity), this;
      },
      bringToFront: function() {
        return this._map && Vn(this._image), this;
      },
      bringToBack: function() {
        return this._map && ui(this._image), this;
      },
      setUrl: function(e) {
        return this._url = e, this._image && (this._image.src = e), this;
      },
      setBounds: function(e) {
        return this._bounds = wt(e), this._map && this._reset(), this;
      },
      getEvents: function() {
        var e = {
          zoom: this._reset,
          viewreset: this._reset
        };
        return this._zoomAnimated && (e.zoomanim = this._animateZoom), e;
      },
      setZIndex: function(e) {
        return this.options.zIndex = e, this._updateZIndex(), this;
      },
      getBounds: function() {
        return this._bounds;
      },
      getElement: function() {
        return this._image;
      },
      _initImage: function() {
        var e = this._url.tagName === "IMG", o = this._image = e ? this._url : Qe("img");
        if (ze(o, "leaflet-image-layer"), this._zoomAnimated && ze(o, "leaflet-zoom-animated"), this.options.className && ze(o, this.options.className), o.onselectstart = M, o.onmousemove = M, o.onload = f(this.fire, this, "load"), o.onerror = f(this._overlayOnError, this, "error"), (this.options.crossOrigin || this.options.crossOrigin === "") && (o.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), this.options.zIndex && this._updateZIndex(), e) {
          this._url = o.src;
          return;
        }
        o.src = this._url, o.alt = this.options.alt;
      },
      _animateZoom: function(e) {
        var o = this._map.getZoomScale(e.zoom), u = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
        k(this._image, u, o);
      },
      _reset: function() {
        var e = this._image, o = new Be(
          this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
          this._map.latLngToLayerPoint(this._bounds.getSouthEast())
        ), u = o.getSize();
        A(e, o.min), e.style.width = u.x + "px", e.style.height = u.y + "px";
      },
      _updateOpacity: function() {
        _(this._image, this.options.opacity);
      },
      _updateZIndex: function() {
        this._image && this.options.zIndex !== void 0 && this.options.zIndex !== null && (this._image.style.zIndex = this.options.zIndex);
      },
      _overlayOnError: function() {
        this.fire("error");
        var e = this.options.errorOverlayUrl;
        e && this._url !== e && (this._url = e, this._image.src = e);
      },
      getCenter: function() {
        return this._bounds.getCenter();
      }
    }), ye = function(e, o, u) {
      return new W(e, o, u);
    }, Ne = W.extend({
      options: {
        autoplay: !0,
        loop: !0,
        keepAspectRatio: !0,
        muted: !1,
        playsInline: !0
      },
      _initImage: function() {
        var e = this._url.tagName === "VIDEO", o = this._image = e ? this._url : Qe("video");
        if (ze(o, "leaflet-image-layer"), this._zoomAnimated && ze(o, "leaflet-zoom-animated"), this.options.className && ze(o, this.options.className), o.onselectstart = M, o.onmousemove = M, o.onloadeddata = f(this.fire, this, "load"), e) {
          for (var u = o.getElementsByTagName("source"), p = [], b = 0; b < u.length; b++)
            p.push(u[b].src);
          this._url = u.length > 0 ? p : [o.src];
          return;
        }
        re(this._url) || (this._url = [this._url]), !this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(o.style, "objectFit") && (o.style.objectFit = "fill"), o.autoplay = !!this.options.autoplay, o.loop = !!this.options.loop, o.muted = !!this.options.muted, o.playsInline = !!this.options.playsInline;
        for (var P = 0; P < this._url.length; P++) {
          var $ = Qe("source");
          $.src = this._url[P], o.appendChild($);
        }
      }
    });
    function lt(e, o, u) {
      return new Ne(e, o, u);
    }
    var Vt = W.extend({
      _initImage: function() {
        var e = this._image = this._url;
        ze(e, "leaflet-image-layer"), this._zoomAnimated && ze(e, "leaflet-zoom-animated"), this.options.className && ze(e, this.options.className), e.onselectstart = M, e.onmousemove = M;
      }
    });
    function Lt(e, o, u) {
      return new Vt(e, o, u);
    }
    var Gn = Wn.extend({
      options: {
        interactive: !1,
        offset: [0, 0],
        className: "",
        pane: void 0,
        content: ""
      },
      initialize: function(e, o) {
        e && (e instanceof $e || re(e)) ? (this._latlng = ot(e), B(this, o)) : (B(this, e), this._source = o), this.options.content && (this._content = this.options.content);
      },
      openOn: function(e) {
        return e = arguments.length ? e : this._source._map, e.hasLayer(this) || e.addLayer(this), this;
      },
      close: function() {
        return this._map && this._map.removeLayer(this), this;
      },
      toggle: function(e) {
        return this._map ? this.close() : (arguments.length ? this._source = e : e = this._source, this._prepareOpen(), this.openOn(e._map)), this;
      },
      onAdd: function(e) {
        this._zoomAnimated = e._zoomAnimated, this._container || this._initLayout(), e._fadeAnimated && _(this._container, 0), clearTimeout(this._removeTimeout), this.getPane().appendChild(this._container), this.update(), e._fadeAnimated && _(this._container, 1), this.bringToFront(), this.options.interactive && (ze(this._container, "leaflet-interactive"), this.addInteractiveTarget(this._container));
      },
      onRemove: function(e) {
        e._fadeAnimated ? (_(this._container, 0), this._removeTimeout = setTimeout(f(yt, void 0, this._container), 200)) : yt(this._container), this.options.interactive && (St(this._container, "leaflet-interactive"), this.removeInteractiveTarget(this._container));
      },
      getLatLng: function() {
        return this._latlng;
      },
      setLatLng: function(e) {
        return this._latlng = ot(e), this._map && (this._updatePosition(), this._adjustPan()), this;
      },
      getContent: function() {
        return this._content;
      },
      setContent: function(e) {
        return this._content = e, this.update(), this;
      },
      getElement: function() {
        return this._container;
      },
      update: function() {
        this._map && (this._container.style.visibility = "hidden", this._updateContent(), this._updateLayout(), this._updatePosition(), this._container.style.visibility = "", this._adjustPan());
      },
      getEvents: function() {
        var e = {
          zoom: this._updatePosition,
          viewreset: this._updatePosition
        };
        return this._zoomAnimated && (e.zoomanim = this._animateZoom), e;
      },
      isOpen: function() {
        return !!this._map && this._map.hasLayer(this);
      },
      bringToFront: function() {
        return this._map && Vn(this._container), this;
      },
      bringToBack: function() {
        return this._map && ui(this._container), this;
      },
      _prepareOpen: function(e) {
        var o = this._source;
        if (!o._map)
          return !1;
        if (o instanceof On) {
          o = null;
          var u = this._source._layers;
          for (var p in u)
            if (u[p]._map) {
              o = u[p];
              break;
            }
          if (!o)
            return !1;
          this._source = o;
        }
        if (!e)
          if (o.getCenter)
            e = o.getCenter();
          else if (o.getLatLng)
            e = o.getLatLng();
          else if (o.getBounds)
            e = o.getBounds().getCenter();
          else
            throw new Error("Unable to get source layer LatLng.");
        return this.setLatLng(e), this._map && this.update(), !0;
      },
      _updateContent: function() {
        if (this._content) {
          var e = this._contentNode, o = typeof this._content == "function" ? this._content(this._source || this) : this._content;
          if (typeof o == "string")
            e.innerHTML = o;
          else {
            for (; e.hasChildNodes(); )
              e.removeChild(e.firstChild);
            e.appendChild(o);
          }
          this.fire("contentupdate");
        }
      },
      _updatePosition: function() {
        if (this._map) {
          var e = this._map.latLngToLayerPoint(this._latlng), o = _e(this.options.offset), u = this._getAnchor();
          this._zoomAnimated ? A(this._container, e.add(u)) : o = o.add(e).add(u);
          var p = this._containerBottom = -o.y, b = this._containerLeft = -Math.round(this._containerWidth / 2) + o.x;
          this._container.style.bottom = p + "px", this._container.style.left = b + "px";
        }
      },
      _getAnchor: function() {
        return [0, 0];
      }
    });
    et.include({
      _initOverlay: function(e, o, u, p) {
        var b = o;
        return b instanceof e || (b = new e(p).setContent(o)), u && b.setLatLng(u), b;
      }
    }), Wn.include({
      _initOverlay: function(e, o, u, p) {
        var b = u;
        return b instanceof e ? (B(b, p), b._source = this) : (b = o && !p ? o : new e(p, this), b.setContent(u)), b;
      }
    });
    var cs = Gn.extend({
      options: {
        pane: "popupPane",
        offset: [0, 7],
        maxWidth: 300,
        minWidth: 50,
        maxHeight: null,
        autoPan: !0,
        autoPanPaddingTopLeft: null,
        autoPanPaddingBottomRight: null,
        autoPanPadding: [5, 5],
        keepInView: !1,
        closeButton: !0,
        autoClose: !0,
        closeOnEscapeKey: !0,
        className: ""
      },
      openOn: function(e) {
        return e = arguments.length ? e : this._source._map, !e.hasLayer(this) && e._popup && e._popup.options.autoClose && e.removeLayer(e._popup), e._popup = this, Gn.prototype.openOn.call(this, e);
      },
      onAdd: function(e) {
        Gn.prototype.onAdd.call(this, e), e.fire("popupopen", { popup: this }), this._source && (this._source.fire("popupopen", { popup: this }, !0), this._source instanceof xn || this._source.on("preclick", _r));
      },
      onRemove: function(e) {
        Gn.prototype.onRemove.call(this, e), e.fire("popupclose", { popup: this }), this._source && (this._source.fire("popupclose", { popup: this }, !0), this._source instanceof xn || this._source.off("preclick", _r));
      },
      getEvents: function() {
        var e = Gn.prototype.getEvents.call(this);
        return (this.options.closeOnClick !== void 0 ? this.options.closeOnClick : this._map.options.closePopupOnClick) && (e.preclick = this.close), this.options.keepInView && (e.moveend = this._adjustPan), e;
      },
      _initLayout: function() {
        var e = "leaflet-popup", o = this._container = Qe(
          "div",
          e + " " + (this.options.className || "") + " leaflet-zoom-animated"
        ), u = this._wrapper = Qe("div", e + "-content-wrapper", o);
        if (this._contentNode = Qe("div", e + "-content", u), mo(o), Hs(this._contentNode), Te(o, "contextmenu", _r), this._tipContainer = Qe("div", e + "-tip-container", o), this._tip = Qe("div", e + "-tip", this._tipContainer), this.options.closeButton) {
          var p = this._closeButton = Qe("a", e + "-close-button", o);
          p.setAttribute("role", "button"), p.setAttribute("aria-label", "Close popup"), p.href = "#close", p.innerHTML = '<span aria-hidden="true">&#215;</span>', Te(p, "click", function(b) {
            Fe(b), this.close();
          }, this);
        }
      },
      _updateLayout: function() {
        var e = this._contentNode, o = e.style;
        o.width = "", o.whiteSpace = "nowrap";
        var u = e.offsetWidth;
        u = Math.min(u, this.options.maxWidth), u = Math.max(u, this.options.minWidth), o.width = u + 1 + "px", o.whiteSpace = "", o.height = "";
        var p = e.offsetHeight, b = this.options.maxHeight, P = "leaflet-popup-scrolled";
        b && p > b ? (o.height = b + "px", ze(e, P)) : St(e, P), this._containerWidth = this._container.offsetWidth;
      },
      _animateZoom: function(e) {
        var o = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), u = this._getAnchor();
        A(this._container, o.add(u));
      },
      _adjustPan: function() {
        if (this.options.autoPan) {
          if (this._map._panAnim && this._map._panAnim.stop(), this._autopanning) {
            this._autopanning = !1;
            return;
          }
          var e = this._map, o = parseInt(Zi(this._container, "marginBottom"), 10) || 0, u = this._container.offsetHeight + o, p = this._containerWidth, b = new we(this._containerLeft, -u - this._containerBottom);
          b._add(R(this._container));
          var P = e.layerPointToContainerPoint(b), $ = _e(this.options.autoPanPadding), V = _e(this.options.autoPanPaddingTopLeft || $), j = _e(this.options.autoPanPaddingBottomRight || $), oe = e.getSize(), ge = 0, Oe = 0;
          P.x + p + j.x > oe.x && (ge = P.x + p - oe.x + j.x), P.x - ge - V.x < 0 && (ge = P.x - V.x), P.y + u + j.y > oe.y && (Oe = P.y + u - oe.y + j.y), P.y - Oe - V.y < 0 && (Oe = P.y - V.y), (ge || Oe) && (this.options.keepInView && (this._autopanning = !0), e.fire("autopanstart").panBy([ge, Oe]));
        }
      },
      _getAnchor: function() {
        return _e(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
      }
    }), qn = function(e, o) {
      return new cs(e, o);
    };
    et.mergeOptions({
      closePopupOnClick: !0
    }), et.include({
      openPopup: function(e, o, u) {
        return this._initOverlay(cs, e, o, u).openOn(this), this;
      },
      closePopup: function(e) {
        return e = arguments.length ? e : this._popup, e && e.close(), this;
      }
    }), Wn.include({
      bindPopup: function(e, o) {
        return this._popup = this._initOverlay(cs, this._popup, e, o), this._popupHandlersAdded || (this.on({
          click: this._openPopup,
          keypress: this._onKeyPress,
          remove: this.closePopup,
          move: this._movePopup
        }), this._popupHandlersAdded = !0), this;
      },
      unbindPopup: function() {
        return this._popup && (this.off({
          click: this._openPopup,
          keypress: this._onKeyPress,
          remove: this.closePopup,
          move: this._movePopup
        }), this._popupHandlersAdded = !1, this._popup = null), this;
      },
      openPopup: function(e) {
        return this._popup && (this instanceof On || (this._popup._source = this), this._popup._prepareOpen(e || this._latlng) && this._popup.openOn(this._map)), this;
      },
      closePopup: function() {
        return this._popup && this._popup.close(), this;
      },
      togglePopup: function() {
        return this._popup && this._popup.toggle(this), this;
      },
      isPopupOpen: function() {
        return this._popup ? this._popup.isOpen() : !1;
      },
      setPopupContent: function(e) {
        return this._popup && this._popup.setContent(e), this;
      },
      getPopup: function() {
        return this._popup;
      },
      _openPopup: function(e) {
        if (!(!this._popup || !this._map)) {
          st(e);
          var o = e.layer || e.target;
          if (this._popup._source === o && !(o instanceof xn)) {
            this._map.hasLayer(this._popup) ? this.closePopup() : this.openPopup(e.latlng);
            return;
          }
          this._popup._source = o, this.openPopup(e.latlng);
        }
      },
      _movePopup: function(e) {
        this._popup.setLatLng(e.latlng);
      },
      _onKeyPress: function(e) {
        e.originalEvent.keyCode === 13 && this._openPopup(e);
      }
    });
    var Lr = Gn.extend({
      options: {
        pane: "tooltipPane",
        offset: [0, 0],
        direction: "auto",
        permanent: !1,
        sticky: !1,
        opacity: 0.9
      },
      onAdd: function(e) {
        Gn.prototype.onAdd.call(this, e), this.setOpacity(this.options.opacity), e.fire("tooltipopen", { tooltip: this }), this._source && (this.addEventParent(this._source), this._source.fire("tooltipopen", { tooltip: this }, !0));
      },
      onRemove: function(e) {
        Gn.prototype.onRemove.call(this, e), e.fire("tooltipclose", { tooltip: this }), this._source && (this.removeEventParent(this._source), this._source.fire("tooltipclose", { tooltip: this }, !0));
      },
      getEvents: function() {
        var e = Gn.prototype.getEvents.call(this);
        return this.options.permanent || (e.preclick = this.close), e;
      },
      _initLayout: function() {
        var e = "leaflet-tooltip", o = e + " " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
        this._contentNode = this._container = Qe("div", o), this._container.setAttribute("role", "tooltip"), this._container.setAttribute("id", "leaflet-tooltip-" + y(this));
      },
      _updateLayout: function() {
      },
      _adjustPan: function() {
      },
      _setPosition: function(e) {
        var o, u, p = this._map, b = this._container, P = p.latLngToContainerPoint(p.getCenter()), $ = p.layerPointToContainerPoint(e), V = this.options.direction, j = b.offsetWidth, oe = b.offsetHeight, ge = _e(this.options.offset), Oe = this._getAnchor();
        V === "top" ? (o = j / 2, u = oe) : V === "bottom" ? (o = j / 2, u = 0) : V === "center" ? (o = j / 2, u = oe / 2) : V === "right" ? (o = 0, u = oe / 2) : V === "left" ? (o = j, u = oe / 2) : $.x < P.x ? (V = "right", o = 0, u = oe / 2) : (V = "left", o = j + (ge.x + Oe.x) * 2, u = oe / 2), e = e.subtract(_e(o, u, !0)).add(ge).add(Oe), St(b, "leaflet-tooltip-right"), St(b, "leaflet-tooltip-left"), St(b, "leaflet-tooltip-top"), St(b, "leaflet-tooltip-bottom"), ze(b, "leaflet-tooltip-" + V), A(b, e);
      },
      _updatePosition: function() {
        var e = this._map.latLngToLayerPoint(this._latlng);
        this._setPosition(e);
      },
      setOpacity: function(e) {
        this.options.opacity = e, this._container && _(this._container, e);
      },
      _animateZoom: function(e) {
        var o = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
        this._setPosition(o);
      },
      _getAnchor: function() {
        return _e(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
      }
    }), iu = function(e, o) {
      return new Lr(e, o);
    };
    et.include({
      openTooltip: function(e, o, u) {
        return this._initOverlay(Lr, e, o, u).openOn(this), this;
      },
      closeTooltip: function(e) {
        return e.close(), this;
      }
    }), Wn.include({
      bindTooltip: function(e, o) {
        return this._tooltip && this.isTooltipOpen() && this.unbindTooltip(), this._tooltip = this._initOverlay(Lr, this._tooltip, e, o), this._initTooltipInteractions(), this._tooltip.options.permanent && this._map && this._map.hasLayer(this) && this.openTooltip(), this;
      },
      unbindTooltip: function() {
        return this._tooltip && (this._initTooltipInteractions(!0), this.closeTooltip(), this._tooltip = null), this;
      },
      _initTooltipInteractions: function(e) {
        if (!(!e && this._tooltipHandlersAdded)) {
          var o = e ? "off" : "on", u = {
            remove: this.closeTooltip,
            move: this._moveTooltip
          };
          this._tooltip.options.permanent ? u.add = this._openTooltip : (u.mouseover = this._openTooltip, u.mouseout = this.closeTooltip, u.click = this._openTooltip, this._map ? this._addFocusListeners() : u.add = this._addFocusListeners), this._tooltip.options.sticky && (u.mousemove = this._moveTooltip), this[o](u), this._tooltipHandlersAdded = !e;
        }
      },
      openTooltip: function(e) {
        return this._tooltip && (this instanceof On || (this._tooltip._source = this), this._tooltip._prepareOpen(e) && (this._tooltip.openOn(this._map), this.getElement ? this._setAriaDescribedByOnLayer(this) : this.eachLayer && this.eachLayer(this._setAriaDescribedByOnLayer, this))), this;
      },
      closeTooltip: function() {
        if (this._tooltip)
          return this._tooltip.close();
      },
      toggleTooltip: function() {
        return this._tooltip && this._tooltip.toggle(this), this;
      },
      isTooltipOpen: function() {
        return this._tooltip.isOpen();
      },
      setTooltipContent: function(e) {
        return this._tooltip && this._tooltip.setContent(e), this;
      },
      getTooltip: function() {
        return this._tooltip;
      },
      _addFocusListeners: function() {
        this.getElement ? this._addFocusListenersOnLayer(this) : this.eachLayer && this.eachLayer(this._addFocusListenersOnLayer, this);
      },
      _addFocusListenersOnLayer: function(e) {
        var o = e.getElement();
        o && (Te(o, "focus", function() {
          this._tooltip._source = e, this.openTooltip();
        }, this), Te(o, "blur", this.closeTooltip, this));
      },
      _setAriaDescribedByOnLayer: function(e) {
        var o = e.getElement();
        o && o.setAttribute("aria-describedby", this._tooltip._container.id);
      },
      _openTooltip: function(e) {
        !this._tooltip || !this._map || this._map.dragging && this._map.dragging.moving() || (this._tooltip._source = e.layer || e.target, this.openTooltip(this._tooltip.options.sticky ? e.latlng : void 0));
      },
      _moveTooltip: function(e) {
        var o = e.latlng, u, p;
        this._tooltip.options.sticky && e.originalEvent && (u = this._map.mouseEventToContainerPoint(e.originalEvent), p = this._map.containerPointToLayerPoint(u), o = this._map.layerPointToLatLng(p)), this._tooltip.setLatLng(o);
      }
    });
    var wr = yr.extend({
      options: {
        iconSize: [12, 12],
        html: !1,
        bgPos: null,
        className: "leaflet-div-icon"
      },
      createIcon: function(e) {
        var o = e && e.tagName === "DIV" ? e : document.createElement("div"), u = this.options;
        if (u.html instanceof Element ? (Vi(o), o.appendChild(u.html)) : o.innerHTML = u.html !== !1 ? u.html : "", u.bgPos) {
          var p = _e(u.bgPos);
          o.style.backgroundPosition = -p.x + "px " + -p.y + "px";
        }
        return this._setIconStyles(o, "icon"), o;
      },
      createShadow: function() {
        return null;
      }
    });
    function hs(e) {
      return new wr(e);
    }
    yr.Default = yo;
    var Ki = Wn.extend({
      options: {
        tileSize: 256,
        opacity: 1,
        updateWhenIdle: be.mobile,
        updateWhenZooming: !0,
        updateInterval: 200,
        zIndex: 1,
        bounds: null,
        minZoom: 0,
        maxZoom: void 0,
        maxNativeZoom: void 0,
        minNativeZoom: void 0,
        noWrap: !1,
        pane: "tilePane",
        className: "",
        keepBuffer: 2
      },
      initialize: function(e) {
        B(this, e);
      },
      onAdd: function() {
        this._initContainer(), this._levels = {}, this._tiles = {}, this._resetView();
      },
      beforeAdd: function(e) {
        e._addZoomLimit(this);
      },
      onRemove: function(e) {
        this._removeAllTiles(), yt(this._container), e._removeZoomLimit(this), this._container = null, this._tileZoom = void 0;
      },
      bringToFront: function() {
        return this._map && (Vn(this._container), this._setAutoZIndex(Math.max)), this;
      },
      bringToBack: function() {
        return this._map && (ui(this._container), this._setAutoZIndex(Math.min)), this;
      },
      getContainer: function() {
        return this._container;
      },
      setOpacity: function(e) {
        return this.options.opacity = e, this._updateOpacity(), this;
      },
      setZIndex: function(e) {
        return this.options.zIndex = e, this._updateZIndex(), this;
      },
      isLoading: function() {
        return this._loading;
      },
      redraw: function() {
        if (this._map) {
          this._removeAllTiles();
          var e = this._clampZoom(this._map.getZoom());
          e !== this._tileZoom && (this._tileZoom = e, this._updateLevels()), this._update();
        }
        return this;
      },
      getEvents: function() {
        var e = {
          viewprereset: this._invalidateAll,
          viewreset: this._resetView,
          zoom: this._resetView,
          moveend: this._onMoveEnd
        };
        return this.options.updateWhenIdle || (this._onMove || (this._onMove = v(this._onMoveEnd, this.options.updateInterval, this)), e.move = this._onMove), this._zoomAnimated && (e.zoomanim = this._animateZoom), e;
      },
      createTile: function() {
        return document.createElement("div");
      },
      getTileSize: function() {
        var e = this.options.tileSize;
        return e instanceof we ? e : new we(e, e);
      },
      _updateZIndex: function() {
        this._container && this.options.zIndex !== void 0 && this.options.zIndex !== null && (this._container.style.zIndex = this.options.zIndex);
      },
      _setAutoZIndex: function(e) {
        for (var o = this.getPane().children, u = -e(-1 / 0, 1 / 0), p = 0, b = o.length, P; p < b; p++)
          P = o[p].style.zIndex, o[p] !== this._container && P && (u = e(u, +P));
        isFinite(u) && (this.options.zIndex = u + e(-1, 1), this._updateZIndex());
      },
      _updateOpacity: function() {
        if (this._map && !be.ielt9) {
          _(this._container, this.options.opacity);
          var e = +new Date(), o = !1, u = !1;
          for (var p in this._tiles) {
            var b = this._tiles[p];
            if (!(!b.current || !b.loaded)) {
              var P = Math.min(1, (e - b.loaded) / 200);
              _(b.el, P), P < 1 ? o = !0 : (b.active ? u = !0 : this._onOpaqueTile(b), b.active = !0);
            }
          }
          u && !this._noPrune && this._pruneTiles(), o && (xt(this._fadeFrame), this._fadeFrame = Pt(this._updateOpacity, this));
        }
      },
      _onOpaqueTile: M,
      _initContainer: function() {
        this._container || (this._container = Qe("div", "leaflet-layer " + (this.options.className || "")), this._updateZIndex(), this.options.opacity < 1 && this._updateOpacity(), this.getPane().appendChild(this._container));
      },
      _updateLevels: function() {
        var e = this._tileZoom, o = this.options.maxZoom;
        if (e !== void 0) {
          for (var u in this._levels)
            u = Number(u), this._levels[u].el.children.length || u === e ? (this._levels[u].el.style.zIndex = o - Math.abs(e - u), this._onUpdateLevel(u)) : (yt(this._levels[u].el), this._removeTilesAtZoom(u), this._onRemoveLevel(u), delete this._levels[u]);
          var p = this._levels[e], b = this._map;
          return p || (p = this._levels[e] = {}, p.el = Qe("div", "leaflet-tile-container leaflet-zoom-animated", this._container), p.el.style.zIndex = o, p.origin = b.project(b.unproject(b.getPixelOrigin()), e).round(), p.zoom = e, this._setZoomTransform(p, b.getCenter(), b.getZoom()), M(p.el.offsetWidth), this._onCreateLevel(p)), this._level = p, p;
        }
      },
      _onUpdateLevel: M,
      _onRemoveLevel: M,
      _onCreateLevel: M,
      _pruneTiles: function() {
        if (this._map) {
          var e, o, u = this._map.getZoom();
          if (u > this.options.maxZoom || u < this.options.minZoom) {
            this._removeAllTiles();
            return;
          }
          for (e in this._tiles)
            o = this._tiles[e], o.retain = o.current;
          for (e in this._tiles)
            if (o = this._tiles[e], o.current && !o.active) {
              var p = o.coords;
              this._retainParent(p.x, p.y, p.z, p.z - 5) || this._retainChildren(p.x, p.y, p.z, p.z + 2);
            }
          for (e in this._tiles)
            this._tiles[e].retain || this._removeTile(e);
        }
      },
      _removeTilesAtZoom: function(e) {
        for (var o in this._tiles)
          this._tiles[o].coords.z === e && this._removeTile(o);
      },
      _removeAllTiles: function() {
        for (var e in this._tiles)
          this._removeTile(e);
      },
      _invalidateAll: function() {
        for (var e in this._levels)
          yt(this._levels[e].el), this._onRemoveLevel(Number(e)), delete this._levels[e];
        this._removeAllTiles(), this._tileZoom = void 0;
      },
      _retainParent: function(e, o, u, p) {
        var b = Math.floor(e / 2), P = Math.floor(o / 2), $ = u - 1, V = new we(+b, +P);
        V.z = +$;
        var j = this._tileCoordsToKey(V), oe = this._tiles[j];
        return oe && oe.active ? (oe.retain = !0, !0) : (oe && oe.loaded && (oe.retain = !0), $ > p ? this._retainParent(b, P, $, p) : !1);
      },
      _retainChildren: function(e, o, u, p) {
        for (var b = 2 * e; b < 2 * e + 2; b++)
          for (var P = 2 * o; P < 2 * o + 2; P++) {
            var $ = new we(b, P);
            $.z = u + 1;
            var V = this._tileCoordsToKey($), j = this._tiles[V];
            if (j && j.active) {
              j.retain = !0;
              continue;
            } else
              j && j.loaded && (j.retain = !0);
            u + 1 < p && this._retainChildren(b, P, u + 1, p);
          }
      },
      _resetView: function(e) {
        var o = e && (e.pinch || e.flyTo);
        this._setView(this._map.getCenter(), this._map.getZoom(), o, o);
      },
      _animateZoom: function(e) {
        this._setView(e.center, e.zoom, !0, e.noUpdate);
      },
      _clampZoom: function(e) {
        var o = this.options;
        return o.minNativeZoom !== void 0 && e < o.minNativeZoom ? o.minNativeZoom : o.maxNativeZoom !== void 0 && o.maxNativeZoom < e ? o.maxNativeZoom : e;
      },
      _setView: function(e, o, u, p) {
        var b = Math.round(o);
        this.options.maxZoom !== void 0 && b > this.options.maxZoom || this.options.minZoom !== void 0 && b < this.options.minZoom ? b = void 0 : b = this._clampZoom(b);
        var P = this.options.updateWhenZooming && b !== this._tileZoom;
        (!p || P) && (this._tileZoom = b, this._abortLoading && this._abortLoading(), this._updateLevels(), this._resetGrid(), b !== void 0 && this._update(e), u || this._pruneTiles(), this._noPrune = !!u), this._setZoomTransforms(e, o);
      },
      _setZoomTransforms: function(e, o) {
        for (var u in this._levels)
          this._setZoomTransform(this._levels[u], e, o);
      },
      _setZoomTransform: function(e, o, u) {
        var p = this._map.getZoomScale(u, e.zoom), b = e.origin.multiplyBy(p).subtract(this._map._getNewPixelOrigin(o, u)).round();
        be.any3d ? k(e.el, b, p) : A(e.el, b);
      },
      _resetGrid: function() {
        var e = this._map, o = e.options.crs, u = this._tileSize = this.getTileSize(), p = this._tileZoom, b = this._map.getPixelWorldBounds(this._tileZoom);
        b && (this._globalTileRange = this._pxBoundsToTileRange(b)), this._wrapX = o.wrapLng && !this.options.noWrap && [
          Math.floor(e.project([0, o.wrapLng[0]], p).x / u.x),
          Math.ceil(e.project([0, o.wrapLng[1]], p).x / u.y)
        ], this._wrapY = o.wrapLat && !this.options.noWrap && [
          Math.floor(e.project([o.wrapLat[0], 0], p).y / u.x),
          Math.ceil(e.project([o.wrapLat[1], 0], p).y / u.y)
        ];
      },
      _onMoveEnd: function() {
        !this._map || this._map._animatingZoom || this._update();
      },
      _getTiledPixelBounds: function(e) {
        var o = this._map, u = o._animatingZoom ? Math.max(o._animateToZoom, o.getZoom()) : o.getZoom(), p = o.getZoomScale(u, this._tileZoom), b = o.project(e, this._tileZoom).floor(), P = o.getSize().divideBy(p * 2);
        return new Be(b.subtract(P), b.add(P));
      },
      _update: function(e) {
        var o = this._map;
        if (o) {
          var u = this._clampZoom(o.getZoom());
          if (e === void 0 && (e = o.getCenter()), this._tileZoom !== void 0) {
            var p = this._getTiledPixelBounds(e), b = this._pxBoundsToTileRange(p), P = b.getCenter(), $ = [], V = this.options.keepBuffer, j = new Be(
              b.getBottomLeft().subtract([V, -V]),
              b.getTopRight().add([V, -V])
            );
            if (!(isFinite(b.min.x) && isFinite(b.min.y) && isFinite(b.max.x) && isFinite(b.max.y)))
              throw new Error("Attempted to load an infinite number of tiles");
            for (var oe in this._tiles) {
              var ge = this._tiles[oe].coords;
              (ge.z !== this._tileZoom || !j.contains(new we(ge.x, ge.y))) && (this._tiles[oe].current = !1);
            }
            if (Math.abs(u - this._tileZoom) > 1) {
              this._setView(e, u);
              return;
            }
            for (var Oe = b.min.y; Oe <= b.max.y; Oe++)
              for (var Ve = b.min.x; Ve <= b.max.x; Ve++) {
                var bn = new we(Ve, Oe);
                if (bn.z = this._tileZoom, !!this._isValidTile(bn)) {
                  var Kn = this._tiles[this._tileCoordsToKey(bn)];
                  Kn ? Kn.current = !0 : $.push(bn);
                }
              }
            if ($.sort(function(Jn, Wr) {
              return Jn.distanceTo(P) - Wr.distanceTo(P);
            }), $.length !== 0) {
              this._loading || (this._loading = !0, this.fire("loading"));
              var Qi = document.createDocumentFragment();
              for (Ve = 0; Ve < $.length; Ve++)
                this._addTile($[Ve], Qi);
              this._level.el.appendChild(Qi);
            }
          }
        }
      },
      _isValidTile: function(e) {
        var o = this._map.options.crs;
        if (!o.infinite) {
          var u = this._globalTileRange;
          if (!o.wrapLng && (e.x < u.min.x || e.x > u.max.x) || !o.wrapLat && (e.y < u.min.y || e.y > u.max.y))
            return !1;
        }
        if (!this.options.bounds)
          return !0;
        var p = this._tileCoordsToBounds(e);
        return wt(this.options.bounds).overlaps(p);
      },
      _keyToBounds: function(e) {
        return this._tileCoordsToBounds(this._keyToTileCoords(e));
      },
      _tileCoordsToNwSe: function(e) {
        var o = this._map, u = this.getTileSize(), p = e.scaleBy(u), b = p.add(u), P = o.unproject(p, e.z), $ = o.unproject(b, e.z);
        return [P, $];
      },
      _tileCoordsToBounds: function(e) {
        var o = this._tileCoordsToNwSe(e), u = new Ht(o[0], o[1]);
        return this.options.noWrap || (u = this._map.wrapLatLngBounds(u)), u;
      },
      _tileCoordsToKey: function(e) {
        return e.x + ":" + e.y + ":" + e.z;
      },
      _keyToTileCoords: function(e) {
        var o = e.split(":"), u = new we(+o[0], +o[1]);
        return u.z = +o[2], u;
      },
      _removeTile: function(e) {
        var o = this._tiles[e];
        o && (yt(o.el), delete this._tiles[e], this.fire("tileunload", {
          tile: o.el,
          coords: this._keyToTileCoords(e)
        }));
      },
      _initTile: function(e) {
        ze(e, "leaflet-tile");
        var o = this.getTileSize();
        e.style.width = o.x + "px", e.style.height = o.y + "px", e.onselectstart = M, e.onmousemove = M, be.ielt9 && this.options.opacity < 1 && _(e, this.options.opacity);
      },
      _addTile: function(e, o) {
        var u = this._getTilePos(e), p = this._tileCoordsToKey(e), b = this.createTile(this._wrapCoords(e), f(this._tileReady, this, e));
        this._initTile(b), this.createTile.length < 2 && Pt(f(this._tileReady, this, e, null, b)), A(b, u), this._tiles[p] = {
          el: b,
          coords: e,
          current: !0
        }, o.appendChild(b), this.fire("tileloadstart", {
          tile: b,
          coords: e
        });
      },
      _tileReady: function(e, o, u) {
        o && this.fire("tileerror", {
          error: o,
          tile: u,
          coords: e
        });
        var p = this._tileCoordsToKey(e);
        u = this._tiles[p], u && (u.loaded = +new Date(), this._map._fadeAnimated ? (_(u.el, 0), xt(this._fadeFrame), this._fadeFrame = Pt(this._updateOpacity, this)) : (u.active = !0, this._pruneTiles()), o || (ze(u.el, "leaflet-tile-loaded"), this.fire("tileload", {
          tile: u.el,
          coords: e
        })), this._noTilesToLoad() && (this._loading = !1, this.fire("load"), be.ielt9 || !this._map._fadeAnimated ? Pt(this._pruneTiles, this) : setTimeout(f(this._pruneTiles, this), 250)));
      },
      _getTilePos: function(e) {
        return e.scaleBy(this.getTileSize()).subtract(this._level.origin);
      },
      _wrapCoords: function(e) {
        var o = new we(
          this._wrapX ? C(e.x, this._wrapX) : e.x,
          this._wrapY ? C(e.y, this._wrapY) : e.y
        );
        return o.z = e.z, o;
      },
      _pxBoundsToTileRange: function(e) {
        var o = this.getTileSize();
        return new Be(
          e.min.unscaleBy(o).floor(),
          e.max.unscaleBy(o).ceil().subtract([1, 1])
        );
      },
      _noTilesToLoad: function() {
        for (var e in this._tiles)
          if (!this._tiles[e].loaded)
            return !1;
        return !0;
      }
    });
    function gt(e) {
      return new Ki(e);
    }
    var Zr = Ki.extend({
      options: {
        minZoom: 0,
        maxZoom: 18,
        subdomains: "abc",
        errorTileUrl: "",
        zoomOffset: 0,
        tms: !1,
        zoomReverse: !1,
        detectRetina: !1,
        crossOrigin: !1,
        referrerPolicy: !1
      },
      initialize: function(e, o) {
        this._url = e, o = B(this, o), o.detectRetina && be.retina && o.maxZoom > 0 ? (o.tileSize = Math.floor(o.tileSize / 2), o.zoomReverse ? (o.zoomOffset--, o.minZoom = Math.min(o.maxZoom, o.minZoom + 1)) : (o.zoomOffset++, o.maxZoom = Math.max(o.minZoom, o.maxZoom - 1)), o.minZoom = Math.max(0, o.minZoom)) : o.zoomReverse ? o.minZoom = Math.min(o.maxZoom, o.minZoom) : o.maxZoom = Math.max(o.minZoom, o.maxZoom), typeof o.subdomains == "string" && (o.subdomains = o.subdomains.split("")), this.on("tileunload", this._onTileRemove);
      },
      setUrl: function(e, o) {
        return this._url === e && o === void 0 && (o = !0), this._url = e, o || this.redraw(), this;
      },
      createTile: function(e, o) {
        var u = document.createElement("img");
        return Te(u, "load", f(this._tileOnLoad, this, o, u)), Te(u, "error", f(this._tileOnError, this, o, u)), (this.options.crossOrigin || this.options.crossOrigin === "") && (u.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), typeof this.options.referrerPolicy == "string" && (u.referrerPolicy = this.options.referrerPolicy), u.alt = "", u.src = this.getTileUrl(e), u;
      },
      getTileUrl: function(e) {
        var o = {
          r: be.retina ? "@2x" : "",
          s: this._getSubdomain(e),
          x: e.x,
          y: e.y,
          z: this._getZoomForUrl()
        };
        if (this._map && !this._map.options.crs.infinite) {
          var u = this._globalTileRange.max.y - e.y;
          this.options.tms && (o.y = u), o["-y"] = u;
        }
        return Q(this._url, a(o, this.options));
      },
      _tileOnLoad: function(e, o) {
        be.ielt9 ? setTimeout(f(e, this, null, o), 0) : e(null, o);
      },
      _tileOnError: function(e, o, u) {
        var p = this.options.errorTileUrl;
        p && o.getAttribute("src") !== p && (o.src = p), e(u, o);
      },
      _onTileRemove: function(e) {
        e.tile.onload = null;
      },
      _getZoomForUrl: function() {
        var e = this._tileZoom, o = this.options.maxZoom, u = this.options.zoomReverse, p = this.options.zoomOffset;
        return u && (e = o - e), e + p;
      },
      _getSubdomain: function(e) {
        var o = Math.abs(e.x + e.y) % this.options.subdomains.length;
        return this.options.subdomains[o];
      },
      _abortLoading: function() {
        var e, o;
        for (e in this._tiles)
          if (this._tiles[e].coords.z !== this._tileZoom && (o = this._tiles[e].el, o.onload = M, o.onerror = M, !o.complete)) {
            o.src = Le;
            var u = this._tiles[e].coords;
            yt(o), delete this._tiles[e], this.fire("tileabort", {
              tile: o,
              coords: u
            });
          }
      },
      _removeTile: function(e) {
        var o = this._tiles[e];
        if (o)
          return o.el.setAttribute("src", Le), Ki.prototype._removeTile.call(this, e);
      },
      _tileReady: function(e, o, u) {
        if (!(!this._map || u && u.getAttribute("src") === Le))
          return Ki.prototype._tileReady.call(this, e, o, u);
      }
    });
    function na(e, o) {
      return new Zr(e, o);
    }
    var wo = Zr.extend({
      defaultWmsParams: {
        service: "WMS",
        request: "GetMap",
        layers: "",
        styles: "",
        format: "image/jpeg",
        transparent: !1,
        version: "1.1.1"
      },
      options: {
        crs: null,
        uppercase: !1
      },
      initialize: function(e, o) {
        this._url = e;
        var u = a({}, this.defaultWmsParams);
        for (var p in o)
          p in this.options || (u[p] = o[p]);
        o = B(this, o);
        var b = o.detectRetina && be.retina ? 2 : 1, P = this.getTileSize();
        u.width = P.x * b, u.height = P.y * b, this.wmsParams = u;
      },
      onAdd: function(e) {
        this._crs = this.options.crs || e.options.crs, this._wmsVersion = parseFloat(this.wmsParams.version);
        var o = this._wmsVersion >= 1.3 ? "crs" : "srs";
        this.wmsParams[o] = this._crs.code, Zr.prototype.onAdd.call(this, e);
      },
      getTileUrl: function(e) {
        var o = this._tileCoordsToNwSe(e), u = this._crs, p = Nt(u.project(o[0]), u.project(o[1])), b = p.min, P = p.max, $ = (this._wmsVersion >= 1.3 && this._crs === ns ? [b.y, b.x, P.y, P.x] : [b.x, b.y, P.x, P.y]).join(","), V = Zr.prototype.getTileUrl.call(this, e);
        return V + X(this.wmsParams, V, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + $;
      },
      setParams: function(e, o) {
        return a(this.wmsParams, e), o || this.redraw(), this;
      }
    });
    function ru(e, o) {
      return new wo(e, o);
    }
    Zr.WMS = wo, na.wms = ru;
    var Ri = Wn.extend({
      options: {
        padding: 0.1
      },
      initialize: function(e) {
        B(this, e), y(this), this._layers = this._layers || {};
      },
      onAdd: function() {
        this._container || (this._initContainer(), this._zoomAnimated && ze(this._container, "leaflet-zoom-animated")), this.getPane().appendChild(this._container), this._update(), this.on("update", this._updatePaths, this);
      },
      onRemove: function() {
        this.off("update", this._updatePaths, this), this._destroyContainer();
      },
      getEvents: function() {
        var e = {
          viewreset: this._reset,
          zoom: this._onZoom,
          moveend: this._update,
          zoomend: this._onZoomEnd
        };
        return this._zoomAnimated && (e.zoomanim = this._onAnimZoom), e;
      },
      _onAnimZoom: function(e) {
        this._updateTransform(e.center, e.zoom);
      },
      _onZoom: function() {
        this._updateTransform(this._map.getCenter(), this._map.getZoom());
      },
      _updateTransform: function(e, o) {
        var u = this._map.getZoomScale(o, this._zoom), p = this._map.getSize().multiplyBy(0.5 + this.options.padding), b = this._map.project(this._center, o), P = p.multiplyBy(-u).add(b).subtract(this._map._getNewPixelOrigin(e, o));
        be.any3d ? k(this._container, P, u) : A(this._container, P);
      },
      _reset: function() {
        this._update(), this._updateTransform(this._center, this._zoom);
        for (var e in this._layers)
          this._layers[e]._reset();
      },
      _onZoomEnd: function() {
        for (var e in this._layers)
          this._layers[e]._project();
      },
      _updatePaths: function() {
        for (var e in this._layers)
          this._layers[e]._update();
      },
      _update: function() {
        var e = this.options.padding, o = this._map.getSize(), u = this._map.containerPointToLayerPoint(o.multiplyBy(-e)).round();
        this._bounds = new Be(u, u.add(o.multiplyBy(1 + e * 2)).round()), this._center = this._map.getCenter(), this._zoom = this._map.getZoom();
      }
    }), Ba = Ri.extend({
      options: {
        tolerance: 0
      },
      getEvents: function() {
        var e = Ri.prototype.getEvents.call(this);
        return e.viewprereset = this._onViewPreReset, e;
      },
      _onViewPreReset: function() {
        this._postponeUpdatePaths = !0;
      },
      onAdd: function() {
        Ri.prototype.onAdd.call(this), this._draw();
      },
      _initContainer: function() {
        var e = this._container = document.createElement("canvas");
        Te(e, "mousemove", this._onMouseMove, this), Te(e, "click dblclick mousedown mouseup contextmenu", this._onClick, this), Te(e, "mouseout", this._handleMouseOut, this), e._leaflet_disable_events = !0, this._ctx = e.getContext("2d");
      },
      _destroyContainer: function() {
        xt(this._redrawRequest), delete this._ctx, yt(this._container), _t(this._container), delete this._container;
      },
      _updatePaths: function() {
        if (!this._postponeUpdatePaths) {
          var e;
          this._redrawBounds = null;
          for (var o in this._layers)
            e = this._layers[o], e._update();
          this._redraw();
        }
      },
      _update: function() {
        if (!(this._map._animatingZoom && this._bounds)) {
          Ri.prototype._update.call(this);
          var e = this._bounds, o = this._container, u = e.getSize(), p = be.retina ? 2 : 1;
          A(o, e.min), o.width = p * u.x, o.height = p * u.y, o.style.width = u.x + "px", o.style.height = u.y + "px", be.retina && this._ctx.scale(2, 2), this._ctx.translate(-e.min.x, -e.min.y), this.fire("update");
        }
      },
      _reset: function() {
        Ri.prototype._reset.call(this), this._postponeUpdatePaths && (this._postponeUpdatePaths = !1, this._updatePaths());
      },
      _initPath: function(e) {
        this._updateDashArray(e), this._layers[y(e)] = e;
        var o = e._order = {
          layer: e,
          prev: this._drawLast,
          next: null
        };
        this._drawLast && (this._drawLast.next = o), this._drawLast = o, this._drawFirst = this._drawFirst || this._drawLast;
      },
      _addPath: function(e) {
        this._requestRedraw(e);
      },
      _removePath: function(e) {
        var o = e._order, u = o.next, p = o.prev;
        u ? u.prev = p : this._drawLast = p, p ? p.next = u : this._drawFirst = u, delete e._order, delete this._layers[y(e)], this._requestRedraw(e);
      },
      _updatePath: function(e) {
        this._extendRedrawBounds(e), e._project(), e._update(), this._requestRedraw(e);
      },
      _updateStyle: function(e) {
        this._updateDashArray(e), this._requestRedraw(e);
      },
      _updateDashArray: function(e) {
        if (typeof e.options.dashArray == "string") {
          var o = e.options.dashArray.split(/[, ]+/), u = [], p, b;
          for (b = 0; b < o.length; b++) {
            if (p = Number(o[b]), isNaN(p))
              return;
            u.push(p);
          }
          e.options._dashArray = u;
        } else
          e.options._dashArray = e.options.dashArray;
      },
      _requestRedraw: function(e) {
        this._map && (this._extendRedrawBounds(e), this._redrawRequest = this._redrawRequest || Pt(this._redraw, this));
      },
      _extendRedrawBounds: function(e) {
        if (e._pxBounds) {
          var o = (e.options.weight || 0) + 1;
          this._redrawBounds = this._redrawBounds || new Be(), this._redrawBounds.extend(e._pxBounds.min.subtract([o, o])), this._redrawBounds.extend(e._pxBounds.max.add([o, o]));
        }
      },
      _redraw: function() {
        this._redrawRequest = null, this._redrawBounds && (this._redrawBounds.min._floor(), this._redrawBounds.max._ceil()), this._clear(), this._draw(), this._redrawBounds = null;
      },
      _clear: function() {
        var e = this._redrawBounds;
        if (e) {
          var o = e.getSize();
          this._ctx.clearRect(e.min.x, e.min.y, o.x, o.y);
        } else
          this._ctx.save(), this._ctx.setTransform(1, 0, 0, 1, 0, 0), this._ctx.clearRect(0, 0, this._container.width, this._container.height), this._ctx.restore();
      },
      _draw: function() {
        var e, o = this._redrawBounds;
        if (this._ctx.save(), o) {
          var u = o.getSize();
          this._ctx.beginPath(), this._ctx.rect(o.min.x, o.min.y, u.x, u.y), this._ctx.clip();
        }
        this._drawing = !0;
        for (var p = this._drawFirst; p; p = p.next)
          e = p.layer, (!o || e._pxBounds && e._pxBounds.intersects(o)) && e._updatePath();
        this._drawing = !1, this._ctx.restore();
      },
      _updatePoly: function(e, o) {
        if (this._drawing) {
          var u, p, b, P, $ = e._parts, V = $.length, j = this._ctx;
          if (V) {
            for (j.beginPath(), u = 0; u < V; u++) {
              for (p = 0, b = $[u].length; p < b; p++)
                P = $[u][p], j[p ? "lineTo" : "moveTo"](P.x, P.y);
              o && j.closePath();
            }
            this._fillStroke(j, e);
          }
        }
      },
      _updateCircle: function(e) {
        if (!(!this._drawing || e._empty())) {
          var o = e._point, u = this._ctx, p = Math.max(Math.round(e._radius), 1), b = (Math.max(Math.round(e._radiusY), 1) || p) / p;
          b !== 1 && (u.save(), u.scale(1, b)), u.beginPath(), u.arc(o.x, o.y / b, p, 0, Math.PI * 2, !1), b !== 1 && u.restore(), this._fillStroke(u, e);
        }
      },
      _fillStroke: function(e, o) {
        var u = o.options;
        u.fill && (e.globalAlpha = u.fillOpacity, e.fillStyle = u.fillColor || u.color, e.fill(u.fillRule || "evenodd")), u.stroke && u.weight !== 0 && (e.setLineDash && e.setLineDash(o.options && o.options._dashArray || []), e.globalAlpha = u.opacity, e.lineWidth = u.weight, e.strokeStyle = u.color, e.lineCap = u.lineCap, e.lineJoin = u.lineJoin, e.stroke());
      },
      _onClick: function(e) {
        for (var o = this._map.mouseEventToLayerPoint(e), u, p, b = this._drawFirst; b; b = b.next)
          u = b.layer, u.options.interactive && u._containsPoint(o) && (!(e.type === "click" || e.type === "preclick") || !this._map._draggableMoved(u)) && (p = u);
        this._fireEvent(p ? [p] : !1, e);
      },
      _onMouseMove: function(e) {
        if (!(!this._map || this._map.dragging.moving() || this._map._animatingZoom)) {
          var o = this._map.mouseEventToLayerPoint(e);
          this._handleMouseHover(e, o);
        }
      },
      _handleMouseOut: function(e) {
        var o = this._hoveredLayer;
        o && (St(this._container, "leaflet-interactive"), this._fireEvent([o], e, "mouseout"), this._hoveredLayer = null, this._mouseHoverThrottled = !1);
      },
      _handleMouseHover: function(e, o) {
        if (!this._mouseHoverThrottled) {
          for (var u, p, b = this._drawFirst; b; b = b.next)
            u = b.layer, u.options.interactive && u._containsPoint(o) && (p = u);
          p !== this._hoveredLayer && (this._handleMouseOut(e), p && (ze(this._container, "leaflet-interactive"), this._fireEvent([p], e, "mouseover"), this._hoveredLayer = p)), this._fireEvent(this._hoveredLayer ? [this._hoveredLayer] : !1, e), this._mouseHoverThrottled = !0, setTimeout(f(function() {
            this._mouseHoverThrottled = !1;
          }, this), 32);
        }
      },
      _fireEvent: function(e, o, u) {
        this._map._fireDOMEvent(o, u || o.type, e);
      },
      _bringToFront: function(e) {
        var o = e._order;
        if (o) {
          var u = o.next, p = o.prev;
          if (u)
            u.prev = p;
          else
            return;
          p ? p.next = u : u && (this._drawFirst = u), o.prev = this._drawLast, this._drawLast.next = o, o.next = null, this._drawLast = o, this._requestRedraw(e);
        }
      },
      _bringToBack: function(e) {
        var o = e._order;
        if (o) {
          var u = o.next, p = o.prev;
          if (p)
            p.next = u;
          else
            return;
          u ? u.prev = p : p && (this._drawLast = p), o.prev = null, o.next = this._drawFirst, this._drawFirst.prev = o, this._drawFirst = o, this._requestRedraw(e);
        }
      }
    });
    function bo(e) {
      return be.canvas ? new Ba(e) : null;
    }
    var Yn = function() {
      try {
        return document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml"), function(e) {
          return document.createElement("<lvml:" + e + ' class="lvml">');
        };
      } catch {
      }
      return function(e) {
        return document.createElement("<" + e + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
      };
    }(), fs = {
      _initContainer: function() {
        this._container = Qe("div", "leaflet-vml-container");
      },
      _update: function() {
        this._map._animatingZoom || (Ri.prototype._update.call(this), this.fire("update"));
      },
      _initPath: function(e) {
        var o = e._container = Yn("shape");
        ze(o, "leaflet-vml-shape " + (this.options.className || "")), o.coordsize = "1 1", e._path = Yn("path"), o.appendChild(e._path), this._updateStyle(e), this._layers[y(e)] = e;
      },
      _addPath: function(e) {
        var o = e._container;
        this._container.appendChild(o), e.options.interactive && e.addInteractiveTarget(o);
      },
      _removePath: function(e) {
        var o = e._container;
        yt(o), e.removeInteractiveTarget(o), delete this._layers[y(e)];
      },
      _updateStyle: function(e) {
        var o = e._stroke, u = e._fill, p = e.options, b = e._container;
        b.stroked = !!p.stroke, b.filled = !!p.fill, p.stroke ? (o || (o = e._stroke = Yn("stroke")), b.appendChild(o), o.weight = p.weight + "px", o.color = p.color, o.opacity = p.opacity, p.dashArray ? o.dashStyle = re(p.dashArray) ? p.dashArray.join(" ") : p.dashArray.replace(/( *, *)/g, " ") : o.dashStyle = "", o.endcap = p.lineCap.replace("butt", "flat"), o.joinstyle = p.lineJoin) : o && (b.removeChild(o), e._stroke = null), p.fill ? (u || (u = e._fill = Yn("fill")), b.appendChild(u), u.color = p.fillColor || p.color, u.opacity = p.fillOpacity) : u && (b.removeChild(u), e._fill = null);
      },
      _updateCircle: function(e) {
        var o = e._point.round(), u = Math.round(e._radius), p = Math.round(e._radiusY || u);
        this._setPath(e, e._empty() ? "M0 0" : "AL " + o.x + "," + o.y + " " + u + "," + p + " 0," + 65535 * 360);
      },
      _setPath: function(e, o) {
        e._path.v = o;
      },
      _bringToFront: function(e) {
        Vn(e._container);
      },
      _bringToBack: function(e) {
        ui(e._container);
      }
    }, So = be.vml ? Yn : bt, Ji = Ri.extend({
      _initContainer: function() {
        this._container = So("svg"), this._container.setAttribute("pointer-events", "none"), this._rootGroup = So("g"), this._container.appendChild(this._rootGroup);
      },
      _destroyContainer: function() {
        yt(this._container), _t(this._container), delete this._container, delete this._rootGroup, delete this._svgSize;
      },
      _update: function() {
        if (!(this._map._animatingZoom && this._bounds)) {
          Ri.prototype._update.call(this);
          var e = this._bounds, o = e.getSize(), u = this._container;
          (!this._svgSize || !this._svgSize.equals(o)) && (this._svgSize = o, u.setAttribute("width", o.x), u.setAttribute("height", o.y)), A(u, e.min), u.setAttribute("viewBox", [e.min.x, e.min.y, o.x, o.y].join(" ")), this.fire("update");
        }
      },
      _initPath: function(e) {
        var o = e._path = So("path");
        e.options.className && ze(o, e.options.className), e.options.interactive && ze(o, "leaflet-interactive"), this._updateStyle(e), this._layers[y(e)] = e;
      },
      _addPath: function(e) {
        this._rootGroup || this._initContainer(), this._rootGroup.appendChild(e._path), e.addInteractiveTarget(e._path);
      },
      _removePath: function(e) {
        yt(e._path), e.removeInteractiveTarget(e._path), delete this._layers[y(e)];
      },
      _updatePath: function(e) {
        e._project(), e._update();
      },
      _updateStyle: function(e) {
        var o = e._path, u = e.options;
        o && (u.stroke ? (o.setAttribute("stroke", u.color), o.setAttribute("stroke-opacity", u.opacity), o.setAttribute("stroke-width", u.weight), o.setAttribute("stroke-linecap", u.lineCap), o.setAttribute("stroke-linejoin", u.lineJoin), u.dashArray ? o.setAttribute("stroke-dasharray", u.dashArray) : o.removeAttribute("stroke-dasharray"), u.dashOffset ? o.setAttribute("stroke-dashoffset", u.dashOffset) : o.removeAttribute("stroke-dashoffset")) : o.setAttribute("stroke", "none"), u.fill ? (o.setAttribute("fill", u.fillColor || u.color), o.setAttribute("fill-opacity", u.fillOpacity), o.setAttribute("fill-rule", u.fillRule || "evenodd")) : o.setAttribute("fill", "none"));
      },
      _updatePoly: function(e, o) {
        this._setPath(e, Rt(e._parts, o));
      },
      _updateCircle: function(e) {
        var o = e._point, u = Math.max(Math.round(e._radius), 1), p = Math.max(Math.round(e._radiusY), 1) || u, b = "a" + u + "," + p + " 0 1,0 ", P = e._empty() ? "M0 0" : "M" + (o.x - u) + "," + o.y + b + u * 2 + ",0 " + b + -u * 2 + ",0 ";
        this._setPath(e, P);
      },
      _setPath: function(e, o) {
        e._path.setAttribute("d", o);
      },
      _bringToFront: function(e) {
        Vn(e._path);
      },
      _bringToBack: function(e) {
        ui(e._path);
      }
    });
    be.vml && Ji.include(fs);
    function ia(e) {
      return be.svg || be.vml ? new Ji(e) : null;
    }
    et.include({
      getRenderer: function(e) {
        var o = e.options.renderer || this._getPaneRenderer(e.options.pane) || this.options.renderer || this._renderer;
        return o || (o = this._renderer = this._createRenderer()), this.hasLayer(o) || this.addLayer(o), o;
      },
      _getPaneRenderer: function(e) {
        if (e === "overlayPane" || e === void 0)
          return !1;
        var o = this._paneRenderers[e];
        return o === void 0 && (o = this._createRenderer({ pane: e }), this._paneRenderers[e] = o), o;
      },
      _createRenderer: function(e) {
        return this.options.preferCanvas && bo(e) || ia(e);
      }
    });
    var ra = Fr.extend({
      initialize: function(e, o) {
        Fr.prototype.initialize.call(this, this._boundsToLatLngs(e), o);
      },
      setBounds: function(e) {
        return this.setLatLngs(this._boundsToLatLngs(e));
      },
      _boundsToLatLngs: function(e) {
        return e = wt(e), [
          e.getSouthWest(),
          e.getNorthWest(),
          e.getNorthEast(),
          e.getSouthEast()
        ];
      }
    });
    function ds(e, o) {
      return new ra(e, o);
    }
    Ji.create = So, Ji.pointsToPath = Rt, Ii.geometryToLayer = Ni, Ii.coordsToLatLng = ss, Ii.coordsToLatLngs = as, Ii.latLngToCoords = ta, Ii.latLngsToCoords = ls, Ii.getFeature = Hr, Ii.asFeature = us, et.mergeOptions({
      boxZoom: !0
    });
    var oa = zt.extend({
      initialize: function(e) {
        this._map = e, this._container = e._container, this._pane = e._panes.overlayPane, this._resetStateTimeout = 0, e.on("unload", this._destroy, this);
      },
      addHooks: function() {
        Te(this._container, "mousedown", this._onMouseDown, this);
      },
      removeHooks: function() {
        _t(this._container, "mousedown", this._onMouseDown, this);
      },
      moved: function() {
        return this._moved;
      },
      _destroy: function() {
        yt(this._pane), delete this._pane;
      },
      _resetState: function() {
        this._resetStateTimeout = 0, this._moved = !1;
      },
      _clearDeferredResetState: function() {
        this._resetStateTimeout !== 0 && (clearTimeout(this._resetStateTimeout), this._resetStateTimeout = 0);
      },
      _onMouseDown: function(e) {
        if (!e.shiftKey || e.which !== 1 && e.button !== 1)
          return !1;
        this._clearDeferredResetState(), this._resetState(), F(), ke(), this._startPoint = this._map.mouseEventToContainerPoint(e), Te(document, {
          contextmenu: st,
          mousemove: this._onMouseMove,
          mouseup: this._onMouseUp,
          keydown: this._onKeyDown
        }, this);
      },
      _onMouseMove: function(e) {
        this._moved || (this._moved = !0, this._box = Qe("div", "leaflet-zoom-box", this._container), ze(this._container, "leaflet-crosshair"), this._map.fire("boxzoomstart")), this._point = this._map.mouseEventToContainerPoint(e);
        var o = new Be(this._point, this._startPoint), u = o.getSize();
        A(this._box, o.min), this._box.style.width = u.x + "px", this._box.style.height = u.y + "px";
      },
      _finish: function() {
        this._moved && (yt(this._box), St(this._container, "leaflet-crosshair")), G(), Ie(), _t(document, {
          contextmenu: st,
          mousemove: this._onMouseMove,
          mouseup: this._onMouseUp,
          keydown: this._onKeyDown
        }, this);
      },
      _onMouseUp: function(e) {
        if (!(e.which !== 1 && e.button !== 1) && (this._finish(), !!this._moved)) {
          this._clearDeferredResetState(), this._resetStateTimeout = setTimeout(f(this._resetState, this), 0);
          var o = new Ht(
            this._map.containerPointToLatLng(this._startPoint),
            this._map.containerPointToLatLng(this._point)
          );
          this._map.fitBounds(o).fire("boxzoomend", { boxZoomBounds: o });
        }
      },
      _onKeyDown: function(e) {
        e.keyCode === 27 && (this._finish(), this._clearDeferredResetState(), this._resetState());
      }
    });
    et.addInitHook("addHandler", "boxZoom", oa), et.mergeOptions({
      doubleClickZoom: !0
    });
    var Vr = zt.extend({
      addHooks: function() {
        this._map.on("dblclick", this._onDoubleClick, this);
      },
      removeHooks: function() {
        this._map.off("dblclick", this._onDoubleClick, this);
      },
      _onDoubleClick: function(e) {
        var o = this._map, u = o.getZoom(), p = o.options.zoomDelta, b = e.originalEvent.shiftKey ? u - p : u + p;
        o.options.doubleClickZoom === "center" ? o.setZoom(b) : o.setZoomAround(e.containerPoint, b);
      }
    });
    et.addInitHook("addHandler", "doubleClickZoom", Vr), et.mergeOptions({
      dragging: !0,
      inertia: !0,
      inertiaDeceleration: 3400,
      inertiaMaxSpeed: 1 / 0,
      easeLinearity: 0.2,
      worldCopyJump: !1,
      maxBoundsViscosity: 0
    });
    var Xi = zt.extend({
      addHooks: function() {
        if (!this._draggable) {
          var e = this._map;
          this._draggable = new Gi(e._mapPane, e._container), this._draggable.on({
            dragstart: this._onDragStart,
            drag: this._onDrag,
            dragend: this._onDragEnd
          }, this), this._draggable.on("predrag", this._onPreDragLimit, this), e.options.worldCopyJump && (this._draggable.on("predrag", this._onPreDragWrap, this), e.on("zoomend", this._onZoomEnd, this), e.whenReady(this._onZoomEnd, this));
        }
        ze(this._map._container, "leaflet-grab leaflet-touch-drag"), this._draggable.enable(), this._positions = [], this._times = [];
      },
      removeHooks: function() {
        St(this._map._container, "leaflet-grab"), St(this._map._container, "leaflet-touch-drag"), this._draggable.disable();
      },
      moved: function() {
        return this._draggable && this._draggable._moved;
      },
      moving: function() {
        return this._draggable && this._draggable._moving;
      },
      _onDragStart: function() {
        var e = this._map;
        if (e._stop(), this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
          var o = wt(this._map.options.maxBounds);
          this._offsetLimit = Nt(
            this._map.latLngToContainerPoint(o.getNorthWest()).multiplyBy(-1),
            this._map.latLngToContainerPoint(o.getSouthEast()).multiplyBy(-1).add(this._map.getSize())
          ), this._viscosity = Math.min(1, Math.max(0, this._map.options.maxBoundsViscosity));
        } else
          this._offsetLimit = null;
        e.fire("movestart").fire("dragstart"), e.options.inertia && (this._positions = [], this._times = []);
      },
      _onDrag: function(e) {
        if (this._map.options.inertia) {
          var o = this._lastTime = +new Date(), u = this._lastPos = this._draggable._absPos || this._draggable._newPos;
          this._positions.push(u), this._times.push(o), this._prunePositions(o);
        }
        this._map.fire("move", e).fire("drag", e);
      },
      _prunePositions: function(e) {
        for (; this._positions.length > 1 && e - this._times[0] > 50; )
          this._positions.shift(), this._times.shift();
      },
      _onZoomEnd: function() {
        var e = this._map.getSize().divideBy(2), o = this._map.latLngToLayerPoint([0, 0]);
        this._initialWorldOffset = o.subtract(e).x, this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
      },
      _viscousLimit: function(e, o) {
        return e - (e - o) * this._viscosity;
      },
      _onPreDragLimit: function() {
        if (!(!this._viscosity || !this._offsetLimit)) {
          var e = this._draggable._newPos.subtract(this._draggable._startPos), o = this._offsetLimit;
          e.x < o.min.x && (e.x = this._viscousLimit(e.x, o.min.x)), e.y < o.min.y && (e.y = this._viscousLimit(e.y, o.min.y)), e.x > o.max.x && (e.x = this._viscousLimit(e.x, o.max.x)), e.y > o.max.y && (e.y = this._viscousLimit(e.y, o.max.y)), this._draggable._newPos = this._draggable._startPos.add(e);
        }
      },
      _onPreDragWrap: function() {
        var e = this._worldWidth, o = Math.round(e / 2), u = this._initialWorldOffset, p = this._draggable._newPos.x, b = (p - o + u) % e + o - u, P = (p + o + u) % e - o - u, $ = Math.abs(b + u) < Math.abs(P + u) ? b : P;
        this._draggable._absPos = this._draggable._newPos.clone(), this._draggable._newPos.x = $;
      },
      _onDragEnd: function(e) {
        var o = this._map, u = o.options, p = !u.inertia || e.noInertia || this._times.length < 2;
        if (o.fire("dragend", e), p)
          o.fire("moveend");
        else {
          this._prunePositions(+new Date());
          var b = this._lastPos.subtract(this._positions[0]), P = (this._lastTime - this._times[0]) / 1e3, $ = u.easeLinearity, V = b.multiplyBy($ / P), j = V.distanceTo([0, 0]), oe = Math.min(u.inertiaMaxSpeed, j), ge = V.multiplyBy(oe / j), Oe = oe / (u.inertiaDeceleration * $), Ve = ge.multiplyBy(-Oe / 2).round();
          !Ve.x && !Ve.y ? o.fire("moveend") : (Ve = o._limitOffset(Ve, o.options.maxBounds), Pt(function() {
            o.panBy(Ve, {
              duration: Oe,
              easeLinearity: $,
              noMoveStart: !0,
              animate: !0
            });
          }));
        }
      }
    });
    et.addInitHook("addHandler", "dragging", Xi), et.mergeOptions({
      keyboard: !0,
      keyboardPanDelta: 80
    });
    var Co = zt.extend({
      keyCodes: {
        left: [37],
        right: [39],
        down: [40],
        up: [38],
        zoomIn: [187, 107, 61, 171],
        zoomOut: [189, 109, 54, 173]
      },
      initialize: function(e) {
        this._map = e, this._setPanDelta(e.options.keyboardPanDelta), this._setZoomDelta(e.options.zoomDelta);
      },
      addHooks: function() {
        var e = this._map._container;
        e.tabIndex <= 0 && (e.tabIndex = "0"), Te(e, {
          focus: this._onFocus,
          blur: this._onBlur,
          mousedown: this._onMouseDown
        }, this), this._map.on({
          focus: this._addHooks,
          blur: this._removeHooks
        }, this);
      },
      removeHooks: function() {
        this._removeHooks(), _t(this._map._container, {
          focus: this._onFocus,
          blur: this._onBlur,
          mousedown: this._onMouseDown
        }, this), this._map.off({
          focus: this._addHooks,
          blur: this._removeHooks
        }, this);
      },
      _onMouseDown: function() {
        if (!this._focused) {
          var e = document.body, o = document.documentElement, u = e.scrollTop || o.scrollTop, p = e.scrollLeft || o.scrollLeft;
          this._map._container.focus(), window.scrollTo(p, u);
        }
      },
      _onFocus: function() {
        this._focused = !0, this._map.fire("focus");
      },
      _onBlur: function() {
        this._focused = !1, this._map.fire("blur");
      },
      _setPanDelta: function(e) {
        var o = this._panKeys = {}, u = this.keyCodes, p, b;
        for (p = 0, b = u.left.length; p < b; p++)
          o[u.left[p]] = [-1 * e, 0];
        for (p = 0, b = u.right.length; p < b; p++)
          o[u.right[p]] = [e, 0];
        for (p = 0, b = u.down.length; p < b; p++)
          o[u.down[p]] = [0, e];
        for (p = 0, b = u.up.length; p < b; p++)
          o[u.up[p]] = [0, -1 * e];
      },
      _setZoomDelta: function(e) {
        var o = this._zoomKeys = {}, u = this.keyCodes, p, b;
        for (p = 0, b = u.zoomIn.length; p < b; p++)
          o[u.zoomIn[p]] = e;
        for (p = 0, b = u.zoomOut.length; p < b; p++)
          o[u.zoomOut[p]] = -e;
      },
      _addHooks: function() {
        Te(document, "keydown", this._onKeyDown, this);
      },
      _removeHooks: function() {
        _t(document, "keydown", this._onKeyDown, this);
      },
      _onKeyDown: function(e) {
        if (!(e.altKey || e.ctrlKey || e.metaKey)) {
          var o = e.keyCode, u = this._map, p;
          if (o in this._panKeys) {
            if (!u._panAnim || !u._panAnim._inProgress)
              if (p = this._panKeys[o], e.shiftKey && (p = _e(p).multiplyBy(3)), u.options.maxBounds && (p = u._limitOffset(_e(p), u.options.maxBounds)), u.options.worldCopyJump) {
                var b = u.wrapLatLng(u.unproject(u.project(u.getCenter()).add(p)));
                u.panTo(b);
              } else
                u.panBy(p);
          } else if (o in this._zoomKeys)
            u.setZoom(u.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[o]);
          else if (o === 27 && u._popup && u._popup.options.closeOnEscapeKey)
            u.closePopup();
          else
            return;
          st(e);
        }
      }
    });
    et.addInitHook("addHandler", "keyboard", Co), et.mergeOptions({
      scrollWheelZoom: !0,
      wheelDebounceTime: 40,
      wheelPxPerZoomLevel: 60
    });
    var Ua = zt.extend({
      addHooks: function() {
        Te(this._map._container, "wheel", this._onWheelScroll, this), this._delta = 0;
      },
      removeHooks: function() {
        _t(this._map._container, "wheel", this._onWheelScroll, this);
      },
      _onWheelScroll: function(e) {
        var o = xa(e), u = this._map.options.wheelDebounceTime;
        this._delta += o, this._lastMousePos = this._map.mouseEventToContainerPoint(e), this._startTime || (this._startTime = +new Date());
        var p = Math.max(u - (+new Date() - this._startTime), 0);
        clearTimeout(this._timer), this._timer = setTimeout(f(this._performZoom, this), p), st(e);
      },
      _performZoom: function() {
        var e = this._map, o = e.getZoom(), u = this._map.options.zoomSnap || 0;
        e._stop();
        var p = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), b = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(p)))) / Math.LN2, P = u ? Math.ceil(b / u) * u : b, $ = e._limitZoom(o + (this._delta > 0 ? P : -P)) - o;
        this._delta = 0, this._startTime = null, $ && (e.options.scrollWheelZoom === "center" ? e.setZoom(o + $) : e.setZoomAround(this._lastMousePos, o + $));
      }
    });
    et.addInitHook("addHandler", "scrollWheelZoom", Ua);
    var ou = 600;
    et.mergeOptions({
      tapHold: be.touchNative && be.safari && be.mobile,
      tapTolerance: 15
    });
    var Fa = zt.extend({
      addHooks: function() {
        Te(this._map._container, "touchstart", this._onDown, this);
      },
      removeHooks: function() {
        _t(this._map._container, "touchstart", this._onDown, this);
      },
      _onDown: function(e) {
        if (clearTimeout(this._holdTimeout), e.touches.length === 1) {
          var o = e.touches[0];
          this._startPos = this._newPos = new we(o.clientX, o.clientY), this._holdTimeout = setTimeout(f(function() {
            this._cancel(), this._isTapValid() && (Te(document, "touchend", Fe), Te(document, "touchend touchcancel", this._cancelClickPrevent), this._simulateEvent("contextmenu", o));
          }, this), ou), Te(document, "touchend touchcancel contextmenu", this._cancel, this), Te(document, "touchmove", this._onMove, this);
        }
      },
      _cancelClickPrevent: function e() {
        _t(document, "touchend", Fe), _t(document, "touchend touchcancel", e);
      },
      _cancel: function() {
        clearTimeout(this._holdTimeout), _t(document, "touchend touchcancel contextmenu", this._cancel, this), _t(document, "touchmove", this._onMove, this);
      },
      _onMove: function(e) {
        var o = e.touches[0];
        this._newPos = new we(o.clientX, o.clientY);
      },
      _isTapValid: function() {
        return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
      },
      _simulateEvent: function(e, o) {
        var u = new MouseEvent(e, {
          bubbles: !0,
          cancelable: !0,
          view: window,
          screenX: o.screenX,
          screenY: o.screenY,
          clientX: o.clientX,
          clientY: o.clientY
        });
        u._simulated = !0, o.target.dispatchEvent(u);
      }
    });
    et.addInitHook("addHandler", "tapHold", Fa), et.mergeOptions({
      touchZoom: be.touch,
      bounceAtZoomLimits: !0
    });
    var To = zt.extend({
      addHooks: function() {
        ze(this._map._container, "leaflet-touch-zoom"), Te(this._map._container, "touchstart", this._onTouchStart, this);
      },
      removeHooks: function() {
        St(this._map._container, "leaflet-touch-zoom"), _t(this._map._container, "touchstart", this._onTouchStart, this);
      },
      _onTouchStart: function(e) {
        var o = this._map;
        if (!(!e.touches || e.touches.length !== 2 || o._animatingZoom || this._zooming)) {
          var u = o.mouseEventToContainerPoint(e.touches[0]), p = o.mouseEventToContainerPoint(e.touches[1]);
          this._centerPoint = o.getSize()._divideBy(2), this._startLatLng = o.containerPointToLatLng(this._centerPoint), o.options.touchZoom !== "center" && (this._pinchStartLatLng = o.containerPointToLatLng(u.add(p)._divideBy(2))), this._startDist = u.distanceTo(p), this._startZoom = o.getZoom(), this._moved = !1, this._zooming = !0, o._stop(), Te(document, "touchmove", this._onTouchMove, this), Te(document, "touchend touchcancel", this._onTouchEnd, this), Fe(e);
        }
      },
      _onTouchMove: function(e) {
        if (!(!e.touches || e.touches.length !== 2 || !this._zooming)) {
          var o = this._map, u = o.mouseEventToContainerPoint(e.touches[0]), p = o.mouseEventToContainerPoint(e.touches[1]), b = u.distanceTo(p) / this._startDist;
          if (this._zoom = o.getScaleZoom(b, this._startZoom), !o.options.bounceAtZoomLimits && (this._zoom < o.getMinZoom() && b < 1 || this._zoom > o.getMaxZoom() && b > 1) && (this._zoom = o._limitZoom(this._zoom)), o.options.touchZoom === "center") {
            if (this._center = this._startLatLng, b === 1)
              return;
          } else {
            var P = u._add(p)._divideBy(2)._subtract(this._centerPoint);
            if (b === 1 && P.x === 0 && P.y === 0)
              return;
            this._center = o.unproject(o.project(this._pinchStartLatLng, this._zoom).subtract(P), this._zoom);
          }
          this._moved || (o._moveStart(!0, !1), this._moved = !0), xt(this._animRequest);
          var $ = f(o._move, o, this._center, this._zoom, { pinch: !0, round: !1 }, void 0);
          this._animRequest = Pt($, this, !0), Fe(e);
        }
      },
      _onTouchEnd: function() {
        if (!this._moved || !this._zooming) {
          this._zooming = !1;
          return;
        }
        this._zooming = !1, xt(this._animRequest), _t(document, "touchmove", this._onTouchMove, this), _t(document, "touchend touchcancel", this._onTouchEnd, this), this._map.options.zoomAnimation ? this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), !0, this._map.options.zoomSnap) : this._map._resetView(this._center, this._map._limitZoom(this._zoom));
      }
    });
    et.addInitHook("addHandler", "touchZoom", To), et.BoxZoom = oa, et.DoubleClickZoom = Vr, et.Drag = Xi, et.Keyboard = Co, et.ScrollWheelZoom = Ua, et.TapHold = Fa, et.TouchZoom = To, r.Bounds = Be, r.Browser = be, r.CRS = Tn, r.Canvas = Ba, r.Circle = Lo, r.CircleMarker = rs, r.Class = Dt, r.Control = En, r.DivIcon = wr, r.DivOverlay = Gn, r.DomEvent = Gl, r.DomUtil = Jo, r.Draggable = Gi, r.Evented = Kt, r.FeatureGroup = On, r.GeoJSON = Ii, r.GridLayer = Ki, r.Handler = zt, r.Icon = yr, r.ImageOverlay = W, r.LatLng = $e, r.LatLngBounds = Ht, r.Layer = Wn, r.LayerGroup = Qt, r.LineUtil = Kl, r.Map = et, r.Marker = is, r.Mixin = ql, r.Path = xn, r.Point = we, r.PolyUtil = Xs, r.Polygon = Fr, r.Polyline = hn, r.Popup = cs, r.PosAnimation = Vs, r.Projection = Jl, r.Rectangle = ra, r.Renderer = Ri, r.SVG = Ji, r.SVGOverlay = Vt, r.TileLayer = Zr, r.Tooltip = Lr, r.Transformation = Jt, r.Util = _n, r.VideoOverlay = Ne, r.bind = f, r.bounds = Nt, r.canvas = bo, r.circle = za, r.circleMarker = tu, r.control = ci, r.divIcon = hs, r.extend = a, r.featureGroup = Ra, r.geoJSON = H, r.geoJson = K, r.gridLayer = gt, r.icon = Ql, r.imageOverlay = ye, r.latLng = ot, r.latLngBounds = wt, r.layerGroup = ea, r.map = on, r.marker = eu, r.point = _e, r.polygon = nu, r.polyline = os, r.popup = qn, r.rectangle = ds, r.setOptions = B, r.stamp = y, r.svg = ia, r.svgOverlay = Lt, r.tileLayer = na, r.tooltip = iu, r.transformation = pt, r.version = h, r.videoOverlay = lt;
    var ps = window.L;
    r.noConflict = function() {
      return window.L = ps, this;
    }, window.L = r;
  });
})(z0, Pl);
const ni = Pl;
(function() {
  var t = Symbol("newer"), i = Symbol("older"), r = function(v, C) {
    typeof v != "number" && (C = v, v = 0), this.size = 0, this.limit = v, this.oldest = this.newest = void 0, this._keymap = /* @__PURE__ */ new Map(), C && (this.assign(C), v < 1 && (this.limit = this.size));
  };
  r.prototype._markEntryAsUsed = function(v) {
    v !== this.newest && (v[t] && (v === this.oldest && (this.oldest = v[t]), v[t][i] = v[i]), v[i] && (v[i][t] = v[t]), v[t] = void 0, v[i] = this.newest, this.newest && (this.newest[t] = v), this.newest = v);
  }, r.prototype.assign = function(v) {
    var C, M = this.limit || Number.MAX_VALUE;
    this._keymap.clear();
    for (var N = v[Symbol.iterator](), I = N.next(); !I.done; I = N.next()) {
      var D = new h(I.value[0], I.value[1]);
      if (this._keymap.set(D.key, D), C ? (C[t] = D, D[i] = C) : this.oldest = D, C = D, M-- == 0)
        throw new Error("overflow");
    }
    this.newest = C, this.size = this._keymap.size;
  }, r.prototype.get = function(v) {
    var C = this._keymap.get(v);
    if (C)
      return this._markEntryAsUsed(C), C.value;
  }, r.prototype.set = function(v, C) {
    var M = this._keymap.get(v);
    return M ? (M.value = C, this._markEntryAsUsed(M), this) : (this._keymap.set(v, M = new h(v, C)), this.newest ? (this.newest[t] = M, M[i] = this.newest) : this.oldest = M, this.newest = M, ++this.size, this.size > this.limit && this.shift(), this);
  }, r.prototype.shift = function() {
    var v = this.oldest;
    if (v)
      return this.oldest[t] ? (this.oldest = this.oldest[t], this.oldest[i] = void 0) : (this.oldest = void 0, this.newest = void 0), v[t] = v[i] = void 0, this._keymap.delete(v.key), --this.size, [v.key, v.value];
  }, r.prototype.find = function(v) {
    var C = this._keymap.get(v);
    return C ? C.value : void 0;
  }, r.prototype.has = function(v) {
    return this._keymap.has(v);
  }, r.prototype.delete = function(v) {
    var C = this._keymap.get(v);
    if (C)
      return this._keymap.delete(C.key), C[t] && C[i] ? (C[i][t] = C[t], C[t][i] = C[i]) : C[t] ? (C[t][i] = void 0, this.oldest = C[t]) : C[i] ? (C[i][t] = void 0, this.newest = C[i]) : this.oldest = this.newest = void 0, this.size--, C.value;
  }, r.prototype.clear = function() {
    this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
  }, r.prototype.keys = function() {
    return new l(this.oldest);
  }, r.prototype.values = function() {
    return new f(this.oldest);
  }, r.prototype.entries = function() {
    return this;
  }, r.prototype[Symbol.iterator] = function() {
    return new a(this.oldest);
  }, r.prototype.forEach = function(v, C) {
    typeof C != "object" && (C = this);
    for (var M = this.oldest; M; )
      v.call(C, M.value, M.key, this), M = M[t];
  }, r.prototype.toJSON = function() {
    for (var v = new Array(this.size), C = 0, M = this.oldest; M; )
      v[C++] = { key: M.key, value: M.value }, M = M[t];
    return v;
  }, r.prototype.toString = function() {
    for (var v = "", C = this.oldest; C; )
      v += String(C.key) + ":" + C.value, C = C[t], C && (v += " < ");
    return v;
  };
  function h(y, v) {
    this.key = y, this.value = v, this[t] = void 0, this[i] = void 0;
  }
  function a(y) {
    this.entry = y;
  }
  a.prototype[Symbol.iterator] = function() {
    return this;
  }, a.prototype.next = function() {
    var y = this.entry;
    return y ? (this.entry = y[t], { done: !1, value: [y.key, y.value] }) : { done: !0, value: void 0 };
  };
  function l(y) {
    this.entry = y;
  }
  l.prototype[Symbol.iterator] = function() {
    return this;
  }, l.prototype.next = function() {
    var y = this.entry;
    return y ? (this.entry = y[t], { done: !1, value: y.key }) : { done: !0, value: void 0 };
  };
  function f(y) {
    this.entry = y;
  }
  f.prototype[Symbol.iterator] = function() {
    return this;
  }, f.prototype.next = function() {
    var y = this.entry;
    return y ? (this.entry = y[t], { done: !1, value: y.value }) : { done: !0, value: void 0 };
  };
  function m(y, v) {
    var C = 0, M = null;
    M = setInterval(function() {
      if (C >= 20)
        throw clearInterval(M), new Error("window.google not found after 10 seconds");
      window.google && window.google.maps && window.google.maps.Map && (clearInterval(M), y.call(v)), ++C;
    }, 500);
  }
  L.GridLayer.GoogleMutant = L.GridLayer.extend({
    options: {
      maxZoom: 21,
      type: "roadmap",
      maxNativeZoom: 21
    },
    initialize: function(y) {
      L.GridLayer.prototype.initialize.call(this, y), this._tileCallbacks = {}, this._lru = new r(100), this._imagesPerTile = this.options.type === "hybrid" ? 2 : 1, this._boundOnMutatedImage = this._onMutatedImage.bind(this);
    },
    onAdd: function(y) {
      var v = this;
      L.GridLayer.prototype.onAdd.call(this, y), this._initMutantContainer(), this._logoContainer && y._controlCorners.bottomleft.appendChild(this._logoContainer), this._attributionContainer && y._controlCorners.bottomright.appendChild(this._attributionContainer), m(function() {
        v._map && (v._initMutant(), google.maps.event.addListenerOnce(v._mutant, "idle", function() {
          v._map && (v._checkZoomLevels(), v._mutantIsReady = !0);
        }));
      });
    },
    onRemove: function(y) {
      L.GridLayer.prototype.onRemove.call(this, y), this._observer.disconnect(), y._container.removeChild(this._mutantContainer), this._logoContainer && L.DomUtil.remove(this._logoContainer), this._attributionContainer && L.DomUtil.remove(this._attributionContainer), this._mutant && google.maps.event.clearListeners(this._mutant, "idle");
    },
    addGoogleLayer: function(y, v) {
      var C = this;
      return this._subLayers || (this._subLayers = {}), this.whenReady(function() {
        var M = google.maps[y], N = new M(v);
        N.setMap(C._mutant), C._subLayers[y] = N;
      }), this;
    },
    removeGoogleLayer: function(y) {
      var v = this;
      return this.whenReady(function() {
        var C = v._subLayers && v._subLayers[y];
        C && (C.setMap(null), delete v._subLayers[y]);
      }), this;
    },
    _initMutantContainer: function() {
      this._mutantContainer || (this._mutantContainer = L.DomUtil.create(
        "div",
        "leaflet-google-mutant leaflet-top leaflet-left"
      ), this._mutantContainer.id = "_MutantContainer_" + L.Util.stamp(this._mutantContainer), this._mutantContainer.style.pointerEvents = "none", this._mutantContainer.style.visibility = "hidden", L.DomEvent.off(this._mutantContainer)), this._map.getContainer().appendChild(this._mutantContainer), this.setOpacity(this.options.opacity);
      var y = this._mutantContainer.style;
      this._map.options.zoomSnap < 1 ? (y.width = "180%", y.height = "180%") : (y.width = "100%", y.height = "100%"), y.zIndex = -1, this._attachObserver(this._mutantContainer);
    },
    _initMutant: function() {
      if (!this._mutant) {
        var y = new google.maps.Map(this._mutantContainer, {
          center: { lat: 0, lng: 0 },
          zoom: 0,
          tilt: 0,
          mapTypeId: this.options.type,
          disableDefaultUI: !0,
          keyboardShortcuts: !1,
          draggable: !1,
          disableDoubleClickZoom: !0,
          scrollwheel: !1,
          styles: this.options.styles || [],
          backgroundColor: "transparent"
        });
        this._mutant = y, this._update(), this.fire("spawned", { mapObject: y }), this._waitControls(), this.once("controls_ready", this._setupAttribution);
      }
    },
    _attachObserver: function(v) {
      this._observer || (this._observer = new MutationObserver(this._onMutations.bind(this))), this._observer.observe(v, { childList: !0, subtree: !0 }), Array.prototype.forEach.call(v.querySelectorAll("img"), this._boundOnMutatedImage);
    },
    _waitControls: function() {
      var y = this, v = setInterval(function() {
        var C = y._mutant.__gm.layoutManager;
        if (C) {
          clearInterval(v);
          var M;
          Object.keys(C).forEach(function(N) {
            var I = C[N];
            I.get && I.get(1) instanceof Node && (M = I);
          }), y.fire("controls_ready", { positions: M });
        }
      }, 50);
    },
    _setupAttribution: function(y) {
      var v = google.maps.ControlPosition, C = this._attributionContainer = y.positions.get(v.BOTTOM_RIGHT);
      L.DomUtil.addClass(C, "leaflet-control leaflet-control-attribution"), L.DomEvent.disableClickPropagation(C), C.style.height = "14px", this._map._controlCorners.bottomright.appendChild(C), this._logoContainer = y.positions.get(v.BOTTOM_LEFT), this._logoContainer.style.pointerEvents = "auto", this._map._controlCorners.bottomleft.appendChild(this._logoContainer);
    },
    _onMutations: function(v) {
      for (var C = 0; C < v.length; ++C)
        for (var M = v[C], N = 0; N < M.addedNodes.length; ++N) {
          var I = M.addedNodes[N];
          I instanceof HTMLImageElement ? this._onMutatedImage(I) : I instanceof HTMLElement && Array.prototype.forEach.call(
            I.querySelectorAll("img"),
            this._boundOnMutatedImage
          );
        }
    },
    _roadRegexp: /!1i(\d+)!2i(\d+)!3i(\d+)!/,
    _satRegexp: /x=(\d+)&y=(\d+)&z=(\d+)/,
    _staticRegExp: /StaticMapService\.GetMapImage/,
    _onMutatedImage: function(v) {
      var C, M = v.src.match(this._roadRegexp), N = 0;
      if (M ? (C = {
        z: M[1],
        x: M[2],
        y: M[3]
      }, this._imagesPerTile > 1 && (v.style.zIndex = 1, N = 1)) : (M = v.src.match(this._satRegexp), M && (C = {
        x: M[1],
        y: M[2],
        z: M[3]
      }), N = 0), C) {
        var I = this._tileCoordsToKey(C);
        v.style.position = "absolute";
        var D = I + "/" + N;
        this._lru.set(D, v), D in this._tileCallbacks && this._tileCallbacks[D] && (this._tileCallbacks[D].forEach(function(B) {
          return B(v);
        }), delete this._tileCallbacks[D]);
      }
    },
    createTile: function(y, v) {
      var C = this._tileCoordsToKey(y), M = L.DomUtil.create("div");
      M.style.textAlign = "left", M.dataset.pending = this._imagesPerTile, v = v.bind(this, null, M);
      for (var N = 0; N < this._imagesPerTile; ++N) {
        var I = C + "/" + N, D = this._lru.get(I);
        D ? (M.appendChild(this._clone(D)), --M.dataset.pending) : (this._tileCallbacks[I] = this._tileCallbacks[I] || [], this._tileCallbacks[I].push(
          function(B) {
            return function(X) {
              B.appendChild(this._clone(X)), --B.dataset.pending, parseInt(B.dataset.pending) || v();
            }.bind(this);
          }.bind(this)(M)
        ));
      }
      return parseInt(M.dataset.pending) || L.Util.requestAnimFrame(v), M;
    },
    _clone: function(y) {
      var v = y.cloneNode(!0);
      return v.style.visibility = "visible", v;
    },
    _checkZoomLevels: function() {
      var y = this._map.getZoom(), v = this._mutant.getZoom();
      !y || !v || (v !== y || v > this.options.maxNativeZoom) && this._setMaxNativeZoom(v);
    },
    _setMaxNativeZoom: function(y) {
      y !== this.options.maxNativeZoom && (this.options.maxNativeZoom = y, this._resetView());
    },
    _update: function(y) {
      if (this._mutant) {
        y = y || this._map.getCenter();
        var v = new google.maps.LatLng(y.lat, y.lng), C = Math.round(this._map.getZoom()), M = this._mutant.getZoom();
        this._mutant.setCenter(v), C !== M && (this._mutant.setZoom(C), this._mutantIsReady && this._checkZoomLevels());
      }
      L.GridLayer.prototype._update.call(this, y);
    },
    whenReady: function(y, v) {
      return this._mutant ? y.call(v || this, { target: this }) : this.on("spawned", y, v), this;
    }
  }), L.gridLayer.googleMutant = function(y) {
    return new L.GridLayer.GoogleMutant(y);
  };
})();
L.Control.Fullscreen = L.Control.extend({
  options: {
    position: "topleft",
    title: {
      false: "View Fullscreen",
      true: "Exit Fullscreen"
    }
  },
  onAdd: function(t) {
    var i = L.DomUtil.create("div", "leaflet-control-fullscreen leaflet-bar leaflet-control");
    return this.link = L.DomUtil.create("a", "leaflet-control-fullscreen-button leaflet-bar-part", i), this.link.href = "#", this._map = t, this._map.on("fullscreenchange", this._toggleTitle, this), this._toggleTitle(), L.DomEvent.on(this.link, "click", this._click, this), i;
  },
  _click: function(t) {
    L.DomEvent.stopPropagation(t), L.DomEvent.preventDefault(t), this._map.toggleFullscreen(this.options);
  },
  _toggleTitle: function() {
    this.link.title = this.options.title[this._map.isFullscreen()];
  }
});
L.Map.include({
  isFullscreen: function() {
    return this._isFullscreen || !1;
  },
  toggleFullscreen: function(t) {
    var i = this.getContainer();
    this.isFullscreen() ? t && t.pseudoFullscreen ? this._disablePseudoFullscreen(i) : document.exitFullscreen ? document.exitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitCancelFullScreen ? document.webkitCancelFullScreen() : document.msExitFullscreen ? document.msExitFullscreen() : this._disablePseudoFullscreen(i) : t && t.pseudoFullscreen ? this._enablePseudoFullscreen(i) : i.requestFullscreen ? i.requestFullscreen() : i.mozRequestFullScreen ? i.mozRequestFullScreen() : i.webkitRequestFullscreen ? i.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT) : i.msRequestFullscreen ? i.msRequestFullscreen() : this._enablePseudoFullscreen(i);
  },
  _enablePseudoFullscreen: function(t) {
    L.DomUtil.addClass(t, "leaflet-pseudo-fullscreen"), this._setFullscreen(!0), this.fire("fullscreenchange");
  },
  _disablePseudoFullscreen: function(t) {
    L.DomUtil.removeClass(t, "leaflet-pseudo-fullscreen"), this._setFullscreen(!1), this.fire("fullscreenchange");
  },
  _setFullscreen: function(t) {
    this._isFullscreen = t;
    var i = this.getContainer();
    t ? L.DomUtil.addClass(i, "leaflet-fullscreen-on") : L.DomUtil.removeClass(i, "leaflet-fullscreen-on"), this.invalidateSize();
  },
  _onFullscreenChange: function(t) {
    var i = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
    i === this.getContainer() && !this._isFullscreen ? (this._setFullscreen(!0), this.fire("fullscreenchange")) : i !== this.getContainer() && this._isFullscreen && (this._setFullscreen(!1), this.fire("fullscreenchange"));
  }
});
L.Map.mergeOptions({
  fullscreenControl: !1
});
L.Map.addInitHook(function() {
  this.options.fullscreenControl && (this.fullscreenControl = new L.Control.Fullscreen(this.options.fullscreenControl), this.addControl(this.fullscreenControl));
  var t;
  if ("onfullscreenchange" in document ? t = "fullscreenchange" : "onmozfullscreenchange" in document ? t = "mozfullscreenchange" : "onwebkitfullscreenchange" in document ? t = "webkitfullscreenchange" : "onmsfullscreenchange" in document && (t = "MSFullscreenChange"), t) {
    var i = L.bind(this._onFullscreenChange, this);
    this.whenReady(function() {
      L.DomEvent.on(document, t, i);
    }), this.on("unload", function() {
      L.DomEvent.off(document, t, i);
    });
  }
});
L.control.fullscreen = function(t) {
  return new L.Control.Fullscreen(t);
};
function gc(t) {
  const i = ni.map(t.element, { ...t.options });
  return i.setView(t.center || io.center, t.zoom || io.zoom), ni.gridLayer.googleMutant(m0).addTo(i), i;
}
const ec = 8, B0 = he({
  emits: ["update:model-value", "validate-field"],
  props: {
    modelValue: {
      type: Object,
      required: !0
    },
    properties: {
      type: Object,
      required: !0
    },
    locale: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      TO_FIXED: ec,
      map: null,
      dialogMap: null,
      marker: null,
      dialogLat: null,
      dialogLng: null
    };
  },
  computed: {
    scopeLat() {
      return dt.get(this.modelValue, this.properties.scopeLat);
    },
    scopeLng() {
      return dt.get(this.modelValue, this.properties.scopeLng);
    },
    latLng() {
      return [this.scopeLat, this.scopeLng];
    },
    hasLatLng() {
      return this.latLng.every((t) => t || t === 0);
    }
  },
  mounted() {
    const t = this.$refs.mapContainer;
    this.map = gc({
      element: t,
      options: {
        dragging: !1,
        touchZoom: !1,
        doubleClickZoom: !1,
        scrollWheelZoom: !1,
        keyboard: !1,
        tap: !1
      }
    }), this.marker = ni.marker(io.center, {
      icon: ni.divIcon(_0)
    });
  },
  methods: {
    onDialogOpened() {
      const t = this.$refs.dialogMapContainer;
      this.dialogMap = gc({
        element: t,
        center: this.hasLatLng ? this.latLng : io.center,
        zoom: this.hasLatLng ? io.nearZoom : io.zoom
      }), this.dialogMap.on("moveend", this.setDialogLatLng), this.dialogMap.on("zoomend", this.setDialogLatLng), this.setDialogLatLng();
    },
    onDialogClose() {
      this.dialogMap.off("moveend", this.setDialogLatLng), this.dialogMap.off("zoomend", this.setDialogLatLng), this.dialogLat = null, this.dialogLng = null;
    },
    setDialogLatLng() {
      const { lat: t, lng: i } = this.dialogMap.getCenter().wrap();
      this.dialogLat = parseFloat(t.toFixed(ec)), this.dialogLng = parseFloat(i.toFixed(ec));
    },
    select() {
      this.$refs.dialog.close();
      let t = this.modelValue;
      t = dt.set(t, this.properties.scopeLat, this.dialogLat), t = dt.set(t, this.properties.scopeLng, this.dialogLng), this.$emit("update:model-value", t), this.$emit("validate-field", this.properties.scopeLat), this.$emit("validate-field", this.properties.scopeLng);
    }
  },
  watch: {
    latLng() {
      this.hasLatLng ? (this.map.flyTo(this.latLng), this.marker.setLatLng(this.latLng), this.marker.addTo(this.map)) : (this.map.flyTo(io.center), this.marker.removeFrom(this.map));
    }
  },
  components: {
    DialogComponent: Uc
  }
}), U0 = "_button_4mbvx_1", F0 = "_button__map_4mbvx_9", H0 = "_edit_4mbvx_16", Z0 = "_dialog__title_4mbvx_38", V0 = "_dialog__content_4mbvx_44", W0 = "_dialog__map_4mbvx_50", j0 = {
  button: U0,
  button__map: F0,
  edit: H0,
  dialog__title: Z0,
  dialog__content: V0,
  dialog__map: W0
}, G0 = /* @__PURE__ */ Mt("div", { class: "marker" }, null, -1);
function q0(t, i, r, h, a, l) {
  const f = q("icon-edit-pen"), m = q("el-icon"), y = q("el-avatar"), v = q("el-button"), C = q("dialog-component"), M = q("el-form-item");
  return pe(), Ae(M, null, {
    default: Y(() => [
      ee(C, {
        width: "1000px",
        ref: "dialog",
        onOpened: t.onDialogOpened,
        onClose: t.onDialogClose
      }, $n({
        activator: Y(({ open: N }) => [
          ee(v, {
            class: Ze(t.$style.button),
            onClick: N
          }, {
            default: Y(() => [
              Mt("div", {
                class: Ze(t.$style.button__map),
                ref: "mapContainer"
              }, null, 2),
              ee(y, {
                class: Ze(t.$style.edit),
                size: 30
              }, {
                default: Y(() => [
                  ee(m, { size: "16" }, {
                    default: Y(() => [
                      ee(f)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 2
          }, 1032, ["class", "onClick"])
        ]),
        default: Y(({ dialogOpen: N }) => [
          N ? (pe(), Tt("div", {
            key: 0,
            class: Ze(t.$style.dialog__content)
          }, [
            Mt("div", {
              class: Ze(t.$style.dialog__map),
              ref: "dialogMapContainer"
            }, null, 2),
            G0
          ], 2)) : _i("", !0)
        ]),
        footer: Y(() => [
          ee(v, { onClick: t.select }, {
            default: Y(() => [
              r0(Ss(t.properties.confirmationText[t.locale]), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 2
      }, [
        t.dialogLat || t.dialogLng ? {
          name: "header",
          fn: Y(() => [
            Mt("div", {
              class: Ze(t.$style.dialog__title)
            }, [
              Mt("span", null, Ss(t.dialogLat), 1),
              Mt("span", null, Ss(t.dialogLng), 1)
            ], 2)
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["onOpened", "onClose"])
    ]),
    _: 1
  });
}
const Y0 = {
  $style: j0
}, K0 = /* @__PURE__ */ Re(B0, [["render", q0], ["__cssModules", Y0]]), tc = {
  left: "left",
  center: "center",
  right: "right"
}, J0 = he({
  emits: ["submit"],
  props: {
    modelValue: {},
    properties: {
      type: Object,
      required: !0
    },
    locale: {
      type: String,
      required: !0
    }
  },
  computed: {
    text() {
      return this.properties.label[this.locale];
    },
    left() {
      return this.properties.align === tc.left;
    },
    center() {
      return this.properties.align === tc.center;
    },
    right() {
      return this.properties.align === tc.right;
    }
  },
  methods: {
    onButtonClick() {
      this.$emit("submit");
    }
  }
}), X0 = "_left_lpbbo_1", Q0 = "_center_lpbbo_5", eb = "_right_lpbbo_9", tb = {
  left: X0,
  center: Q0,
  right: eb
}, nb = ["innerHTML"];
function ib(t, i, r, h, a, l) {
  const f = q("el-button"), m = q("el-form-item");
  return pe(), Ae(m, null, {
    default: Y(() => [
      ee(f, {
        class: Ze({ [t.$style.left]: t.left, [t.$style.center]: t.center, [t.$style.right]: t.right }),
        onClick: t.onButtonClick
      }, {
        default: Y(() => [
          Mt("span", { innerHTML: t.text }, null, 8, nb)
        ]),
        _: 1
      }, 8, ["class", "onClick"])
    ]),
    _: 1
  });
}
const rb = {
  $style: tb
}, ob = /* @__PURE__ */ Re(J0, [["render", ib], ["__cssModules", rb]]), sb = he({
  mixins: [Sa],
  emits: ["update:model-value", "submit", "validate-field"],
  data() {
    return {
      ButtonComponent: {
        [Zf.mapSelect]: Ge(K0),
        [Zf.submit]: Ge(ob)
      }
    };
  },
  computed: {
    properties() {
      return this.schema.properties;
    },
    model: {
      get() {
        return this.modelValue;
      },
      set(t) {
        this.$emit("update:model-value", t);
      }
    }
  },
  methods: {
    onSubmitForm() {
      this.$emit("submit");
    },
    validateField(t) {
      this.$emit("validate-field", t);
    }
  }
});
function ab(t, i, r, h, a, l) {
  return t.isShown ? (pe(), Ae(zo(t.ButtonComponent[t.properties.type]), {
    key: 0,
    modelValue: t.model,
    "onUpdate:modelValue": i[0] || (i[0] = (f) => t.model = f),
    id: t.schema.id,
    properties: t.properties,
    locale: t.locale,
    onSubmit: t.onSubmitForm,
    onValidateField: t.validateField
  }, null, 40, ["modelValue", "id", "properties", "locale", "onSubmit", "onValidateField"])) : _i("", !0);
}
const Jp = /* @__PURE__ */ Re(sb, [["render", ab]]), lb = he({
  props: {
    label: {
      type: String
    },
    rules: {
      type: Array
    }
  },
  computed: {
    hasRules() {
      return this.rules && this.rules.length > 0;
    }
  }
}), ub = "_label_hgnjd_1", cb = "_star_hgnjd_5", hb = {
  label: ub,
  star: cb
}, fb = ["innerHTML"];
function db(t, i, r, h, a, l) {
  return pe(), Tt(si, null, [
    Mt("span", {
      innerHTML: t.label,
      class: Ze(t.$style.label)
    }, null, 10, fb),
    t.hasRules ? (pe(), Tt("span", {
      key: 0,
      class: Ze(t.$style.star)
    }, " *", 2)) : _i("", !0)
  ], 64);
}
const pb = {
  $style: hb
}, mb = /* @__PURE__ */ Re(lb, [["render", db], ["__cssModules", pb]]), _b = he({
  props: {
    error: {
      type: String,
      required: !0
    }
  }
}), gb = "_component_yrikm_1", vb = "_component__icon_yrikm_7", yb = {
  component: gb,
  component__icon: vb
}, Lb = ["innerHTML"];
function wb(t, i, r, h, a, l) {
  const f = q("icon-warning-filled");
  return pe(), Tt("span", {
    class: Ze(t.$style.component)
  }, [
    ee(f, {
      class: Ze(t.$style.component__icon)
    }, null, 8, ["class"]),
    Mt("span", { innerHTML: t.error }, null, 8, Lb)
  ], 2);
}
const bb = {
  $style: yb
}, Sb = /* @__PURE__ */ Re(_b, [["render", wb], ["__cssModules", bb]]), Bn = he({
  emits: ["update:model-value"],
  props: {
    modelValue: {
      type: Object,
      required: !0
    },
    scope: {
      type: String,
      required: !0
    },
    properties: {
      type: Object,
      required: !0
    },
    errorScopes: {
      type: Array,
      default: () => []
    },
    locale: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      path: this.scope.split(".")
    };
  },
  computed: {
    label() {
      var t, i;
      return (i = (t = this.properties) == null ? void 0 : t.label) == null ? void 0 : i[this.locale];
    },
    value() {
      return dt.get(this.modelValue, this.path);
    },
    rules() {
      return this.properties.rules;
    },
    model: {
      get() {
        return this.value;
      },
      set(t) {
        this.$emit("update:model-value", dt.set(this.modelValue, this.path, t));
      }
    }
  },
  mounted() {
    this.properties.value && (this.model = this.properties.value);
  },
  unmounted() {
    dt.unset(this.modelValue, this.path);
  },
  components: {
    ControlLabelComponent: mb,
    ControlErrorComponent: Sb
  }
}), Cb = he({
  mixins: [Bn],
  emits: ["update:model-value"],
  computed: {
    model: {
      get() {
        return this.value || [];
      },
      set(t) {
        const i = Array.isArray(t) && t.length > 0 ? t : [{ key: Date.now(), value: null }];
        this.$emit("update:model-value", dt.set(this.modelValue, this.path, i));
      }
    }
  },
  mounted() {
    Array.isArray(this.properties.value) && this.properties.value.length > 0 && (this.model = this.properties.value), this.model = [{ key: Date.now(), value: null }];
  },
  methods: {
    onAddClick() {
      this.model = this.model.concat({ key: Date.now(), value: null });
    },
    onDeleteClick(t) {
      this.model = this.value.filter((i, r) => r !== t);
    }
  }
}), Tb = "_component__input_1bb9s_1", Eb = "_component__prepend_1bb9s_8", Pb = "_component_1bb9s_1", Mb = "_component__item_1bb9s_12", Ob = {
  component__input: Tb,
  "component__input--append": "_component__input--append_1bb9s_4",
  component__prepend: Eb,
  component: Pb,
  component__item: Mb
};
function xb(t, i, r, h, a, l) {
  const f = q("control-label-component"), m = q("el-button"), y = q("el-input"), v = q("control-error-component"), C = q("el-form-item");
  return pe(), Ae(C, {
    class: Ze(t.$style.component)
  }, $n({
    default: Y(() => [
      (pe(!0), Tt(si, null, ar(t.model, (M, N) => (pe(), Ae(C, {
        key: M.key,
        class: Ze(t.$style.component__item),
        prop: `${t.scope}.${N}.value`,
        rules: t.rules
      }, {
        error: Y(({ error: I }) => [
          ee(v, {
            error: I[t.locale]
          }, null, 8, ["error"])
        ]),
        default: Y(() => {
          var I;
          return [
            ee(y, {
              modelValue: M.value,
              "onUpdate:modelValue": (D) => M.value = D,
              class: Ze([t.$style.component__input, { [t.$style["component__input--append"]]: t.model.length > 1 }]),
              placeholder: (I = t.properties.placeholder) == null ? void 0 : I[t.locale]
            }, $n({
              prepend: Y(() => [
                Mt("div", {
                  class: Ze(t.$style.component__prepend)
                }, Ss(N + 1), 3)
              ]),
              _: 2
            }, [
              t.model.length > 1 ? {
                name: "append",
                fn: Y(() => [
                  ee(m, {
                    class: Ze(t.$style.component__append),
                    icon: "icon-delete",
                    onClick: (D) => t.onDeleteClick(N)
                  }, null, 8, ["class", "onClick"])
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["modelValue", "onUpdate:modelValue", "class", "placeholder"])
          ];
        }),
        _: 2
      }, 1032, ["class", "prop", "rules"]))), 128)),
      ee(m, {
        icon: "icon-plus",
        onClick: t.onAddClick
      }, null, 8, ["onClick"])
    ]),
    _: 2
  }, [
    t.label ? {
      name: "label",
      fn: Y(() => [
        ee(f, {
          label: t.label,
          rules: t.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["class"]);
}
const Db = {
  $style: Ob
}, kb = /* @__PURE__ */ Re(Cb, [["render", xb], ["__cssModules", Db]]), Ab = he({
  mixins: [Bn],
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(t) {
        this.$emit("update:model-value", dt.set(this.modelValue, this.path, t || null));
      }
    }
  }
});
function Ib(t, i, r, h, a, l) {
  const f = q("control-label-component"), m = q("el-checkbox"), y = q("control-error-component"), v = q("el-form-item");
  return pe(), Ae(v, {
    prop: t.scope,
    rules: t.rules
  }, {
    error: Y(({ error: C }) => [
      ee(y, {
        error: C[t.locale]
      }, null, 8, ["error"])
    ]),
    default: Y(() => [
      ee(m, {
        modelValue: t.model,
        "onUpdate:modelValue": i[0] || (i[0] = (C) => t.model = C),
        size: "default",
        id: "test"
      }, {
        default: Y(() => [
          t.label ? (pe(), Ae(f, {
            key: 0,
            label: t.label,
            rules: t.rules
          }, null, 8, ["label", "rules"])) : _i("", !0)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["prop", "rules"]);
}
const Nb = /* @__PURE__ */ Re(Ab, [["render", Ib]]), Rb = "YYYY-MM-DD HH:mm:ss", $b = he({
  mixins: [Bn],
  data() {
    return {
      format: Rb
    };
  }
});
function zb(t, i, r, h, a, l) {
  const f = q("control-label-component"), m = q("el-date-picker"), y = q("control-error-component"), v = q("el-form-item");
  return pe(), Ae(v, {
    prop: t.scope,
    rules: t.rules
  }, $n({
    error: Y(({ error: C }) => [
      ee(y, {
        error: C[t.locale]
      }, null, 8, ["error"])
    ]),
    default: Y(() => {
      var C, M, N;
      return [
        ee(m, {
          modelValue: t.model,
          "onUpdate:modelValue": i[0] || (i[0] = (I) => t.model = I),
          placeholder: (C = t.properties.placeholder) == null ? void 0 : C[t.locale],
          "start-placeholder": (M = t.properties.startPlaceholder) == null ? void 0 : M[t.locale],
          "end-placeholder": (N = t.properties.endPlaceholder) == null ? void 0 : N[t.locale],
          type: t.properties.picker,
          format: t.properties.format,
          "value-format": t.properties.format || t.format
        }, null, 8, ["modelValue", "placeholder", "start-placeholder", "end-placeholder", "type", "format", "value-format"])
      ];
    }),
    _: 2
  }, [
    t.label ? {
      name: "label",
      fn: Y(() => [
        ee(f, {
          label: t.label,
          rules: t.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["prop", "rules"]);
}
const Bb = /* @__PURE__ */ Re($b, [["render", zb]]);
var vc = {}, Ub = {
  get exports() {
    return vc;
  },
  set exports(t) {
    vc = t;
  }
};
(function(t, i) {
  (function(r, h) {
    var a = 1, l = 3, f = 9, m = 11, y = 1, v = "​";
    r.defaultView;
    var C = navigator.userAgent, M = /Mac OS X/.test(C), N = /Windows NT/.test(C), I = /iP(?:ad|hone|od)/.test(C) || M && !!navigator.maxTouchPoints, D = /Gecko\//.test(C), B = /Edge\//.test(C), X = !B && /WebKit\//.test(C), le = /Trident\/[4567]\./.test(C), Q = M ? "meta-" : "ctrl-", re = X, ve = typeof MutationObserver < "u", Le = typeof WeakMap < "u", Ce = /[^ \t\r\n]/, se = Array.prototype.indexOf, Me = { 1: 1, 2: 2, 3: 4, 8: 128, 9: 256, 11: 1024 }, rt = function() {
      return !0;
    };
    function Et(d, w, _) {
      this.root = this.currentNode = d, this.nodeType = w, this.filter = _ || rt;
    }
    Et.prototype.nextNode = function() {
      for (var d, w = this.currentNode, _ = this.root, S = this.nodeType, E = this.filter; ; ) {
        for (d = w.firstChild; !d && w && w !== _; )
          (d = w.nextSibling) || (w = w.parentNode);
        if (!d)
          return null;
        if (Me[d.nodeType] & S && E(d))
          return this.currentNode = d, d;
        w = d;
      }
    }, Et.prototype.previousNode = function() {
      for (var d, w = this.currentNode, _ = this.root, S = this.nodeType, E = this.filter; ; ) {
        if (w === _)
          return null;
        if (d = w.previousSibling)
          for (; w = d.lastChild; )
            d = w;
        else
          d = w.parentNode;
        if (!d)
          return null;
        if (Me[d.nodeType] & S && E(d))
          return this.currentNode = d, d;
        w = d;
      }
    }, Et.prototype.previousPONode = function() {
      for (var d, w = this.currentNode, _ = this.root, S = this.nodeType, E = this.filter; ; ) {
        for (d = w.lastChild; !d && w && w !== _; )
          (d = w.previousSibling) || (w = w.parentNode);
        if (!d)
          return null;
        if (Me[d.nodeType] & S && E(d))
          return this.currentNode = d, d;
        w = d;
      }
    };
    var Pt = /^(?:#text|A(?:BBR|CRONYM)?|B(?:R|D[IO])?|C(?:ITE|ODE)|D(?:ATA|EL|FN)|EM|FONT|HR|I(?:FRAME|MG|NPUT|NS)?|KBD|Q|R(?:P|T|UBY)|S(?:AMP|MALL|PAN|TR(?:IKE|ONG)|U[BP])?|TIME|U|VAR|WBR)$/, xt = { BR: 1, HR: 1, IFRAME: 1, IMG: 1, INPUT: 1 }, _n = 0, Dt = 1, gn = 2, It = 3, Kt = Le ? /* @__PURE__ */ new WeakMap() : null;
    function we(d) {
      return d.nodeType === a && !!xt[d.nodeName];
    }
    function gi(d) {
      switch (d.nodeType) {
        case l:
          return Dt;
        case a:
        case m:
          if (Le && Kt.has(d))
            return Kt.get(d);
          break;
        default:
          return _n;
      }
      var w;
      return w = function(_, S) {
        for (var E = _.length; E--; )
          if (!S(_[E]))
            return !1;
        return !0;
      }(d.childNodes, _e) ? Pt.test(d.nodeName) ? Dt : gn : It, Le && Kt.set(d, w), w;
    }
    function _e(d) {
      return gi(d) === Dt;
    }
    function Be(d) {
      return gi(d) === gn;
    }
    function Nt(d) {
      return gi(d) === It;
    }
    function Ht(d, w) {
      var _ = new Et(w, y, Be);
      return _.currentNode = d, _;
    }
    function wt(d, w) {
      return (d = Ht(d, w).previousNode()) !== w ? d : null;
    }
    function $e(d, w) {
      return (d = Ht(d, w).nextNode()) !== w ? d : null;
    }
    function ot(d) {
      return !d.textContent && !d.querySelector("IMG");
    }
    function Tn(d, w) {
      return !we(d) && d.nodeType === w.nodeType && d.nodeName === w.nodeName && d.nodeName !== "A" && d.className === w.className && (!d.style && !w.style || d.style.cssText === w.style.cssText);
    }
    function en(d, w, _) {
      if (d.nodeName !== w)
        return !1;
      for (var S in _)
        if (d.getAttribute(S) !== _[S])
          return !1;
      return !0;
    }
    function ft(d, w, _, S) {
      for (; d && d !== w; ) {
        if (en(d, _, S))
          return d;
        d = d.parentNode;
      }
      return null;
    }
    function Mi(d, w) {
      for (; w; ) {
        if (w === d)
          return !0;
        w = w.parentNode;
      }
      return !1;
    }
    function Jt(d) {
      var w = d.nodeType;
      return w === a || w === m ? d.childNodes.length : d.length || 0;
    }
    function pt(d) {
      var w = d.parentNode;
      return w && w.removeChild(d), d;
    }
    function jt(d, w) {
      var _ = d.parentNode;
      _ && _.replaceChild(w, d);
    }
    function Ke(d) {
      for (var w = d.ownerDocument.createDocumentFragment(), _ = d.childNodes, S = _ ? _.length : 0; S--; )
        w.appendChild(d.firstChild);
      return w;
    }
    function bt(d, w, _, S) {
      var E, k, A, R, F = d.createElement(w);
      if (_ instanceof Array && (S = _, _ = null), _)
        for (E in _)
          (k = _[E]) !== h && F.setAttribute(E, k);
      if (S)
        for (A = 0, R = S.length; A < R; A += 1)
          F.appendChild(S[A]);
      return F;
    }
    function Rt(d, w) {
      var _, S, E = w.__squire__, k = d.ownerDocument, A = d;
      if (d === w && ((S = d.firstChild) && S.nodeName !== "BR" || (_ = E.createDefaultBlock(), S ? d.replaceChild(_, S) : d.appendChild(_), d = _, _ = null)), d.nodeType === l)
        return A;
      if (_e(d)) {
        for (S = d.firstChild; re && S && S.nodeType === l && !S.data; )
          d.removeChild(S), S = d.firstChild;
        S || (re ? (_ = k.createTextNode(v), E._didAddZWS()) : _ = k.createTextNode(""));
      } else if (!d.querySelector("BR"))
        for (_ = bt(k, "BR"); (S = d.lastElementChild) && !_e(S); )
          d = S;
      if (_)
        try {
          d.appendChild(_);
        } catch (R) {
          E.didError({ name: "Squire: fixCursor – " + R, message: "Parent: " + d.nodeName + "/" + d.innerHTML + " appendChild: " + _.nodeName });
        }
      return A;
    }
    function $t(d, w) {
      var _, S, E, k, A = d.childNodes, R = d.ownerDocument, F = null;
      for (_ = 0, S = A.length; _ < S; _ += 1)
        !(k = (E = A[_]).nodeName === "BR") && _e(E) ? (F || (F = bt(R, "div")), F.appendChild(E), _ -= 1, S -= 1) : (k || F) && (F || (F = bt(R, "div")), Rt(F, w), k ? d.replaceChild(F, E) : (d.insertBefore(F, E), _ += 1, S += 1), F = null), Nt(E) && $t(E, w);
      return F && d.appendChild(Rt(F, w)), d;
    }
    function Xt(d, w, _, S) {
      var E, k, A, R = d.nodeType;
      if (R === l && d !== _)
        return Xt(d.parentNode, d.splitText(w), _, S);
      if (R === a) {
        if (typeof w == "number" && (w = w < d.childNodes.length ? d.childNodes[w] : null), d === _)
          return w;
        for (E = d.parentNode, k = d.cloneNode(!1); w; )
          A = w.nextSibling, k.appendChild(w), w = A;
        return d.nodeName === "OL" && ft(d, S, "BLOCKQUOTE") && (k.start = (+d.start || 1) + d.childNodes.length - 1), Rt(d, S), Rt(k, S), (A = d.nextSibling) ? E.insertBefore(k, A) : E.appendChild(k), Xt(E, k, _, S);
      }
      return w;
    }
    function Ui(d, w) {
      if (d.nodeType === l && (d = d.parentNode), d.nodeType === a) {
        var _ = { startContainer: w.startContainer, startOffset: w.startOffset, endContainer: w.endContainer, endOffset: w.endOffset };
        (function S(E, k) {
          for (var A, R, F, G = E.childNodes, ue = G.length, fe = []; ue--; )
            if (A = G[ue], R = ue && G[ue - 1], ue && _e(A) && Tn(A, R) && !xt[A.nodeName])
              k.startContainer === A && (k.startContainer = R, k.startOffset += Jt(R)), k.endContainer === A && (k.endContainer = R, k.endOffset += Jt(R)), k.startContainer === E && (k.startOffset > ue ? k.startOffset -= 1 : k.startOffset === ue && (k.startContainer = R, k.startOffset = Jt(R))), k.endContainer === E && (k.endOffset > ue ? k.endOffset -= 1 : k.endOffset === ue && (k.endContainer = R, k.endOffset = Jt(R))), pt(A), A.nodeType === l ? R.appendData(A.data) : fe.push(Ke(A));
            else if (A.nodeType === a) {
              for (F = fe.length; F--; )
                A.appendChild(fe.pop());
              S(A, k);
            }
        })(d, _), w.setStart(_.startContainer, _.startOffset), w.setEnd(_.endContainer, _.endOffset);
      }
    }
    function Un(d, w, _, S) {
      for (var E, k, A, R = w; (E = R.parentNode) && E !== S && E.nodeType === a && E.childNodes.length === 1; )
        R = E;
      pt(R), A = d.childNodes.length, (k = d.lastChild) && k.nodeName === "BR" && (d.removeChild(k), A -= 1), d.appendChild(Ke(w)), _.setStart(d, A), _.collapse(!0), Ui(d, _);
    }
    function kt(d, w) {
      var _, S, E = d.previousSibling, k = d.firstChild, A = d.ownerDocument, R = d.nodeName === "LI";
      if (!R || k && /^[OU]L$/.test(k.nodeName))
        if (E && Tn(E, d)) {
          if (!Nt(E)) {
            if (!R)
              return;
            (S = bt(A, "DIV")).appendChild(Ke(E)), E.appendChild(S);
          }
          pt(d), _ = !Nt(d), E.appendChild(Ke(d)), _ && $t(E, w), k && kt(k, w);
        } else
          R && (E = bt(A, "DIV"), d.insertBefore(E, k), Rt(E, w));
    }
    var ai = function(d, w) {
      for (var _ = d.childNodes; w && d.nodeType === a; )
        w = (_ = (d = _[w - 1]).childNodes).length;
      return d;
    }, Oi = function(d, w) {
      if (d.nodeType === a) {
        var _ = d.childNodes;
        if (w < _.length)
          d = _[w];
        else {
          for (; d && !d.nextSibling; )
            d = d.parentNode;
          d && (d = d.nextSibling);
        }
      }
      return d;
    }, Fn = function(d, w) {
      var _, S, E, k, A = d.startContainer, R = d.startOffset, F = d.endContainer, G = d.endOffset;
      A.nodeType === l ? (S = (_ = A.parentNode).childNodes, R === A.length ? (R = se.call(S, A) + 1, d.collapsed && (F = _, G = R)) : (R && (k = A.splitText(R), F === A ? (G -= R, F = k) : F === _ && (G += 1), A = k), R = se.call(S, A)), A = _) : S = A.childNodes, R === (E = S.length) ? A.appendChild(w) : A.insertBefore(w, S[R]), A === F && (G += S.length - E), d.setStart(A, R), d.setEnd(F, G);
    }, xi = function(d, w, _) {
      var S = d.startContainer, E = d.startOffset, k = d.endContainer, A = d.endOffset;
      w || (w = d.commonAncestorContainer), w.nodeType === l && (w = w.parentNode);
      for (var R, F, G, ue, fe, ke = Xt(k, A, w, _), Ie = Xt(S, E, w, _), de = w.ownerDocument.createDocumentFragment(); Ie !== ke; )
        R = Ie.nextSibling, de.appendChild(Ie), Ie = R;
      return S = w, E = ke ? se.call(w.childNodes, ke) : w.childNodes.length, (F = (G = w.childNodes[E]) && G.previousSibling) && F.nodeType === l && G.nodeType === l && (S = F, E = F.length, ue = F.data, fe = G.data, ue.charAt(ue.length - 1) === " " && fe.charAt(0) === " " && (fe = " " + fe.slice(1)), F.appendData(fe), pt(G)), d.setStart(S, E), d.collapse(!0), Rt(w, _), de;
    }, Hn = function(d, w) {
      var _, S, E = rn(d, w), k = yn(d, w), A = E !== k;
      return nn(d), vn(d, E, k, w), _ = xi(d, null, w), nn(d), A && (k = yn(d, w), E && k && E !== k && Un(E, k, d, w)), E && Rt(E, w), (S = w.firstChild) && S.nodeName !== "BR" ? d.collapse(!0) : (Rt(w, w), d.selectNodeContents(w.firstChild)), _;
    }, Di = function(d, w, _) {
      var S, E, k, A, R, F, G, ue, fe, ke, Ie, de = w.firstChild && _e(w.firstChild);
      for ($t(w, _), S = w; S = $e(S, _); )
        Rt(S, _);
      if (d.collapsed || Hn(d, _), nn(d), d.collapse(!1), A = ft(d.endContainer, _, "BLOCKQUOTE") || _, E = rn(d, _), ue = $e(w, w), G = !de && !!E && ot(E), E && ue && !G && !ft(ue, w, "PRE") && !ft(ue, w, "TABLE")) {
        if (vn(d, E, E, _), d.collapse(!0), R = d.endContainer, F = d.endOffset, pr(E, _, !1), _e(R) && (R = (fe = Xt(R, F, wt(R, _), _)).parentNode, F = se.call(R.childNodes, fe)), F !== Jt(R))
          for (k = _.ownerDocument.createDocumentFragment(); S = R.childNodes[F]; )
            k.appendChild(S);
        Un(R, ue, d, _), F = se.call(R.parentNode.childNodes, R) + 1, R = R.parentNode, d.setEnd(R, F);
      }
      Jt(w) && (G && (d.setEndBefore(E), d.collapse(!1), pt(E)), vn(d, A, A, _), ke = (fe = Xt(d.endContainer, d.endOffset, A, _)) ? fe.previousSibling : A.lastChild, A.insertBefore(w, fe), fe ? d.setEndBefore(fe) : d.setEnd(A, Jt(A)), E = yn(d, _), nn(d), R = d.endContainer, F = d.endOffset, fe && Nt(fe) && kt(fe, _), (fe = ke && ke.nextSibling) && Nt(fe) && kt(fe, _), d.setEnd(R, F)), k && (Un(E, k, Ie = d.cloneRange(), _), d.setEnd(Ie.endContainer, Ie.endOffset)), nn(d);
    }, tn = function(d, w, _) {
      var S = w.ownerDocument.createRange();
      if (S.selectNode(w), _) {
        var E = d.compareBoundaryPoints(3, S) > -1, k = d.compareBoundaryPoints(1, S) < 1;
        return !E && !k;
      }
      var A = d.compareBoundaryPoints(0, S) < 1, R = d.compareBoundaryPoints(2, S) > -1;
      return A && R;
    }, nn = function(d) {
      for (var w, _ = d.startContainer, S = d.startOffset, E = d.endContainer, k = d.endOffset, A = !0; _.nodeType !== l && (w = _.childNodes[S]) && !we(w); )
        _ = w, S = 0;
      if (k)
        for (; E.nodeType !== l; ) {
          if (!(w = E.childNodes[k - 1]) || we(w)) {
            if (A && w && w.nodeName === "BR") {
              k -= 1, A = !1;
              continue;
            }
            break;
          }
          k = Jt(E = w);
        }
      else
        for (; E.nodeType !== l && (w = E.firstChild) && !we(w); )
          E = w;
      d.collapsed ? (d.setStart(E, k), d.setEnd(_, S)) : (d.setStart(_, S), d.setEnd(E, k));
    }, vn = function(d, w, _, S) {
      var E, k = d.startContainer, A = d.startOffset, R = d.endContainer, F = d.endOffset, G = !0;
      for (w || (w = d.commonAncestorContainer), _ || (_ = w); !A && k !== w && k !== S; )
        E = k.parentNode, A = se.call(E.childNodes, k), k = E;
      for (; R !== _ && R !== S && (G && R.nodeType !== l && R.childNodes[F] && R.childNodes[F].nodeName === "BR" && (F += 1, G = !1), F === Jt(R)); )
        E = R.parentNode, F = se.call(E.childNodes, R) + 1, R = E;
      d.setStart(k, A), d.setEnd(R, F);
    }, hr = function(d, w, _) {
      var S = ft(d.endContainer, _, "A");
      if (S) {
        var E = d.cloneRange();
        S = S.parentNode, vn(E, S, S, _), E.endContainer === S && (d.setStart(E.endContainer, E.endOffset), d.setEnd(E.endContainer, E.endOffset));
      }
      return d;
    }, rn = function(d, w) {
      var _, S = d.startContainer;
      return (_ = _e(S) ? wt(S, w) : S !== w && Be(S) ? S : $e(_ = ai(S, d.startOffset), w)) && tn(d, _, !0) ? _ : null;
    }, yn = function(d, w) {
      var _, S, E = d.endContainer;
      if (_e(E))
        _ = wt(E, w);
      else if (E !== w && Be(E))
        _ = E;
      else {
        if (!(_ = Oi(E, d.endOffset)) || !Mi(w, _))
          for (_ = w; S = _.lastChild; )
            _ = S;
        _ = wt(_, w);
      }
      return _ && tn(d, _, !0) ? _ : null;
    }, un = new Et(null, 4 | y, function(d) {
      return d.nodeType === l ? Ce.test(d.data) : d.nodeName === "IMG";
    }), vi = function(d, w) {
      var _, S = d.startContainer, E = d.startOffset;
      if (un.root = null, S.nodeType === l) {
        if (E)
          return !1;
        _ = S;
      } else if ((_ = Oi(S, E)) && !Mi(w, _) && (_ = null), !_ && (_ = ai(S, E)).nodeType === l && _.length)
        return !1;
      return un.currentNode = _, un.root = rn(d, w), !un.previousNode();
    }, fr = function(d, w) {
      var _, S = d.endContainer, E = d.endOffset;
      if (un.root = null, S.nodeType === l) {
        if ((_ = S.data.length) && E < _)
          return !1;
        un.currentNode = S;
      } else
        un.currentNode = ai(S, E);
      return un.root = yn(d, w), !un.nextNode();
    }, li = function(d, w) {
      var _, S = rn(d, w), E = yn(d, w);
      S && E && (_ = S.parentNode, d.setStart(_, se.call(_.childNodes, S)), _ = E.parentNode, d.setEnd(_, se.call(_.childNodes, E) + 1));
    }, Rs = { 8: "backspace", 9: "tab", 13: "enter", 32: "space", 33: "pageup", 34: "pagedown", 37: "left", 39: "right", 46: "delete", 191: "/", 219: "[", 220: "\\", 221: "]" }, $s = function(d) {
      var w = d.keyCode, _ = Rs[w], S = "", E = this.getSelection();
      d.defaultPrevented || (_ || (_ = String.fromCharCode(w).toLowerCase(), /^[A-Za-z0-9]$/.test(_) || (_ = "")), 111 < w && w < 124 && (_ = "f" + (w - 111)), _ !== "backspace" && _ !== "delete" && (d.altKey && (S += "alt-"), d.ctrlKey && (S += "ctrl-"), d.metaKey && (S += "meta-"), d.shiftKey && (S += "shift-")), N && d.shiftKey && _ === "delete" && (S += "shift-"), _ = S + _, this._keyHandlers[_] ? this._keyHandlers[_](this, d, E) : E.collapsed || d.isComposing || d.ctrlKey || d.metaKey || (d.key || _).length !== 1 || (this.saveUndoState(E), Hn(E, this._root), this._ensureBottomLine(), this.setSelection(E), this._updatePath(E, !0)));
    }, dr = function(d) {
      return function(w, _) {
        _.preventDefault(), w[d]();
      };
    }, yi = function(d, w) {
      return w = w || null, function(_, S) {
        S.preventDefault();
        var E = _.getSelection();
        _.hasFormat(d, null, E) ? _.changeFormat(null, { tag: d }, E) : _.changeFormat({ tag: d }, w, E);
      };
    }, ki = function(d, w) {
      try {
        w || (w = d.getSelection());
        var _, S = w.startContainer;
        for (S.nodeType === l && (S = S.parentNode), _ = S; _e(_) && (!_.textContent || _.textContent === v); )
          _ = (S = _).parentNode;
        S !== _ && (w.setStart(_, se.call(_.childNodes, S)), w.collapse(!0), _.removeChild(S), Be(_) || (_ = wt(_, d._root)), Rt(_, d._root), nn(w)), S === d._root && (S = S.firstChild) && S.nodeName === "BR" && pt(S), d._ensureBottomLine(), d.setSelection(w), d._updatePath(w, !0);
      } catch (E) {
        d.didError(E);
      }
    }, Uo = function(d, w) {
      for (var _; (_ = d.parentNode) && _ !== w && !_.isContentEditable; )
        d = _;
      pt(d);
    }, Fo = function(d, w, _) {
      var S, E, k, A, R, F = d._root;
      if (d._recordUndoState(_), d._config.addLinks && Vn(_.startContainer, F, d), d._removeZWS(), d._getRangeAndRemoveBookmark(_), _.collapsed || Hn(_, F), (S = rn(_, F)) && (E = ft(S, F, "PRE")))
        return nn(_), k = _.startContainer, A = _.startOffset, k.nodeType !== l && (k = d._doc.createTextNode(""), E.insertBefore(k, E.firstChild)), w || k.data.charAt(A - 1) !== `
` && !vi(_, F) || k.data.charAt(A) !== `
` && !fr(_, F) ? (k.insertData(A, `
`), Rt(E, F), k.length === A + 1 ? _.setStartAfter(k) : _.setStart(k, A + 1)) : (k.deleteData(A && A - 1, A ? 2 : 1), (k = (R = Xt(k, A && A - 1, F, F)).previousSibling).textContent || pt(k), k = d.createDefaultBlock(), R.parentNode.insertBefore(k, R), R.textContent || pt(R), _.setStart(k, 0)), _.collapse(!0), d.setSelection(_), d._updatePath(_, !0), void d._docWasChanged();
      if (!S || w || /^T[HD]$/.test(S.nodeName))
        return hr(_, 0, F), Fn(_, d.createElement("BR")), _.collapse(!1), d.setSelection(_), void d._updatePath(_, !0);
      if ((E = ft(S, F, "LI")) && (S = E), ot(S)) {
        if (ft(S, F, "UL") || ft(S, F, "OL"))
          return d.decreaseListLevel(_);
        if (ft(S, F, "BLOCKQUOTE"))
          return d.modifyBlocks(Qe, _);
      }
      for (R = fo(d, S, _.startContainer, _.startOffset), Hi(S), uo(S), Rt(S, F); R.nodeType === a; ) {
        var G, ue = R.firstChild;
        if (R.nodeName === "A" && (!R.textContent || R.textContent === v)) {
          jt(R, ue = d._doc.createTextNode("")), R = ue;
          break;
        }
        for (; ue && ue.nodeType === l && !ue.data && (G = ue.nextSibling) && G.nodeName !== "BR"; )
          pt(ue), ue = G;
        if (!ue || ue.nodeName === "BR" || ue.nodeType === l)
          break;
        R = ue;
      }
      _ = d.createRange(R, 0), d.setSelection(_), d._updatePath(_, !0);
    }, Bt = { enter: I ? function(d, w, _) {
      d._saveRangeToBookmark(_);
      var S = d._getHTML(), E = function() {
        d.removeEventListener("keyup", E), d._setHTML(S), _ = d._getRangeAndRemoveBookmark(), Fo(d, !1, _);
      };
      d.addEventListener("keyup", E);
    } : function(d, w, _) {
      w.preventDefault(), Fo(d, w.shiftKey, _);
    }, "shift-enter": function(d, w, _) {
      return d._keyHandlers.enter(d, w, _);
    }, backspace: function(d, w, _) {
      var S = d._root;
      if (d._removeZWS(), d.saveUndoState(_), _.collapsed)
        if (vi(_, S)) {
          w.preventDefault();
          var E, k = rn(_, S);
          if (!k)
            return;
          if ($t(k.parentNode, S), E = wt(k, S)) {
            if (!E.isContentEditable)
              return void Uo(E, S);
            for (Un(E, k, _, S), k = E.parentNode; k !== S && !k.nextSibling; )
              k = k.parentNode;
            k !== S && (k = k.nextSibling) && kt(k, S), d.setSelection(_);
          } else if (k) {
            if (ft(k, S, "UL") || ft(k, S, "OL"))
              return d.decreaseListLevel(_);
            if (ft(k, S, "BLOCKQUOTE"))
              return d.modifyBlocks(Zi, _);
            d.setSelection(_), d._updatePath(_, !0);
          }
        } else
          d.setSelection(_), setTimeout(function() {
            ki(d);
          }, 0);
      else
        w.preventDefault(), Hn(_, S), ki(d, _);
    }, delete: function(d, w, _) {
      var S, E, k, A, R, F, G = d._root;
      if (d._removeZWS(), d.saveUndoState(_), _.collapsed)
        if (fr(_, G)) {
          if (w.preventDefault(), !(S = rn(_, G)))
            return;
          if ($t(S.parentNode, G), E = $e(S, G)) {
            if (!E.isContentEditable)
              return void Uo(E, G);
            for (Un(S, E, _, G), E = S.parentNode; E !== G && !E.nextSibling; )
              E = E.parentNode;
            E !== G && (E = E.nextSibling) && kt(E, G), d.setSelection(_), d._updatePath(_, !0);
          }
        } else {
          if (k = _.cloneRange(), vn(_, G, G, G), A = _.endContainer, R = _.endOffset, A.nodeType === a && (F = A.childNodes[R]) && F.nodeName === "IMG")
            return w.preventDefault(), pt(F), nn(_), void ki(d, _);
          d.setSelection(k), setTimeout(function() {
            ki(d);
          }, 0);
        }
      else
        w.preventDefault(), Hn(_, G), ki(d, _);
    }, tab: function(d, w, _) {
      var S, E, k = d._root;
      if (d._removeZWS(), _.collapsed && vi(_, k))
        for (S = rn(_, k); E = S.parentNode; ) {
          if (E.nodeName === "UL" || E.nodeName === "OL") {
            w.preventDefault(), d.increaseListLevel(_);
            break;
          }
          S = E;
        }
    }, "shift-tab": function(d, w, _) {
      var S, E = d._root;
      d._removeZWS(), _.collapsed && vi(_, E) && (ft(S = _.startContainer, E, "UL") || ft(S, E, "OL")) && (w.preventDefault(), d.decreaseListLevel(_));
    }, space: function(d, w, _) {
      var S, E = d._root;
      if (d._recordUndoState(_), d._config.addLinks && Vn(_.startContainer, E, d), d._getRangeAndRemoveBookmark(_), S = _.endContainer, _.collapsed && _.endOffset === Jt(S))
        do
          if (S.nodeName === "A") {
            _.setStartAfter(S);
            break;
          }
        while (!S.nextSibling && (S = S.parentNode) && S !== E);
      _.collapsed || (Hn(_, E), d._ensureBottomLine(), d.setSelection(_), d._updatePath(_, !0)), d.setSelection(_);
    }, left: function(d) {
      d._removeZWS();
    }, right: function(d) {
      d._removeZWS();
    } };
    M && D && (Bt["meta-left"] = function(d, w) {
      w.preventDefault();
      var _ = zr(d);
      _ && _.modify && _.modify("move", "backward", "lineboundary");
    }, Bt["meta-right"] = function(d, w) {
      w.preventDefault();
      var _ = zr(d);
      _ && _.modify && _.modify("move", "forward", "lineboundary");
    }), M || (Bt.pageup = function(d) {
      d.moveCursorToStart();
    }, Bt.pagedown = function(d) {
      d.moveCursorToEnd();
    });
    const Ho = function(d, w) {
      return function(_, S) {
        S.preventDefault();
        var E = _.getPath();
        /(?:^|>)BLOCKQUOTE/.test(E) || !/(?:^|>)[OU]L/.test(E) ? _[d]() : _[w]();
      };
    }, so = function(d, w) {
      return function(_, S) {
        S.preventDefault();
        var E = _.getPath();
        d.test(E) ? _.removeList() : _[w]();
      };
    };
    Bt[Q + "b"] = yi("B"), Bt[Q + "i"] = yi("I"), Bt[Q + "u"] = yi("U"), Bt[Q + "shift-7"] = yi("S"), Bt[Q + "shift-5"] = yi("SUB", { tag: "SUP" }), Bt[Q + "shift-6"] = yi("SUP", { tag: "SUB" }), Bt[Q + "shift-8"] = so(/(?:^|>)UL/, "makeUnorderedList"), Bt[Q + "shift-9"] = so(/(?:^|>)OL/, "makeOrderedList"), Bt[Q + "["] = Ho("decreaseQuoteLevel", "decreaseListLevel"), Bt[Q + "]"] = Ho("increaseQuoteLevel", "increaseListLevel"), Bt[Q + "d"] = dr("toggleCode"), Bt[Q + "y"] = dr("redo"), Bt[Q + "z"] = dr("undo"), Bt[Q + "shift-z"] = dr("redo");
    var zs = { 1: 10, 2: 13, 3: 16, 4: 18, 5: 24, 6: 32, 7: 48 }, Ir = { fontWeight: { regexp: /^bold|^700/i, replace: function(d) {
      return bt(d, "B");
    } }, fontStyle: { regexp: /^italic/i, replace: function(d) {
      return bt(d, "I");
    } }, fontFamily: { regexp: Ce, replace: function(d, w, _) {
      return bt(d, "SPAN", { class: w.fontFamily, style: "font-family:" + _ });
    } }, fontSize: { regexp: Ce, replace: function(d, w, _) {
      return bt(d, "SPAN", { class: w.fontSize, style: "font-size:" + _ });
    } }, textDecoration: { regexp: /^underline/i, replace: function(d) {
      return bt(d, "U");
    } } }, Nr = function(d) {
      return function(w, _) {
        var S, E, k, A = bt(w.ownerDocument, d), R = w.attributes;
        for (S = 0, E = R.length; S < E; S += 1)
          k = R[S], A.setAttribute(k.name, k.value);
        return _.replaceChild(A, w), A.appendChild(Ke(w)), A;
      };
    }, ao = { SPAN: function(d, w, _) {
      var S, E, k, A, R, F, G = d.style, ue = d.ownerDocument;
      for (S in Ir)
        if (E = Ir[S], (k = G[S]) && E.regexp.test(k)) {
          if ((F = E.replace(ue, _.classNames, k)).nodeName === d.nodeName && F.className === d.className)
            continue;
          R || (R = F), A && A.appendChild(F), A = F, d.style[S] = "";
        }
      return R && (A.appendChild(Ke(d)), d.appendChild(R)), A || d;
    }, STRONG: Nr("B"), EM: Nr("I"), INS: Nr("U"), STRIKE: Nr("S"), FONT: function(d, w, _) {
      var S, E, k, A, R, F = d.face, G = d.size, ue = d.color, fe = d.ownerDocument, ke = _.classNames;
      return F && (R = S = bt(fe, "SPAN", { class: ke.fontFamily, style: "font-family:" + F }), A = S), G && (E = bt(fe, "SPAN", { class: ke.fontSize, style: "font-size:" + zs[G] + "px" }), R || (R = E), A && A.appendChild(E), A = E), ue && /^#?([\dA-F]{3}){1,2}$/i.test(ue) && (ue.charAt(0) !== "#" && (ue = "#" + ue), k = bt(fe, "SPAN", { class: ke.colour, style: "color:" + ue }), R || (R = k), A && A.appendChild(k), A = k), R || (R = A = bt(fe, "SPAN")), w.replaceChild(R, d), A.appendChild(Ke(d)), A;
    }, TT: function(d, w, _) {
      var S = bt(d.ownerDocument, "SPAN", { class: _.classNames.fontFamily, style: 'font-family:menlo,consolas,"courier new",monospace' });
      return w.replaceChild(S, d), S.appendChild(Ke(d)), S;
    } }, Bs = /^(?:A(?:DDRESS|RTICLE|SIDE|UDIO)|BLOCKQUOTE|CAPTION|D(?:[DLT]|IV)|F(?:IGURE|IGCAPTION|OOTER)|H[1-6]|HEADER|L(?:ABEL|EGEND|I)|O(?:L|UTPUT)|P(?:RE)?|SECTION|T(?:ABLE|BODY|D|FOOT|H|HEAD|R)|COL(?:GROUP)?|UL)$/, lo = /^(?:HEAD|META|STYLE)/, cn = new Et(null, 4 | y), be = function d(w, _, S) {
      var E, k, A, R, F, G, ue, fe, ke, Ie, de, tt, mt = w.childNodes;
      for (E = w; _e(E); )
        E = E.parentNode;
      for (cn.root = E, k = 0, A = mt.length; k < A; k += 1)
        if (F = (R = mt[k]).nodeName, G = R.nodeType, ue = ao[F], G === a) {
          if (fe = R.childNodes.length, ue)
            R = ue(R, w, _);
          else {
            if (lo.test(F)) {
              w.removeChild(R), k -= 1, A -= 1;
              continue;
            }
            if (!Bs.test(F) && !_e(R)) {
              k -= 1, A += fe - 1, w.replaceChild(Ke(R), R);
              continue;
            }
          }
          fe && d(R, _, S || F === "PRE");
        } else {
          if (G === l) {
            if (de = R.data, ke = !Ce.test(de.charAt(0)), Ie = !Ce.test(de.charAt(de.length - 1)), S || !ke && !Ie)
              continue;
            if (ke) {
              for (cn.currentNode = R; (tt = cn.previousPONode()) && !((F = tt.nodeName) === "IMG" || F === "#text" && Ce.test(tt.data)); )
                if (!_e(tt)) {
                  tt = null;
                  break;
                }
              de = de.replace(/^[ \r\n]+/g, tt ? " " : "");
            }
            if (Ie) {
              for (cn.currentNode = R; (tt = cn.nextNode()) && !(F === "IMG" || F === "#text" && Ce.test(tt.data)); )
                if (!_e(tt)) {
                  tt = null;
                  break;
                }
              de = de.replace(/[ \r\n]+$/g, tt ? " " : "");
            }
            if (de) {
              R.data = de;
              continue;
            }
          }
          w.removeChild(R), k -= 1, A -= 1;
        }
      return w;
    }, uo = function d(w) {
      for (var _, S = w.childNodes, E = S.length; E--; )
        (_ = S[E]).nodeType !== a || we(_) ? _.nodeType !== l || _.data || w.removeChild(_) : (d(_), _e(_) && !_.firstChild && w.removeChild(_));
    }, Zo = function(d) {
      return d.nodeType === a ? d.nodeName === "BR" : Ce.test(d.data);
    }, co = function(d, w) {
      for (var _, S = d.parentNode; _e(S); )
        S = S.parentNode;
      return (_ = new Et(S, 4 | y, Zo)).currentNode = d, !!_.nextNode() || w && !_.previousNode();
    }, pr = function(d, w, _) {
      var S, E, k, A = d.querySelectorAll("BR"), R = [], F = A.length;
      for (S = 0; S < F; S += 1)
        R[S] = co(A[S], _);
      for (; F--; )
        (k = (E = A[F]).parentNode) && (R[F] ? _e(k) || $t(k, w) : pt(E));
    }, Rr = function(d, w, _, S, E, k) {
      var A, R, F = d.clipboardData, G = d.target.ownerDocument, ue = G.body, fe = bt(G, "div");
      fe.appendChild(w), A = fe.innerHTML, S && (A = S(A)), E ? R = E(A) : (pr(fe, _, !0), fe.setAttribute("style", "position:fixed;overflow:hidden;bottom:100%;right:100%;"), ue.appendChild(fe), R = (R = fe.innerText || fe.textContent).replace(/ /g, " "), ue.removeChild(fe)), N && (R = R.replace(/\r?\n/g, `\r
`)), k || R === A || F.setData("text/html", A), F.setData("text/plain", R), d.preventDefault();
    }, Vo = function(d) {
      var w, _, S, E, k, A = this.getSelection(), R = this._root, F = this;
      if (A.collapsed)
        d.preventDefault();
      else {
        if (this.saveUndoState(A), !B && d.clipboardData) {
          for (_ = (w = rn(A, R)) === yn(A, R) && w || R, S = Hn(A, R), (E = A.commonAncestorContainer).nodeType === l && (E = E.parentNode); E && E !== _; )
            (k = E.cloneNode(!1)).appendChild(S), S = k, E = E.parentNode;
          Rr(d, S, R, this._config.willCutCopy, null, !1);
        } else
          setTimeout(function() {
            try {
              F._ensureBottomLine();
            } catch (G) {
              F.didError(G);
            }
          }, 0);
        this.setSelection(A);
      }
    }, Li = function(d, w, _, S, E, k) {
      var A, R, F, G, ue;
      if (!B && d.clipboardData) {
        for (R = (A = rn(w, _)) === yn(w, _) && A || _, w = w.cloneRange(), nn(w), vn(w, R, R, _), F = w.cloneContents(), (G = w.commonAncestorContainer).nodeType === l && (G = G.parentNode); G && G !== R; )
          (ue = G.cloneNode(!1)).appendChild(F), F = ue, G = G.parentNode;
        Rr(d, F, _, S, E, k);
      }
    }, Wo = function(d) {
      Li(d, this.getSelection(), this._root, this._config.willCutCopy, null, !1);
    };
    function jo(d) {
      this.isShiftDown = d.shiftKey;
    }
    var Go = function(d) {
      var w, _, S, E, k, A = d.clipboardData, R = A && A.items, F = this.isShiftDown, G = !1, ue = !1, fe = !1, ke = null, Ie = null, de = this;
      if (R) {
        for (w = R.length; w--; )
          (S = (_ = R[w]).type) === "text/html" ? Ie = _ : S === "text/plain" || S === "text/uri-list" ? ke = _ : S === "text/rtf" ? ue = !0 : /^image\/.*/.test(S) && (fe = !0);
        if (fe && (!ue || !Ie))
          return d.preventDefault(), this.fireEvent("dragover", { dataTransfer: A, preventDefault: function() {
            G = !0;
          } }), void (G && this.fireEvent("drop", { dataTransfer: A }));
        if (!B)
          return d.preventDefault(), void (!Ie || F && ke ? ke && ke.getAsString(function(Gt) {
            de.insertPlainText(Gt, !0);
          }) : Ie.getAsString(function(Gt) {
            de.insertHTML(Gt, !0);
          }));
      }
      if (E = A && A.types, !B && E && (se.call(E, "text/html") > -1 || !D && se.call(E, "text/plain") > -1 && se.call(E, "text/rtf") < 0))
        return d.preventDefault(), void (!F && (k = A.getData("text/html")) ? this.insertHTML(k, !0) : ((k = A.getData("text/plain")) || (k = A.getData("text/uri-list"))) && this.insertPlainText(k, !0));
      this._awaitingPaste = !0;
      var tt = this._doc.body, mt = this.getSelection(), Ln = mt.startContainer, Zt = mt.startOffset, Wi = mt.endContainer, Jo = mt.endOffset, Te = this.createElement("DIV", { contenteditable: "true", style: "position:fixed; overflow:hidden; top:0; right:100%; width:1px; height:1px;" });
      tt.appendChild(Te), mt.selectNodeContents(Te), this.setSelection(mt), setTimeout(function() {
        try {
          de._awaitingPaste = !1;
          for (var Gt, _t, Br = "", ji = Te; Te = ji; )
            ji = Te.nextSibling, pt(Te), (Gt = Te.firstChild) && Gt === Te.lastChild && Gt.nodeName === "DIV" && (Te = Gt), Br += Te.innerHTML;
          _t = de.createRange(Ln, Zt, Wi, Jo), de.setSelection(_t), Br && de.insertHTML(Br, !0);
        } catch (po) {
          de.didError(po);
        }
      }, 0);
    }, Us = function(d) {
      for (var w = d.dataTransfer.types, _ = w.length, S = !1, E = !1; _--; )
        switch (w[_]) {
          case "text/plain":
            S = !0;
            break;
          case "text/html":
            E = !0;
            break;
          default:
            return;
        }
      (E || S) && this.saveUndoState();
    };
    function Fi(d, w, _) {
      var S, E;
      if (d || (d = {}), w)
        for (S in w)
          !_ && S in d || (E = w[S], d[S] = E && E.constructor === Object ? Fi(d[S], E, _) : E);
      return d;
    }
    function We(d, w) {
      d.nodeType === f && (d = d.body);
      var _, S = d.ownerDocument, E = S.defaultView;
      this._win = E, this._doc = S, this._root = d, this._events = {}, this._isFocused = !1, this._lastSelection = null, this._hasZWS = !1, this._lastAnchorNode = null, this._lastFocusNode = null, this._path = "", this._willUpdatePath = !1, "onselectionchange" in S ? this.addEventListener("selectionchange", this._updatePathOnEvent) : (this.addEventListener("keyup", this._updatePathOnEvent), this.addEventListener("mouseup", this._updatePathOnEvent)), this._undoIndex = -1, this._undoStack = [], this._undoStackLength = 0, this._isInUndoState = !1, this._ignoreChange = !1, this._ignoreAllChanges = !1, ve ? ((_ = new MutationObserver(this._docWasChanged.bind(this))).observe(d, { childList: !0, attributes: !0, characterData: !0, subtree: !0 }), this._mutation = _) : this.addEventListener("keyup", this._keyUpDetectChange), this._restoreSelection = !1, this.addEventListener("blur", ho), this.addEventListener("mousedown", qo), this.addEventListener("touchstart", qo), this.addEventListener("focus", Yo), this._awaitingPaste = !1, this.addEventListener("cut", Vo), this.addEventListener("copy", Wo), this.addEventListener("keydown", jo), this.addEventListener("keyup", jo), this.addEventListener("paste", Go), this.addEventListener("drop", Us), this.addEventListener("keydown", $s), this._keyHandlers = Object.create(Bt), this.setConfig(w), d.setAttribute("contenteditable", "true"), d.setAttribute("data-gramm", "false");
      try {
        S.execCommand("enableObjectResizing", !1, "false"), S.execCommand("enableInlineTableEditing", !1, "false");
      } catch {
      }
      d.__squire__ = this, this.setHTML("");
    }
    var ce = We.prototype, $r = function(d, w, _) {
      var S = _._doc, E = d ? DOMPurify.sanitize(d, { ALLOW_UNKNOWN_PROTOCOLS: !0, WHOLE_DOCUMENT: !1, RETURN_DOM: !0, RETURN_DOM_FRAGMENT: !0, FORCE_BODY: !1 }) : null;
      return E ? S.importNode(E, !0) : S.createDocumentFragment();
    };
    ce.setConfig = function(d) {
      return (d = Fi({ blockTag: "DIV", blockAttributes: null, tagAttributes: { blockquote: null, ul: null, ol: null, li: null, a: null }, classNames: { colour: "colour", fontFamily: "font", fontSize: "size", highlight: "highlight" }, leafNodeNames: xt, undo: { documentSizeThreshold: -1, undoLimit: -1 }, isInsertedHTMLSanitized: !0, isSetHTMLSanitized: !0, sanitizeToDOMFragment: typeof DOMPurify < "u" && DOMPurify.isSupported ? $r : null, willCutCopy: null, addLinks: !0 }, d, !0)).blockTag = d.blockTag.toUpperCase(), this._config = d, this;
    }, ce.createElement = function(d, w, _) {
      return bt(this._doc, d, w, _);
    }, ce.createDefaultBlock = function(d) {
      var w = this._config;
      return Rt(this.createElement(w.blockTag, w.blockAttributes, d), this._root);
    }, ce.didError = function(d) {
      console.log(d);
    }, ce.getDocument = function() {
      return this._doc;
    }, ce.getRoot = function() {
      return this._root;
    }, ce.modifyDocument = function(d) {
      var w = this._mutation;
      w && (w.takeRecords().length && this._docWasChanged(), w.disconnect()), this._ignoreAllChanges = !0, d(), this._ignoreAllChanges = !1, w && (w.observe(this._root, { childList: !0, attributes: !0, characterData: !0, subtree: !0 }), this._ignoreChange = !1);
    };
    var mr = { pathChange: 1, select: 1, input: 1, undoStateChange: 1 };
    ce.fireEvent = function(d, w) {
      var _, S, E, k = this._events[d];
      if (/^(?:focus|blur)/.test(d))
        if (_ = this._root === this._doc.activeElement, d === "focus") {
          if (!_ || this._isFocused)
            return this;
          this._isFocused = !0;
        } else {
          if (_ || !this._isFocused)
            return this;
          this._isFocused = !1;
        }
      if (k)
        for (w || (w = {}), w.type !== d && (w.type = d), S = (k = k.slice()).length; S--; ) {
          E = k[S];
          try {
            E.handleEvent ? E.handleEvent(w) : E.call(this, w);
          } catch (A) {
            A.details = "Squire: fireEvent error. Event type: " + d, this.didError(A);
          }
        }
      return this;
    }, ce.destroy = function() {
      var d, w = this._events;
      for (d in w)
        this.removeEventListener(d);
      this._mutation && this._mutation.disconnect(), delete this._root.__squire__, this._undoIndex = -1, this._undoStack = [], this._undoStackLength = 0;
    }, ce.handleEvent = function(d) {
      this.fireEvent(d.type, d);
    }, ce.addEventListener = function(d, w) {
      var _ = this._events[d], S = this._root;
      return w ? (_ || (_ = this._events[d] = [], mr[d] || (d === "selectionchange" && (S = this._doc), S.addEventListener(d, this, !0))), _.push(w), this) : (this.didError({ name: "Squire: addEventListener with null or undefined fn", message: "Event type: " + d }), this);
    }, ce.removeEventListener = function(d, w) {
      var _, S = this._events[d], E = this._root;
      if (S) {
        if (w)
          for (_ = S.length; _--; )
            S[_] === w && S.splice(_, 1);
        else
          S.length = 0;
        S.length || (delete this._events[d], mr[d] || (d === "selectionchange" && (E = this._doc), E.removeEventListener(d, this, !0)));
      }
      return this;
    }, ce.createRange = function(d, w, _, S) {
      if (d instanceof this._win.Range)
        return d.cloneRange();
      var E = this._doc.createRange();
      return E.setStart(d, w), _ ? E.setEnd(_, S) : E.setEnd(d, w), E;
    }, ce.getCursorPosition = function(d) {
      if (!d && !(d = this.getSelection()) || !d.getBoundingClientRect)
        return null;
      var w, _, S = d.getBoundingClientRect();
      return S && !S.top && (this._ignoreChange = !0, (w = this._doc.createElement("SPAN")).textContent = v, Fn(d, w), S = w.getBoundingClientRect(), (_ = w.parentNode).removeChild(w), Ui(_, d)), S;
    }, ce._moveCursorTo = function(d) {
      var w = this._root, _ = this.createRange(w, d ? 0 : w.childNodes.length);
      return nn(_), this.setSelection(_), this;
    }, ce.moveCursorToStart = function() {
      return this._moveCursorTo(!0);
    }, ce.moveCursorToEnd = function() {
      return this._moveCursorTo(!1);
    };
    var zr = function(d) {
      return d._win.getSelection() || null;
    };
    function ho() {
      this._restoreSelection = !0;
    }
    function qo() {
      this._restoreSelection = !1;
    }
    function Yo() {
      this._restoreSelection && this.setSelection(this._lastSelection);
    }
    ce.setSelection = function(d) {
      if (d)
        if (this._lastSelection = d, this._isFocused) {
          I && this._win.focus();
          var w = zr(this);
          w && w.setBaseAndExtent ? w.setBaseAndExtent(d.startContainer, d.startOffset, d.endContainer, d.endOffset) : w && (w.removeAllRanges(), w.addRange(d));
        } else
          ho.call(this);
      return this;
    }, ce.getSelection = function() {
      var d, w, _, S, E = zr(this), k = this._root;
      return this._isFocused && E && E.rangeCount && (w = (d = E.getRangeAt(0).cloneRange()).startContainer, _ = d.endContainer, w && we(w) && d.setStartBefore(w), _ && we(_) && d.setEndBefore(_)), d && Mi(k, d.commonAncestorContainer) ? this._lastSelection = d : Mi((S = (d = this._lastSelection).commonAncestorContainer).ownerDocument, S) || (d = null), d || (d = this.createRange(k.firstChild, 0)), d;
    }, ce.getSelectedText = function() {
      var d = this.getSelection();
      if (!d || d.collapsed)
        return "";
      var w, _ = new Et(d.commonAncestorContainer, 4 | y, function(F) {
        return tn(d, F, !0);
      }), S = d.startContainer, E = d.endContainer, k = _.currentNode = S, A = "", R = !1;
      for (_.filter(k) || (k = _.nextNode()); k; )
        k.nodeType === l ? (w = k.data) && /\S/.test(w) && (k === E && (w = w.slice(0, d.endOffset)), k === S && (w = w.slice(d.startOffset)), A += w, R = !0) : (k.nodeName === "BR" || R && !_e(k)) && (A += `
`, R = !1), k = _.nextNode();
      return A;
    }, ce.getPath = function() {
      return this._path;
    };
    var Hi = function(d, w) {
      for (var _, S, E, k = new Et(d, 4); S = k.nextNode(); )
        for (; (E = S.data.indexOf(v)) > -1 && (!w || S.parentNode !== w); ) {
          if (S.length === 1) {
            do
              (_ = S.parentNode).removeChild(S), S = _, k.currentNode = _;
            while (_e(S) && !Jt(S));
            break;
          }
          S.deleteData(E, 1);
        }
    };
    ce._didAddZWS = function() {
      this._hasZWS = !0;
    }, ce._removeZWS = function() {
      this._hasZWS && (Hi(this._root), this._hasZWS = !1);
    }, ce._updatePath = function(d, w) {
      if (d) {
        var _, S = d.startContainer, E = d.endContainer;
        (w || S !== this._lastAnchorNode || E !== this._lastFocusNode) && (this._lastAnchorNode = S, this._lastFocusNode = E, _ = S && E ? S === E ? function k(A, R, F) {
          var G, ue, fe, ke, Ie, de = "";
          return A && A !== R && (de = k(A.parentNode, R, F), A.nodeType === a && (de += (de ? ">" : "") + A.nodeName, (G = A.id) && (de += "#" + G), (ue = A.className.trim()) && ((fe = ue.split(/\s\s*/)).sort(), de += ".", de += fe.join(".")), (ke = A.dir) && (de += "[dir=" + ke + "]"), fe && (Ie = F.classNames, se.call(fe, Ie.highlight) > -1 && (de += "[backgroundColor=" + A.style.backgroundColor.replace(/ /g, "") + "]"), se.call(fe, Ie.colour) > -1 && (de += "[color=" + A.style.color.replace(/ /g, "") + "]"), se.call(fe, Ie.fontFamily) > -1 && (de += "[fontFamily=" + A.style.fontFamily.replace(/ /g, "") + "]"), se.call(fe, Ie.fontSize) > -1 && (de += "[fontSize=" + A.style.fontSize + "]")))), de;
        }(E, this._root, this._config) : "(selection)" : "", this._path !== _ && (this._path = _, this.fireEvent("pathChange", { path: _ }))), this.fireEvent(d.collapsed ? "cursor" : "select", { range: d });
      }
    }, ce._updatePathOnEvent = function() {
      var d = this;
      d._isFocused && !d._willUpdatePath && (d._willUpdatePath = !0, setTimeout(function() {
        d._willUpdatePath = !1, d._updatePath(d.getSelection());
      }, 0));
    }, ce.focus = function() {
      return this._root.focus({ preventScroll: !0 }), le && this.fireEvent("focus"), this;
    }, ce.blur = function() {
      return this._root.blur(), le && this.fireEvent("blur"), this;
    };
    var Zn = "squire-selection-end";
    ce._saveRangeToBookmark = function(d) {
      var w, _ = this.createElement("INPUT", { id: "squire-selection-start", type: "hidden" }), S = this.createElement("INPUT", { id: Zn, type: "hidden" });
      Fn(d, _), d.collapse(!1), Fn(d, S), 2 & _.compareDocumentPosition(S) && (_.id = Zn, S.id = "squire-selection-start", w = _, _ = S, S = w), d.setStartAfter(_), d.setEndBefore(S);
    }, ce._getRangeAndRemoveBookmark = function(d) {
      var w = this._root, _ = w.querySelector("#squire-selection-start"), S = w.querySelector("#" + Zn);
      if (_ && S) {
        var E = _.parentNode, k = S.parentNode, A = se.call(E.childNodes, _), R = se.call(k.childNodes, S);
        E === k && (R -= 1), pt(_), pt(S), d || (d = this._doc.createRange()), d.setStart(E, A), d.setEnd(k, R), Ui(E, d), E !== k && Ui(k, d), d.collapsed && (E = d.startContainer).nodeType === l && ((k = E.childNodes[d.startOffset]) && k.nodeType === l || (k = E.childNodes[d.startOffset - 1]), k && k.nodeType === l && (d.setStart(k, 0), d.collapse(!0)));
      }
      return d || null;
    }, ce._keyUpDetectChange = function(d) {
      var w = d.keyCode;
      d.ctrlKey || d.metaKey || d.altKey || !(w < 16 || w > 20) || !(w < 33 || w > 45) || this._docWasChanged();
    }, ce._docWasChanged = function() {
      Le && (Kt = /* @__PURE__ */ new WeakMap()), this._ignoreAllChanges || (ve && this._ignoreChange ? this._ignoreChange = !1 : (this._isInUndoState && (this._isInUndoState = !1, this.fireEvent("undoStateChange", { canUndo: !0, canRedo: !1 })), this.fireEvent("input")));
    }, ce._recordUndoState = function(d, w) {
      if (!this._isInUndoState || w) {
        var _, S = this._undoIndex, E = this._undoStack, k = this._config.undo, A = k.documentSizeThreshold, R = k.undoLimit;
        w || (S += 1), S < this._undoStackLength && (E.length = this._undoStackLength = S), d && this._saveRangeToBookmark(d), _ = this._getHTML(), A > -1 && 2 * _.length > A && R > -1 && S > R && (E.splice(0, S - R), S = R, this._undoStackLength = R), E[S] = _, this._undoIndex = S, this._undoStackLength += 1, this._isInUndoState = !0;
      }
    }, ce.saveUndoState = function(d) {
      return d === h && (d = this.getSelection()), this._recordUndoState(d, this._isInUndoState), this._getRangeAndRemoveBookmark(d), this;
    }, ce.undo = function() {
      if (this._undoIndex !== 0 || !this._isInUndoState) {
        this._recordUndoState(this.getSelection(), !1), this._undoIndex -= 1, this._setHTML(this._undoStack[this._undoIndex]);
        var d = this._getRangeAndRemoveBookmark();
        d && this.setSelection(d), this._isInUndoState = !0, this.fireEvent("undoStateChange", { canUndo: this._undoIndex !== 0, canRedo: !0 }), this.fireEvent("input");
      }
      return this;
    }, ce.redo = function() {
      var d = this._undoIndex, w = this._undoStackLength;
      if (d + 1 < w && this._isInUndoState) {
        this._undoIndex += 1, this._setHTML(this._undoStack[this._undoIndex]);
        var _ = this._getRangeAndRemoveBookmark();
        _ && this.setSelection(_), this.fireEvent("undoStateChange", { canUndo: !0, canRedo: d + 2 < w }), this.fireEvent("input");
      }
      return this;
    }, ce.hasFormat = function(d, w, _) {
      if (d = d.toUpperCase(), w || (w = {}), !_ && !(_ = this.getSelection()))
        return !1;
      !_.collapsed && _.startContainer.nodeType === l && _.startOffset === _.startContainer.length && _.startContainer.nextSibling && _.setStartBefore(_.startContainer.nextSibling), !_.collapsed && _.endContainer.nodeType === l && _.endOffset === 0 && _.endContainer.previousSibling && _.setEndAfter(_.endContainer.previousSibling);
      var S, E, k = this._root, A = _.commonAncestorContainer;
      if (ft(A, k, d, w))
        return !0;
      if (A.nodeType === l)
        return !1;
      S = new Et(A, 4, function(F) {
        return tn(_, F, !0);
      });
      for (var R = !1; E = S.nextNode(); ) {
        if (!ft(E, k, d, w))
          return !1;
        R = !0;
      }
      return R;
    }, ce.getFontInfo = function(d) {
      var w, _, S, E = { color: h, backgroundColor: h, family: h, size: h }, k = 0;
      if (!d && !(d = this.getSelection()))
        return E;
      if (w = d.commonAncestorContainer, d.collapsed || w.nodeType === l)
        for (w.nodeType === l && (w = w.parentNode); k < 4 && w; )
          (_ = w.style) && (!E.color && (S = _.color) && (E.color = S, k += 1), !E.backgroundColor && (S = _.backgroundColor) && (E.backgroundColor = S, k += 1), !E.family && (S = _.fontFamily) && (E.family = S, k += 1), !E.size && (S = _.fontSize) && (E.size = S, k += 1)), w = w.parentNode;
      return E;
    }, ce._addFormat = function(d, w, _) {
      var S, E, k, A, R, F, G, ue, fe = this._root;
      if (_.collapsed) {
        for (S = Rt(this.createElement(d, w), fe), Fn(_, S), _.setStart(S.firstChild, S.firstChild.length), _.collapse(!0), ue = S; _e(ue); )
          ue = ue.parentNode;
        Hi(ue, S);
      } else {
        if (E = new Et(_.commonAncestorContainer, 4 | y, function(ke) {
          return (ke.nodeType === l || ke.nodeName === "BR" || ke.nodeName === "IMG") && tn(_, ke, !0);
        }), k = _.startContainer, R = _.startOffset, A = _.endContainer, F = _.endOffset, E.currentNode = k, E.filter(k) || (k = E.nextNode(), R = 0), !k)
          return _;
        do
          !ft(G = E.currentNode, fe, d, w) && (G === A && G.length > F && G.splitText(F), G === k && R && (G = G.splitText(R), A === k && (A = G, F -= R), k = G, R = 0), jt(G, S = this.createElement(d, w)), S.appendChild(G));
        while (E.nextNode());
        A.nodeType !== l && (G.nodeType === l ? (A = G, F = G.length) : (A = G.parentNode, F = 1)), _ = this.createRange(k, R, A, F);
      }
      return _;
    }, ce._removeFormat = function(d, w, _, S) {
      this._saveRangeToBookmark(_);
      var E, k = this._doc;
      _.collapsed && (re ? (E = k.createTextNode(v), this._didAddZWS()) : E = k.createTextNode(""), Fn(_, E));
      for (var A = _.commonAncestorContainer; _e(A); )
        A = A.parentNode;
      var R = _.startContainer, F = _.startOffset, G = _.endContainer, ue = _.endOffset, fe = [], ke = function(de, tt) {
        if (!tn(_, de, !1)) {
          var mt, Ln, Zt = de.nodeType === l;
          if (tn(_, de, !0))
            if (Zt)
              de === G && ue !== de.length && fe.push([tt, de.splitText(ue)]), de === R && F && (de.splitText(F), fe.push([tt, de]));
            else
              for (mt = de.firstChild; mt; mt = Ln)
                Ln = mt.nextSibling, ke(mt, tt);
          else
            de.nodeName === "INPUT" || Zt && !de.data || fe.push([tt, de]);
        }
      }, Ie = Array.prototype.filter.call(A.getElementsByTagName(d), function(de) {
        return tn(_, de, !0) && en(de, d, w);
      });
      return S || Ie.forEach(function(de) {
        ke(de, de);
      }), fe.forEach(function(de) {
        var tt = de[0].cloneNode(!1), mt = de[1];
        jt(mt, tt), tt.appendChild(mt);
      }), Ie.forEach(function(de) {
        jt(de, Ke(de));
      }), this._getRangeAndRemoveBookmark(_), E && _.collapse(!1), Ui(A, _), _;
    }, ce.changeFormat = function(d, w, _, S) {
      return _ || (_ = this.getSelection()) ? (this.saveUndoState(_), w && (_ = this._removeFormat(w.tag.toUpperCase(), w.attributes || {}, _, S)), d && (_ = this._addFormat(d.tag.toUpperCase(), d.attributes || {}, _)), this.setSelection(_), this._updatePath(_, !0), ve || this._docWasChanged(), this) : this;
    };
    var Ko = { DT: "DD", DD: "DT", LI: "LI", PRE: "PRE" }, fo = function(d, w, _, S) {
      var E = Ko[w.nodeName], k = null, A = Xt(_, S, w.parentNode, d._root), R = d._config;
      return E || (E = R.blockTag, k = R.blockAttributes), en(A, E, k) || (w = bt(A.ownerDocument, E, k), A.dir && (w.dir = A.dir), jt(A, w), w.appendChild(Ke(A)), A = w), A;
    };
    ce.forEachBlock = function(d, w, _) {
      if (!_ && !(_ = this.getSelection()))
        return this;
      w && this.saveUndoState(_);
      var S = this._root, E = rn(_, S), k = yn(_, S);
      if (E && k)
        do
          if (d(E) || E === k)
            break;
        while (E = $e(E, S));
      return w && (this.setSelection(_), this._updatePath(_, !0), ve || this._docWasChanged()), this;
    }, ce.modifyBlocks = function(d, w) {
      if (!w && !(w = this.getSelection()))
        return this;
      this._recordUndoState(w, this._isInUndoState);
      var _, S = this._root;
      return li(w, S), vn(w, S, S, S), _ = xi(w, S, S), Fn(w, d.call(this, _)), w.endOffset < w.endContainer.childNodes.length && kt(w.endContainer.childNodes[w.endOffset], S), kt(w.startContainer.childNodes[w.startOffset], S), this._getRangeAndRemoveBookmark(w), this.setSelection(w), this._updatePath(w, !0), ve || this._docWasChanged(), this;
    };
    var Zi = function(d) {
      var w = d.querySelectorAll("blockquote");
      return Array.prototype.filter.call(w, function(_) {
        return !ft(_.parentNode, d, "BLOCKQUOTE");
      }).forEach(function(_) {
        jt(_, Ke(_));
      }), d;
    }, Qe = function() {
      return this.createDefaultBlock([this.createElement("INPUT", { id: "squire-selection-start", type: "hidden" }), this.createElement("INPUT", { id: Zn, type: "hidden" })]);
    }, yt = function(d, w, _) {
      for (var S, E, k, A, R = Ht(w, d._root), F = d._config.tagAttributes, G = F[_.toLowerCase()], ue = F.li; S = R.nextNode(); )
        S.parentNode.nodeName === "LI" && (S = S.parentNode, R.currentNode = S.lastChild), S.nodeName !== "LI" ? (A = d.createElement("LI", ue), S.dir && (A.dir = S.dir), (k = S.previousSibling) && k.nodeName === _ ? (k.appendChild(A), pt(S)) : jt(S, d.createElement(_, G, [A])), A.appendChild(Ke(S)), R.currentNode = A) : (E = (S = S.parentNode).nodeName) !== _ && /^[OU]L$/.test(E) && jt(S, d.createElement(_, G, [Ke(S)]));
    }, Vi = function(d, w) {
      for (var _ = d.commonAncestorContainer, S = d.startContainer, E = d.endContainer; _ && _ !== w && !/^[OU]L$/.test(_.nodeName); )
        _ = _.parentNode;
      if (!_ || _ === w)
        return null;
      for (S === _ && (S = S.childNodes[d.startOffset]), E === _ && (E = E.childNodes[d.endOffset]); S && S.parentNode !== _; )
        S = S.parentNode;
      for (; E && E.parentNode !== _; )
        E = E.parentNode;
      return [_, S, E];
    };
    ce.increaseListLevel = function(d) {
      if (!d && !(d = this.getSelection()))
        return this.focus();
      var w = this._root, _ = Vi(d, w);
      if (!_)
        return this.focus();
      var S = _[0], E = _[1], k = _[2];
      if (!E || E === S.firstChild)
        return this.focus();
      this._recordUndoState(d, this._isInUndoState);
      var A, R, F = S.nodeName, G = E.previousSibling;
      G.nodeName !== F && (A = this._config.tagAttributes[F.toLowerCase()], G = this.createElement(F, A), S.insertBefore(G, E));
      do
        R = E === k ? null : E.nextSibling, G.appendChild(E);
      while (E = R);
      return (R = G.nextSibling) && kt(R, w), this._getRangeAndRemoveBookmark(d), this.setSelection(d), this._updatePath(d, !0), ve || this._docWasChanged(), this.focus();
    }, ce.decreaseListLevel = function(d) {
      if (!d && !(d = this.getSelection()))
        return this.focus();
      var w = this._root, _ = Vi(d, w);
      if (!_)
        return this.focus();
      var S, E, k, A, R = _[0], F = _[1], G = _[2];
      if (F || (F = R.firstChild), G || (G = R.lastChild), this._recordUndoState(d, this._isInUndoState), F) {
        if (S = R.parentNode, k = G.nextSibling ? Xt(R, G.nextSibling, S, w) : R.nextSibling, S !== w && S.nodeName === "LI") {
          for (S = S.parentNode; k; )
            E = k.nextSibling, G.appendChild(k), k = E;
          k = R.parentNode.nextSibling;
        }
        A = !/^[OU]L$/.test(S.nodeName);
        do
          E = F === G ? null : F.nextSibling, R.removeChild(F), A && F.nodeName === "LI" && (F = this.createDefaultBlock([Ke(F)])), S.insertBefore(F, k);
        while (F = E);
      }
      return R.firstChild || pt(R), k && kt(k, w), this._getRangeAndRemoveBookmark(d), this.setSelection(d), this._updatePath(d, !0), ve || this._docWasChanged(), this.focus();
    }, ce._ensureBottomLine = function() {
      var d = this._root, w = d.lastElementChild;
      w && w.nodeName === this._config.blockTag && Be(w) || d.appendChild(this.createDefaultBlock());
    }, ce.setKeyHandler = function(d, w) {
      return this._keyHandlers[d] = w, this;
    }, ce._getHTML = function() {
      return this._root.innerHTML;
    }, ce._setHTML = function(d) {
      var w = this._root, _ = w, S = this._config.sanitizeToDOMFragment;
      if (typeof S == "function") {
        var E = S(d, !1, this);
        Ke(_), _.appendChild(E);
      } else
        _.innerHTML = d;
      do
        Rt(_, w);
      while (_ = $e(_, w));
      this._ignoreChange = !0;
    }, ce.getHTML = function(d) {
      var w, _;
      return d && (_ = this.getSelection()) && this._saveRangeToBookmark(_), w = this._getHTML().replace(/\u200B/g, ""), _ && this._getRangeAndRemoveBookmark(_), w;
    }, ce.setHTML = function(d) {
      var w, _, S, E = this._config, k = E.isSetHTMLSanitized ? E.sanitizeToDOMFragment : null, A = this._root;
      typeof k == "function" ? _ = k(d, !1, this) : ((w = this.createElement("DIV")).innerHTML = d, (_ = this._doc.createDocumentFragment()).appendChild(Ke(w))), be(_, E), pr(_, A, !1), $t(_, A);
      for (var R = _; R = $e(R, A); )
        Rt(R, A);
      for (this._ignoreChange = !0; S = A.lastChild; )
        A.removeChild(S);
      A.appendChild(_), Rt(A, A), this._undoIndex = -1, this._undoStack.length = 0, this._undoStackLength = 0, this._isInUndoState = !1;
      var F = this._getRangeAndRemoveBookmark() || this.createRange(A.firstChild, 0);
      return this.saveUndoState(F), this._lastSelection = F, ho.call(this), this._updatePath(F, !0), this;
    }, ce.insertElement = function(d, w) {
      if (w || (w = this.getSelection()), w.collapse(!0), _e(d))
        Fn(w, d), w.setStartAfter(d);
      else {
        for (var _, S = this._root, E = rn(w, S) || S; E !== S && !E.nextSibling; )
          E = E.parentNode;
        E !== S && (_ = Xt(E.parentNode, E.nextSibling, S, S)), _ ? S.insertBefore(d, _) : (S.appendChild(d), _ = this.createDefaultBlock(), S.appendChild(_)), w.setStart(_, 0), w.setEnd(_, 0), nn(w);
      }
      return this.focus(), this.setSelection(w), this._updatePath(w), ve || this._docWasChanged(), this;
    }, ce.insertImage = function(d, w) {
      var _ = this.createElement("IMG", Fi({ src: d }, w, !0));
      return this.insertElement(_), _;
    }, ce.linkRegExp = /\b(?:((?:(?:ht|f)tps?:\/\/|www\d{0,3}[.]|[a-z0-9][a-z0-9.\-]*[.][a-z]{2,}\/)(?:[^\s()<>]+|\([^\s()<>]+\))+(?:[^\s?&`!()\[\]{};:'".,<>«»“”‘’]|\([^\s()<>]+\)))|([\w\-.%+]+@(?:[\w\-]+\.)+[a-z]{2,}\b(?:[?][^&?\s]+=[^\s?&`!()\[\]{};:'".,<>«»“”‘’]+(?:&[^&?\s]+=[^\s?&`!()\[\]{};:'".,<>«»“”‘’]+)*)?))/i;
    var Vn = function(d, w, _) {
      var S, E, k, A, R, F, G, ue = d.ownerDocument, fe = new Et(d, 4, function(de) {
        return !ft(de, w, "A");
      }), ke = _.linkRegExp, Ie = _._config.tagAttributes.a;
      if (ke)
        for (; S = fe.nextNode(); )
          for (E = S.data, k = S.parentNode; A = ke.exec(E); )
            F = (R = A.index) + A[0].length, R && (G = ue.createTextNode(E.slice(0, R)), k.insertBefore(G, S)), (G = _.createElement("A", Fi({ href: A[1] ? /^(?:ht|f)tps?:/i.test(A[1]) ? A[1] : "http://" + A[1] : "mailto:" + A[0] }, Ie, !1))).textContent = E.slice(R, F), k.insertBefore(G, S), S.data = E = E.slice(F);
    };
    ce.insertHTML = function(d, w) {
      var _, S, E, k, A, R, F, G = this._config, ue = G.isInsertedHTMLSanitized ? G.sanitizeToDOMFragment : null, fe = this.getSelection(), ke = this._doc;
      typeof ue == "function" ? k = ue(d, w, this) : (w && (_ = d.indexOf("<!--StartFragment-->"), S = d.lastIndexOf("<!--EndFragment-->"), _ > -1 && S > -1 && (d = d.slice(_ + 20, S))), /<\/td>((?!<\/tr>)[\s\S])*$/i.test(d) && (d = "<TR>" + d + "</TR>"), /<\/tr>((?!<\/table>)[\s\S])*$/i.test(d) && (d = "<TABLE>" + d + "</TABLE>"), (E = this.createElement("DIV")).innerHTML = d, (k = ke.createDocumentFragment()).appendChild(Ke(E))), this.saveUndoState(fe);
      try {
        for (A = this._root, R = k, F = { fragment: k, preventDefault: function() {
          this.defaultPrevented = !0;
        }, defaultPrevented: !1 }, Vn(k, k, this), be(k, G), pr(k, A, !1), uo(k), k.normalize(); R = $e(R, k); )
          Rt(R, A);
        w && this.fireEvent("willPaste", F), F.defaultPrevented || (Di(fe, F.fragment, A), ve || this._docWasChanged(), fe.collapse(!1), hr(fe, 0, A), this._ensureBottomLine()), this.setSelection(fe), this._updatePath(fe, !0), w && this.focus();
      } catch (Ie) {
        this.didError(Ie);
      }
      return this;
    };
    var ui = function(d) {
      return d.split("&").join("&amp;").split("<").join("&lt;").split(">").join("&gt;").split('"').join("&quot;");
    };
    ce.insertPlainText = function(d, w) {
      var _ = this.getSelection();
      if (_.collapsed && ft(_.startContainer, this._root, "PRE")) {
        var S, E, k = _.startContainer, A = _.startOffset;
        return k && k.nodeType === l || (S = this._doc.createTextNode(""), k.insertBefore(S, k.childNodes[A]), k = S, A = 0), E = { text: d, preventDefault: function() {
          this.defaultPrevented = !0;
        }, defaultPrevented: !1 }, w && this.fireEvent("willPaste", E), E.defaultPrevented || (d = E.text, k.insertData(A, d), _.setStart(k, A + d.length), _.collapse(!0)), this.setSelection(_), this;
      }
      var R, F, G, ue, fe = d.split(`
`), ke = this._config, Ie = ke.blockTag, de = ke.blockAttributes, tt = "</" + Ie + ">", mt = "<" + Ie;
      for (R in de)
        mt += " " + R + '="' + ui(de[R]) + '"';
      for (mt += ">", F = 0, G = fe.length; F < G; F += 1)
        ue = fe[F], ue = ui(ue).replace(/ (?= )/g, "&nbsp;"), F && (ue = mt + (ue || "<BR>") + tt), fe[F] = ue;
      return this.insertHTML(fe.join(""), w);
    };
    var Ut = function(d, w, _) {
      return function() {
        return this[d](w, _), this.focus();
      };
    };
    ce.addStyles = function(d) {
      if (d) {
        var w = this._doc.documentElement.firstChild, _ = this.createElement("STYLE", { type: "text/css" });
        _.appendChild(this._doc.createTextNode(d)), w.appendChild(_);
      }
      return this;
    }, ce.bold = Ut("changeFormat", { tag: "B" }), ce.italic = Ut("changeFormat", { tag: "I" }), ce.underline = Ut("changeFormat", { tag: "U" }), ce.strikethrough = Ut("changeFormat", { tag: "S" }), ce.subscript = Ut("changeFormat", { tag: "SUB" }, { tag: "SUP" }), ce.superscript = Ut("changeFormat", { tag: "SUP" }, { tag: "SUB" }), ce.removeBold = Ut("changeFormat", null, { tag: "B" }), ce.removeItalic = Ut("changeFormat", null, { tag: "I" }), ce.removeUnderline = Ut("changeFormat", null, { tag: "U" }), ce.removeStrikethrough = Ut("changeFormat", null, { tag: "S" }), ce.removeSubscript = Ut("changeFormat", null, { tag: "SUB" }), ce.removeSuperscript = Ut("changeFormat", null, { tag: "SUP" }), ce.makeLink = function(d, w) {
      var _ = this.getSelection();
      if (_.collapsed) {
        var S = d.indexOf(":") + 1;
        if (S)
          for (; d[S] === "/"; )
            S += 1;
        Fn(_, this._doc.createTextNode(d.slice(S)));
      }
      return w = Fi(Fi({ href: d }, w, !0), this._config.tagAttributes.a, !1), this.changeFormat({ tag: "A", attributes: w }, { tag: "A" }, _), this.focus();
    }, ce.removeLink = function() {
      return this.changeFormat(null, { tag: "A" }, this.getSelection(), !0), this.focus();
    }, ce.setFontFace = function(d) {
      var w = this._config.classNames.fontFamily;
      return this.changeFormat(d ? { tag: "SPAN", attributes: { class: w, style: "font-family: " + d + ", sans-serif;" } } : null, { tag: "SPAN", attributes: { class: w } }), this.focus();
    }, ce.setFontSize = function(d) {
      var w = this._config.classNames.fontSize;
      return this.changeFormat(d ? { tag: "SPAN", attributes: { class: w, style: "font-size: " + (typeof d == "number" ? d + "px" : d) } } : null, { tag: "SPAN", attributes: { class: w } }), this.focus();
    }, ce.setTextColour = function(d) {
      var w = this._config.classNames.colour;
      return this.changeFormat(d ? { tag: "SPAN", attributes: { class: w, style: "color:" + d } } : null, { tag: "SPAN", attributes: { class: w } }), this.focus();
    }, ce.setHighlightColour = function(d) {
      var w = this._config.classNames.highlight;
      return this.changeFormat(d && { tag: "SPAN", attributes: { class: w, style: "background-color:" + d } }, { tag: "SPAN", attributes: { class: w } }), this.focus();
    }, ce.setTextAlignment = function(d) {
      return this.forEachBlock(function(w) {
        var _ = w.className.split(/\s+/).filter(function(S) {
          return !!S && !/^align/.test(S);
        }).join(" ");
        d ? (w.className = _ + " align-" + d, w.style.textAlign = d) : (w.className = _, w.style.textAlign = "");
      }, !0), this.focus();
    }, ce.setTextDirection = function(d) {
      return this.forEachBlock(function(w) {
        d ? w.dir = d : w.removeAttribute("dir");
      }, !0), this.focus();
    };
    var ze = function(d) {
      for (var w, _ = this._root, S = this._doc, E = S.createDocumentFragment(), k = Ht(d, _); w = k.nextNode(); ) {
        var A, R, F = w.querySelectorAll("BR"), G = [], ue = F.length;
        for (A = 0; A < ue; A += 1)
          G[A] = co(F[A], !1);
        for (; ue--; )
          R = F[ue], G[ue] ? jt(R, S.createTextNode(`
`)) : pt(R);
        for (ue = (F = w.querySelectorAll("CODE")).length; ue--; )
          pt(F[ue]);
        E.childNodes.length && E.appendChild(S.createTextNode(`
`)), E.appendChild(Ke(w));
      }
      for (k = new Et(E, 4); w = k.nextNode(); )
        w.data = w.data.replace(/ /g, " ");
      return E.normalize(), Rt(this.createElement("PRE", this._config.tagAttributes.pre, [E]), _);
    }, St = function(d) {
      for (var w, _, S, E, k, A, R = this._doc, F = this._root, G = d.querySelectorAll("PRE"), ue = G.length; ue--; ) {
        for (_ = new Et(w = G[ue], 4); S = _.nextNode(); ) {
          for (E = (E = S.data).replace(/ (?= )/g, " "), k = R.createDocumentFragment(); (A = E.indexOf(`
`)) > -1; )
            k.appendChild(R.createTextNode(E.slice(0, A))), k.appendChild(R.createElement("BR")), E = E.slice(A + 1);
          S.parentNode.insertBefore(k, S), S.data = E;
        }
        $t(w, F), jt(w, Ke(w));
      }
      return d;
    };
    ce.code = function() {
      var d = this.getSelection();
      return d.collapsed || Nt(d.commonAncestorContainer) ? this.modifyBlocks(ze, d) : this.changeFormat({ tag: "CODE", attributes: this._config.tagAttributes.code }, null, d), this.focus();
    }, ce.removeCode = function() {
      var d = this.getSelection();
      return ft(d.commonAncestorContainer, this._root, "PRE") ? this.modifyBlocks(St, d) : this.changeFormat(null, { tag: "CODE" }, d), this.focus();
    }, ce.toggleCode = function() {
      return this.hasFormat("PRE") || this.hasFormat("CODE") ? this.removeCode() : this.code(), this;
    }, ce.removeAllFormatting = function(d) {
      if (!d && !(d = this.getSelection()) || d.collapsed)
        return this;
      for (var w = this._root, _ = d.commonAncestorContainer; _ && !Be(_); )
        _ = _.parentNode;
      if (_ || (li(d, w), _ = w), _.nodeType === l)
        return this;
      this.saveUndoState(d), vn(d, _, _, w);
      for (var S, E, k = _.ownerDocument, A = d.startContainer, R = d.startOffset, F = d.endContainer, G = d.endOffset, ue = k.createDocumentFragment(), fe = k.createDocumentFragment(), ke = Xt(F, G, _, w), Ie = Xt(A, R, _, w); Ie !== ke; )
        S = Ie.nextSibling, ue.appendChild(Ie), Ie = S;
      return function de(tt, mt, Ln) {
        var Zt, Wi;
        for (Zt = mt.firstChild; Zt; Zt = Wi) {
          if (Wi = Zt.nextSibling, _e(Zt)) {
            if (Zt.nodeType === l || Zt.nodeName === "BR" || Zt.nodeName === "IMG") {
              Ln.appendChild(Zt);
              continue;
            }
          } else if (Be(Zt)) {
            Ln.appendChild(tt.createDefaultBlock([de(tt, Zt, tt._doc.createDocumentFragment())]));
            continue;
          }
          de(tt, Zt, Ln);
        }
        return Ln;
      }(this, ue, fe), fe.normalize(), Ie = fe.firstChild, S = fe.lastChild, E = _.childNodes, Ie ? (_.insertBefore(fe, ke), R = se.call(E, Ie), G = se.call(E, S) + 1) : G = R = se.call(E, ke), d.setStart(_, R), d.setEnd(_, G), Ui(_, d), nn(d), this.setSelection(d), this._updatePath(d, !0), this.focus();
    }, ce.increaseQuoteLevel = Ut("modifyBlocks", function(d) {
      return this.createElement("BLOCKQUOTE", this._config.tagAttributes.blockquote, [d]);
    }), ce.decreaseQuoteLevel = Ut("modifyBlocks", Zi), ce.makeUnorderedList = Ut("modifyBlocks", function(d) {
      return yt(this, d, "UL"), d;
    }), ce.makeOrderedList = Ut("modifyBlocks", function(d) {
      return yt(this, d, "OL"), d;
    }), ce.removeList = Ut("modifyBlocks", function(d) {
      var w, _, S, E, k, A = d.querySelectorAll("UL, OL"), R = d.querySelectorAll("LI"), F = this._root;
      for (w = 0, _ = A.length; w < _; w += 1)
        $t(E = Ke(S = A[w]), F), jt(S, E);
      for (w = 0, _ = R.length; w < _; w += 1)
        Be(k = R[w]) ? jt(k, this.createDefaultBlock([Ke(k)])) : ($t(k, F), jt(k, Ke(k)));
      return d;
    }), We.isInline = _e, We.isBlock = Be, We.isContainer = Nt, We.getBlockWalker = Ht, We.getPreviousBlock = wt, We.getNextBlock = $e, We.areAlike = Tn, We.hasTagAttributes = en, We.getNearest = ft, We.isOrContains = Mi, We.detach = pt, We.replaceWith = jt, We.empty = Ke, We.getNodeBefore = ai, We.getNodeAfter = Oi, We.insertNodeInRange = Fn, We.extractContentsOfRange = xi, We.deleteContentsOfRange = Hn, We.insertTreeFragmentIntoRange = Di, We.isNodeContainedInRange = tn, We.moveRangeBoundariesDownTree = nn, We.moveRangeBoundariesUpTree = vn, We.getStartBlockOfRange = rn, We.getEndBlockOfRange = yn, We.contentWalker = un, We.rangeDoesStartAtBlockBoundary = vi, We.rangeDoesEndAtBlockBoundary = fr, We.expandRangeToBlockBoundaries = li, We.onCopy = Li, We.onPaste = Go, We.addLinks = Vn, We.splitBlock = fo, We.startSelectionId = "squire-selection-start", We.endSelectionId = Zn, t.exports = We;
  })(document);
})(Ub);
const Fb = vc, Hb = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTE0IDM2VjhoMTEuNHEzLjMgMCA1LjcyNSAyLjF0Mi40MjUgNS4zcTAgMS45LTEuMDUgMy41dC0yLjggMi40NXYuM3EyLjE1LjcgMy40NzUgMi41IDEuMzI1IDEuOCAxLjMyNSA0LjA1IDAgMy40LTIuNjI1IDUuNlEyOS4yNSAzNiAyNS43NSAzNlptNC4zLTE2LjE1aDYuOHExLjc1IDAgMy4wMjUtMS4xNXQxLjI3NS0yLjlxMC0xLjc1LTEuMjc1LTIuOTI1UTI2Ljg1IDExLjcgMjUuMSAxMS43aC02LjhabTAgMTIuMzVoNy4ycTEuOSAwIDMuMy0xLjI1dDEuNC0zLjE1cTAtMS44NS0xLjQtMy4xdC0zLjMtMS4yNWgtNy4yWiIvPjwvc3ZnPg==", an = {
  separator: ">",
  paragraph: "P",
  bold: "B",
  italic: "I",
  code: "PRE",
  underline: "U",
  unorderedList: "UL",
  orderedList: "OL",
  link: "A"
}, Zb = he({
  props: {
    isActive: {
      type: Boolean
    },
    isDisabled: {
      type: Boolean
    }
  }
}), Vb = "_component_wn3g0_2", Wb = "_active_wn3g0_11", jb = "_disabled_wn3g0_15", Gb = {
  component: Vb,
  active: Wb,
  disabled: jb
}, qb = ["disabled"];
function Yb(t, i, r, h, a, l) {
  return pe(), Tt("button", {
    class: Ze([t.$style.component, { [t.$style.active]: t.isActive, [t.$style.disabled]: t.isDisabled }]),
    disabled: t.isDisabled,
    onClick: i[0] || (i[0] = mc(() => {
    }, ["prevent"]))
  }, [
    ri(t.$slots, "default")
  ], 10, qb);
}
const Kb = {
  $style: Gb
}, Jb = /* @__PURE__ */ Re(Zb, [["render", Yb], ["__cssModules", Kb]]), ur = he({
  emits: ["update"],
  props: {
    editor: {
      type: Object,
      required: !0
    },
    path: {
      type: String,
      default: an.paragraph
    }
  },
  components: {
    ButtonComponent: Jb
  }
}), Xb = he({
  mixins: [ur],
  data() {
    return {
      BoldSvg: Hb
    };
  },
  computed: {
    isActive() {
      return this.path.split(an.separator).includes(an.bold);
    }
  },
  methods: {
    onButtonClick() {
      this.editor.hasFormat(an.bold) ? this.editor.removeBold() : this.editor.bold();
    }
  }
});
function Qb(t, i, r, h, a, l) {
  const f = q("el-image"), m = q("button-component");
  return pe(), Ae(m, {
    "is-active": t.isActive,
    onClick: i[0] || (i[0] = (y) => t.onButtonClick())
  }, {
    default: Y(() => [
      ee(f, { src: t.BoldSvg }, null, 8, ["src"])
    ]),
    _: 1
  }, 8, ["is-active"]);
}
const eS = /* @__PURE__ */ Re(Xb, [["render", Qb]]), tS = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTEwIDQwdi01aDYuODVsOC45LTIySDE4VjhoMjB2NWgtNi44NWwtOC45IDIySDMwdjVaIi8+PC9zdmc+", nS = he({
  mixins: [ur],
  data() {
    return {
      ItalicSvg: tS
    };
  },
  computed: {
    isActive() {
      return this.path.split(an.separator).includes(an.italic);
    }
  },
  methods: {
    onButtonClick() {
      this.editor.hasFormat(an.italic) ? this.editor.removeItalic() : this.editor.italic();
    }
  }
});
function iS(t, i, r, h, a, l) {
  const f = q("el-image"), m = q("button-component");
  return pe(), Ae(m, {
    "is-active": t.isActive,
    onClick: i[0] || (i[0] = (y) => t.onButtonClick())
  }, {
    default: Y(() => [
      ee(f, { src: t.ItalicSvg }, null, 8, ["src"])
    ]),
    _: 1
  }, 8, ["is-active"]);
}
const rS = /* @__PURE__ */ Re(nS, [["render", iS]]), oS = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTEwIDQydi0zaDI4djNabTE0LThxLTUuMDUgMC04LjUyNS0zLjQ1UTEyIDI3LjEgMTIgMjIuMVY2aDR2MTYuMnEwIDMuMyAyLjMgNS41NVQyNCAzMHEzLjQgMCA1LjctMi4yNVEzMiAyNS41IDMyIDIyLjJWNmg0djE2LjFxMCA1LTMuNDc1IDguNDVRMjkuMDUgMzQgMjQgMzRaIi8+PC9zdmc+", sS = he({
  mixins: [ur],
  emits: ["update"],
  data() {
    return {
      UnderlineSvg: oS
    };
  },
  computed: {
    isActive() {
      return this.path.split(an.separator).includes(an.underline);
    }
  },
  methods: {
    onButtonClick() {
      this.editor.hasFormat(an.underline) ? this.editor.removeUnderline() : this.editor.underline();
    }
  }
});
function aS(t, i, r, h, a, l) {
  const f = q("el-image"), m = q("button-component");
  return pe(), Ae(m, {
    "is-active": t.isActive,
    onClick: i[0] || (i[0] = (y) => t.onButtonClick())
  }, {
    default: Y(() => [
      ee(f, { src: t.UnderlineSvg }, null, 8, ["src"])
    ]),
    _: 1
  }, 8, ["is-active"]);
}
const lS = /* @__PURE__ */ Re(sS, [["render", aS]]), Vf = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTYgNDJ2LTNoMzZ2M1ptMC04LjI1di0zaDIzLjZ2M1ptMC04LjI1di0zaDM2djNabTAtOC4yNXYtM2gyMy42djNaTTYgOVY2aDM2djNaIi8+PC9zdmc+", uS = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTYgNDJ2LTNoMzZ2M1ptOC4yLTguMjV2LTNoMTkuNjV2M1pNNiAyNS41di0zaDM2djNabTguMi04LjI1di0zaDE5LjY1djNaTTYgOVY2aDM2djNaIi8+PC9zdmc+", cS = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTYgNDJ2LTNoMzZ2M1ptMTIuNDUtOC4yNXYtM0g0MnYzWk02IDI1LjV2LTNoMzZ2M1ptMTIuNDUtOC4yNXYtM0g0MnYzWk02IDlWNmgzNnYzWiIvPjwvc3ZnPg==", hS = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTYgNDJ2LTNoMzZ2M1ptMC04LjI1di0zaDM2djNabTAtOC4yNXYtM2gzNnYzWm0wLTguMjV2LTNoMzZ2M1pNNiA5VjZoMzZ2M1oiLz48L3N2Zz4=";
var Wf;
const Ei = typeof window < "u", wa = (t) => typeof t == "function", Xp = (t) => typeof t == "string", Ml = () => +Date.now(), jf = (t, i, r) => Math.min(r, Math.max(i, t)), Ti = () => {
}, Gf = Ei && ((Wf = window == null ? void 0 : window.navigator) == null ? void 0 : Wf.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function ct(t) {
  return typeof t == "function" ? t() : Es(t);
}
function Ca(t, i) {
  function r(...h) {
    t(() => i.apply(this, h), { fn: i, thisArg: this, args: h });
  }
  return r;
}
const Fc = (t) => t();
function fS(t, i = {}) {
  let r, h;
  return (l) => {
    const f = ct(t), m = ct(i.maxWait);
    if (r && clearTimeout(r), f <= 0 || m !== void 0 && m <= 0)
      return h && (clearTimeout(h), h = null), l();
    m && !h && (h = setTimeout(() => {
      r && clearTimeout(r), h = null, l();
    }, m)), r = setTimeout(() => {
      h && clearTimeout(h), h = null, l();
    }, f);
  };
}
function Qp(t, i = !0, r = !0) {
  let h = 0, a, l = !0;
  const f = () => {
    a && (clearTimeout(a), a = void 0);
  };
  return (y) => {
    const v = ct(t), C = Date.now() - h;
    if (f(), v <= 0)
      return h = Date.now(), y();
    C > v && (r || !l) ? (h = Date.now(), y()) : i && (a = setTimeout(() => {
      h = Date.now(), l = !0, f(), y();
    }, v - C)), !r && !a && (a = setTimeout(() => l = !0, v)), l = !1;
  };
}
function dS(t = Fc) {
  const i = J(!0);
  function r() {
    i.value = !1;
  }
  function h() {
    i.value = !0;
  }
  return { isActive: i, pause: r, resume: h, eventFilter: (...l) => {
    i.value && t(...l);
  } };
}
const lr = {
  mounted: "mounted",
  updated: "updated",
  unmounted: "unmounted"
};
function pS(t, i = !1, r = "Timeout") {
  return new Promise((h, a) => {
    setTimeout(i ? () => a(r) : h, t);
  });
}
function mS(t) {
  return t;
}
function _S(t) {
  let i;
  function r() {
    return i || (i = t()), i;
  }
  return r.reset = async () => {
    const h = i;
    i = void 0, h && await h;
  }, r;
}
function gS(t, i, r = !1) {
  return i.reduce((h, a) => (a in t && (!r || t[a] !== void 0) && (h[a] = t[a]), h), {});
}
function vS(t, i) {
  let r, h, a;
  const l = J(!0), f = () => {
    l.value = !0, a();
  };
  it(t, f, { flush: "sync" });
  const m = wa(i) ? i : i.get, y = wa(i) ? void 0 : i.set, v = qp((C, M) => (h = C, a = M, {
    get() {
      return l.value && (r = m(), l.value = !1), h(), r;
    },
    set(N) {
      y == null || y(N);
    }
  }));
  return Object.isExtensible(v) && (v.trigger = f), v;
}
function zn(t) {
  return o0() ? (s0(t), !0) : !1;
}
function em(t, i = 200, r = {}) {
  return Ca(fS(i, r), t);
}
function yS(t, i = 200, r = !1, h = !0) {
  return Ca(Qp(i, r, h), t);
}
function Hc(t) {
  return typeof t == "function" ? ht(t) : J(t);
}
function qf(t, i, r = {}) {
  var h, a;
  const {
    flush: l = "sync",
    deep: f = !1,
    immediate: m = !0,
    direction: y = "both",
    transform: v = {}
  } = r;
  let C, M;
  const N = (h = v.ltr) != null ? h : (D) => D, I = (a = v.rtl) != null ? a : (D) => D;
  return (y === "both" || y === "ltr") && (C = it(t, (D) => i.value = N(D), { flush: l, deep: f, immediate: m })), (y === "both" || y === "rtl") && (M = it(i, (D) => t.value = I(D), { flush: l, deep: f, immediate: m })), () => {
    C == null || C(), M == null || M();
  };
}
var LS = Object.defineProperty, wS = Object.defineProperties, bS = Object.getOwnPropertyDescriptors, Yf = Object.getOwnPropertySymbols, SS = Object.prototype.hasOwnProperty, CS = Object.prototype.propertyIsEnumerable, Kf = (t, i, r) => i in t ? LS(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, TS = (t, i) => {
  for (var r in i || (i = {}))
    SS.call(i, r) && Kf(t, r, i[r]);
  if (Yf)
    for (var r of Yf(i))
      CS.call(i, r) && Kf(t, r, i[r]);
  return t;
}, ES = (t, i) => wS(t, bS(i));
function tm(t) {
  if (!Ps(t))
    return Bc(t);
  const i = Array.isArray(t.value) ? new Array(t.value.length) : {};
  for (const r in t.value)
    i[r] = qp(() => ({
      get() {
        return t.value[r];
      },
      set(h) {
        if (Array.isArray(t.value)) {
          const a = [...t.value];
          a[r] = h, t.value = a;
        } else {
          const a = ES(TS({}, t.value), { [r]: h });
          Object.setPrototypeOf(a, t.value), t.value = a;
        }
      }
    }));
  return i;
}
function As(t, i = !0) {
  Yp() ? a0(t) : i ? t() : ks(t);
}
function nm(t, i = 1e3, r = {}) {
  const {
    immediate: h = !0,
    immediateCallback: a = !1
  } = r;
  let l = null;
  const f = J(!1);
  function m() {
    l && (clearInterval(l), l = null);
  }
  function y() {
    f.value = !1, m();
  }
  function v() {
    Es(i) <= 0 || (f.value = !0, a && t(), m(), l = setInterval(t, ct(i)));
  }
  if (h && Ei && v(), Ps(i) || wa(i)) {
    const C = it(i, () => {
      f.value && Ei && v();
    });
    zn(C);
  }
  return zn(y), {
    isActive: f,
    pause: y,
    resume: v
  };
}
function PS(t = !1, i = {}) {
  const {
    truthyValue: r = !0,
    falsyValue: h = !1
  } = i, a = Ps(t), l = J(t);
  function f(m) {
    if (arguments.length)
      return l.value = m, l.value;
    {
      const y = ct(r);
      return l.value = l.value === y ? ct(h) : y, l.value;
    }
  }
  return a ? f : [l, f];
}
var Jf = Object.getOwnPropertySymbols, MS = Object.prototype.hasOwnProperty, OS = Object.prototype.propertyIsEnumerable, xS = (t, i) => {
  var r = {};
  for (var h in t)
    MS.call(t, h) && i.indexOf(h) < 0 && (r[h] = t[h]);
  if (t != null && Jf)
    for (var h of Jf(t))
      i.indexOf(h) < 0 && OS.call(t, h) && (r[h] = t[h]);
  return r;
};
function DS(t, i, r = {}) {
  const h = r, {
    eventFilter: a = Fc
  } = h, l = xS(h, [
    "eventFilter"
  ]);
  return it(t, Ca(a, i), l);
}
var kS = Object.defineProperty, AS = Object.defineProperties, IS = Object.getOwnPropertyDescriptors, Ol = Object.getOwnPropertySymbols, im = Object.prototype.hasOwnProperty, rm = Object.prototype.propertyIsEnumerable, Xf = (t, i, r) => i in t ? kS(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, NS = (t, i) => {
  for (var r in i || (i = {}))
    im.call(i, r) && Xf(t, r, i[r]);
  if (Ol)
    for (var r of Ol(i))
      rm.call(i, r) && Xf(t, r, i[r]);
  return t;
}, RS = (t, i) => AS(t, IS(i)), $S = (t, i) => {
  var r = {};
  for (var h in t)
    im.call(t, h) && i.indexOf(h) < 0 && (r[h] = t[h]);
  if (t != null && Ol)
    for (var h of Ol(t))
      i.indexOf(h) < 0 && rm.call(t, h) && (r[h] = t[h]);
  return r;
};
function om(t, i, r = {}) {
  const h = r, {
    eventFilter: a
  } = h, l = $S(h, [
    "eventFilter"
  ]), { eventFilter: f, pause: m, resume: y, isActive: v } = dS(a);
  return { stop: DS(t, i, RS(NS({}, l), {
    eventFilter: f
  })), pause: m, resume: y, isActive: v };
}
function oi(t) {
  var i;
  const r = ct(t);
  return (i = r == null ? void 0 : r.$el) != null ? i : r;
}
const Ot = Ei ? window : void 0, sm = Ei ? window.document : void 0, Bl = Ei ? window.navigator : void 0;
function Ee(...t) {
  let i, r, h, a;
  if (Xp(t[0]) || Array.isArray(t[0]) ? ([r, h, a] = t, i = Ot) : [i, r, h, a] = t, !i)
    return Ti;
  Array.isArray(r) || (r = [r]), Array.isArray(h) || (h = [h]);
  const l = [], f = () => {
    l.forEach((C) => C()), l.length = 0;
  }, m = (C, M, N) => (C.addEventListener(M, N, a), () => C.removeEventListener(M, N, a)), y = it(() => oi(i), (C) => {
    f(), C && l.push(...r.flatMap((M) => h.map((N) => m(C, M, N))));
  }, { immediate: !0, flush: "post" }), v = () => {
    y(), f();
  };
  return zn(v), v;
}
function zS(t, i, r = {}) {
  const { window: h = Ot, ignore: a = [], capture: l = !0, detectIframe: f = !1 } = r;
  if (!h)
    return;
  let m = !0, y;
  const v = (I) => a.some((D) => {
    if (typeof D == "string")
      return Array.from(h.document.querySelectorAll(D)).some((B) => B === I.target || I.composedPath().includes(B));
    {
      const B = oi(D);
      return B && (I.target === B || I.composedPath().includes(B));
    }
  }), C = (I) => {
    h.clearTimeout(y);
    const D = oi(t);
    if (!(!D || D === I.target || I.composedPath().includes(D))) {
      if (I.detail === 0 && (m = !v(I)), !m) {
        m = !0;
        return;
      }
      i(I);
    }
  }, M = [
    Ee(h, "click", C, { passive: !0, capture: l }),
    Ee(h, "pointerdown", (I) => {
      const D = oi(t);
      D && (m = !I.composedPath().includes(D) && !v(I));
    }, { passive: !0 }),
    Ee(h, "pointerup", (I) => {
      if (I.button === 0) {
        const D = I.composedPath();
        I.composedPath = () => D, y = h.setTimeout(() => C(I), 50);
      }
    }, { passive: !0 }),
    f && Ee(h, "blur", (I) => {
      var D;
      const B = oi(t);
      ((D = h.document.activeElement) == null ? void 0 : D.tagName) === "IFRAME" && !(B != null && B.contains(h.document.activeElement)) && i(I);
    })
  ].filter(Boolean);
  return () => M.forEach((I) => I());
}
function BS(t = {}) {
  const { window: i = Ot } = t, r = vS(() => null, () => i == null ? void 0 : i.document.activeElement);
  return i && (Ee(i, "blur", (h) => {
    h.relatedTarget !== null && r.trigger();
  }, !0), Ee(i, "focus", r.trigger, !0)), r;
}
function cr(t, i = !1) {
  const r = J(), h = () => r.value = Boolean(t());
  return h(), As(h, i), r;
}
function US({ navigator: t = Bl } = {}) {
  const i = ["chargingchange", "chargingtimechange", "dischargingtimechange", "levelchange"], r = cr(() => t && "getBattery" in t), h = J(!1), a = J(0), l = J(0), f = J(1);
  let m;
  function y() {
    h.value = this.charging, a.value = this.chargingTime || 0, l.value = this.dischargingTime || 0, f.value = this.level;
  }
  return r.value && t.getBattery().then((v) => {
    m = v, y.call(m);
    for (const C of i)
      Ee(m, C, y, { passive: !0 });
  }), {
    isSupported: r,
    charging: h,
    chargingTime: a,
    dischargingTime: l,
    level: f
  };
}
function Ro(t, i = {}) {
  const { window: r = Ot } = i, h = cr(() => r && "matchMedia" in r && typeof r.matchMedia == "function");
  let a;
  const l = J(!1), f = () => {
    a && ("removeEventListener" in a ? a.removeEventListener("change", m) : a.removeListener(m));
  }, m = () => {
    h.value && (f(), a = r.matchMedia(Hc(t).value), l.value = a.matches, "addEventListener" in a ? a.addEventListener("change", m) : a.addListener(m));
  };
  return Kp(m), zn(() => f()), l;
}
function FS({ window: t = Ot } = {}) {
  const i = (h) => {
    const { state: a, length: l } = (t == null ? void 0 : t.history) || {}, { hash: f, host: m, hostname: y, href: v, origin: C, pathname: M, port: N, protocol: I, search: D } = (t == null ? void 0 : t.location) || {};
    return {
      trigger: h,
      state: a,
      length: l,
      hash: f,
      host: m,
      hostname: y,
      href: v,
      origin: C,
      pathname: M,
      port: N,
      protocol: I,
      search: D
    };
  }, r = J(i("load"));
  return t && (Ee(t, "popstate", () => r.value = i("popstate"), { passive: !0 }), Ee(t, "hashchange", () => r.value = i("hashchange"), { passive: !0 })), r;
}
const yc = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Lc = "__vueuse_ssr_handlers__";
yc[Lc] = yc[Lc] || {};
const HS = yc[Lc];
function am(t, i) {
  return HS[t] || i;
}
function ZS(t) {
  return t == null ? "any" : t instanceof Set ? "set" : t instanceof Map ? "map" : t instanceof Date ? "date" : typeof t == "boolean" ? "boolean" : typeof t == "string" ? "string" : typeof t == "object" ? "object" : Number.isNaN(t) ? "any" : "number";
}
var VS = Object.defineProperty, Qf = Object.getOwnPropertySymbols, WS = Object.prototype.hasOwnProperty, jS = Object.prototype.propertyIsEnumerable, ed = (t, i, r) => i in t ? VS(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, td = (t, i) => {
  for (var r in i || (i = {}))
    WS.call(i, r) && ed(t, r, i[r]);
  if (Qf)
    for (var r of Qf(i))
      jS.call(i, r) && ed(t, r, i[r]);
  return t;
};
const GS = {
  boolean: {
    read: (t) => t === "true",
    write: (t) => String(t)
  },
  object: {
    read: (t) => JSON.parse(t),
    write: (t) => JSON.stringify(t)
  },
  number: {
    read: (t) => Number.parseFloat(t),
    write: (t) => String(t)
  },
  any: {
    read: (t) => t,
    write: (t) => String(t)
  },
  string: {
    read: (t) => t,
    write: (t) => String(t)
  },
  map: {
    read: (t) => new Map(JSON.parse(t)),
    write: (t) => JSON.stringify(Array.from(t.entries()))
  },
  set: {
    read: (t) => new Set(JSON.parse(t)),
    write: (t) => JSON.stringify(Array.from(t))
  },
  date: {
    read: (t) => new Date(t),
    write: (t) => t.toISOString()
  }
};
function lm(t, i, r, h = {}) {
  var a;
  const {
    flush: l = "pre",
    deep: f = !0,
    listenToStorageChanges: m = !0,
    writeDefaults: y = !0,
    mergeDefaults: v = !1,
    shallow: C,
    window: M = Ot,
    eventFilter: N,
    onError: I = (se) => {
      console.error(se);
    }
  } = h, D = (C ? zl : J)(i);
  if (!r)
    try {
      r = am("getDefaultStorage", () => {
        var se;
        return (se = Ot) == null ? void 0 : se.localStorage;
      })();
    } catch (se) {
      I(se);
    }
  if (!r)
    return D;
  const B = ct(i), X = ZS(B), le = (a = h.serializer) != null ? a : GS[X], { pause: Q, resume: re } = om(D, () => ve(D.value), { flush: l, deep: f, eventFilter: N });
  return M && m && Ee(M, "storage", Ce), Ce(), D;
  function ve(se) {
    try {
      if (se == null)
        r.removeItem(t);
      else {
        const Me = le.write(se), rt = r.getItem(t);
        rt !== Me && (r.setItem(t, Me), M && (M == null || M.dispatchEvent(new StorageEvent("storage", {
          key: t,
          oldValue: rt,
          newValue: Me,
          storageArea: r
        }))));
      }
    } catch (Me) {
      I(Me);
    }
  }
  function Le(se) {
    const Me = se ? se.newValue : r.getItem(t);
    if (Me == null)
      return y && B !== null && r.setItem(t, le.write(B)), B;
    if (!se && v) {
      const rt = le.read(Me);
      return wa(v) ? v(rt, B) : X === "object" && !Array.isArray(rt) ? td(td({}, B), rt) : rt;
    } else
      return typeof Me != "string" ? Me : le.read(Me);
  }
  function Ce(se) {
    if (!(se && se.storageArea !== r)) {
      if (se && se.key == null) {
        D.value = B;
        return;
      }
      if (!(se && se.key !== t)) {
        Q();
        try {
          D.value = Le(se);
        } catch (Me) {
          I(Me);
        } finally {
          se ? ks(re) : re();
        }
      }
    }
  }
}
function Zc(t) {
  return Ro("(prefers-color-scheme: dark)", t);
}
var qS = Object.defineProperty, nd = Object.getOwnPropertySymbols, YS = Object.prototype.hasOwnProperty, KS = Object.prototype.propertyIsEnumerable, id = (t, i, r) => i in t ? qS(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, JS = (t, i) => {
  for (var r in i || (i = {}))
    YS.call(i, r) && id(t, r, i[r]);
  if (nd)
    for (var r of nd(i))
      KS.call(i, r) && id(t, r, i[r]);
  return t;
};
function XS(t = {}) {
  const {
    selector: i = "html",
    attribute: r = "class",
    initialValue: h = "auto",
    window: a = Ot,
    storage: l,
    storageKey: f = "vueuse-color-scheme",
    listenToStorageChanges: m = !0,
    storageRef: y,
    emitAuto: v
  } = t, C = JS({
    auto: "",
    light: "light",
    dark: "dark"
  }, t.modes || {}), M = Zc({ window: a }), N = ht(() => M.value ? "dark" : "light"), I = y || (f == null ? J(h) : lm(f, h, l, { window: a, listenToStorageChanges: m })), D = ht({
    get() {
      return I.value === "auto" && !v ? N.value : I.value;
    },
    set(Q) {
      I.value = Q;
    }
  }), B = am("updateHTMLAttrs", (Q, re, ve) => {
    const Le = a == null ? void 0 : a.document.querySelector(Q);
    if (Le)
      if (re === "class") {
        const Ce = ve.split(/\s/g);
        Object.values(C).flatMap((se) => (se || "").split(/\s/g)).filter(Boolean).forEach((se) => {
          Ce.includes(se) ? Le.classList.add(se) : Le.classList.remove(se);
        });
      } else
        Le.setAttribute(re, ve);
  });
  function X(Q) {
    var re;
    const ve = Q === "auto" ? N.value : Q;
    B(i, r, (re = C[ve]) != null ? re : ve);
  }
  function le(Q) {
    t.onChanged ? t.onChanged(Q, X) : X(Q);
  }
  return it(D, le, { flush: "post", immediate: !0 }), v && it(N, () => le(D.value), { flush: "post" }), As(() => le(D.value)), D;
}
var QS = Object.defineProperty, e1 = Object.defineProperties, t1 = Object.getOwnPropertyDescriptors, rd = Object.getOwnPropertySymbols, n1 = Object.prototype.hasOwnProperty, i1 = Object.prototype.propertyIsEnumerable, od = (t, i, r) => i in t ? QS(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, r1 = (t, i) => {
  for (var r in i || (i = {}))
    n1.call(i, r) && od(t, r, i[r]);
  if (rd)
    for (var r of rd(i))
      i1.call(i, r) && od(t, r, i[r]);
  return t;
}, o1 = (t, i) => e1(t, t1(i));
function s1(t = {}) {
  const {
    valueDark: i = "dark",
    valueLight: r = "",
    window: h = Ot
  } = t, a = XS(o1(r1({}, t), {
    onChanged: (m, y) => {
      var v;
      t.onChanged ? (v = t.onChanged) == null || v.call(t, m === "dark") : y(m);
    },
    modes: {
      dark: i,
      light: r
    }
  })), l = Zc({ window: h });
  return ht({
    get() {
      return a.value === "dark";
    },
    set(m) {
      m === l.value ? a.value = "auto" : a.value = m ? "dark" : "light";
    }
  });
}
function a1(t = {}) {
  const {
    window: i = Ot,
    eventFilter: r = Fc
  } = t, h = J({ x: null, y: null, z: null }), a = J({ alpha: null, beta: null, gamma: null }), l = J(0), f = J({
    x: null,
    y: null,
    z: null
  });
  if (i) {
    const m = Ca(r, (y) => {
      h.value = y.acceleration, f.value = y.accelerationIncludingGravity, a.value = y.rotationRate, l.value = y.interval;
    });
    Ee(i, "devicemotion", m);
  }
  return {
    acceleration: h,
    accelerationIncludingGravity: f,
    rotationRate: a,
    interval: l
  };
}
function l1(t = {}) {
  const { window: i = Ot } = t, r = cr(() => i && "DeviceOrientationEvent" in i), h = J(!1), a = J(null), l = J(null), f = J(null);
  return i && r.value && Ee(i, "deviceorientation", (m) => {
    h.value = m.absolute, a.value = m.alpha, l.value = m.beta, f.value = m.gamma;
  }), {
    isSupported: r,
    isAbsolute: h,
    alpha: a,
    beta: l,
    gamma: f
  };
}
function u1({
  window: t = Ot
} = {}) {
  if (!t)
    return {
      pixelRatio: J(1)
    };
  const i = J(1), r = [], h = () => {
    r.map((l) => l()), r.length = 0;
  }, a = () => {
    i.value = t.devicePixelRatio, h();
    const l = t.matchMedia(`(resolution: ${i.value}dppx)`);
    l.addEventListener("change", a, { once: !0 }), r.push(() => {
      l.removeEventListener("change", a);
    });
  };
  return a(), zn(h), { pixelRatio: i };
}
function c1(t, i = {}) {
  const {
    controls: r = !1,
    navigator: h = Bl
  } = i, a = cr(() => h && "permissions" in h);
  let l;
  const f = typeof t == "string" ? { name: t } : t, m = J(), y = () => {
    l && (m.value = l.state);
  }, v = _S(async () => {
    if (a.value) {
      if (!l)
        try {
          l = await h.permissions.query(f), Ee(l, "change", y), y();
        } catch {
          m.value = "prompt";
        }
      return l;
    }
  });
  return v(), r ? {
    state: m,
    isSupported: a,
    query: v
  } : m;
}
function h1(t = {}) {
  const {
    navigator: i = Bl,
    requestPermissions: r = !1,
    constraints: h = { audio: !0, video: !0 },
    onUpdated: a
  } = t, l = J([]), f = ht(() => l.value.filter((I) => I.kind === "videoinput")), m = ht(() => l.value.filter((I) => I.kind === "audioinput")), y = ht(() => l.value.filter((I) => I.kind === "audiooutput")), v = cr(() => i && i.mediaDevices && i.mediaDevices.enumerateDevices), C = J(!1);
  async function M() {
    v.value && (l.value = await i.mediaDevices.enumerateDevices(), a == null || a(l.value));
  }
  async function N() {
    if (!v.value)
      return !1;
    if (C.value)
      return !0;
    const { state: I, query: D } = c1("camera", { controls: !0 });
    return await D(), I.value !== "granted" && ((await i.mediaDevices.getUserMedia(h)).getTracks().forEach((X) => X.stop()), M()), C.value = !0, C.value;
  }
  return v.value && (r && N(), Ee(i.mediaDevices, "devicechange", M), M()), {
    devices: l,
    ensurePermissions: N,
    permissionGranted: C,
    videoInputs: f,
    audioInputs: m,
    audioOutputs: y,
    isSupported: v
  };
}
function f1({ document: t = sm } = {}) {
  if (!t)
    return J("visible");
  const i = J(t.visibilityState);
  return Ee(t, "visibilitychange", () => {
    i.value = t.visibilityState;
  }), i;
}
var d1 = Object.defineProperty, p1 = Object.defineProperties, m1 = Object.getOwnPropertyDescriptors, sd = Object.getOwnPropertySymbols, _1 = Object.prototype.hasOwnProperty, g1 = Object.prototype.propertyIsEnumerable, ad = (t, i, r) => i in t ? d1(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, v1 = (t, i) => {
  for (var r in i || (i = {}))
    _1.call(i, r) && ad(t, r, i[r]);
  if (sd)
    for (var r of sd(i))
      g1.call(i, r) && ad(t, r, i[r]);
  return t;
}, y1 = (t, i) => p1(t, m1(i));
function L1(t, i = {}) {
  var r, h, a;
  const l = (r = i.draggingElement) != null ? r : Ot, f = (h = i.handle) != null ? h : t, m = J((a = ct(i.initialValue)) != null ? a : { x: 0, y: 0 }), y = J(), v = (D) => i.pointerTypes ? i.pointerTypes.includes(D.pointerType) : !0, C = (D) => {
    ct(i.preventDefault) && D.preventDefault(), ct(i.stopPropagation) && D.stopPropagation();
  }, M = (D) => {
    var B;
    if (!v(D) || ct(i.exact) && D.target !== ct(t))
      return;
    const X = ct(t).getBoundingClientRect(), le = {
      x: D.clientX - X.left,
      y: D.clientY - X.top
    };
    ((B = i.onStart) == null ? void 0 : B.call(i, le, D)) !== !1 && (y.value = le, C(D));
  }, N = (D) => {
    var B;
    v(D) && y.value && (m.value = {
      x: D.clientX - y.value.x,
      y: D.clientY - y.value.y
    }, (B = i.onMove) == null || B.call(i, m.value, D), C(D));
  }, I = (D) => {
    var B;
    v(D) && y.value && (y.value = void 0, (B = i.onEnd) == null || B.call(i, m.value, D), C(D));
  };
  return Ei && (Ee(f, "pointerdown", M, !0), Ee(l, "pointermove", N, !0), Ee(l, "pointerup", I, !0)), y1(v1({}, tm(m)), {
    position: m,
    isDragging: ht(() => !!y.value),
    style: ht(() => `left:${m.value.x}px;top:${m.value.y}px;`)
  });
}
var ld = Object.getOwnPropertySymbols, w1 = Object.prototype.hasOwnProperty, b1 = Object.prototype.propertyIsEnumerable, S1 = (t, i) => {
  var r = {};
  for (var h in t)
    w1.call(t, h) && i.indexOf(h) < 0 && (r[h] = t[h]);
  if (t != null && ld)
    for (var h of ld(t))
      i.indexOf(h) < 0 && b1.call(t, h) && (r[h] = t[h]);
  return r;
};
function um(t, i, r = {}) {
  const h = r, { window: a = Ot } = h, l = S1(h, ["window"]);
  let f;
  const m = cr(() => a && "ResizeObserver" in a), y = () => {
    f && (f.disconnect(), f = void 0);
  }, v = it(() => oi(t), (M) => {
    y(), m.value && a && M && (f = new ResizeObserver(i), f.observe(M, l));
  }, { immediate: !0, flush: "post" }), C = () => {
    y(), v();
  };
  return zn(C), {
    isSupported: m,
    stop: C
  };
}
function C1(t, i = {}) {
  const {
    reset: r = !0,
    windowResize: h = !0,
    windowScroll: a = !0,
    immediate: l = !0
  } = i, f = J(0), m = J(0), y = J(0), v = J(0), C = J(0), M = J(0), N = J(0), I = J(0);
  function D() {
    const B = oi(t);
    if (!B) {
      r && (f.value = 0, m.value = 0, y.value = 0, v.value = 0, C.value = 0, M.value = 0, N.value = 0, I.value = 0);
      return;
    }
    const X = B.getBoundingClientRect();
    f.value = X.height, m.value = X.bottom, y.value = X.left, v.value = X.right, C.value = X.top, M.value = X.width, N.value = X.x, I.value = X.y;
  }
  return um(t, D), it(() => oi(t), (B) => !B && D()), a && Ee("scroll", D, { passive: !0 }), h && Ee("resize", D, { passive: !0 }), As(() => {
    l && D();
  }), {
    height: f,
    bottom: m,
    left: y,
    right: v,
    top: C,
    width: M,
    x: N,
    y: I,
    update: D
  };
}
function cm(t, i = {}) {
  const {
    immediate: r = !0,
    window: h = Ot
  } = i, a = J(!1);
  let l = 0, f = null;
  function m(C) {
    if (!a.value || !h)
      return;
    const M = C - l;
    t({ delta: M, timestamp: C }), l = C, f = h.requestAnimationFrame(m);
  }
  function y() {
    !a.value && h && (a.value = !0, f = h.requestAnimationFrame(m));
  }
  function v() {
    a.value = !1, f != null && h && (h.cancelAnimationFrame(f), f = null);
  }
  return r && y(), zn(v), {
    isActive: a,
    pause: v,
    resume: y
  };
}
function hm(t, i = { width: 0, height: 0 }, r = {}) {
  const { box: h = "content-box" } = r, a = J(i.width), l = J(i.height);
  return um(t, ([f]) => {
    const m = h === "border-box" ? f.borderBoxSize : h === "content-box" ? f.contentBoxSize : f.devicePixelContentBoxSize;
    m ? (a.value = m.reduce((y, { inlineSize: v }) => y + v, 0), l.value = m.reduce((y, { blockSize: v }) => y + v, 0)) : (a.value = f.contentRect.width, l.value = f.contentRect.height);
  }, r), it(() => oi(t), (f) => {
    a.value = f ? i.width : 0, l.value = f ? i.height : 0;
  }), {
    width: a,
    height: l
  };
}
function T1(t, { window: i = Ot, scrollTarget: r } = {}) {
  const h = J(!1), a = () => {
    if (!i)
      return;
    const l = i.document, f = oi(t);
    if (!f)
      h.value = !1;
    else {
      const m = f.getBoundingClientRect();
      h.value = m.top <= (i.innerHeight || l.documentElement.clientHeight) && m.left <= (i.innerWidth || l.documentElement.clientWidth) && m.bottom >= 0 && m.right >= 0;
    }
  };
  return it(() => oi(t), () => a(), { immediate: !0, flush: "post" }), i && Ee(r || i, "scroll", a, {
    capture: !1,
    passive: !0
  }), h;
}
function E1(t = {}) {
  const { initialValue: i = "" } = t, r = cr(() => typeof window < "u" && "EyeDropper" in window), h = J(i);
  async function a(l) {
    if (!r.value)
      return;
    const m = await new window.EyeDropper().open(l);
    return h.value = m.sRGBHex, m;
  }
  return { isSupported: r, sRGBHex: h, open: a };
}
const ud = [
  [
    "requestFullscreen",
    "exitFullscreen",
    "fullscreenElement",
    "fullscreenEnabled",
    "fullscreenchange",
    "fullscreenerror"
  ],
  [
    "webkitRequestFullscreen",
    "webkitExitFullscreen",
    "webkitFullscreenElement",
    "webkitFullscreenEnabled",
    "webkitfullscreenchange",
    "webkitfullscreenerror"
  ],
  [
    "webkitRequestFullScreen",
    "webkitCancelFullScreen",
    "webkitCurrentFullScreenElement",
    "webkitCancelFullScreen",
    "webkitfullscreenchange",
    "webkitfullscreenerror"
  ],
  [
    "mozRequestFullScreen",
    "mozCancelFullScreen",
    "mozFullScreenElement",
    "mozFullScreenEnabled",
    "mozfullscreenchange",
    "mozfullscreenerror"
  ],
  [
    "msRequestFullscreen",
    "msExitFullscreen",
    "msFullscreenElement",
    "msFullscreenEnabled",
    "MSFullscreenChange",
    "MSFullscreenError"
  ]
];
function P1(t, i = {}) {
  const { document: r = sm, autoExit: h = !1 } = i, a = t || (r == null ? void 0 : r.querySelector("html")), l = J(!1);
  let f = ud[0];
  const m = cr(() => {
    if (r) {
      for (const B of ud)
        if (B[1] in r)
          return f = B, !0;
    } else
      return !1;
    return !1;
  }), [y, v, C, , M] = f;
  async function N() {
    m.value && (r != null && r[C] && await r[v](), l.value = !1);
  }
  async function I() {
    if (!m.value)
      return;
    await N();
    const B = oi(a);
    B && (await B[y](), l.value = !0);
  }
  async function D() {
    l.value ? await N() : await I();
  }
  return r && Ee(r, M, () => {
    l.value = !!(r != null && r[C]);
  }, !1), h && zn(N), {
    isSupported: m,
    isFullscreen: l,
    enter: I,
    exit: N,
    toggle: D
  };
}
function M1(t = {}) {
  const {
    enableHighAccuracy: i = !0,
    maximumAge: r = 3e4,
    timeout: h = 27e3,
    navigator: a = Bl,
    immediate: l = !0
  } = t, f = cr(() => a && "geolocation" in a), m = J(null), y = J(null), v = J({
    accuracy: 0,
    latitude: 1 / 0,
    longitude: 1 / 0,
    altitude: null,
    altitudeAccuracy: null,
    heading: null,
    speed: null
  });
  function C(D) {
    m.value = D.timestamp, v.value = D.coords, y.value = null;
  }
  let M;
  function N() {
    f.value && (M = a.geolocation.watchPosition(C, (D) => y.value = D, {
      enableHighAccuracy: i,
      maximumAge: r,
      timeout: h
    }));
  }
  l && N();
  function I() {
    M && a && a.geolocation.clearWatch(M);
  }
  return zn(() => {
    I();
  }), {
    isSupported: f,
    coords: v,
    locatedAt: m,
    error: y,
    resume: N,
    pause: I
  };
}
const O1 = ["mousemove", "mousedown", "resize", "keydown", "touchstart", "wheel"], x1 = 6e4;
function D1(t = x1, i = {}) {
  const {
    initialState: r = !1,
    listenForVisibilityChange: h = !0,
    events: a = O1,
    window: l = Ot,
    eventFilter: f = Qp(50)
  } = i, m = J(r), y = J(Ml());
  let v;
  const C = Ca(f, () => {
    m.value = !1, y.value = Ml(), clearTimeout(v), v = setTimeout(() => m.value = !0, t);
  });
  if (l) {
    const M = l.document;
    for (const N of a)
      Ee(l, N, C, { passive: !0 });
    h && Ee(M, "visibilitychange", () => {
      M.hidden || C();
    });
  }
  return v = setTimeout(() => m.value = !0, t), { idle: m, lastActive: y };
}
function fm(t = {}) {
  const {
    type: i = "page",
    touch: r = !0,
    resetOnTouchEnds: h = !1,
    initialValue: a = { x: 0, y: 0 },
    window: l = Ot,
    eventFilter: f
  } = t, m = J(a.x), y = J(a.y), v = J(null), C = (B) => {
    i === "page" ? (m.value = B.pageX, y.value = B.pageY) : i === "client" && (m.value = B.clientX, y.value = B.clientY), v.value = "mouse";
  }, M = () => {
    m.value = a.x, y.value = a.y;
  }, N = (B) => {
    if (B.touches.length > 0) {
      const X = B.touches[0];
      i === "page" ? (m.value = X.pageX, y.value = X.pageY) : i === "client" && (m.value = X.clientX, y.value = X.clientY), v.value = "touch";
    }
  }, I = (B) => f === void 0 ? C(B) : f(() => C(B), {}), D = (B) => f === void 0 ? N(B) : f(() => N(B), {});
  return l && (Ee(l, "mousemove", I, { passive: !0 }), Ee(l, "dragover", I, { passive: !0 }), r && (Ee(l, "touchstart", D, { passive: !0 }), Ee(l, "touchmove", D, { passive: !0 }), h && Ee(l, "touchend", M, { passive: !0 }))), {
    x: m,
    y,
    sourceType: v
  };
}
function k1(t, i = {}) {
  const {
    handleOutside: r = !0,
    window: h = Ot
  } = i, { x: a, y: l, sourceType: f } = fm(i), m = J(t ?? (h == null ? void 0 : h.document.body)), y = J(0), v = J(0), C = J(0), M = J(0), N = J(0), I = J(0), D = J(!0);
  let B = () => {
  };
  return h && (B = it([m, a, l], () => {
    const X = oi(m);
    if (!X)
      return;
    const {
      left: le,
      top: Q,
      width: re,
      height: ve
    } = X.getBoundingClientRect();
    C.value = le + h.pageXOffset, M.value = Q + h.pageYOffset, N.value = ve, I.value = re;
    const Le = a.value - C.value, Ce = l.value - M.value;
    D.value = re === 0 || ve === 0 || Le < 0 || Ce < 0 || Le > re || Ce > ve, (r || !D.value) && (y.value = Le, v.value = Ce);
  }, { immediate: !0 })), {
    x: a,
    y: l,
    sourceType: f,
    elementX: y,
    elementY: v,
    elementPositionX: C,
    elementPositionY: M,
    elementHeight: N,
    elementWidth: I,
    isOutside: D,
    stop: B
  };
}
function A1(t = {}) {
  const {
    touch: i = !0,
    drag: r = !0,
    initialValue: h = !1,
    window: a = Ot
  } = t, l = J(h), f = J(null);
  if (!a)
    return {
      pressed: l,
      sourceType: f
    };
  const m = (C) => () => {
    l.value = !0, f.value = C;
  }, y = () => {
    l.value = !1, f.value = null;
  }, v = ht(() => oi(t.target) || a);
  return Ee(v, "mousedown", m("mouse"), { passive: !0 }), Ee(a, "mouseleave", y, { passive: !0 }), Ee(a, "mouseup", y, { passive: !0 }), r && (Ee(v, "dragstart", m("mouse"), { passive: !0 }), Ee(a, "drop", y, { passive: !0 }), Ee(a, "dragend", y, { passive: !0 })), i && (Ee(v, "touchstart", m("touch"), { passive: !0 }), Ee(a, "touchend", y, { passive: !0 }), Ee(a, "touchcancel", y, { passive: !0 })), {
    pressed: l,
    sourceType: f
  };
}
function dm(t = {}) {
  const { window: i = Ot } = t, r = i == null ? void 0 : i.navigator, h = cr(() => r && "connection" in r), a = J(!0), l = J(!1), f = J(void 0), m = J(void 0), y = J(void 0), v = J(void 0), C = J(void 0), M = J(void 0), N = J("unknown"), I = h.value && r.connection;
  function D() {
    r && (a.value = r.onLine, f.value = a.value ? void 0 : Date.now(), m.value = a.value ? Date.now() : void 0, I && (y.value = I.downlink, v.value = I.downlinkMax, M.value = I.effectiveType, C.value = I.rtt, l.value = I.saveData, N.value = I.type));
  }
  return i && (Ee(i, "offline", () => {
    a.value = !1, f.value = Date.now();
  }), Ee(i, "online", () => {
    a.value = !0, m.value = Date.now();
  })), I && Ee(I, "change", D, !1), D(), {
    isSupported: h,
    isOnline: a,
    saveData: l,
    offlineAt: f,
    onlineAt: m,
    downlink: y,
    downlinkMax: v,
    effectiveType: M,
    rtt: C,
    type: N
  };
}
var I1 = Object.defineProperty, cd = Object.getOwnPropertySymbols, N1 = Object.prototype.hasOwnProperty, R1 = Object.prototype.propertyIsEnumerable, hd = (t, i, r) => i in t ? I1(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, $1 = (t, i) => {
  for (var r in i || (i = {}))
    N1.call(i, r) && hd(t, r, i[r]);
  if (cd)
    for (var r of cd(i))
      R1.call(i, r) && hd(t, r, i[r]);
  return t;
};
function pm(t = {}) {
  const {
    controls: i = !1,
    interval: r = "requestAnimationFrame"
  } = t, h = J(new Date()), a = () => h.value = new Date(), l = r === "requestAnimationFrame" ? cm(a, { immediate: !0 }) : nm(a, r, { immediate: !0 });
  return i ? $1({
    now: h
  }, l) : h;
}
function z1(t) {
  const i = J(), r = () => {
    i.value && URL.revokeObjectURL(i.value), i.value = void 0;
  };
  return it(() => Es(t), (h) => {
    r(), h && (i.value = URL.createObjectURL(h));
  }, { immediate: !0 }), zn(r), l0(i);
}
function fd(t, i, r) {
  const h = J(t);
  return ht({
    get() {
      return h.value = jf(h.value, ct(i), ct(r));
    },
    set(a) {
      h.value = jf(a, ct(i), ct(r));
    }
  });
}
function B1(t) {
  const {
    total: i = 1 / 0,
    pageSize: r = 10,
    page: h = 1,
    onPageChange: a = Ti,
    onPageSizeChange: l = Ti,
    onPageCountChange: f = Ti
  } = t, m = fd(r, 1, 1 / 0), y = ht(() => Math.max(1, Math.ceil(Es(i) / Es(m)))), v = fd(h, 1, y), C = ht(() => v.value === 1), M = ht(() => v.value === y.value);
  Ps(h) && qf(h, v), Ps(r) && qf(r, m);
  function N() {
    v.value--;
  }
  function I() {
    v.value++;
  }
  const D = {
    currentPage: v,
    currentPageSize: m,
    pageCount: y,
    isFirstPage: C,
    isLastPage: M,
    prev: N,
    next: I
  };
  return it(v, () => {
    a(Ue(D));
  }), it(m, () => {
    l(Ue(D));
  }), it(y, () => {
    f(Ue(D));
  }), D;
}
function U1(t = {}) {
  const { isOnline: i } = dm(t);
  return i;
}
function F1(t = {}) {
  const { window: i = Ot } = t, r = J(!1), h = (a) => {
    if (!i)
      return;
    a = a || i.event;
    const l = a.relatedTarget || a.toElement;
    r.value = !l;
  };
  return i && (Ee(i, "mouseout", h, { passive: !0 }), Ee(i.document, "mouseleave", h, { passive: !0 }), Ee(i.document, "mouseenter", h, { passive: !0 })), r;
}
var H1 = Object.defineProperty, Z1 = Object.defineProperties, V1 = Object.getOwnPropertyDescriptors, dd = Object.getOwnPropertySymbols, W1 = Object.prototype.hasOwnProperty, j1 = Object.prototype.propertyIsEnumerable, pd = (t, i, r) => i in t ? H1(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, G1 = (t, i) => {
  for (var r in i || (i = {}))
    W1.call(i, r) && pd(t, r, i[r]);
  if (dd)
    for (var r of dd(i))
      j1.call(i, r) && pd(t, r, i[r]);
  return t;
}, q1 = (t, i) => Z1(t, V1(i));
const mm = {
  x: 0,
  y: 0,
  pointerId: 0,
  pressure: 0,
  tiltX: 0,
  tiltY: 0,
  width: 0,
  height: 0,
  twist: 0,
  pointerType: null
}, Y1 = /* @__PURE__ */ Object.keys(mm);
function K1(t = {}) {
  const {
    target: i = Ot
  } = t, r = J(!1), h = J(t.initialValue || {});
  Object.assign(h.value, mm, h.value);
  const a = (l) => {
    r.value = !0, !(t.pointerTypes && !t.pointerTypes.includes(l.pointerType)) && (h.value = gS(l, Y1, !1));
  };
  return i && (Ee(i, "pointerdown", a, { passive: !0 }), Ee(i, "pointermove", a, { passive: !0 }), Ee(i, "pointerleave", () => r.value = !1, { passive: !0 })), q1(G1({}, tm(h)), {
    isInside: r
  });
}
var md;
(function(t) {
  t.UP = "UP", t.RIGHT = "RIGHT", t.DOWN = "DOWN", t.LEFT = "LEFT", t.NONE = "NONE";
})(md || (md = {}));
function J1(t) {
  const i = Ro("(prefers-color-scheme: light)", t), r = Ro("(prefers-color-scheme: dark)", t);
  return ht(() => r.value ? "dark" : i.value ? "light" : "no-preference");
}
function X1(t) {
  const i = Ro("(prefers-contrast: more)", t), r = Ro("(prefers-contrast: less)", t), h = Ro("(prefers-contrast: custom)", t);
  return ht(() => i.value ? "more" : r.value ? "less" : h.value ? "custom" : "no-preference");
}
function Q1(t = {}) {
  const { window: i = Ot } = t;
  if (!i)
    return J(["en"]);
  const r = i.navigator, h = J(r.languages);
  return Ee(i, "languagechange", () => {
    h.value = r.languages;
  }), h;
}
function eC(t) {
  const i = Ro("(prefers-reduced-motion: reduce)", t);
  return ht(() => i.value ? "reduce" : "no-preference");
}
var tC = Object.defineProperty, xl = Object.getOwnPropertySymbols, _m = Object.prototype.hasOwnProperty, gm = Object.prototype.propertyIsEnumerable, _d = (t, i, r) => i in t ? tC(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, nC = (t, i) => {
  for (var r in i || (i = {}))
    _m.call(i, r) && _d(t, r, i[r]);
  if (xl)
    for (var r of xl(i))
      gm.call(i, r) && _d(t, r, i[r]);
  return t;
}, iC = (t, i) => {
  var r = {};
  for (var h in t)
    _m.call(t, h) && i.indexOf(h) < 0 && (r[h] = t[h]);
  if (t != null && xl)
    for (var h of xl(t))
      i.indexOf(h) < 0 && gm.call(t, h) && (r[h] = t[h]);
  return r;
};
const rC = [
  { max: 6e4, value: 1e3, name: "second" },
  { max: 276e4, value: 6e4, name: "minute" },
  { max: 72e6, value: 36e5, name: "hour" },
  { max: 5184e5, value: 864e5, name: "day" },
  { max: 24192e5, value: 6048e5, name: "week" },
  { max: 28512e6, value: 2592e6, name: "month" },
  { max: 1 / 0, value: 31536e6, name: "year" }
], oC = {
  justNow: "just now",
  past: (t) => t.match(/\d/) ? `${t} ago` : t,
  future: (t) => t.match(/\d/) ? `in ${t}` : t,
  month: (t, i) => t === 1 ? i ? "last month" : "next month" : `${t} month${t > 1 ? "s" : ""}`,
  year: (t, i) => t === 1 ? i ? "last year" : "next year" : `${t} year${t > 1 ? "s" : ""}`,
  day: (t, i) => t === 1 ? i ? "yesterday" : "tomorrow" : `${t} day${t > 1 ? "s" : ""}`,
  week: (t, i) => t === 1 ? i ? "last week" : "next week" : `${t} week${t > 1 ? "s" : ""}`,
  hour: (t) => `${t} hour${t > 1 ? "s" : ""}`,
  minute: (t) => `${t} minute${t > 1 ? "s" : ""}`,
  second: (t) => `${t} second${t > 1 ? "s" : ""}`,
  invalid: ""
}, sC = (t) => t.toISOString().slice(0, 10);
function aC(t, i = {}) {
  const {
    controls: r = !1,
    updateInterval: h = 3e4
  } = i, a = pm({ interval: h, controls: !0 }), { now: l } = a, f = iC(a, ["now"]), m = ht(() => lC(new Date(ct(t)), i, Es(l.value)));
  return r ? nC({
    timeAgo: m
  }, f) : m;
}
function lC(t, i = {}, r = Date.now()) {
  var h;
  const {
    max: a,
    messages: l = oC,
    fullDateFormatter: f = sC,
    units: m = rC,
    showSecond: y = !1,
    rounding: v = "round"
  } = i, C = typeof v == "number" ? (X) => +X.toFixed(v) : Math[v], M = +r - +t, N = Math.abs(M);
  function I(X, le) {
    return C(Math.abs(X) / le.value);
  }
  function D(X, le) {
    const Q = I(X, le), re = X > 0, ve = B(le.name, Q, re);
    return B(re ? "past" : "future", ve, re);
  }
  function B(X, le, Q) {
    const re = l[X];
    return typeof re == "function" ? re(le, Q) : re.replace("{0}", le.toString());
  }
  if (N < 6e4 && !y)
    return l.justNow;
  if (typeof a == "number" && N > a)
    return f(new Date(t));
  if (typeof a == "string") {
    const X = (h = m.find((le) => le.name === a)) == null ? void 0 : h.max;
    if (X && N > X)
      return f(new Date(t));
  }
  for (const [X, le] of m.entries()) {
    if (I(M, le) <= 0 && m[X - 1])
      return D(M, m[X - 1]);
    if (N < le.max)
      return D(M, le);
  }
  return l.invalid;
}
var uC = Object.defineProperty, gd = Object.getOwnPropertySymbols, cC = Object.prototype.hasOwnProperty, hC = Object.prototype.propertyIsEnumerable, vd = (t, i, r) => i in t ? uC(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, fC = (t, i) => {
  for (var r in i || (i = {}))
    cC.call(i, r) && vd(t, r, i[r]);
  if (gd)
    for (var r of gd(i))
      hC.call(i, r) && vd(t, r, i[r]);
  return t;
};
function dC(t = {}) {
  const {
    controls: i = !1,
    offset: r = 0,
    immediate: h = !0,
    interval: a = "requestAnimationFrame",
    callback: l
  } = t, f = J(Ml() + r), m = () => f.value = Ml() + r, y = l ? () => {
    m(), l(f.value);
  } : m, v = a === "requestAnimationFrame" ? cm(y, { immediate: h }) : nm(y, a, { immediate: h });
  return i ? fC({
    timestamp: f
  }, v) : f;
}
var pC = Object.defineProperty, yd = Object.getOwnPropertySymbols, mC = Object.prototype.hasOwnProperty, _C = Object.prototype.propertyIsEnumerable, Ld = (t, i, r) => i in t ? pC(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, gC = (t, i) => {
  for (var r in i || (i = {}))
    mC.call(i, r) && Ld(t, r, i[r]);
  if (yd)
    for (var r of yd(i))
      _C.call(i, r) && Ld(t, r, i[r]);
  return t;
};
const vC = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
gC({
  linear: mS
}, vC);
function yC(t, i) {
  const { containerStyle: r, wrapperProps: h, scrollTo: a, calculateRange: l, currentList: f, containerRef: m } = "itemHeight" in i ? bC(i, t) : wC(i, t);
  return {
    list: f,
    scrollTo: a,
    containerProps: {
      ref: m,
      onScroll: () => {
        l();
      },
      style: r
    },
    wrapperProps: h
  };
}
function vm(t) {
  const i = J(null), r = hm(i), h = J([]), a = zl(t);
  return { state: J({ start: 0, end: 10 }), source: a, currentList: h, size: r, containerRef: i };
}
function ym(t, i, r) {
  return (h) => {
    if (typeof r == "number")
      return Math.ceil(h / r);
    const { start: a = 0 } = t.value;
    let l = 0, f = 0;
    for (let m = a; m < i.value.length; m++) {
      const y = r(m);
      if (l += y, l >= h) {
        f = m;
        break;
      }
    }
    return f - a;
  };
}
function Lm(t, i) {
  return (r) => {
    if (typeof i == "number")
      return Math.floor(r / i) + 1;
    let h = 0, a = 0;
    for (let l = 0; l < t.value.length; l++) {
      const f = i(l);
      if (h += f, h >= r) {
        a = l;
        break;
      }
    }
    return a + 1;
  };
}
function wm(t, i, r, h, { containerRef: a, state: l, currentList: f, source: m }) {
  return () => {
    const y = a.value;
    if (y) {
      const v = r(t === "vertical" ? y.scrollTop : y.scrollLeft), C = h(t === "vertical" ? y.clientHeight : y.clientWidth), M = v - i, N = v + C + i;
      l.value = {
        start: M < 0 ? 0 : M,
        end: N > m.value.length ? m.value.length : N
      }, f.value = m.value.slice(l.value.start, l.value.end).map((I, D) => ({
        data: I,
        index: D + l.value.start
      }));
    }
  };
}
function bm(t, i) {
  return (r) => typeof t == "number" ? r * t : i.value.slice(0, r).reduce((a, l, f) => a + t(f), 0);
}
function Sm(t, i, r) {
  it([t.width, t.height, i], () => {
    r();
  });
}
function Cm(t, i) {
  return ht(() => typeof t == "number" ? i.value.length * t : i.value.reduce((r, h, a) => r + t(a), 0));
}
const LC = {
  horizontal: "scrollLeft",
  vertical: "scrollTop"
};
function Tm(t, i, r, h) {
  return (a) => {
    h.value && (h.value[LC[t]] = r(a), i());
  };
}
function wC(t, i) {
  const r = vm(i), { state: h, source: a, currentList: l, size: f, containerRef: m } = r, y = { overflowX: "auto" }, { itemWidth: v, overscan: C = 5 } = t, M = ym(h, a, v), N = Lm(a, v), I = wm("horizontal", C, N, M, r), D = bm(v, a), B = ht(() => D(h.value.start)), X = Cm(v, a);
  Sm(f, i, I);
  const le = Tm("horizontal", I, D, m), Q = ht(() => ({
    style: {
      height: "100%",
      width: `${X.value - B.value}px`,
      marginLeft: `${B.value}px`,
      display: "flex"
    }
  }));
  return {
    scrollTo: le,
    calculateRange: I,
    wrapperProps: Q,
    containerStyle: y,
    currentList: l,
    containerRef: m
  };
}
function bC(t, i) {
  const r = vm(i), { state: h, source: a, currentList: l, size: f, containerRef: m } = r, y = { overflowY: "auto" }, { itemHeight: v, overscan: C = 5 } = t, M = ym(h, a, v), N = Lm(a, v), I = wm("vertical", C, N, M, r), D = bm(v, a), B = ht(() => D(h.value.start)), X = Cm(v, a);
  Sm(f, i, I);
  const le = Tm("vertical", I, D, m), Q = ht(() => ({
    style: {
      width: "100%",
      height: `${X.value - B.value}px`,
      marginTop: `${B.value}px`
    }
  }));
  return {
    calculateRange: I,
    scrollTo: le,
    containerStyle: y,
    wrapperProps: Q,
    currentList: l,
    containerRef: m
  };
}
function SC({ window: t = Ot } = {}) {
  if (!t)
    return J(!1);
  const i = J(t.document.hasFocus());
  return Ee(t, "blur", () => {
    i.value = !1;
  }), Ee(t, "focus", () => {
    i.value = !0;
  }), i;
}
function CC(t = {}) {
  const {
    window: i = Ot,
    initialWidth: r = 1 / 0,
    initialHeight: h = 1 / 0,
    listenOrientation: a = !0,
    includeScrollbar: l = !0
  } = t, f = J(r), m = J(h), y = () => {
    i && (l ? (f.value = i.innerWidth, m.value = i.innerHeight) : (f.value = i.document.documentElement.clientWidth, m.value = i.document.documentElement.clientHeight));
  };
  return y(), As(y), Ee("resize", y, { passive: !0 }), a && Ee("orientationchange", y, { passive: !0 }), { width: f, height: m };
}
const TC = he({
  name: "OnClickOutside",
  props: ["as", "options"],
  emits: ["trigger"],
  setup(t, { slots: i, emit: r }) {
    const h = J();
    return zS(h, (a) => {
      r("trigger", a);
    }, t.options), () => {
      if (i.default)
        return sn(t.as || "div", { ref: h }, i.default());
    };
  }
});
function mi(t) {
  var i;
  const r = ct(t);
  return (i = r == null ? void 0 : r.$el) != null ? i : r;
}
const Pi = Ei ? window : void 0;
function Rn(...t) {
  let i, r, h, a;
  if (Xp(t[0]) || Array.isArray(t[0]) ? ([r, h, a] = t, i = Pi) : [i, r, h, a] = t, !i)
    return Ti;
  Array.isArray(r) || (r = [r]), Array.isArray(h) || (h = [h]);
  const l = [], f = () => {
    l.forEach((C) => C()), l.length = 0;
  }, m = (C, M, N) => (C.addEventListener(M, N, a), () => C.removeEventListener(M, N, a)), y = it(() => mi(i), (C) => {
    f(), C && l.push(...r.flatMap((M) => h.map((N) => m(C, M, N))));
  }, { immediate: !0, flush: "post" }), v = () => {
    y(), f();
  };
  return zn(v), v;
}
function wd(t, i, r = {}) {
  const { window: h = Pi, ignore: a = [], capture: l = !0, detectIframe: f = !1 } = r;
  if (!h)
    return;
  let m = !0, y;
  const v = (I) => a.some((D) => {
    if (typeof D == "string")
      return Array.from(h.document.querySelectorAll(D)).some((B) => B === I.target || I.composedPath().includes(B));
    {
      const B = mi(D);
      return B && (I.target === B || I.composedPath().includes(B));
    }
  }), C = (I) => {
    h.clearTimeout(y);
    const D = mi(t);
    if (!(!D || D === I.target || I.composedPath().includes(D))) {
      if (I.detail === 0 && (m = !v(I)), !m) {
        m = !0;
        return;
      }
      i(I);
    }
  }, M = [
    Rn(h, "click", C, { passive: !0, capture: l }),
    Rn(h, "pointerdown", (I) => {
      const D = mi(t);
      D && (m = !I.composedPath().includes(D) && !v(I));
    }, { passive: !0 }),
    Rn(h, "pointerup", (I) => {
      if (I.button === 0) {
        const D = I.composedPath();
        I.composedPath = () => D, y = h.setTimeout(() => C(I), 50);
      }
    }, { passive: !0 }),
    f && Rn(h, "blur", (I) => {
      var D;
      const B = mi(t);
      ((D = h.document.activeElement) == null ? void 0 : D.tagName) === "IFRAME" && !(B != null && B.contains(h.document.activeElement)) && i(I);
    })
  ].filter(Boolean);
  return () => M.forEach((I) => I());
}
lr.mounted + "", lr.unmounted + "";
const EC = (t) => typeof t == "function" ? t : typeof t == "string" ? (i) => i.key === t : Array.isArray(t) ? (i) => t.includes(i.key) : () => !0;
function bd(...t) {
  let i, r, h = {};
  t.length === 3 ? (i = t[0], r = t[1], h = t[2]) : t.length === 2 ? typeof t[1] == "object" ? (i = !0, r = t[0], h = t[1]) : (i = t[0], r = t[1]) : (i = !0, r = t[0]);
  const { target: a = Pi, eventName: l = "keydown", passive: f = !1 } = h, m = EC(i);
  return Rn(a, l, (v) => {
    m(v) && r(v);
  }, f);
}
var PC = Object.defineProperty, Sd = Object.getOwnPropertySymbols, MC = Object.prototype.hasOwnProperty, OC = Object.prototype.propertyIsEnumerable, Cd = (t, i, r) => i in t ? PC(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, xC = (t, i) => {
  for (var r in i || (i = {}))
    MC.call(i, r) && Cd(t, r, i[r]);
  if (Sd)
    for (var r of Sd(i))
      OC.call(i, r) && Cd(t, r, i[r]);
  return t;
};
lr.mounted + "";
const DC = 500;
function wc(t, i, r) {
  var h, a;
  const l = ht(() => mi(t));
  let f;
  function m() {
    f && (clearTimeout(f), f = void 0);
  }
  function y(C) {
    var M, N, I, D;
    (M = r == null ? void 0 : r.modifiers) != null && M.self && C.target !== l.value || (m(), (N = r == null ? void 0 : r.modifiers) != null && N.prevent && C.preventDefault(), (I = r == null ? void 0 : r.modifiers) != null && I.stop && C.stopPropagation(), f = setTimeout(() => i(C), (D = r == null ? void 0 : r.delay) != null ? D : DC));
  }
  const v = {
    capture: (h = r == null ? void 0 : r.modifiers) == null ? void 0 : h.capture,
    once: (a = r == null ? void 0 : r.modifiers) == null ? void 0 : a.once
  };
  Rn(l, "pointerdown", y, v), Rn(l, "pointerup", m, v), Rn(l, "pointerleave", m, v);
}
he({
  name: "OnLongPress",
  props: ["as", "options"],
  emits: ["trigger"],
  setup(t, { slots: i, emit: r }) {
    const h = J();
    return wc(h, (a) => {
      r("trigger", a);
    }, t.options), () => {
      if (i.default)
        return sn(t.as || "div", { ref: h }, i.default());
    };
  }
});
lr.mounted + "";
he({
  name: "UseActiveElement",
  setup(t, { slots: i }) {
    const r = Ue({
      element: BS()
    });
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
he({
  name: "UseBattery",
  setup(t, { slots: i }) {
    const r = Ue(US(t));
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
he({
  name: "UseBrowserLocation",
  setup(t, { slots: i }) {
    const r = Ue(FS());
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
const bc = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Sc = "__vueuse_ssr_handlers__";
bc[Sc] = bc[Sc] || {};
const kC = bc[Sc];
function Em(t, i) {
  return kC[t] || i;
}
function AC(t) {
  return t == null ? "any" : t instanceof Set ? "set" : t instanceof Map ? "map" : t instanceof Date ? "date" : typeof t == "boolean" ? "boolean" : typeof t == "string" ? "string" : typeof t == "object" ? "object" : Number.isNaN(t) ? "any" : "number";
}
var IC = Object.defineProperty, Td = Object.getOwnPropertySymbols, NC = Object.prototype.hasOwnProperty, RC = Object.prototype.propertyIsEnumerable, Ed = (t, i, r) => i in t ? IC(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, Pd = (t, i) => {
  for (var r in i || (i = {}))
    NC.call(i, r) && Ed(t, r, i[r]);
  if (Td)
    for (var r of Td(i))
      RC.call(i, r) && Ed(t, r, i[r]);
  return t;
};
const $C = {
  boolean: {
    read: (t) => t === "true",
    write: (t) => String(t)
  },
  object: {
    read: (t) => JSON.parse(t),
    write: (t) => JSON.stringify(t)
  },
  number: {
    read: (t) => Number.parseFloat(t),
    write: (t) => String(t)
  },
  any: {
    read: (t) => t,
    write: (t) => String(t)
  },
  string: {
    read: (t) => t,
    write: (t) => String(t)
  },
  map: {
    read: (t) => new Map(JSON.parse(t)),
    write: (t) => JSON.stringify(Array.from(t.entries()))
  },
  set: {
    read: (t) => new Set(JSON.parse(t)),
    write: (t) => JSON.stringify(Array.from(t))
  },
  date: {
    read: (t) => new Date(t),
    write: (t) => t.toISOString()
  }
};
function zC(t, i, r, h = {}) {
  var a;
  const {
    flush: l = "pre",
    deep: f = !0,
    listenToStorageChanges: m = !0,
    writeDefaults: y = !0,
    mergeDefaults: v = !1,
    shallow: C,
    window: M = Pi,
    eventFilter: N,
    onError: I = (se) => {
      console.error(se);
    }
  } = h, D = (C ? zl : J)(i);
  if (!r)
    try {
      r = Em("getDefaultStorage", () => {
        var se;
        return (se = Pi) == null ? void 0 : se.localStorage;
      })();
    } catch (se) {
      I(se);
    }
  if (!r)
    return D;
  const B = ct(i), X = AC(B), le = (a = h.serializer) != null ? a : $C[X], { pause: Q, resume: re } = om(D, () => ve(D.value), { flush: l, deep: f, eventFilter: N });
  return M && m && Rn(M, "storage", Ce), Ce(), D;
  function ve(se) {
    try {
      if (se == null)
        r.removeItem(t);
      else {
        const Me = le.write(se), rt = r.getItem(t);
        rt !== Me && (r.setItem(t, Me), M && (M == null || M.dispatchEvent(new StorageEvent("storage", {
          key: t,
          oldValue: rt,
          newValue: Me,
          storageArea: r
        }))));
      }
    } catch (Me) {
      I(Me);
    }
  }
  function Le(se) {
    const Me = se ? se.newValue : r.getItem(t);
    if (Me == null)
      return y && B !== null && r.setItem(t, le.write(B)), B;
    if (!se && v) {
      const rt = le.read(Me);
      return wa(v) ? v(rt, B) : X === "object" && !Array.isArray(rt) ? Pd(Pd({}, B), rt) : rt;
    } else
      return typeof Me != "string" ? Me : le.read(Me);
  }
  function Ce(se) {
    if (!(se && se.storageArea !== r)) {
      if (se && se.key == null) {
        D.value = B;
        return;
      }
      if (!(se && se.key !== t)) {
        Q();
        try {
          D.value = Le(se);
        } catch (Me) {
          I(Me);
        } finally {
          se ? ks(re) : re();
        }
      }
    }
  }
}
function Vc(t, i = !1) {
  const r = J(), h = () => r.value = Boolean(t());
  return h(), As(h, i), r;
}
function BC(t, i = {}) {
  const { window: r = Pi } = i, h = Vc(() => r && "matchMedia" in r && typeof r.matchMedia == "function");
  let a;
  const l = J(!1), f = () => {
    a && ("removeEventListener" in a ? a.removeEventListener("change", m) : a.removeListener(m));
  }, m = () => {
    h.value && (f(), a = r.matchMedia(Hc(t).value), l.value = a.matches, "addEventListener" in a ? a.addEventListener("change", m) : a.addListener(m));
  };
  return Kp(m), zn(() => f()), l;
}
function UC(t) {
  return BC("(prefers-color-scheme: dark)", t);
}
var FC = Object.defineProperty, Md = Object.getOwnPropertySymbols, HC = Object.prototype.hasOwnProperty, ZC = Object.prototype.propertyIsEnumerable, Od = (t, i, r) => i in t ? FC(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, VC = (t, i) => {
  for (var r in i || (i = {}))
    HC.call(i, r) && Od(t, r, i[r]);
  if (Md)
    for (var r of Md(i))
      ZC.call(i, r) && Od(t, r, i[r]);
  return t;
};
function WC(t = {}) {
  const {
    selector: i = "html",
    attribute: r = "class",
    initialValue: h = "auto",
    window: a = Pi,
    storage: l,
    storageKey: f = "vueuse-color-scheme",
    listenToStorageChanges: m = !0,
    storageRef: y,
    emitAuto: v
  } = t, C = VC({
    auto: "",
    light: "light",
    dark: "dark"
  }, t.modes || {}), M = UC({ window: a }), N = ht(() => M.value ? "dark" : "light"), I = y || (f == null ? J(h) : zC(f, h, l, { window: a, listenToStorageChanges: m })), D = ht({
    get() {
      return I.value === "auto" && !v ? N.value : I.value;
    },
    set(Q) {
      I.value = Q;
    }
  }), B = Em("updateHTMLAttrs", (Q, re, ve) => {
    const Le = a == null ? void 0 : a.document.querySelector(Q);
    if (Le)
      if (re === "class") {
        const Ce = ve.split(/\s/g);
        Object.values(C).flatMap((se) => (se || "").split(/\s/g)).filter(Boolean).forEach((se) => {
          Ce.includes(se) ? Le.classList.add(se) : Le.classList.remove(se);
        });
      } else
        Le.setAttribute(re, ve);
  });
  function X(Q) {
    var re;
    const ve = Q === "auto" ? N.value : Q;
    B(i, r, (re = C[ve]) != null ? re : ve);
  }
  function le(Q) {
    t.onChanged ? t.onChanged(Q, X) : X(Q);
  }
  return it(D, le, { flush: "post", immediate: !0 }), v && it(N, () => le(D.value), { flush: "post" }), As(() => le(D.value)), D;
}
he({
  name: "UseColorMode",
  props: ["selector", "attribute", "modes", "onChanged", "storageKey", "storage", "emitAuto"],
  setup(t, { slots: i }) {
    const r = WC(t), h = Ue({
      mode: r
    });
    return () => {
      if (i.default)
        return i.default(h);
    };
  }
});
const jC = he({
  name: "UseDark",
  props: ["selector", "attribute", "valueDark", "valueLight", "onChanged", "storageKey", "storage"],
  setup(t, { slots: i }) {
    const r = s1(t), h = Ue({
      isDark: r,
      toggleDark: PS(r)
    });
    return () => {
      if (i.default)
        return i.default(h);
    };
  }
});
he({
  name: "UseDeviceMotion",
  setup(t, { slots: i }) {
    const r = Ue(a1());
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
he({
  name: "UseDeviceOrientation",
  setup(t, { slots: i }) {
    const r = Ue(l1());
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
he({
  name: "UseDevicePixelRatio",
  setup(t, { slots: i }) {
    const r = Ue({
      pixelRatio: u1()
    });
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
he({
  name: "UseDevicesList",
  props: ["onUpdated", "requestPermissions", "constraints"],
  setup(t, { slots: i }) {
    const r = Ue(h1(t));
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
he({
  name: "UseDocumentVisibility",
  setup(t, { slots: i }) {
    const r = Ue({
      visibility: f1()
    });
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
var GC = Object.defineProperty, qC = Object.defineProperties, YC = Object.getOwnPropertyDescriptors, xd = Object.getOwnPropertySymbols, KC = Object.prototype.hasOwnProperty, JC = Object.prototype.propertyIsEnumerable, Dd = (t, i, r) => i in t ? GC(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, XC = (t, i) => {
  for (var r in i || (i = {}))
    KC.call(i, r) && Dd(t, r, i[r]);
  if (xd)
    for (var r of xd(i))
      JC.call(i, r) && Dd(t, r, i[r]);
  return t;
}, QC = (t, i) => qC(t, YC(i));
he({
  name: "UseDraggable",
  props: [
    "storageKey",
    "storageType",
    "initialValue",
    "exact",
    "preventDefault",
    "stopPropagation",
    "pointerTypes",
    "as",
    "handle"
  ],
  setup(t, { slots: i }) {
    const r = J(), h = ht(() => {
      var f;
      return (f = t.handle) != null ? f : r.value;
    }), a = t.storageKey ? lm(t.storageKey, ct(t.initialValue) || { x: 0, y: 0 }, Ei ? t.storageType === "session" ? sessionStorage : localStorage : void 0) : t.initialValue || { x: 0, y: 0 }, l = Ue(L1(r, QC(XC({}, t), {
      handle: h,
      initialValue: a
    })));
    return () => {
      if (i.default)
        return sn(t.as || "div", { ref: r, style: `touch-action:none;${l.style}` }, i.default(l));
    };
  }
});
he({
  name: "UseElementBounding",
  props: ["box", "as"],
  setup(t, { slots: i }) {
    const r = J(), h = Ue(C1(r));
    return () => {
      if (i.default)
        return sn(t.as || "div", { ref: r }, i.default(h));
    };
  }
});
function eT(t) {
  const i = J(!1);
  return Rn(t, "mouseenter", () => i.value = !0), Rn(t, "mouseleave", () => i.value = !1), i;
}
lr.mounted + "";
he({
  name: "UseElementSize",
  props: ["width", "height", "box"],
  setup(t, { slots: i }) {
    const r = J(), h = Ue(hm(r, { width: t.width, height: t.height }, { box: t.box }));
    return () => {
      if (i.default)
        return sn(t.as || "div", { ref: r }, i.default(h));
    };
  }
});
var kd = Object.getOwnPropertySymbols, tT = Object.prototype.hasOwnProperty, nT = Object.prototype.propertyIsEnumerable, iT = (t, i) => {
  var r = {};
  for (var h in t)
    tT.call(t, h) && i.indexOf(h) < 0 && (r[h] = t[h]);
  if (t != null && kd)
    for (var h of kd(t))
      i.indexOf(h) < 0 && nT.call(t, h) && (r[h] = t[h]);
  return r;
};
function rT(t, i, r = {}) {
  const h = r, { window: a = Pi } = h, l = iT(h, ["window"]);
  let f;
  const m = Vc(() => a && "ResizeObserver" in a), y = () => {
    f && (f.disconnect(), f = void 0);
  }, v = it(() => mi(t), (M) => {
    y(), m.value && a && M && (f = new ResizeObserver(i), f.observe(M, l));
  }, { immediate: !0, flush: "post" }), C = () => {
    y(), v();
  };
  return zn(C), {
    isSupported: m,
    stop: C
  };
}
function oT(t, i = { width: 0, height: 0 }, r = {}) {
  const { box: h = "content-box" } = r, a = J(i.width), l = J(i.height);
  return rT(t, ([f]) => {
    const m = h === "border-box" ? f.borderBoxSize : h === "content-box" ? f.contentBoxSize : f.devicePixelContentBoxSize;
    m ? (a.value = m.reduce((y, { inlineSize: v }) => y + v, 0), l.value = m.reduce((y, { blockSize: v }) => y + v, 0)) : (a.value = f.contentRect.width, l.value = f.contentRect.height);
  }, r), it(() => mi(t), (f) => {
    a.value = f ? i.width : 0, l.value = f ? i.height : 0;
  }), {
    width: a,
    height: l
  };
}
lr.mounted + "";
he({
  name: "UseElementVisibility",
  props: ["as"],
  setup(t, { slots: i }) {
    const r = J(), h = Ue({
      isVisible: T1(r)
    });
    return () => {
      if (i.default)
        return sn(t.as || "div", { ref: r }, i.default(h));
    };
  }
});
function Ad(t, { window: i = Pi, scrollTarget: r } = {}) {
  const h = J(!1), a = () => {
    if (!i)
      return;
    const l = i.document, f = mi(t);
    if (!f)
      h.value = !1;
    else {
      const m = f.getBoundingClientRect();
      h.value = m.top <= (i.innerHeight || l.documentElement.clientHeight) && m.left <= (i.innerWidth || l.documentElement.clientWidth) && m.bottom >= 0 && m.right >= 0;
    }
  };
  return it(() => mi(t), () => a(), { immediate: !0, flush: "post" }), i && Rn(r || i, "scroll", a, {
    capture: !1,
    passive: !0
  }), h;
}
lr.mounted + "";
he({
  name: "UseEyeDropper",
  props: {
    sRGBHex: String
  },
  setup(t, { slots: i }) {
    const r = Ue(E1());
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
he({
  name: "UseFullscreen",
  props: ["as"],
  setup(t, { slots: i }) {
    const r = J(), h = Ue(P1(r));
    return () => {
      if (i.default)
        return sn(t.as || "div", { ref: r }, i.default(h));
    };
  }
});
he({
  name: "UseGeolocation",
  props: ["enableHighAccuracy", "maximumAge", "timeout", "navigator"],
  setup(t, { slots: i }) {
    const r = Ue(M1(t));
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
he({
  name: "UseIdle",
  props: ["timeout", "events", "listenForVisibilityChange", "initialState"],
  setup(t, { slots: i }) {
    const r = Ue(D1(t.timeout, t));
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
function sT(t, i, r) {
  const {
    immediate: h = !0,
    delay: a = 0,
    onError: l = Ti,
    onSuccess: f = Ti,
    resetOnExecute: m = !0,
    shallow: y = !0,
    throwError: v
  } = r ?? {}, C = y ? zl(i) : J(i), M = J(!1), N = J(!1), I = J(void 0);
  async function D(B = 0, ...X) {
    m && (C.value = i), I.value = void 0, M.value = !1, N.value = !0, B > 0 && await pS(B);
    const le = typeof t == "function" ? t(...X) : t;
    try {
      const Q = await le;
      C.value = Q, M.value = !0, f(Q);
    } catch (Q) {
      if (I.value = Q, l(Q), v)
        throw I;
    } finally {
      N.value = !1;
    }
    return C.value;
  }
  return h && D(a), {
    state: C,
    isReady: M,
    isLoading: N,
    error: I,
    execute: D
  };
}
var aT = Object.defineProperty, Id = Object.getOwnPropertySymbols, lT = Object.prototype.hasOwnProperty, uT = Object.prototype.propertyIsEnumerable, Nd = (t, i, r) => i in t ? aT(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, cT = (t, i) => {
  for (var r in i || (i = {}))
    lT.call(i, r) && Nd(t, r, i[r]);
  if (Id)
    for (var r of Id(i))
      uT.call(i, r) && Nd(t, r, i[r]);
  return t;
};
async function hT(t) {
  return new Promise((i, r) => {
    const h = new Image(), { src: a, srcset: l, sizes: f } = t;
    h.src = a, l && (h.srcset = l), f && (h.sizes = f), h.onload = () => i(h), h.onerror = r;
  });
}
const fT = (t, i = {}) => {
  const r = sT(() => hT(ct(t)), void 0, cT({
    resetOnExecute: !0
  }, i));
  return it(() => ct(t), () => r.execute(i.delay), { deep: !0 }), r;
};
he({
  name: "UseImage",
  props: [
    "src",
    "srcset",
    "sizes",
    "as"
  ],
  setup(t, { slots: i }) {
    const r = Ue(fT(t));
    return () => r.isLoading && i.loading ? i.loading(r) : r.error && i.error ? i.error(r.error) : i.default ? i.default(r) : sn(t.as || "img", t);
  }
});
const Rd = 1;
function Cc(t, i = {}) {
  const {
    throttle: r = 0,
    idle: h = 200,
    onStop: a = Ti,
    onScroll: l = Ti,
    offset: f = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    eventListenerOptions: m = {
      capture: !1,
      passive: !0
    },
    behavior: y = "auto"
  } = i, v = J(0), C = J(0), M = ht({
    get() {
      return v.value;
    },
    set(re) {
      I(re, void 0);
    }
  }), N = ht({
    get() {
      return C.value;
    },
    set(re) {
      I(void 0, re);
    }
  });
  function I(re, ve) {
    var Le, Ce, se;
    const Me = ct(t);
    Me && ((se = Me instanceof Document ? document.body : Me) == null || se.scrollTo({
      top: (Le = ct(ve)) != null ? Le : N.value,
      left: (Ce = ct(re)) != null ? Ce : M.value,
      behavior: ct(y)
    }));
  }
  const D = J(!1), B = Ue({
    left: !0,
    right: !1,
    top: !0,
    bottom: !1
  }), X = Ue({
    left: !1,
    right: !1,
    top: !1,
    bottom: !1
  }), le = em((re) => {
    D.value = !1, X.left = !1, X.right = !1, X.top = !1, X.bottom = !1, a(re);
  }, r + h), Q = (re) => {
    const ve = re.target === document ? re.target.documentElement : re.target, Le = ve.scrollLeft;
    X.left = Le < v.value, X.right = Le > C.value, B.left = Le <= 0 + (f.left || 0), B.right = Le + ve.clientWidth >= ve.scrollWidth - (f.right || 0) - Rd, v.value = Le;
    let Ce = ve.scrollTop;
    re.target === document && !Ce && (Ce = document.body.scrollTop), X.top = Ce < C.value, X.bottom = Ce > C.value, B.top = Ce <= 0 + (f.top || 0), B.bottom = Ce + ve.clientHeight >= ve.scrollHeight - (f.bottom || 0) - Rd, C.value = Ce, D.value = !0, le(re), l(re);
  };
  return Rn(t, "scroll", r ? yS(Q, r, !0, !1) : Q, m), {
    x: M,
    y: N,
    isScrolling: D,
    arrivedState: B,
    directions: X
  };
}
var dT = Object.defineProperty, pT = Object.defineProperties, mT = Object.getOwnPropertyDescriptors, $d = Object.getOwnPropertySymbols, _T = Object.prototype.hasOwnProperty, gT = Object.prototype.propertyIsEnumerable, zd = (t, i, r) => i in t ? dT(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, Bd = (t, i) => {
  for (var r in i || (i = {}))
    _T.call(i, r) && zd(t, r, i[r]);
  if ($d)
    for (var r of $d(i))
      gT.call(i, r) && zd(t, r, i[r]);
  return t;
}, vT = (t, i) => pT(t, mT(i));
function Ud(t, i, r = {}) {
  var h, a;
  const l = (h = r.direction) != null ? h : "bottom", f = Ue(Cc(t, vT(Bd({}, r), {
    offset: Bd({
      [l]: (a = r.distance) != null ? a : 0
    }, r.offset)
  })));
  it(() => f.arrivedState[l], async (m) => {
    var y, v;
    if (m) {
      const C = ct(t), M = {
        height: (y = C == null ? void 0 : C.scrollHeight) != null ? y : 0,
        width: (v = C == null ? void 0 : C.scrollWidth) != null ? v : 0
      };
      await i(f), r.preserveScrollPosition && C && ks(() => {
        C.scrollTo({
          top: C.scrollHeight - M.height,
          left: C.scrollWidth - M.width
        });
      });
    }
  });
}
lr.mounted + "";
function Fd(t, i, r = {}) {
  const {
    root: h,
    rootMargin: a = "0px",
    threshold: l = 0.1,
    window: f = Pi
  } = r, m = Vc(() => f && "IntersectionObserver" in f);
  let y = Ti;
  const v = m.value ? it(() => ({
    el: mi(t),
    root: mi(h)
  }), ({ el: M, root: N }) => {
    if (y(), !M)
      return;
    const I = new IntersectionObserver(i, {
      root: N,
      rootMargin: a,
      threshold: l
    });
    I.observe(M), y = () => {
      I.disconnect(), y = Ti;
    };
  }, { immediate: !0, flush: "post" }) : Ti, C = () => {
    y(), v();
  };
  return zn(C), {
    isSupported: m,
    stop: C
  };
}
lr.mounted + "";
he({
  name: "UseMouse",
  props: ["touch", "resetOnTouchEnds", "initialValue"],
  setup(t, { slots: i }) {
    const r = Ue(fm(t));
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
he({
  name: "UseMouseElement",
  props: ["handleOutside", "as"],
  setup(t, { slots: i }) {
    const r = J(), h = Ue(k1(r, t));
    return () => {
      if (i.default)
        return sn(t.as || "div", { ref: r }, i.default(h));
    };
  }
});
var yT = Object.defineProperty, LT = Object.defineProperties, wT = Object.getOwnPropertyDescriptors, Hd = Object.getOwnPropertySymbols, bT = Object.prototype.hasOwnProperty, ST = Object.prototype.propertyIsEnumerable, Zd = (t, i, r) => i in t ? yT(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, CT = (t, i) => {
  for (var r in i || (i = {}))
    bT.call(i, r) && Zd(t, r, i[r]);
  if (Hd)
    for (var r of Hd(i))
      ST.call(i, r) && Zd(t, r, i[r]);
  return t;
}, TT = (t, i) => LT(t, wT(i));
he({
  name: "UseMousePressed",
  props: ["touch", "initialValue", "as"],
  setup(t, { slots: i }) {
    const r = J(), h = Ue(A1(TT(CT({}, t), { target: r })));
    return () => {
      if (i.default)
        return sn(t.as || "div", { ref: r }, i.default(h));
    };
  }
});
he({
  name: "UseNetwork",
  setup(t, { slots: i }) {
    const r = Ue(dm());
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
var ET = Object.defineProperty, PT = Object.defineProperties, MT = Object.getOwnPropertyDescriptors, Vd = Object.getOwnPropertySymbols, OT = Object.prototype.hasOwnProperty, xT = Object.prototype.propertyIsEnumerable, Wd = (t, i, r) => i in t ? ET(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, DT = (t, i) => {
  for (var r in i || (i = {}))
    OT.call(i, r) && Wd(t, r, i[r]);
  if (Vd)
    for (var r of Vd(i))
      xT.call(i, r) && Wd(t, r, i[r]);
  return t;
}, kT = (t, i) => PT(t, MT(i));
he({
  name: "UseNow",
  props: ["interval"],
  setup(t, { slots: i }) {
    const r = Ue(pm(kT(DT({}, t), { controls: !0 })));
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
he({
  name: "UseObjectUrl",
  props: [
    "object"
  ],
  setup(t, { slots: i }) {
    const r = u0(t, "object"), h = z1(r);
    return () => {
      if (i.default && h.value)
        return i.default(h);
    };
  }
});
var AT = Object.defineProperty, IT = Object.defineProperties, NT = Object.getOwnPropertyDescriptors, jd = Object.getOwnPropertySymbols, RT = Object.prototype.hasOwnProperty, $T = Object.prototype.propertyIsEnumerable, Gd = (t, i, r) => i in t ? AT(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, zT = (t, i) => {
  for (var r in i || (i = {}))
    RT.call(i, r) && Gd(t, r, i[r]);
  if (jd)
    for (var r of jd(i))
      $T.call(i, r) && Gd(t, r, i[r]);
  return t;
}, BT = (t, i) => IT(t, NT(i));
he({
  name: "UseOffsetPagination",
  props: [
    "total",
    "page",
    "pageSize",
    "onPageChange",
    "onPageSizeChange",
    "onPageCountChange"
  ],
  emits: [
    "page-change",
    "page-size-change",
    "page-count-change"
  ],
  setup(t, { slots: i, emit: r }) {
    const h = Ue(B1(BT(zT({}, t), {
      onPageChange(...a) {
        var l;
        (l = t.onPageChange) == null || l.call(t, ...a), r("page-change", ...a);
      },
      onPageSizeChange(...a) {
        var l;
        (l = t.onPageSizeChange) == null || l.call(t, ...a), r("page-size-change", ...a);
      },
      onPageCountChange(...a) {
        var l;
        (l = t.onPageCountChange) == null || l.call(t, ...a), r("page-count-change", ...a);
      }
    })));
    return () => {
      if (i.default)
        return i.default(h);
    };
  }
});
he({
  name: "UseOnline",
  setup(t, { slots: i }) {
    const r = Ue({
      isOnline: U1()
    });
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
he({
  name: "UsePageLeave",
  setup(t, { slots: i }) {
    const r = Ue({
      isLeft: F1()
    });
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
var UT = Object.defineProperty, FT = Object.defineProperties, HT = Object.getOwnPropertyDescriptors, qd = Object.getOwnPropertySymbols, ZT = Object.prototype.hasOwnProperty, VT = Object.prototype.propertyIsEnumerable, Yd = (t, i, r) => i in t ? UT(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, WT = (t, i) => {
  for (var r in i || (i = {}))
    ZT.call(i, r) && Yd(t, r, i[r]);
  if (qd)
    for (var r of qd(i))
      VT.call(i, r) && Yd(t, r, i[r]);
  return t;
}, jT = (t, i) => FT(t, HT(i));
he({
  name: "UsePointer",
  props: [
    "pointerTypes",
    "initialValue",
    "target"
  ],
  setup(t, { slots: i }) {
    const r = J(null), h = Ue(K1(jT(WT({}, t), {
      target: t.target === "self" ? r : Pi
    })));
    return () => {
      if (i.default)
        return i.default(h, { ref: r });
    };
  }
});
he({
  name: "UsePreferredColorScheme",
  setup(t, { slots: i }) {
    const r = Ue({
      colorScheme: J1()
    });
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
he({
  name: "UsePreferredContrast",
  setup(t, { slots: i }) {
    const r = Ue({
      contrast: X1()
    });
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
he({
  name: "UsePreferredDark",
  setup(t, { slots: i }) {
    const r = Ue({
      prefersDark: Zc()
    });
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
he({
  name: "UsePreferredLanguages",
  setup(t, { slots: i }) {
    const r = Ue({
      languages: Q1()
    });
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
he({
  name: "UsePreferredReducedMotion",
  setup(t, { slots: i }) {
    const r = Ue({
      motion: eC()
    });
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
function ml(t, i, { window: r = Pi, initialValue: h = "" } = {}) {
  const a = J(h), l = ht(() => {
    var f;
    return mi(i) || ((f = r == null ? void 0 : r.document) == null ? void 0 : f.documentElement);
  });
  return it([l, () => ct(t)], ([f, m]) => {
    var y;
    if (f && r) {
      const v = (y = r.getComputedStyle(f).getPropertyValue(m)) == null ? void 0 : y.trim();
      a.value = v || h;
    }
  }, { immediate: !0 }), it(a, (f) => {
    var m;
    (m = l.value) != null && m.style && l.value.style.setProperty(ct(t), f);
  }), a;
}
const Kd = "--vueuse-safe-area-top", Jd = "--vueuse-safe-area-right", Xd = "--vueuse-safe-area-bottom", Qd = "--vueuse-safe-area-left";
function GT() {
  const t = J(""), i = J(""), r = J(""), h = J("");
  if (Ei) {
    const l = ml(Kd), f = ml(Jd), m = ml(Xd), y = ml(Qd);
    l.value = "env(safe-area-inset-top, 0px)", f.value = "env(safe-area-inset-right, 0px)", m.value = "env(safe-area-inset-bottom, 0px)", y.value = "env(safe-area-inset-left, 0px)", a(), Rn("resize", em(a));
  }
  function a() {
    t.value = _l(Kd), i.value = _l(Jd), r.value = _l(Xd), h.value = _l(Qd);
  }
  return {
    top: t,
    right: i,
    bottom: r,
    left: h,
    update: a
  };
}
function _l(t) {
  return getComputedStyle(document.documentElement).getPropertyValue(t);
}
he({
  name: "UseScreenSafeArea",
  props: {
    top: Boolean,
    right: Boolean,
    bottom: Boolean,
    left: Boolean
  },
  setup(t, { slots: i }) {
    const {
      top: r,
      right: h,
      bottom: a,
      left: l
    } = GT();
    return () => {
      if (i.default)
        return sn("div", {
          style: {
            paddingTop: t.top ? r.value : "",
            paddingRight: t.right ? h.value : "",
            paddingBottom: t.bottom ? a.value : "",
            paddingLeft: t.left ? l.value : "",
            boxSizing: "border-box",
            maxHeight: "100vh",
            maxWidth: "100vw",
            overflow: "auto"
          }
        }, i.default());
    };
  }
});
var qT = Object.defineProperty, YT = Object.defineProperties, KT = Object.getOwnPropertyDescriptors, ep = Object.getOwnPropertySymbols, JT = Object.prototype.hasOwnProperty, XT = Object.prototype.propertyIsEnumerable, tp = (t, i, r) => i in t ? qT(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, QT = (t, i) => {
  for (var r in i || (i = {}))
    JT.call(i, r) && tp(t, r, i[r]);
  if (ep)
    for (var r of ep(i))
      XT.call(i, r) && tp(t, r, i[r]);
  return t;
}, eE = (t, i) => YT(t, KT(i));
lr.mounted + "";
function tE(t) {
  const i = t || window.event;
  return i.touches.length > 1 ? !0 : (i.preventDefault && i.preventDefault(), !1);
}
function nE(t, i = !1) {
  const r = J(i);
  let h = null, a;
  it(Hc(t), (m) => {
    if (m) {
      const y = m;
      a = y.style.overflow, r.value && (y.style.overflow = "hidden");
    }
  }, {
    immediate: !0
  });
  const l = () => {
    const m = ct(t);
    !m || r.value || (Gf && (h = Rn(m, "touchmove", tE, { passive: !1 })), m.style.overflow = "hidden", r.value = !0);
  }, f = () => {
    const m = ct(t);
    !m || !r.value || (Gf && (h == null || h()), m.style.overflow = a, r.value = !1);
  };
  return zn(f), ht({
    get() {
      return r.value;
    },
    set(m) {
      m ? l() : f();
    }
  });
}
const iE = () => {
  let t = !1;
  const i = J(!1);
  return (r, h) => {
    if (i.value = h.value, t)
      return;
    t = !0;
    const a = nE(r, h.value);
    it(i, (l) => a.value = l);
  };
};
iE();
var rE = Object.defineProperty, oE = Object.defineProperties, sE = Object.getOwnPropertyDescriptors, np = Object.getOwnPropertySymbols, aE = Object.prototype.hasOwnProperty, lE = Object.prototype.propertyIsEnumerable, ip = (t, i, r) => i in t ? rE(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, uE = (t, i) => {
  for (var r in i || (i = {}))
    aE.call(i, r) && ip(t, r, i[r]);
  if (np)
    for (var r of np(i))
      lE.call(i, r) && ip(t, r, i[r]);
  return t;
}, cE = (t, i) => oE(t, sE(i));
he({
  name: "UseTimeAgo",
  props: ["time", "updateInterval", "max", "fullDateFormatter", "messages", "showSecond"],
  setup(t, { slots: i }) {
    const r = Ue(aC(() => t.time, cE(uE({}, t), { controls: !0 })));
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
var hE = Object.defineProperty, fE = Object.defineProperties, dE = Object.getOwnPropertyDescriptors, rp = Object.getOwnPropertySymbols, pE = Object.prototype.hasOwnProperty, mE = Object.prototype.propertyIsEnumerable, op = (t, i, r) => i in t ? hE(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, _E = (t, i) => {
  for (var r in i || (i = {}))
    pE.call(i, r) && op(t, r, i[r]);
  if (rp)
    for (var r of rp(i))
      mE.call(i, r) && op(t, r, i[r]);
  return t;
}, gE = (t, i) => fE(t, dE(i));
he({
  name: "UseTimestamp",
  props: ["immediate", "interval", "offset"],
  setup(t, { slots: i }) {
    const r = Ue(dC(gE(_E({}, t), { controls: !0 })));
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
var vE = Object.defineProperty, sp = Object.getOwnPropertySymbols, yE = Object.prototype.hasOwnProperty, LE = Object.prototype.propertyIsEnumerable, ap = (t, i, r) => i in t ? vE(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, lp = (t, i) => {
  for (var r in i || (i = {}))
    yE.call(i, r) && ap(t, r, i[r]);
  if (sp)
    for (var r of sp(i))
      LE.call(i, r) && ap(t, r, i[r]);
  return t;
};
he({
  name: "UseVirtualList",
  props: [
    "list",
    "options",
    "height"
  ],
  setup(t, { slots: i }) {
    const { list: r } = Bc(t), { list: h, containerProps: a, wrapperProps: l } = yC(r, t.options);
    return typeof a.style == "object" && !Array.isArray(a.style) && (a.style.height = t.height || "300px"), () => sn("div", lp({}, a), [
      sn("div", lp({}, l.value), h.value.map((f) => sn("div", { style: { overFlow: "hidden", height: f.height } }, i.default ? i.default(f) : "Please set content!")))
    ]);
  }
});
he({
  name: "UseWindowFocus",
  setup(t, { slots: i }) {
    const r = Ue({
      focused: SC()
    });
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
he({
  name: "UseWindowSize",
  props: ["initialWidth", "initialHeight"],
  setup(t, { slots: i }) {
    const r = Ue(CC(t));
    return () => {
      if (i.default)
        return i.default(r);
    };
  }
});
const wE = he({
  props: {
    visible: {
      type: Boolean
    },
    width: {
      type: String,
      default: "400px"
    }
  },
  methods: {
    hide() {
      this.$emit("visible", !1);
    }
  },
  components: {
    OnClickOutside: TC
  }
}), bE = "_component__confirm_1qlyr_1", SE = {
  component__confirm: bE
};
function CE(t, i, r, h, a, l) {
  const f = q("on-click-outside"), m = q("el-popover");
  return pe(), Ae(m, {
    "popper-class": t.$style.component,
    visible: t.visible,
    width: t.width
  }, {
    reference: Y(() => [
      ri(t.$slots, "reference")
    ]),
    default: Y(() => [
      ee(f, { onTrigger: t.hide }, {
        default: Y(() => [
          ri(t.$slots, "content"),
          Mt("div", {
            class: Ze(t.$style.component__confirm)
          }, [
            ri(t.$slots, "confirm")
          ], 2)
        ]),
        _: 3
      }, 8, ["onTrigger"])
    ]),
    _: 3
  }, 8, ["popper-class", "visible", "width"]);
}
const TE = {
  $style: SE
}, Ul = /* @__PURE__ */ Re(wE, [["render", CE], ["__cssModules", TE]]), gl = {
  left: "left",
  center: "center",
  right: "right",
  justify: "justify"
}, vl = {
  alignLeft: "align-left",
  alignCenter: "align-center",
  alignRight: "align-right",
  alignJustify: "align-justify"
}, EE = he({
  mixins: [ur],
  data() {
    return {
      visible: !1,
      AlignLeftSvg: Vf,
      dropdown: [{
        type: gl.left,
        class: vl.alignLeft,
        image: Vf
      }, {
        type: gl.center,
        class: vl.alignCenter,
        image: uS
      }, {
        type: gl.right,
        class: vl.alignRight,
        image: cS
      }, {
        type: gl.justify,
        class: vl.alignJustify,
        image: hS
      }]
    };
  },
  methods: {
    isActive(t) {
      return this.path.includes(t);
    },
    setTextAlignment(t) {
      this.path.includes(t) ? this.editor.setTextAlignment(null) : this.editor.setTextAlignment(t), this.setVisible(!1);
    },
    setVisible(t) {
      this.visible = t;
    },
    onReferenceClick() {
      this.setVisible(!0);
    }
  },
  components: {
    PopoverComponent: Ul
  }
}), PE = "_content_ydego_1", ME = {
  content: PE
};
function OE(t, i, r, h, a, l) {
  const f = q("el-image"), m = q("button-component"), y = q("icon-arrow-down"), v = q("el-icon"), C = q("popover-component");
  return pe(), Ae(C, {
    visible: t.visible,
    width: "auto",
    onVisible: t.setVisible
  }, {
    content: Y(() => [
      Mt("div", {
        class: Ze(t.$style.content)
      }, [
        (pe(!0), Tt(si, null, ar(t.dropdown, (M, N) => (pe(), Ae(m, {
          key: N,
          "is-active": t.isActive(M.class),
          onClick: (I) => t.setTextAlignment(M.type)
        }, {
          default: Y(() => [
            ee(f, {
              src: M.image
            }, null, 8, ["src"])
          ]),
          _: 2
        }, 1032, ["is-active", "onClick"]))), 128))
      ], 2)
    ]),
    reference: Y(() => [
      ee(m, { onClick: t.onReferenceClick }, {
        default: Y(() => [
          ee(f, { src: t.AlignLeftSvg }, null, 8, ["src"]),
          ee(v, { size: "12" }, {
            default: Y(() => [
              ee(y)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 8, ["visible", "onVisible"]);
}
const xE = {
  $style: ME
}, DE = /* @__PURE__ */ Re(EE, [["render", OE], ["__cssModules", xE]]), kE = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTguNTUgMzlxLTEuMDUgMC0xLjgtLjcyNVQ2IDM2LjU1cTAtMS4wNS43NS0xLjh0MS44LS43NXExIDAgMS43MjUuNzUuNzI1Ljc1LjcyNSAxLjggMCAxLS43MjUgMS43MjVROS41NSAzOSA4LjU1IDM5Wk0xNiAzOHYtM2gyNnYzWk04LjU1IDI2LjVxLTEuMDUgMC0xLjgtLjcyNVQ2IDI0cTAtMS4wNS43NS0xLjc3NS43NS0uNzI1IDEuOC0uNzI1IDEgMCAxLjcyNS43NVExMSAyMyAxMSAyNHQtLjcyNSAxLjc1cS0uNzI1Ljc1LTEuNzI1Ljc1Wm03LjQ1LTF2LTNoMjZ2M1pNOC41IDE0cS0xLjA1IDAtMS43NzUtLjcyNVE2IDEyLjU1IDYgMTEuNXEwLTEuMDUuNzI1LTEuNzc1UTcuNDUgOSA4LjUgOXExLjA1IDAgMS43NzUuNzI1UTExIDEwLjQ1IDExIDExLjVxMCAxLjA1LS43MjUgMS43NzVROS41NSAxNCA4LjUgMTRabTcuNS0xdi0zaDI2djNaIi8+PC9zdmc+", AE = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTYgNDB2LTEuN2g0LjJWMzdIOC4xdi0xLjdoMi4xVjM0SDZ2LTEuN2g1LjlWNDBabTEwLjQ1LTIuNDV2LTNINDJ2M1pNNiAyNy44NXYtMS42bDMuNzUtNC40SDZ2LTEuN2g1Ljl2MS42bC0zLjggNC40aDMuOHYxLjdabTEwLjQ1LTIuNDV2LTNINDJ2M1pNOC4xIDE1LjhWOS43SDZWOGgzLjh2Ny44Wm04LjM1LTIuNTV2LTNINDJ2M1oiLz48L3N2Zz4=", IE = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTYgNDJ2LTNoMzZ2M1ptMC0xMS4xNXYtMTMuOGw3LjA1IDYuOFpNNiA5VjZoMzZ2M1ptMTYuNjUgMjQuNzV2LTNINDJ2M1ptMC04LjI1di0zSDQydjNabTAtOC4yNXYtM0g0MnYzWiIvPjwvc3ZnPg==", NE = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTYgNDJ2LTNoMzZ2M1ptMTYuNjUtOC4yNXYtM0g0MnYzWm0tOS40LTIuOS03LjA1LTcgNy4wNS02LjhabTkuNC01LjM1di0zSDQydjNabTAtOC4yNXYtM0g0MnYzWk02IDlWNmgzNnYzWiIvPjwvc3ZnPg==", RE = he({
  mixins: [ur],
  data() {
    return {
      ListBulletedSvg: kE,
      ListNumberedSvg: AE,
      IndentIncreaseSvg: IE,
      IndentDecreaseSvg: NE
    };
  },
  computed: {
    isActiveUnorderedList() {
      return this.path.split(an.separator).includes(an.unorderedList);
    },
    isActiveOrderedList() {
      return this.path.split(an.separator).includes(an.orderedList);
    }
  },
  methods: {
    makeUnorderedList() {
      this.isActiveUnorderedList ? this.editor.removeList() : this.editor.makeUnorderedList();
    },
    makeOrderedList() {
      this.isActiveOrderedList ? this.editor.removeList() : this.editor.makeOrderedList();
    },
    increaseListLevel() {
      this.editor.increaseListLevel();
    },
    decreaseListLevel() {
      this.editor.decreaseListLevel();
    }
  }
});
function $E(t, i, r, h, a, l) {
  const f = q("el-image"), m = q("button-component");
  return pe(), Tt(si, null, [
    ee(m, {
      "is-active": t.isActiveUnorderedList,
      onClick: t.makeUnorderedList
    }, {
      default: Y(() => [
        ee(f, { src: t.ListBulletedSvg }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["is-active", "onClick"]),
    ee(m, {
      "is-active": t.isActiveOrderedList,
      onClick: t.makeOrderedList
    }, {
      default: Y(() => [
        ee(f, { src: t.ListNumberedSvg }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["is-active", "onClick"]),
    ee(m, { onClick: t.increaseListLevel }, {
      default: Y(() => [
        ee(f, { src: t.IndentIncreaseSvg }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["onClick"]),
    ee(m, { onClick: t.decreaseListLevel }, {
      default: Y(() => [
        ee(f, { src: t.IndentDecreaseSvg }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["onClick"])
  ], 64);
}
const zE = /* @__PURE__ */ Re(RE, [["render", $E]]), BE = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDQwIDQwIiB3aWR0aD0iNDAiIGhlaWdodD0iNDAiPgoJPHRpdGxlPmZvcm1hdF9jb2xvcl90ZXh0X0ZJTEwwX3dnaHQ0MDBfR1JBRDBfb3BzejQ4LXN2ZzwvdGl0bGU+Cgk8c3R5bGU+CgkJLnMwIHsgZmlsbDogIzAwMDAwMCB9IAoJPC9zdHlsZT4KCTxwYXRoIGlkPSJMYXllciIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGFzcz0iczAiIGQ9Im0wLjUgNDh2LTdoMzl2N3ptNi41LTE0bDExLTI4aDRsMTEgMjhoLTMuOGwtMi44LTcuNWgtMTIuOGwtMi44IDcuNXptNy44LTEwLjdoMTAuNGwtNS4xLTEzLjZoLTAuMnoiLz4KPC9zdmc+", UE = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDQwIDQwIiB3aWR0aD0iNDAiIGhlaWdodD0iNDAiPgoJPHRpdGxlPmZvcm1hdF9jb2xvcl9maWxsX0ZJTEwwX3dnaHQ0MDBfR1JBRDBfb3BzejQ4LXN2ZzwvdGl0bGU+Cgk8c3R5bGU+CgkJLnMwIHsgZmlsbDogIzAwMDAwMCB9IAoJPC9zdHlsZT4KCTxwYXRoIGlkPSJMYXllciIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGFzcz0iczAiIGQ9Im04LjggMi4xbDIuMS0yLjEgMTcuNCAxNy40cTEuMSAxLjEgMS4xIDIuOCAwIDEuNy0xLjEgMi44bC04LjkgOC45cS0xLjEgMS4yLTIuNyAxLjItMS41IDAtMi43LTEuMmwtOC45LTguOXEtMS4xLTEuMS0xLjEtMi44IDAtMS43IDEuMS0yLjhsOS41LTkuNHptNy45IDcuOWwtOS45IDkuOWgxOS44em0xNi45IDIzLjlxLTEuNSAwLTIuNS0xLTEtMS4xLTEtMi42IDAtMC45IDAuMy0xLjkgMC40LTEgMS4yLTIgMC4zLTAuNyAwLjktMS40IDAuNi0wLjggMS4yLTEuNCAwLjUgMC42IDEuMSAxLjQgMC41IDAuNyAxIDEuNCAwLjcgMSAxLjEgMiAwLjQgMSAwLjQgMS45IDAgMS41LTEuMSAyLjUtMSAxLjEtMi42IDEuMXptLTMzLjUgMTQuMXYtNi4xaDQwdjYuMXoiLz4KPC9zdmc+", up = "#0F3D45", FE = he({
  mixins: [ur],
  data() {
    return {
      ColorTextSvg: BE,
      ColorFillSvg: UE,
      color: null,
      textColor: up,
      highlightColor: up
    };
  },
  methods: {
    setTextColour() {
      this.editor.setTextColour(this.textColor);
    },
    setHighlightColour() {
      this.editor.setHighlightColour(this.highlightColor);
    }
  },
  watch: {
    textColor() {
      this.setTextColour();
    },
    highlightColor() {
      this.setHighlightColour();
    }
  }
}), HE = "_component_16446_1", ZE = "_picker_16446_29", VE = "_image_16446_33", WE = {
  component: HE,
  picker: ZE,
  image: VE
};
function jE(t, i, r, h, a, l) {
  const f = q("el-image"), m = q("button-component"), y = q("el-color-picker");
  return pe(), Tt("div", {
    class: Ze(t.$style.component)
  }, [
    ee(m, { onClick: t.setTextColour }, {
      default: Y(() => [
        ee(f, {
          src: t.ColorTextSvg,
          class: Ze(t.$style.image),
          style: _c({ borderBottomColor: t.textColor })
        }, null, 8, ["src", "class", "style"])
      ]),
      _: 1
    }, 8, ["onClick"]),
    ee(y, {
      modelValue: t.textColor,
      "onUpdate:modelValue": i[0] || (i[0] = (v) => t.textColor = v),
      "popper-class": t.$style.picker
    }, null, 8, ["modelValue", "popper-class"]),
    ee(m, { onClick: t.setHighlightColour }, {
      default: Y(() => [
        ee(f, {
          src: t.ColorFillSvg,
          class: Ze(t.$style.image),
          style: _c({ borderBottomColor: t.highlightColor })
        }, null, 8, ["src", "class", "style"])
      ]),
      _: 1
    }, 8, ["onClick"]),
    ee(y, {
      modelValue: t.highlightColor,
      "onUpdate:modelValue": i[1] || (i[1] = (v) => t.highlightColor = v),
      "popper-class": t.$style.picker
    }, null, 8, ["modelValue", "popper-class"])
  ], 2);
}
const GE = {
  $style: WE
}, qE = /* @__PURE__ */ Re(FE, [["render", jE], ["__cssModules", GE]]), YE = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTIyLjUgMzRIMTRxLTQuMTUgMC03LjA3NS0yLjkyNVQ0IDI0cTAtNC4xNSAyLjkyNS03LjA3NVQxNCAxNGg4LjV2M0gxNHEtMi45IDAtNC45NSAyLjA1UTcgMjEuMSA3IDI0cTAgMi45IDIuMDUgNC45NVExMS4xIDMxIDE0IDMxaDguNVptLTYuMjUtOC41di0zaDE1LjV2M1pNMjUuNSAzNHYtM0gzNHEyLjkgMCA0Ljk1LTIuMDVRNDEgMjYuOSA0MSAyNHEwLTIuOS0yLjA1LTQuOTVRMzYuOSAxNyAzNCAxN2gtOC41di0zSDM0cTQuMTUgMCA3LjA3NSAyLjkyNVQ0NCAyNHEwIDQuMTUtMi45MjUgNy4wNzVUMzQgMzRaIi8+PC9zdmc+", KE = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTM3LjUgMzMuNDUgMzUuMDUgMzFxMi41NS0uNSA0LjI1LTIuNCAxLjctMS45IDEuNy00LjQ1IDAtMi45LTIuMDUtNC45NS0yLjA1LTIuMDUtNC45NS0yLjA1aC03Ljc1di0zSDM0cTQuMTUgMCA3LjA3NSAyLjkyNVQ0NCAyNC4xNXEwIDMuMS0xLjggNS42LTEuOCAyLjUtNC43IDMuN1ptLTcuOC03LjgtMy0zaDUuMDV2M1ptMTEgMTkuNTVMMy4xNSA3LjY1IDUuMyA1LjVsMzcuNTUgMzcuNTVaTTIyLjUgMzRIMTRxLTQuMTUgMC03LjA3NS0yLjkyNVQ0IDI0cTAtMy42IDIuMjI1LTYuMzVROC40NSAxNC45IDExLjkgMTQuMmwyLjggMi44SDE0cS0yLjkgMC00Ljk1IDIuMDVRNyAyMS4xIDcgMjRxMCAyLjkgMi4wNSA0Ljk1UTExLjEgMzEgMTQgMzFoOC41Wm0tNi4yNS04LjV2LTNoMy45NWwzIDNaIi8+PC9zdmc+", cp = {
  self: "_self",
  blank: "_blank"
}, JE = he({
  mixins: [ur],
  data() {
    return {
      TARGET: cp,
      LinkSvg: YE,
      LinkOffSvg: KE,
      visible: !1,
      href: null,
      target: cp.self
    };
  },
  computed: {
    isActive() {
      return this.path.split(an.separator).includes(an.link);
    }
  },
  methods: {
    setVisible(t) {
      this.visible = t;
    },
    makeLink() {
      this.href && this.editor.makeLink(this.href, {
        target: this.target
      }), this.setVisible(!1), this.href = null;
    },
    onReferenceClick() {
      this.editor.hasFormat(an.link) ? this.editor.removeLink() : this.setVisible(!0);
    }
  },
  components: {
    PopoverComponent: Ul
  }
}), XE = /* @__PURE__ */ Mt("span", null, "OK", -1);
function QE(t, i, r, h, a, l) {
  const f = q("el-input"), m = q("el-form-item"), y = q("el-option"), v = q("el-select"), C = q("el-form"), M = q("el-button"), N = q("el-image"), I = q("button-component"), D = q("popover-component");
  return pe(), Ae(D, {
    visible: t.visible,
    width: "400px",
    onVisible: t.setVisible
  }, {
    content: Y(() => [
      ee(C, null, {
        default: Y(() => [
          ee(m, { size: "default" }, {
            default: Y(() => [
              ee(f, {
                modelValue: t.href,
                "onUpdate:modelValue": i[0] || (i[0] = (B) => t.href = B),
                placeholder: "Source",
                size: "default"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          ee(m, { size: "default" }, {
            default: Y(() => [
              ee(v, {
                modelValue: t.target,
                "onUpdate:modelValue": i[3] || (i[3] = (B) => t.target = B),
                teleported: !1,
                placeholder: "Target",
                size: "default"
              }, {
                default: Y(() => [
                  ee(y, {
                    value: t.TARGET.self,
                    label: "Current window",
                    onClick: i[1] || (i[1] = mc(() => {
                    }, ["stop"]))
                  }, null, 8, ["value"]),
                  ee(y, {
                    value: t.TARGET.blank,
                    label: "New window",
                    onClick: i[2] || (i[2] = mc(() => {
                    }, ["stop"]))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    confirm: Y(() => [
      ee(M, {
        size: "small",
        onClick: t.makeLink
      }, {
        default: Y(() => [
          XE
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    reference: Y(() => [
      ee(I, { onClick: t.onReferenceClick }, {
        default: Y(() => [
          ee(N, {
            src: t.isActive ? t.LinkOffSvg : t.LinkSvg
          }, null, 8, ["src"])
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 8, ["visible", "onVisible"]);
}
const eP = /* @__PURE__ */ Re(JE, [["render", QE]]), tP = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTkgNDJxLTEuMiAwLTIuMS0uOVE2IDQwLjIgNiAzOVY5cTAtMS4yLjktMi4xUTcuOCA2IDkgNmgzMHExLjIgMCAyLjEuOS45LjkuOSAyLjF2MzBxMCAxLjItLjkgMi4xLS45LjktMi4xLjlabTAtM2gzMFY5SDl2MzBabTIuOC00Ljg1aDI0LjQ1bC03LjM1LTkuOC02LjYgOC41NS00LjY1LTYuMzVaTTkgMzlWOXYzMFoiLz48L3N2Zz4=", nP = he({
  mixins: [ur],
  data() {
    return {
      ImageSvg: tP,
      visible: !1,
      src: null,
      alt: null,
      width: null,
      height: null
    };
  },
  methods: {
    setVisible(t) {
      this.visible = t;
    },
    insertImage() {
      this.src && this.editor.insertImage(this.src, {
        alt: this.alt,
        width: this.width,
        height: this.height
      }), this.setVisible(!1), this.src = null, this.alt = null, this.width = null, this.height = null;
    },
    onReferenceClick() {
      this.setVisible(!0);
    }
  },
  components: {
    PopoverComponent: Ul
  }
}), iP = /* @__PURE__ */ Mt("span", null, "OK", -1);
function rP(t, i, r, h, a, l) {
  const f = q("el-input"), m = q("el-form-item"), y = q("el-col"), v = q("el-row"), C = q("el-form"), M = q("el-button"), N = q("el-image"), I = q("button-component"), D = q("popover-component");
  return pe(), Ae(D, {
    visible: t.visible,
    width: "400px",
    onVisible: t.setVisible
  }, {
    content: Y(() => [
      ee(C, null, {
        default: Y(() => [
          ee(m, { size: "default" }, {
            default: Y(() => [
              ee(f, {
                modelValue: t.src,
                "onUpdate:modelValue": i[0] || (i[0] = (B) => t.src = B),
                placeholder: "Source",
                size: "default"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          ee(m, { size: "default" }, {
            default: Y(() => [
              ee(f, {
                modelValue: t.alt,
                "onUpdate:modelValue": i[1] || (i[1] = (B) => t.alt = B),
                placeholder: "Description",
                size: "default"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          ee(m, { size: "default" }, {
            default: Y(() => [
              ee(v, { gutter: 24 }, {
                default: Y(() => [
                  ee(y, { span: 12 }, {
                    default: Y(() => [
                      ee(f, {
                        modelValue: t.width,
                        "onUpdate:modelValue": i[2] || (i[2] = (B) => t.width = B),
                        size: "default",
                        placeholder: "Width"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  ee(y, { span: 12 }, {
                    default: Y(() => [
                      ee(f, {
                        modelValue: t.height,
                        "onUpdate:modelValue": i[3] || (i[3] = (B) => t.height = B),
                        size: "default",
                        placeholder: "Height"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    confirm: Y(() => [
      ee(M, {
        size: "small",
        onClick: t.insertImage
      }, {
        default: Y(() => [
          iP
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    reference: Y(() => [
      ee(I, { onClick: t.onReferenceClick }, {
        default: Y(() => [
          ee(N, { src: t.ImageSvg }, null, 8, ["src"])
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 8, ["visible", "onVisible"]);
}
const oP = /* @__PURE__ */ Re(nP, [["render", rP]]), sP = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTAgMzBWMThoMi40djQuNDVoNS40VjE4aDIuNHYxMkg3Ljh2LTUuMTVIMi40VjMwWm0xNS44IDB2LTkuNmgtMy41VjE4aDkuNHYyLjRoLTMuNVYzMFptOCAwVjE5LjdxMC0uNzUuNDc1LTEuMjI1UTI0Ljc1IDE4IDI1LjUgMThoMTBxLjc1IDAgMS4yMjUuNDc1LjQ3NS40NzUuNDc1IDEuMjI1VjMwaC0yLjR2LTkuNmgtMy4xdjcuNWgtMi40di03LjVoLTMuMVYzMFptMTYuMyAwVjE4aDIuNHY5LjZINDhWMzBaIi8+PC9zdmc+", aP = he({
  mixins: [ur],
  data() {
    return {
      HtmlSvg: sP,
      visible: !1,
      html: null
    };
  },
  methods: {
    setVisible(t) {
      this.visible = t;
    },
    setHTML() {
      this.editor.setHTML(this.html), this.setVisible(!1), this.$emit("update", this.html);
    },
    onReferenceClick() {
      this.html = this.editor.getHTML(), this.setVisible(!0);
    }
  },
  components: {
    PopoverComponent: Ul
  }
}), lP = /* @__PURE__ */ Mt("span", null, "OK", -1);
function uP(t, i, r, h, a, l) {
  const f = q("el-input"), m = q("el-form-item"), y = q("el-form"), v = q("el-button"), C = q("el-image"), M = q("button-component"), N = q("popover-component");
  return pe(), Ae(N, {
    visible: t.visible,
    width: "500px",
    onVisible: t.setVisible
  }, {
    content: Y(() => [
      ee(y, null, {
        default: Y(() => [
          ee(m, { size: "default" }, {
            default: Y(() => [
              ee(f, {
                modelValue: t.html,
                "onUpdate:modelValue": i[0] || (i[0] = (I) => t.html = I),
                autosize: { minRows: 4, maxRows: 12 },
                type: "textarea",
                placeholder: "Html",
                size: "default"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    confirm: Y(() => [
      ee(v, {
        size: "small",
        onClick: t.setHTML
      }, {
        default: Y(() => [
          lP
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    reference: Y(() => [
      ee(M, { onClick: t.onReferenceClick }, {
        default: Y(() => [
          ee(C, { src: t.HtmlSvg }, null, 8, ["src"])
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 8, ["visible", "onVisible"]);
}
const cP = /* @__PURE__ */ Re(aP, [["render", uP]]), hP = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTE0IDM4di0zaDE0LjQ1cTMuNSAwIDYuMDI1LTIuMzI1UTM3IDMwLjM1IDM3IDI2Ljl0LTIuNTI1LTUuNzc1UTMxLjk1IDE4LjggMjguNDUgMTguOEgxMy43bDUuNyA1LjctMi4xIDIuMUw4IDE3LjMgMTcuMyA4bDIuMSAyLjEtNS43IDUuN2gxNC43cTQuNzUgMCA4LjE3NSAzLjJRNDAgMjIuMiA0MCAyNi45dC0zLjQyNSA3LjlRMzMuMTUgMzggMjguNCAzOFoiLz48L3N2Zz4=", fP = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHdpZHRoPSI0OCI+PHBhdGggZD0iTTE5LjYgMzhxLTQuNzUgMC04LjE3NS0zLjJROCAzMS42IDggMjYuOXQzLjQyNS03LjlxMy40MjUtMy4yIDguMTc1LTMuMmgxNC43bC01LjctNS43TDMwLjcgOGw5LjMgOS4zLTkuMyA5LjMtMi4xLTIuMSA1LjctNS43SDE5LjU1cS0zLjUgMC02LjAyNSAyLjMyNVExMSAyMy40NSAxMSAyNi45dDIuNTI1IDUuNzc1UTE2LjA1IDM1IDE5LjU1IDM1SDM0djNaIi8+PC9zdmc+", dP = he({
  mixins: [ur],
  data() {
    return {
      UndoSvg: hP,
      RedoSvg: fP,
      canUndo: !1,
      canRedo: !1
    };
  },
  mounted() {
    this.editor.addEventListener("undoStateChange", this.undoStateChange);
  },
  unmounted() {
    this.editor.removeEventListener("undoStateChange", this.undoStateChange);
  },
  methods: {
    undoStateChange(t) {
      this.canUndo = t.canUndo, this.canRedo = t.canRedo;
    },
    onUndoClick() {
      this.editor.undo();
    },
    onRedoClick() {
      this.editor.redo();
    }
  }
});
function pP(t, i, r, h, a, l) {
  const f = q("el-image"), m = q("button-component");
  return pe(), Tt(si, null, [
    ee(m, {
      "is-disabled": !t.canUndo,
      onClick: i[0] || (i[0] = (y) => t.onUndoClick())
    }, {
      default: Y(() => [
        ee(f, { src: t.UndoSvg }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["is-disabled"]),
    ee(m, {
      "is-disabled": !t.canRedo,
      onClick: t.onRedoClick
    }, {
      default: Y(() => [
        ee(f, { src: t.RedoSvg }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["is-disabled", "onClick"])
  ], 64);
}
const mP = /* @__PURE__ */ Re(dP, [["render", pP]]), _P = {
  bold: Ge(eS),
  italic: Ge(rS),
  underline: Ge(lS),
  alignment: Ge(DE),
  list: Ge(zE),
  color: Ge(qE),
  link: Ge(eP),
  image: Ge(oP),
  html: Ge(cP),
  undoRedo: Ge(mP)
}, gP = "_component_14xye_2", vP = "_divider_14xye_11", yP = "_header_14xye_16", LP = "_editor_14xye_26", wP = "_footer_14xye_42", bP = {
  component: gP,
  divider: vP,
  header: yP,
  editor: LP,
  footer: wP
}, nc = {
  paragraph: "<p><br></p>",
  div: "<div><br></div>"
}, SP = {
  emits: ["update:model-value", "blur"],
  props: {
    modelValue: {
      type: [String, null]
    }
  },
  data() {
    return {
      toolbar: Object.values(_P),
      editor: null,
      path: an.paragraph
    };
  },
  mounted() {
    this.editor = new Fb(this.$refs.editor, {
      blockTag: an.paragraph
    }), this.$nextTick(() => {
      this.editor.setHTML(this.modelValue || nc.paragraph);
    }), this.editor.addEventListener("pathChange", this.pathChange), this.editor.addEventListener("input", this.input), this.editor.addEventListener("blur", this.blur);
  },
  unmounted() {
    this.editor.removeEventListener("pathChange", this.pathChange), this.editor.removeEventListener("input", this.input), this.editor.removeEventListener("blur", this.blur);
  },
  methods: {
    pathChange() {
      this.path = this.editor.getPath();
    },
    input() {
      let t = this.editor.getHTML();
      (t === nc.paragraph || t === nc.div) && (t = null), this.$emit("update:model-value", t);
    },
    blur() {
      this.$emit("blur");
    }
  }
};
function CP(t, i, r, h, a, l) {
  const f = q("el-divider");
  return pe(), Tt("div", {
    class: Ze(t.$style.component)
  }, [
    a.editor ? (pe(), Tt("header", {
      key: 0,
      class: Ze(t.$style.header)
    }, [
      (pe(!0), Tt(si, null, ar(a.toolbar, (m, y) => (pe(), Ae(zo(m), {
        key: y,
        editor: a.editor,
        path: a.path,
        onUpdate: l.input
      }, null, 40, ["editor", "path", "onUpdate"]))), 128))
    ], 2)) : _i("", !0),
    ee(f, {
      class: Ze(t.$style.divider)
    }, null, 8, ["class"]),
    Mt("div", {
      class: Ze(t.$style.editor),
      ref: "editor"
    }, null, 2),
    ee(f, {
      class: Ze(t.$style.divider)
    }, null, 8, ["class"]),
    Mt("footer", {
      class: Ze(t.$style.footer)
    }, [
      Mt("span", null, Ss(a.path), 1)
    ], 2)
  ], 2);
}
const TP = {
  $style: bP
}, EP = /* @__PURE__ */ Re(SP, [["render", CP], ["__cssModules", TP]]), PP = he({
  emits: ["validate-field"],
  mixins: [Bn],
  methods: {
    onUpdate() {
      this.$emit("validate-field", this.scope);
    },
    onBlur() {
      this.$emit("validate-field", this.scope);
    }
  },
  components: {
    EditorComponent: EP
  }
});
function MP(t, i, r, h, a, l) {
  const f = q("control-label-component"), m = q("editor-component"), y = q("control-error-component"), v = q("el-form-item");
  return pe(), Ae(v, {
    prop: t.scope,
    rules: t.rules
  }, $n({
    error: Y(({ error: C }) => [
      ee(y, {
        error: C[t.locale]
      }, null, 8, ["error"])
    ]),
    default: Y(() => [
      ee(m, {
        modelValue: t.model,
        "onUpdate:modelValue": [
          i[0] || (i[0] = (C) => t.model = C),
          t.onUpdate
        ],
        onBlur: t.onBlur
      }, null, 8, ["modelValue", "onBlur", "onUpdate:modelValue"])
    ]),
    _: 2
  }, [
    t.label ? {
      name: "label",
      fn: Y(() => [
        ee(f, {
          label: t.label,
          rules: t.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["prop", "rules"]);
}
const OP = /* @__PURE__ */ Re(PP, [["render", MP]]);
var Dl = {}, xP = {
  get exports() {
    return Dl;
  },
  set exports(t) {
    Dl = t;
  }
};
xP.exports = Pm;
var DP = Dl.parse = Pm, hp = Dl.stringify = Mm, fp = /[-+]?([0-9]*\.[0-9]+|[0-9]+)([eE][-+]?[0-9]+)?/, dp = new RegExp("^" + fp.source + "(\\s" + fp.source + "){1,}");
function Pm(t) {
  var i = t.split(";"), r = i.pop(), h = (i.shift() || "").split("=").pop(), a = 0;
  function l(Q) {
    var re = r.substring(a).match(Q);
    return re ? (a += re[0].length, re[0]) : null;
  }
  function f(Q) {
    return Q && h.match(/\d+/) && (Q.crs = {
      type: "name",
      properties: {
        name: "urn:ogc:def:crs:EPSG::" + h
      }
    }), Q;
  }
  function m() {
    l(/^\s*/);
  }
  function y() {
    m();
    for (var Q = 0, re = [], ve = [re], Le = re, Ce; Ce = l(/^(\()/) || l(/^(\))/) || l(/^(,)/) || l(dp); ) {
      if (Ce === "(")
        ve.push(Le), Le = [], ve[ve.length - 1].push(Le), Q++;
      else if (Ce === ")") {
        if (Le.length === 0 || (Le = ve.pop(), !Le))
          return null;
        if (Q--, Q === 0)
          break;
      } else if (Ce === ",")
        Le = [], ve[ve.length - 1].push(Le);
      else if (!Ce.split(/\s/g).some(isNaN))
        Array.prototype.push.apply(Le, Ce.split(/\s/g).map(parseFloat));
      else
        return null;
      m();
    }
    return Q !== 0 ? null : re;
  }
  function v() {
    for (var Q = [], re, ve; ve = l(dp) || l(/^(,)/); )
      ve === "," ? (Q.push(re), re = []) : ve.split(/\s/g).some(isNaN) || (re || (re = []), Array.prototype.push.apply(re, ve.split(/\s/g).map(parseFloat))), m();
    if (re)
      Q.push(re);
    else
      return null;
    return Q.length ? Q : null;
  }
  function C() {
    if (!l(/^(point(\sz)?)/i) || (m(), !l(/^(\()/)))
      return null;
    var Q = v();
    return !Q || (m(), !l(/^(\))/)) ? null : {
      type: "Point",
      coordinates: Q[0]
    };
  }
  function M() {
    if (!l(/^(multipoint)/i))
      return null;
    m();
    var Q = r.substring(r.indexOf("(") + 1, r.length - 1).replace(/\(/g, "").replace(/\)/g, "");
    r = "MULTIPOINT (" + Q + ")";
    var re = y();
    return re ? (m(), {
      type: "MultiPoint",
      coordinates: re
    }) : null;
  }
  function N() {
    if (!l(/^(multilinestring)/i))
      return null;
    m();
    var Q = y();
    return Q ? (m(), {
      type: "MultiLineString",
      coordinates: Q
    }) : null;
  }
  function I() {
    if (!l(/^(linestring(\sz)?)/i) || (m(), !l(/^(\()/)))
      return null;
    var Q = v();
    return !Q || !l(/^(\))/) ? null : {
      type: "LineString",
      coordinates: Q
    };
  }
  function D() {
    if (!l(/^(polygon(\sz)?)/i))
      return null;
    m();
    var Q = y();
    return Q ? {
      type: "Polygon",
      coordinates: Q
    } : null;
  }
  function B() {
    if (!l(/^(multipolygon)/i))
      return null;
    m();
    var Q = y();
    return Q ? {
      type: "MultiPolygon",
      coordinates: Q
    } : null;
  }
  function X() {
    var Q = [], re;
    if (!l(/^(geometrycollection)/i) || (m(), !l(/^(\()/)))
      return null;
    for (; re = le(); )
      Q.push(re), m(), l(/^(,)/), m();
    return l(/^(\))/) ? {
      type: "GeometryCollection",
      geometries: Q
    } : null;
  }
  function le() {
    return C() || I() || D() || M() || N() || B() || X();
  }
  return f(le());
}
function Mm(t) {
  t.type === "Feature" && (t = t.geometry);
  function i(f) {
    return f.join(" ");
  }
  function r(f) {
    return f.map(i).join(", ");
  }
  function h(f) {
    return f.map(r).map(l).join(", ");
  }
  function a(f) {
    return f.map(h).map(l).join(", ");
  }
  function l(f) {
    return "(" + f + ")";
  }
  switch (t.type) {
    case "Point":
      return "POINT (" + i(t.coordinates) + ")";
    case "LineString":
      return "LINESTRING (" + r(t.coordinates) + ")";
    case "Polygon":
      return "POLYGON (" + h(t.coordinates) + ")";
    case "MultiPoint":
      return "MULTIPOINT (" + r(t.coordinates) + ")";
    case "MultiPolygon":
      return "MULTIPOLYGON (" + a(t.coordinates) + ")";
    case "MultiLineString":
      return "MULTILINESTRING (" + h(t.coordinates) + ")";
    case "GeometryCollection":
      return "GEOMETRYCOLLECTION (" + t.geometries.map(Mm).join(", ") + ")";
    default:
      throw new Error("stringify requires a valid GeoJSON Feature or geometry object as input");
  }
}
(function(t, i, r) {
  function h(a, l) {
    for (; (a = a.parentElement) && !a.classList.contains(l); )
      ;
    return a;
  }
  L.drawVersion = "1.0.4", L.Draw = {}, L.drawLocal = { draw: { toolbar: { actions: { title: "Cancel drawing", text: "Cancel" }, finish: { title: "Finish drawing", text: "Finish" }, undo: { title: "Delete last point drawn", text: "Delete last point" }, buttons: { polyline: "Draw a polyline", polygon: "Draw a polygon", rectangle: "Draw a rectangle", circle: "Draw a circle", marker: "Draw a marker", circlemarker: "Draw a circlemarker" } }, handlers: { circle: { tooltip: { start: "Click and drag to draw circle." }, radius: "Radius" }, circlemarker: { tooltip: { start: "Click map to place circle marker." } }, marker: { tooltip: { start: "Click map to place marker." } }, polygon: { tooltip: { start: "Click to start drawing shape.", cont: "Click to continue drawing shape.", end: "Click first point to close this shape." } }, polyline: { error: "<strong>Error:</strong> shape edges cannot cross!", tooltip: { start: "Click to start drawing line.", cont: "Click to continue drawing line.", end: "Click last point to finish line." } }, rectangle: { tooltip: { start: "Click and drag to draw rectangle." } }, simpleshape: { tooltip: { end: "Release mouse to finish drawing." } } } }, edit: { toolbar: { actions: { save: { title: "Save changes", text: "Save" }, cancel: { title: "Cancel editing, discards all changes", text: "Cancel" }, clearAll: { title: "Clear all layers", text: "Clear All" } }, buttons: { edit: "Edit layers", editDisabled: "No layers to edit", remove: "Delete layers", removeDisabled: "No layers to delete" } }, handlers: { edit: { tooltip: { text: "Drag handles or markers to edit features.", subtext: "Click cancel to undo changes." } }, remove: { tooltip: { text: "Click on a feature to remove." } } } } }, L.Draw.Event = {}, L.Draw.Event.CREATED = "draw:created", L.Draw.Event.EDITED = "draw:edited", L.Draw.Event.DELETED = "draw:deleted", L.Draw.Event.DRAWSTART = "draw:drawstart", L.Draw.Event.DRAWSTOP = "draw:drawstop", L.Draw.Event.DRAWVERTEX = "draw:drawvertex", L.Draw.Event.EDITSTART = "draw:editstart", L.Draw.Event.EDITMOVE = "draw:editmove", L.Draw.Event.EDITRESIZE = "draw:editresize", L.Draw.Event.EDITVERTEX = "draw:editvertex", L.Draw.Event.EDITSTOP = "draw:editstop", L.Draw.Event.DELETESTART = "draw:deletestart", L.Draw.Event.DELETESTOP = "draw:deletestop", L.Draw.Event.TOOLBAROPENED = "draw:toolbaropened", L.Draw.Event.TOOLBARCLOSED = "draw:toolbarclosed", L.Draw.Event.MARKERCONTEXT = "draw:markercontext", L.Draw = L.Draw || {}, L.Draw.Feature = L.Handler.extend({ initialize: function(a, l) {
    this._map = a, this._container = a._container, this._overlayPane = a._panes.overlayPane, this._popupPane = a._panes.popupPane, l && l.shapeOptions && (l.shapeOptions = L.Util.extend({}, this.options.shapeOptions, l.shapeOptions)), L.setOptions(this, l);
    var f = L.version.split(".");
    parseInt(f[0], 10) === 1 && parseInt(f[1], 10) >= 2 ? L.Draw.Feature.include(L.Evented.prototype) : L.Draw.Feature.include(L.Mixin.Events);
  }, enable: function() {
    this._enabled || (L.Handler.prototype.enable.call(this), this.fire("enabled", { handler: this.type }), this._map.fire(L.Draw.Event.DRAWSTART, { layerType: this.type }));
  }, disable: function() {
    this._enabled && (L.Handler.prototype.disable.call(this), this._map.fire(L.Draw.Event.DRAWSTOP, { layerType: this.type }), this.fire("disabled", { handler: this.type }));
  }, addHooks: function() {
    var a = this._map;
    a && (L.DomUtil.disableTextSelection(), a.getContainer().focus(), this._tooltip = new L.Draw.Tooltip(this._map), L.DomEvent.on(this._container, "keyup", this._cancelDrawing, this));
  }, removeHooks: function() {
    this._map && (L.DomUtil.enableTextSelection(), this._tooltip.dispose(), this._tooltip = null, L.DomEvent.off(this._container, "keyup", this._cancelDrawing, this));
  }, setOptions: function(a) {
    L.setOptions(this, a);
  }, _fireCreatedEvent: function(a) {
    this._map.fire(L.Draw.Event.CREATED, { layer: a, layerType: this.type });
  }, _cancelDrawing: function(a) {
    a.keyCode === 27 && (this._map.fire("draw:canceled", { layerType: this.type }), this.disable());
  } }), L.Draw.Polyline = L.Draw.Feature.extend({ statics: { TYPE: "polyline" }, Poly: L.Polyline, options: { allowIntersection: !0, repeatMode: !1, drawError: { color: "#b00b00", timeout: 2500 }, icon: new L.DivIcon({ iconSize: new L.Point(8, 8), className: "leaflet-div-icon leaflet-editing-icon" }), touchIcon: new L.DivIcon({ iconSize: new L.Point(20, 20), className: "leaflet-div-icon leaflet-editing-icon leaflet-touch-icon" }), guidelineDistance: 20, maxGuideLineLength: 4e3, shapeOptions: { stroke: !0, color: "#3388ff", weight: 4, opacity: 0.5, fill: !1, clickable: !0 }, metric: !0, feet: !0, nautic: !1, showLength: !0, zIndexOffset: 2e3, factor: 1, maxPoints: 0 }, initialize: function(a, l) {
    L.Browser.touch && (this.options.icon = this.options.touchIcon), this.options.drawError.message = L.drawLocal.draw.handlers.polyline.error, l && l.drawError && (l.drawError = L.Util.extend({}, this.options.drawError, l.drawError)), this.type = L.Draw.Polyline.TYPE, L.Draw.Feature.prototype.initialize.call(this, a, l);
  }, addHooks: function() {
    L.Draw.Feature.prototype.addHooks.call(this), this._map && (this._markers = [], this._markerGroup = new L.LayerGroup(), this._map.addLayer(this._markerGroup), this._poly = new L.Polyline([], this.options.shapeOptions), this._tooltip.updateContent(this._getTooltipText()), this._mouseMarker || (this._mouseMarker = L.marker(this._map.getCenter(), { icon: L.divIcon({ className: "leaflet-mouse-marker", iconAnchor: [20, 20], iconSize: [40, 40] }), opacity: 0, zIndexOffset: this.options.zIndexOffset })), this._mouseMarker.on("mouseout", this._onMouseOut, this).on("mousemove", this._onMouseMove, this).on("mousedown", this._onMouseDown, this).on("mouseup", this._onMouseUp, this).addTo(this._map), this._map.on("mouseup", this._onMouseUp, this).on("mousemove", this._onMouseMove, this).on("zoomlevelschange", this._onZoomEnd, this).on("touchstart", this._onTouch, this).on("zoomend", this._onZoomEnd, this));
  }, removeHooks: function() {
    L.Draw.Feature.prototype.removeHooks.call(this), this._clearHideErrorTimeout(), this._cleanUpShape(), this._map.removeLayer(this._markerGroup), delete this._markerGroup, delete this._markers, this._map.removeLayer(this._poly), delete this._poly, this._mouseMarker.off("mousedown", this._onMouseDown, this).off("mouseout", this._onMouseOut, this).off("mouseup", this._onMouseUp, this).off("mousemove", this._onMouseMove, this), this._map.removeLayer(this._mouseMarker), delete this._mouseMarker, this._clearGuides(), this._map.off("mouseup", this._onMouseUp, this).off("mousemove", this._onMouseMove, this).off("zoomlevelschange", this._onZoomEnd, this).off("zoomend", this._onZoomEnd, this).off("touchstart", this._onTouch, this).off("click", this._onTouch, this);
  }, deleteLastVertex: function() {
    if (!(this._markers.length <= 1)) {
      var a = this._markers.pop(), l = this._poly, f = l.getLatLngs(), m = f.splice(-1, 1)[0];
      this._poly.setLatLngs(f), this._markerGroup.removeLayer(a), l.getLatLngs().length < 2 && this._map.removeLayer(l), this._vertexChanged(m, !1);
    }
  }, addVertex: function(a) {
    if (this._markers.length >= 2 && !this.options.allowIntersection && this._poly.newLatLngIntersects(a))
      return void this._showErrorTooltip();
    this._errorShown && this._hideErrorTooltip(), this._markers.push(this._createMarker(a)), this._poly.addLatLng(a), this._poly.getLatLngs().length === 2 && this._map.addLayer(this._poly), this._vertexChanged(a, !0);
  }, completeShape: function() {
    this._markers.length <= 1 || !this._shapeIsValid() || (this._fireCreatedEvent(), this.disable(), this.options.repeatMode && this.enable());
  }, _finishShape: function() {
    var a = this._poly._defaultShape ? this._poly._defaultShape() : this._poly.getLatLngs(), l = this._poly.newLatLngIntersects(a[a.length - 1]);
    if (!this.options.allowIntersection && l || !this._shapeIsValid())
      return void this._showErrorTooltip();
    this._fireCreatedEvent(), this.disable(), this.options.repeatMode && this.enable();
  }, _shapeIsValid: function() {
    return !0;
  }, _onZoomEnd: function() {
    this._markers !== null && this._updateGuide();
  }, _onMouseMove: function(a) {
    var l = this._map.mouseEventToLayerPoint(a.originalEvent), f = this._map.layerPointToLatLng(l);
    this._currentLatLng = f, this._updateTooltip(f), this._updateGuide(l), this._mouseMarker.setLatLng(f), L.DomEvent.preventDefault(a.originalEvent);
  }, _vertexChanged: function(a, l) {
    this._map.fire(L.Draw.Event.DRAWVERTEX, { layers: this._markerGroup }), this._updateFinishHandler(), this._updateRunningMeasure(a, l), this._clearGuides(), this._updateTooltip();
  }, _onMouseDown: function(a) {
    if (!this._clickHandled && !this._touchHandled && !this._disableMarkers) {
      this._onMouseMove(a), this._clickHandled = !0, this._disableNewMarkers();
      var l = a.originalEvent, f = l.clientX, m = l.clientY;
      this._startPoint.call(this, f, m);
    }
  }, _startPoint: function(a, l) {
    this._mouseDownOrigin = L.point(a, l);
  }, _onMouseUp: function(a) {
    var l = a.originalEvent, f = l.clientX, m = l.clientY;
    this._endPoint.call(this, f, m, a), this._clickHandled = null;
  }, _endPoint: function(a, l, f) {
    if (this._mouseDownOrigin) {
      var m = L.point(a, l).distanceTo(this._mouseDownOrigin), y = this._calculateFinishDistance(f.latlng);
      this.options.maxPoints > 1 && this.options.maxPoints == this._markers.length + 1 ? (this.addVertex(f.latlng), this._finishShape()) : y < 10 && L.Browser.touch ? this._finishShape() : Math.abs(m) < 9 * (t.devicePixelRatio || 1) && this.addVertex(f.latlng), this._enableNewMarkers();
    }
    this._mouseDownOrigin = null;
  }, _onTouch: function(a) {
    var l, f, m = a.originalEvent;
    !m.touches || !m.touches[0] || this._clickHandled || this._touchHandled || this._disableMarkers || (l = m.touches[0].clientX, f = m.touches[0].clientY, this._disableNewMarkers(), this._touchHandled = !0, this._startPoint.call(this, l, f), this._endPoint.call(this, l, f, a), this._touchHandled = null), this._clickHandled = null;
  }, _onMouseOut: function() {
    this._tooltip && this._tooltip._onMouseOut.call(this._tooltip);
  }, _calculateFinishDistance: function(a) {
    var l;
    if (this._markers.length > 0) {
      var f;
      if (this.type === L.Draw.Polyline.TYPE)
        f = this._markers[this._markers.length - 1];
      else {
        if (this.type !== L.Draw.Polygon.TYPE)
          return 1 / 0;
        f = this._markers[0];
      }
      var m = this._map.latLngToContainerPoint(f.getLatLng()), y = new L.Marker(a, { icon: this.options.icon, zIndexOffset: 2 * this.options.zIndexOffset }), v = this._map.latLngToContainerPoint(y.getLatLng());
      l = m.distanceTo(v);
    } else
      l = 1 / 0;
    return l;
  }, _updateFinishHandler: function() {
    var a = this._markers.length;
    a > 1 && this._markers[a - 1].on("click", this._finishShape, this), a > 2 && this._markers[a - 2].off("click", this._finishShape, this);
  }, _createMarker: function(a) {
    var l = new L.Marker(a, { icon: this.options.icon, zIndexOffset: 2 * this.options.zIndexOffset });
    return this._markerGroup.addLayer(l), l;
  }, _updateGuide: function(a) {
    var l = this._markers ? this._markers.length : 0;
    l > 0 && (a = a || this._map.latLngToLayerPoint(this._currentLatLng), this._clearGuides(), this._drawGuide(this._map.latLngToLayerPoint(this._markers[l - 1].getLatLng()), a));
  }, _updateTooltip: function(a) {
    var l = this._getTooltipText();
    a && this._tooltip.updatePosition(a), this._errorShown || this._tooltip.updateContent(l);
  }, _drawGuide: function(a, l) {
    var f, m, y, v = Math.floor(Math.sqrt(Math.pow(l.x - a.x, 2) + Math.pow(l.y - a.y, 2))), C = this.options.guidelineDistance, M = this.options.maxGuideLineLength, N = v > M ? v - M : C;
    for (this._guidesContainer || (this._guidesContainer = L.DomUtil.create("div", "leaflet-draw-guides", this._overlayPane)); N < v; N += this.options.guidelineDistance)
      f = N / v, m = { x: Math.floor(a.x * (1 - f) + f * l.x), y: Math.floor(a.y * (1 - f) + f * l.y) }, y = L.DomUtil.create("div", "leaflet-draw-guide-dash", this._guidesContainer), y.style.backgroundColor = this._errorShown ? this.options.drawError.color : this.options.shapeOptions.color, L.DomUtil.setPosition(y, m);
  }, _updateGuideColor: function(a) {
    if (this._guidesContainer)
      for (var l = 0, f = this._guidesContainer.childNodes.length; l < f; l++)
        this._guidesContainer.childNodes[l].style.backgroundColor = a;
  }, _clearGuides: function() {
    if (this._guidesContainer)
      for (; this._guidesContainer.firstChild; )
        this._guidesContainer.removeChild(this._guidesContainer.firstChild);
  }, _getTooltipText: function() {
    var a, l, f = this.options.showLength;
    return this._markers.length === 0 ? a = { text: L.drawLocal.draw.handlers.polyline.tooltip.start } : (l = f ? this._getMeasurementString() : "", a = this._markers.length === 1 ? { text: L.drawLocal.draw.handlers.polyline.tooltip.cont, subtext: l } : { text: L.drawLocal.draw.handlers.polyline.tooltip.end, subtext: l }), a;
  }, _updateRunningMeasure: function(a, l) {
    var f, m, y = this._markers.length;
    this._markers.length === 1 ? this._measurementRunningTotal = 0 : (f = y - (l ? 2 : 1), m = L.GeometryUtil.isVersion07x() ? a.distanceTo(this._markers[f].getLatLng()) * (this.options.factor || 1) : this._map.distance(a, this._markers[f].getLatLng()) * (this.options.factor || 1), this._measurementRunningTotal += m * (l ? 1 : -1));
  }, _getMeasurementString: function() {
    var a, l = this._currentLatLng, f = this._markers[this._markers.length - 1].getLatLng();
    return a = L.GeometryUtil.isVersion07x() ? f && l && l.distanceTo ? this._measurementRunningTotal + l.distanceTo(f) * (this.options.factor || 1) : this._measurementRunningTotal || 0 : f && l ? this._measurementRunningTotal + this._map.distance(l, f) * (this.options.factor || 1) : this._measurementRunningTotal || 0, L.GeometryUtil.readableDistance(a, this.options.metric, this.options.feet, this.options.nautic, this.options.precision);
  }, _showErrorTooltip: function() {
    this._errorShown = !0, this._tooltip.showAsError().updateContent({ text: this.options.drawError.message }), this._updateGuideColor(this.options.drawError.color), this._poly.setStyle({ color: this.options.drawError.color }), this._clearHideErrorTimeout(), this._hideErrorTimeout = setTimeout(L.Util.bind(this._hideErrorTooltip, this), this.options.drawError.timeout);
  }, _hideErrorTooltip: function() {
    this._errorShown = !1, this._clearHideErrorTimeout(), this._tooltip.removeError().updateContent(this._getTooltipText()), this._updateGuideColor(this.options.shapeOptions.color), this._poly.setStyle({ color: this.options.shapeOptions.color });
  }, _clearHideErrorTimeout: function() {
    this._hideErrorTimeout && (clearTimeout(this._hideErrorTimeout), this._hideErrorTimeout = null);
  }, _disableNewMarkers: function() {
    this._disableMarkers = !0;
  }, _enableNewMarkers: function() {
    setTimeout(function() {
      this._disableMarkers = !1;
    }.bind(this), 50);
  }, _cleanUpShape: function() {
    this._markers.length > 1 && this._markers[this._markers.length - 1].off("click", this._finishShape, this);
  }, _fireCreatedEvent: function() {
    var a = new this.Poly(this._poly.getLatLngs(), this.options.shapeOptions);
    L.Draw.Feature.prototype._fireCreatedEvent.call(this, a);
  } }), L.Draw.Polygon = L.Draw.Polyline.extend({ statics: { TYPE: "polygon" }, Poly: L.Polygon, options: { showArea: !1, showLength: !1, shapeOptions: { stroke: !0, color: "#3388ff", weight: 4, opacity: 0.5, fill: !0, fillColor: null, fillOpacity: 0.2, clickable: !0 }, metric: !0, feet: !0, nautic: !1, precision: {} }, initialize: function(a, l) {
    L.Draw.Polyline.prototype.initialize.call(this, a, l), this.type = L.Draw.Polygon.TYPE;
  }, _updateFinishHandler: function() {
    var a = this._markers.length;
    a === 1 && this._markers[0].on("click", this._finishShape, this), a > 2 && (this._markers[a - 1].on("dblclick", this._finishShape, this), a > 3 && this._markers[a - 2].off("dblclick", this._finishShape, this));
  }, _getTooltipText: function() {
    var a, l;
    return this._markers.length === 0 ? a = L.drawLocal.draw.handlers.polygon.tooltip.start : this._markers.length < 3 ? (a = L.drawLocal.draw.handlers.polygon.tooltip.cont, l = this._getMeasurementString()) : (a = L.drawLocal.draw.handlers.polygon.tooltip.end, l = this._getMeasurementString()), { text: a, subtext: l };
  }, _getMeasurementString: function() {
    var a = this._area, l = "";
    return a || this.options.showLength ? (this.options.showLength && (l = L.Draw.Polyline.prototype._getMeasurementString.call(this)), a && (l += "<br>" + L.GeometryUtil.readableArea(a, this.options.metric, this.options.precision)), l) : null;
  }, _shapeIsValid: function() {
    return this._markers.length >= 3;
  }, _vertexChanged: function(a, l) {
    var f;
    !this.options.allowIntersection && this.options.showArea && (f = this._poly.getLatLngs(), this._area = L.GeometryUtil.geodesicArea(f)), L.Draw.Polyline.prototype._vertexChanged.call(this, a, l);
  }, _cleanUpShape: function() {
    var a = this._markers.length;
    a > 0 && (this._markers[0].off("click", this._finishShape, this), a > 2 && this._markers[a - 1].off("dblclick", this._finishShape, this));
  } }), L.SimpleShape = {}, L.Draw.SimpleShape = L.Draw.Feature.extend({ options: { repeatMode: !1 }, initialize: function(a, l) {
    this._endLabelText = L.drawLocal.draw.handlers.simpleshape.tooltip.end, L.Draw.Feature.prototype.initialize.call(this, a, l);
  }, addHooks: function() {
    L.Draw.Feature.prototype.addHooks.call(this), this._map && (this._mapDraggable = this._map.dragging.enabled(), this._mapDraggable && this._map.dragging.disable(), this._container.style.cursor = "crosshair", this._tooltip.updateContent({ text: this._initialLabelText }), this._map.on("mousedown", this._onMouseDown, this).on("mousemove", this._onMouseMove, this).on("touchstart", this._onMouseDown, this).on("touchmove", this._onMouseMove, this), i.addEventListener("touchstart", L.DomEvent.preventDefault, { passive: !1 }));
  }, removeHooks: function() {
    L.Draw.Feature.prototype.removeHooks.call(this), this._map && (this._mapDraggable && this._map.dragging.enable(), this._container.style.cursor = "", this._map.off("mousedown", this._onMouseDown, this).off("mousemove", this._onMouseMove, this).off("touchstart", this._onMouseDown, this).off("touchmove", this._onMouseMove, this), L.DomEvent.off(i, "mouseup", this._onMouseUp, this), L.DomEvent.off(i, "touchend", this._onMouseUp, this), i.removeEventListener("touchstart", L.DomEvent.preventDefault), this._shape && (this._map.removeLayer(this._shape), delete this._shape)), this._isDrawing = !1;
  }, _getTooltipText: function() {
    return { text: this._endLabelText };
  }, _onMouseDown: function(a) {
    this._isDrawing = !0, this._startLatLng = a.latlng, L.DomEvent.on(i, "mouseup", this._onMouseUp, this).on(i, "touchend", this._onMouseUp, this).preventDefault(a.originalEvent);
  }, _onMouseMove: function(a) {
    var l = a.latlng;
    this._tooltip.updatePosition(l), this._isDrawing && (this._tooltip.updateContent(this._getTooltipText()), this._drawShape(l));
  }, _onMouseUp: function() {
    this._shape && this._fireCreatedEvent(), this.disable(), this.options.repeatMode && this.enable();
  } }), L.Draw.Rectangle = L.Draw.SimpleShape.extend({ statics: { TYPE: "rectangle" }, options: { shapeOptions: { stroke: !0, color: "#3388ff", weight: 4, opacity: 0.5, fill: !0, fillColor: null, fillOpacity: 0.2, clickable: !0 }, showArea: !0, metric: !0 }, initialize: function(a, l) {
    this.type = L.Draw.Rectangle.TYPE, this._initialLabelText = L.drawLocal.draw.handlers.rectangle.tooltip.start, L.Draw.SimpleShape.prototype.initialize.call(this, a, l);
  }, disable: function() {
    this._enabled && (this._isCurrentlyTwoClickDrawing = !1, L.Draw.SimpleShape.prototype.disable.call(this));
  }, _onMouseUp: function(a) {
    if (!this._shape && !this._isCurrentlyTwoClickDrawing)
      return void (this._isCurrentlyTwoClickDrawing = !0);
    this._isCurrentlyTwoClickDrawing && !h(a.target, "leaflet-pane") || L.Draw.SimpleShape.prototype._onMouseUp.call(this);
  }, _drawShape: function(a) {
    this._shape ? this._shape.setBounds(new L.LatLngBounds(this._startLatLng, a)) : (this._shape = new L.Rectangle(new L.LatLngBounds(this._startLatLng, a), this.options.shapeOptions), this._map.addLayer(this._shape));
  }, _fireCreatedEvent: function() {
    var a = new L.Rectangle(this._shape.getBounds(), this.options.shapeOptions);
    L.Draw.SimpleShape.prototype._fireCreatedEvent.call(this, a);
  }, _getTooltipText: function() {
    var a, l, f, m = L.Draw.SimpleShape.prototype._getTooltipText.call(this), y = this._shape, v = this.options.showArea;
    return y && (a = this._shape._defaultShape ? this._shape._defaultShape() : this._shape.getLatLngs(), l = L.GeometryUtil.geodesicArea(a), f = v ? L.GeometryUtil.readableArea(l, this.options.metric) : ""), { text: m.text, subtext: f };
  } }), L.Draw.Marker = L.Draw.Feature.extend({ statics: { TYPE: "marker" }, options: { icon: new L.Icon.Default(), repeatMode: !1, zIndexOffset: 2e3 }, initialize: function(a, l) {
    this.type = L.Draw.Marker.TYPE, this._initialLabelText = L.drawLocal.draw.handlers.marker.tooltip.start, L.Draw.Feature.prototype.initialize.call(this, a, l);
  }, addHooks: function() {
    L.Draw.Feature.prototype.addHooks.call(this), this._map && (this._tooltip.updateContent({ text: this._initialLabelText }), this._mouseMarker || (this._mouseMarker = L.marker(this._map.getCenter(), { icon: L.divIcon({ className: "leaflet-mouse-marker", iconAnchor: [20, 20], iconSize: [40, 40] }), opacity: 0, zIndexOffset: this.options.zIndexOffset })), this._mouseMarker.on("click", this._onClick, this).addTo(this._map), this._map.on("mousemove", this._onMouseMove, this), this._map.on("click", this._onTouch, this));
  }, removeHooks: function() {
    L.Draw.Feature.prototype.removeHooks.call(this), this._map && (this._map.off("click", this._onClick, this).off("click", this._onTouch, this), this._marker && (this._marker.off("click", this._onClick, this), this._map.removeLayer(this._marker), delete this._marker), this._mouseMarker.off("click", this._onClick, this), this._map.removeLayer(this._mouseMarker), delete this._mouseMarker, this._map.off("mousemove", this._onMouseMove, this));
  }, _onMouseMove: function(a) {
    var l = a.latlng;
    this._tooltip.updatePosition(l), this._mouseMarker.setLatLng(l), this._marker ? (l = this._mouseMarker.getLatLng(), this._marker.setLatLng(l)) : (this._marker = this._createMarker(l), this._marker.on("click", this._onClick, this), this._map.on("click", this._onClick, this).addLayer(this._marker));
  }, _createMarker: function(a) {
    return new L.Marker(a, { icon: this.options.icon, zIndexOffset: this.options.zIndexOffset });
  }, _onClick: function() {
    this._fireCreatedEvent(), this.disable(), this.options.repeatMode && this.enable();
  }, _onTouch: function(a) {
    this._onMouseMove(a), this._onClick();
  }, _fireCreatedEvent: function() {
    var a = new L.Marker.Touch(this._marker.getLatLng(), { icon: this.options.icon });
    L.Draw.Feature.prototype._fireCreatedEvent.call(this, a);
  } }), L.Draw.CircleMarker = L.Draw.Marker.extend({ statics: { TYPE: "circlemarker" }, options: { stroke: !0, color: "#3388ff", weight: 4, opacity: 0.5, fill: !0, fillColor: null, fillOpacity: 0.2, clickable: !0, zIndexOffset: 2e3 }, initialize: function(a, l) {
    this.type = L.Draw.CircleMarker.TYPE, this._initialLabelText = L.drawLocal.draw.handlers.circlemarker.tooltip.start, L.Draw.Feature.prototype.initialize.call(this, a, l);
  }, _fireCreatedEvent: function() {
    var a = new L.CircleMarker(this._marker.getLatLng(), this.options);
    L.Draw.Feature.prototype._fireCreatedEvent.call(this, a);
  }, _createMarker: function(a) {
    return new L.CircleMarker(a, this.options);
  } }), L.Draw.Circle = L.Draw.SimpleShape.extend({ statics: { TYPE: "circle" }, options: { shapeOptions: { stroke: !0, color: "#3388ff", weight: 4, opacity: 0.5, fill: !0, fillColor: null, fillOpacity: 0.2, clickable: !0 }, showRadius: !0, metric: !0, feet: !0, nautic: !1 }, initialize: function(a, l) {
    this.type = L.Draw.Circle.TYPE, this._initialLabelText = L.drawLocal.draw.handlers.circle.tooltip.start, L.Draw.SimpleShape.prototype.initialize.call(this, a, l);
  }, _drawShape: function(a) {
    if (L.GeometryUtil.isVersion07x())
      var l = this._startLatLng.distanceTo(a);
    else
      var l = this._map.distance(this._startLatLng, a);
    this._shape ? this._shape.setRadius(l) : (this._shape = new L.Circle(this._startLatLng, l, this.options.shapeOptions), this._map.addLayer(this._shape));
  }, _fireCreatedEvent: function() {
    var a = new L.Circle(this._startLatLng, this._shape.getRadius(), this.options.shapeOptions);
    L.Draw.SimpleShape.prototype._fireCreatedEvent.call(this, a);
  }, _onMouseMove: function(a) {
    var l, f = a.latlng, m = this.options.showRadius, y = this.options.metric;
    if (this._tooltip.updatePosition(f), this._isDrawing) {
      this._drawShape(f), l = this._shape.getRadius().toFixed(1);
      var v = "";
      m && (v = L.drawLocal.draw.handlers.circle.radius + ": " + L.GeometryUtil.readableDistance(l, y, this.options.feet, this.options.nautic)), this._tooltip.updateContent({ text: this._endLabelText, subtext: v });
    }
  } }), L.Edit = L.Edit || {}, L.Edit.Marker = L.Handler.extend({ initialize: function(a, l) {
    this._marker = a, L.setOptions(this, l);
  }, addHooks: function() {
    var a = this._marker;
    a.dragging.enable(), a.on("dragend", this._onDragEnd, a), this._toggleMarkerHighlight();
  }, removeHooks: function() {
    var a = this._marker;
    a.dragging.disable(), a.off("dragend", this._onDragEnd, a), this._toggleMarkerHighlight();
  }, _onDragEnd: function(a) {
    var l = a.target;
    l.edited = !0, this._map.fire(L.Draw.Event.EDITMOVE, { layer: l });
  }, _toggleMarkerHighlight: function() {
    var a = this._marker._icon;
    a && (a.style.display = "none", L.DomUtil.hasClass(a, "leaflet-edit-marker-selected") ? (L.DomUtil.removeClass(a, "leaflet-edit-marker-selected"), this._offsetMarker(a, -4)) : (L.DomUtil.addClass(a, "leaflet-edit-marker-selected"), this._offsetMarker(a, 4)), a.style.display = "");
  }, _offsetMarker: function(a, l) {
    var f = parseInt(a.style.marginTop, 10) - l, m = parseInt(a.style.marginLeft, 10) - l;
    a.style.marginTop = f + "px", a.style.marginLeft = m + "px";
  } }), L.Marker.addInitHook(function() {
    L.Edit.Marker && (this.editing = new L.Edit.Marker(this), this.options.editable && this.editing.enable());
  }), L.Edit = L.Edit || {}, L.Edit.Poly = L.Handler.extend({ initialize: function(a) {
    this.latlngs = [a._latlngs], a._holes && (this.latlngs = this.latlngs.concat(a._holes)), this._poly = a, this._poly.on("revert-edited", this._updateLatLngs, this);
  }, _defaultShape: function() {
    return L.Polyline._flat ? L.Polyline._flat(this._poly._latlngs) ? this._poly._latlngs : this._poly._latlngs[0] : this._poly._latlngs;
  }, _eachVertexHandler: function(a) {
    for (var l = 0; l < this._verticesHandlers.length; l++)
      a(this._verticesHandlers[l]);
  }, addHooks: function() {
    this._initHandlers(), this._eachVertexHandler(function(a) {
      a.addHooks();
    });
  }, removeHooks: function() {
    this._eachVertexHandler(function(a) {
      a.removeHooks();
    });
  }, updateMarkers: function() {
    this._eachVertexHandler(function(a) {
      a.updateMarkers();
    });
  }, _initHandlers: function() {
    this._verticesHandlers = [];
    for (var a = 0; a < this.latlngs.length; a++)
      this._verticesHandlers.push(new L.Edit.PolyVerticesEdit(this._poly, this.latlngs[a], this._poly.options.poly));
  }, _updateLatLngs: function(a) {
    this.latlngs = [a.layer._latlngs], a.layer._holes && (this.latlngs = this.latlngs.concat(a.layer._holes));
  } }), L.Edit.PolyVerticesEdit = L.Handler.extend({ options: { icon: new L.DivIcon({ iconSize: new L.Point(8, 8), className: "leaflet-div-icon leaflet-editing-icon" }), touchIcon: new L.DivIcon({ iconSize: new L.Point(20, 20), className: "leaflet-div-icon leaflet-editing-icon leaflet-touch-icon" }), drawError: { color: "#b00b00", timeout: 1e3 } }, initialize: function(a, l, f) {
    L.Browser.touch && (this.options.icon = this.options.touchIcon), this._poly = a, f && f.drawError && (f.drawError = L.Util.extend({}, this.options.drawError, f.drawError)), this._latlngs = l, L.setOptions(this, f);
  }, _defaultShape: function() {
    return L.Polyline._flat ? L.Polyline._flat(this._latlngs) ? this._latlngs : this._latlngs[0] : this._latlngs;
  }, addHooks: function() {
    var a = this._poly, l = a._path;
    a instanceof L.Polygon || (a.options.fill = !1, a.options.editing && (a.options.editing.fill = !1)), l && a.options.editing && a.options.editing.className && (a.options.original.className && a.options.original.className.split(" ").forEach(function(f) {
      L.DomUtil.removeClass(l, f);
    }), a.options.editing.className.split(" ").forEach(function(f) {
      L.DomUtil.addClass(l, f);
    })), a.setStyle(a.options.editing), this._poly._map && (this._map = this._poly._map, this._markerGroup || this._initMarkers(), this._poly._map.addLayer(this._markerGroup));
  }, removeHooks: function() {
    var a = this._poly, l = a._path;
    l && a.options.editing && a.options.editing.className && (a.options.editing.className.split(" ").forEach(function(f) {
      L.DomUtil.removeClass(l, f);
    }), a.options.original.className && a.options.original.className.split(" ").forEach(function(f) {
      L.DomUtil.addClass(l, f);
    })), a.setStyle(a.options.original), a._map && (a._map.removeLayer(this._markerGroup), delete this._markerGroup, delete this._markers);
  }, updateMarkers: function() {
    this._markerGroup.clearLayers(), this._initMarkers();
  }, _initMarkers: function() {
    this._markerGroup || (this._markerGroup = new L.LayerGroup()), this._markers = [];
    var a, l, f, m, y = this._defaultShape();
    for (a = 0, f = y.length; a < f; a++)
      m = this._createMarker(y[a], a), m.on("click", this._onMarkerClick, this), m.on("contextmenu", this._onContextMenu, this), this._markers.push(m);
    var v, C;
    for (a = 0, l = f - 1; a < f; l = a++)
      (a !== 0 || L.Polygon && this._poly instanceof L.Polygon) && (v = this._markers[l], C = this._markers[a], this._createMiddleMarker(v, C), this._updatePrevNext(v, C));
  }, _createMarker: function(a, l) {
    var f = new L.Marker.Touch(a, { draggable: !0, icon: this.options.icon });
    return f._origLatLng = a, f._index = l, f.on("dragstart", this._onMarkerDragStart, this).on("drag", this._onMarkerDrag, this).on("dragend", this._fireEdit, this).on("touchmove", this._onTouchMove, this).on("touchend", this._fireEdit, this).on("MSPointerMove", this._onTouchMove, this).on("MSPointerUp", this._fireEdit, this), this._markerGroup.addLayer(f), f;
  }, _onMarkerDragStart: function() {
    this._poly.fire("editstart");
  }, _spliceLatLngs: function() {
    var a = this._defaultShape(), l = [].splice.apply(a, arguments);
    return this._poly._convertLatLngs(a, !0), this._poly.redraw(), l;
  }, _removeMarker: function(a) {
    var l = a._index;
    this._markerGroup.removeLayer(a), this._markers.splice(l, 1), this._spliceLatLngs(l, 1), this._updateIndexes(l, -1), a.off("dragstart", this._onMarkerDragStart, this).off("drag", this._onMarkerDrag, this).off("dragend", this._fireEdit, this).off("touchmove", this._onMarkerDrag, this).off("touchend", this._fireEdit, this).off("click", this._onMarkerClick, this).off("MSPointerMove", this._onTouchMove, this).off("MSPointerUp", this._fireEdit, this);
  }, _fireEdit: function() {
    this._poly.edited = !0, this._poly.fire("edit"), this._poly._map.fire(L.Draw.Event.EDITVERTEX, { layers: this._markerGroup, poly: this._poly });
  }, _onMarkerDrag: function(a) {
    var l = a.target, f = this._poly, m = L.LatLngUtil.cloneLatLng(l._origLatLng);
    if (L.extend(l._origLatLng, l._latlng), f.options.poly) {
      var y = f._map._editTooltip;
      if (!f.options.poly.allowIntersection && f.intersects()) {
        L.extend(l._origLatLng, m), l.setLatLng(m);
        var v = f.options.color;
        f.setStyle({ color: this.options.drawError.color }), y && y.updateContent({ text: L.drawLocal.draw.handlers.polyline.error }), setTimeout(function() {
          f.setStyle({ color: v }), y && y.updateContent({ text: L.drawLocal.edit.handlers.edit.tooltip.text, subtext: L.drawLocal.edit.handlers.edit.tooltip.subtext });
        }, 1e3);
      }
    }
    l._middleLeft && l._middleLeft.setLatLng(this._getMiddleLatLng(l._prev, l)), l._middleRight && l._middleRight.setLatLng(this._getMiddleLatLng(l, l._next)), this._poly._bounds._southWest = L.latLng(1 / 0, 1 / 0), this._poly._bounds._northEast = L.latLng(-1 / 0, -1 / 0);
    var C = this._poly.getLatLngs();
    this._poly._convertLatLngs(C, !0), this._poly.redraw(), this._poly.fire("editdrag");
  }, _onMarkerClick: function(a) {
    var l = L.Polygon && this._poly instanceof L.Polygon ? 4 : 3, f = a.target;
    this._defaultShape().length < l || (this._removeMarker(f), this._updatePrevNext(f._prev, f._next), f._middleLeft && this._markerGroup.removeLayer(f._middleLeft), f._middleRight && this._markerGroup.removeLayer(f._middleRight), f._prev && f._next ? this._createMiddleMarker(f._prev, f._next) : f._prev ? f._next || (f._prev._middleRight = null) : f._next._middleLeft = null, this._fireEdit());
  }, _onContextMenu: function(a) {
    var l = a.target;
    this._poly, this._poly._map.fire(L.Draw.Event.MARKERCONTEXT, { marker: l, layers: this._markerGroup, poly: this._poly }), L.DomEvent.stopPropagation;
  }, _onTouchMove: function(a) {
    var l = this._map.mouseEventToLayerPoint(a.originalEvent.touches[0]), f = this._map.layerPointToLatLng(l), m = a.target;
    L.extend(m._origLatLng, f), m._middleLeft && m._middleLeft.setLatLng(this._getMiddleLatLng(m._prev, m)), m._middleRight && m._middleRight.setLatLng(this._getMiddleLatLng(m, m._next)), this._poly.redraw(), this.updateMarkers();
  }, _updateIndexes: function(a, l) {
    this._markerGroup.eachLayer(function(f) {
      f._index > a && (f._index += l);
    });
  }, _createMiddleMarker: function(a, l) {
    var f, m, y, v = this._getMiddleLatLng(a, l), C = this._createMarker(v);
    C.setOpacity(0.6), a._middleRight = l._middleLeft = C, m = function() {
      C.off("touchmove", m, this);
      var M = l._index;
      C._index = M, C.off("click", f, this).on("click", this._onMarkerClick, this), v.lat = C.getLatLng().lat, v.lng = C.getLatLng().lng, this._spliceLatLngs(M, 0, v), this._markers.splice(M, 0, C), C.setOpacity(1), this._updateIndexes(M, 1), l._index++, this._updatePrevNext(a, C), this._updatePrevNext(C, l), this._poly.fire("editstart");
    }, y = function() {
      C.off("dragstart", m, this), C.off("dragend", y, this), C.off("touchmove", m, this), this._createMiddleMarker(a, C), this._createMiddleMarker(C, l);
    }, f = function() {
      m.call(this), y.call(this), this._fireEdit();
    }, C.on("click", f, this).on("dragstart", m, this).on("dragend", y, this).on("touchmove", m, this), this._markerGroup.addLayer(C);
  }, _updatePrevNext: function(a, l) {
    a && (a._next = l), l && (l._prev = a);
  }, _getMiddleLatLng: function(a, l) {
    var f = this._poly._map, m = f.project(a.getLatLng()), y = f.project(l.getLatLng());
    return f.unproject(m._add(y)._divideBy(2));
  } }), L.Polyline.addInitHook(function() {
    this.editing || (L.Edit.Poly && (this.editing = new L.Edit.Poly(this), this.options.editable && this.editing.enable()), this.on("add", function() {
      this.editing && this.editing.enabled() && this.editing.addHooks();
    }), this.on("remove", function() {
      this.editing && this.editing.enabled() && this.editing.removeHooks();
    }));
  }), L.Edit = L.Edit || {}, L.Edit.SimpleShape = L.Handler.extend({ options: { moveIcon: new L.DivIcon({ iconSize: new L.Point(8, 8), className: "leaflet-div-icon leaflet-editing-icon leaflet-edit-move" }), resizeIcon: new L.DivIcon({
    iconSize: new L.Point(8, 8),
    className: "leaflet-div-icon leaflet-editing-icon leaflet-edit-resize"
  }), touchMoveIcon: new L.DivIcon({ iconSize: new L.Point(20, 20), className: "leaflet-div-icon leaflet-editing-icon leaflet-edit-move leaflet-touch-icon" }), touchResizeIcon: new L.DivIcon({ iconSize: new L.Point(20, 20), className: "leaflet-div-icon leaflet-editing-icon leaflet-edit-resize leaflet-touch-icon" }) }, initialize: function(a, l) {
    L.Browser.touch && (this.options.moveIcon = this.options.touchMoveIcon, this.options.resizeIcon = this.options.touchResizeIcon), this._shape = a, L.Util.setOptions(this, l);
  }, addHooks: function() {
    var a = this._shape;
    this._shape._map && (this._map = this._shape._map, a.setStyle(a.options.editing), a._map && (this._map = a._map, this._markerGroup || this._initMarkers(), this._map.addLayer(this._markerGroup)));
  }, removeHooks: function() {
    var a = this._shape;
    if (a.setStyle(a.options.original), a._map) {
      this._unbindMarker(this._moveMarker);
      for (var l = 0, f = this._resizeMarkers.length; l < f; l++)
        this._unbindMarker(this._resizeMarkers[l]);
      this._resizeMarkers = null, this._map.removeLayer(this._markerGroup), delete this._markerGroup;
    }
    this._map = null;
  }, updateMarkers: function() {
    this._markerGroup.clearLayers(), this._initMarkers();
  }, _initMarkers: function() {
    this._markerGroup || (this._markerGroup = new L.LayerGroup()), this._createMoveMarker(), this._createResizeMarker();
  }, _createMoveMarker: function() {
  }, _createResizeMarker: function() {
  }, _createMarker: function(a, l) {
    var f = new L.Marker.Touch(a, { draggable: !0, icon: l, zIndexOffset: 10 });
    return this._bindMarker(f), this._markerGroup.addLayer(f), f;
  }, _bindMarker: function(a) {
    a.on("dragstart", this._onMarkerDragStart, this).on("drag", this._onMarkerDrag, this).on("dragend", this._onMarkerDragEnd, this).on("touchstart", this._onTouchStart, this).on("touchmove", this._onTouchMove, this).on("MSPointerMove", this._onTouchMove, this).on("touchend", this._onTouchEnd, this).on("MSPointerUp", this._onTouchEnd, this);
  }, _unbindMarker: function(a) {
    a.off("dragstart", this._onMarkerDragStart, this).off("drag", this._onMarkerDrag, this).off("dragend", this._onMarkerDragEnd, this).off("touchstart", this._onTouchStart, this).off("touchmove", this._onTouchMove, this).off("MSPointerMove", this._onTouchMove, this).off("touchend", this._onTouchEnd, this).off("MSPointerUp", this._onTouchEnd, this);
  }, _onMarkerDragStart: function(a) {
    a.target.setOpacity(0), this._shape.fire("editstart");
  }, _fireEdit: function() {
    this._shape.edited = !0, this._shape.fire("edit");
  }, _onMarkerDrag: function(a) {
    var l = a.target, f = l.getLatLng();
    l === this._moveMarker ? this._move(f) : this._resize(f), this._shape.redraw(), this._shape.fire("editdrag");
  }, _onMarkerDragEnd: function(a) {
    a.target.setOpacity(1), this._fireEdit();
  }, _onTouchStart: function(a) {
    if (L.Edit.SimpleShape.prototype._onMarkerDragStart.call(this, a), typeof this._getCorners == "function") {
      var l = this._getCorners(), f = a.target, m = f._cornerIndex;
      f.setOpacity(0), this._oppositeCorner = l[(m + 2) % 4], this._toggleCornerMarkers(0, m);
    }
    this._shape.fire("editstart");
  }, _onTouchMove: function(a) {
    var l = this._map.mouseEventToLayerPoint(a.originalEvent.touches[0]), f = this._map.layerPointToLatLng(l);
    return a.target === this._moveMarker ? this._move(f) : this._resize(f), this._shape.redraw(), !1;
  }, _onTouchEnd: function(a) {
    a.target.setOpacity(1), this.updateMarkers(), this._fireEdit();
  }, _move: function() {
  }, _resize: function() {
  } }), L.Edit = L.Edit || {}, L.Edit.Rectangle = L.Edit.SimpleShape.extend({ _createMoveMarker: function() {
    var a = this._shape.getBounds(), l = a.getCenter();
    this._moveMarker = this._createMarker(l, this.options.moveIcon);
  }, _createResizeMarker: function() {
    var a = this._getCorners();
    this._resizeMarkers = [];
    for (var l = 0, f = a.length; l < f; l++)
      this._resizeMarkers.push(this._createMarker(a[l], this.options.resizeIcon)), this._resizeMarkers[l]._cornerIndex = l;
  }, _onMarkerDragStart: function(a) {
    L.Edit.SimpleShape.prototype._onMarkerDragStart.call(this, a);
    var l = this._getCorners(), f = a.target, m = f._cornerIndex;
    this._oppositeCorner = l[(m + 2) % 4], this._toggleCornerMarkers(0, m);
  }, _onMarkerDragEnd: function(a) {
    var l, f, m = a.target;
    m === this._moveMarker && (l = this._shape.getBounds(), f = l.getCenter(), m.setLatLng(f)), this._toggleCornerMarkers(1), this._repositionCornerMarkers(), L.Edit.SimpleShape.prototype._onMarkerDragEnd.call(this, a);
  }, _move: function(a) {
    for (var l, f = this._shape._defaultShape ? this._shape._defaultShape() : this._shape.getLatLngs(), m = this._shape.getBounds(), y = m.getCenter(), v = [], C = 0, M = f.length; C < M; C++)
      l = [f[C].lat - y.lat, f[C].lng - y.lng], v.push([a.lat + l[0], a.lng + l[1]]);
    this._shape.setLatLngs(v), this._repositionCornerMarkers(), this._map.fire(L.Draw.Event.EDITMOVE, { layer: this._shape });
  }, _resize: function(a) {
    var l;
    this._shape.setBounds(L.latLngBounds(a, this._oppositeCorner)), l = this._shape.getBounds(), this._moveMarker.setLatLng(l.getCenter()), this._map.fire(L.Draw.Event.EDITRESIZE, { layer: this._shape });
  }, _getCorners: function() {
    var a = this._shape.getBounds();
    return [a.getNorthWest(), a.getNorthEast(), a.getSouthEast(), a.getSouthWest()];
  }, _toggleCornerMarkers: function(a) {
    for (var l = 0, f = this._resizeMarkers.length; l < f; l++)
      this._resizeMarkers[l].setOpacity(a);
  }, _repositionCornerMarkers: function() {
    for (var a = this._getCorners(), l = 0, f = this._resizeMarkers.length; l < f; l++)
      this._resizeMarkers[l].setLatLng(a[l]);
  } }), L.Rectangle.addInitHook(function() {
    L.Edit.Rectangle && (this.editing = new L.Edit.Rectangle(this), this.options.editable && this.editing.enable());
  }), L.Edit = L.Edit || {}, L.Edit.CircleMarker = L.Edit.SimpleShape.extend({ _createMoveMarker: function() {
    var a = this._shape.getLatLng();
    this._moveMarker = this._createMarker(a, this.options.moveIcon);
  }, _createResizeMarker: function() {
    this._resizeMarkers = [];
  }, _move: function(a) {
    if (this._resizeMarkers.length) {
      var l = this._getResizeMarkerPoint(a);
      this._resizeMarkers[0].setLatLng(l);
    }
    this._shape.setLatLng(a), this._map.fire(L.Draw.Event.EDITMOVE, { layer: this._shape });
  } }), L.CircleMarker.addInitHook(function() {
    L.Edit.CircleMarker && (this.editing = new L.Edit.CircleMarker(this), this.options.editable && this.editing.enable()), this.on("add", function() {
      this.editing && this.editing.enabled() && this.editing.addHooks();
    }), this.on("remove", function() {
      this.editing && this.editing.enabled() && this.editing.removeHooks();
    });
  }), L.Edit = L.Edit || {}, L.Edit.Circle = L.Edit.CircleMarker.extend({ _createResizeMarker: function() {
    var a = this._shape.getLatLng(), l = this._getResizeMarkerPoint(a);
    this._resizeMarkers = [], this._resizeMarkers.push(this._createMarker(l, this.options.resizeIcon));
  }, _getResizeMarkerPoint: function(a) {
    var l = this._shape._radius * Math.cos(Math.PI / 4), f = this._map.project(a);
    return this._map.unproject([f.x + l, f.y - l]);
  }, _resize: function(a) {
    var l = this._moveMarker.getLatLng();
    L.GeometryUtil.isVersion07x() ? radius = l.distanceTo(a) : radius = this._map.distance(l, a), this._shape.setRadius(radius), this._map.editTooltip && this._map._editTooltip.updateContent({ text: L.drawLocal.edit.handlers.edit.tooltip.subtext + "<br />" + L.drawLocal.edit.handlers.edit.tooltip.text, subtext: L.drawLocal.draw.handlers.circle.radius + ": " + L.GeometryUtil.readableDistance(radius, !0, this.options.feet, this.options.nautic) }), this._shape.setRadius(radius), this._map.fire(L.Draw.Event.EDITRESIZE, { layer: this._shape });
  } }), L.Circle.addInitHook(function() {
    L.Edit.Circle && (this.editing = new L.Edit.Circle(this), this.options.editable && this.editing.enable());
  }), L.Map.mergeOptions({ touchExtend: !0 }), L.Map.TouchExtend = L.Handler.extend({ initialize: function(a) {
    this._map = a, this._container = a._container, this._pane = a._panes.overlayPane;
  }, addHooks: function() {
    L.DomEvent.on(this._container, "touchstart", this._onTouchStart, this), L.DomEvent.on(this._container, "touchend", this._onTouchEnd, this), L.DomEvent.on(this._container, "touchmove", this._onTouchMove, this), this._detectIE() ? (L.DomEvent.on(this._container, "MSPointerDown", this._onTouchStart, this), L.DomEvent.on(this._container, "MSPointerUp", this._onTouchEnd, this), L.DomEvent.on(this._container, "MSPointerMove", this._onTouchMove, this), L.DomEvent.on(this._container, "MSPointerCancel", this._onTouchCancel, this)) : (L.DomEvent.on(this._container, "touchcancel", this._onTouchCancel, this), L.DomEvent.on(this._container, "touchleave", this._onTouchLeave, this));
  }, removeHooks: function() {
    L.DomEvent.off(this._container, "touchstart", this._onTouchStart, this), L.DomEvent.off(this._container, "touchend", this._onTouchEnd, this), L.DomEvent.off(this._container, "touchmove", this._onTouchMove, this), this._detectIE() ? (L.DomEvent.off(this._container, "MSPointerDown", this._onTouchStart, this), L.DomEvent.off(this._container, "MSPointerUp", this._onTouchEnd, this), L.DomEvent.off(this._container, "MSPointerMove", this._onTouchMove, this), L.DomEvent.off(this._container, "MSPointerCancel", this._onTouchCancel, this)) : (L.DomEvent.off(this._container, "touchcancel", this._onTouchCancel, this), L.DomEvent.off(this._container, "touchleave", this._onTouchLeave, this));
  }, _touchEvent: function(a, l) {
    var f = {};
    if (a.touches !== void 0) {
      if (!a.touches.length)
        return;
      f = a.touches[0];
    } else if (a.pointerType !== "touch" || (f = a, !this._filterClick(a)))
      return;
    var m = this._map.mouseEventToContainerPoint(f), y = this._map.mouseEventToLayerPoint(f), v = this._map.layerPointToLatLng(y);
    this._map.fire(l, { latlng: v, layerPoint: y, containerPoint: m, pageX: f.pageX, pageY: f.pageY, originalEvent: a });
  }, _filterClick: function(a) {
    var l = a.timeStamp || a.originalEvent.timeStamp, f = L.DomEvent._lastClick && l - L.DomEvent._lastClick;
    return f && f > 100 && f < 500 || a.target._simulatedClick && !a._simulated ? (L.DomEvent.stop(a), !1) : (L.DomEvent._lastClick = l, !0);
  }, _onTouchStart: function(a) {
    this._map._loaded && this._touchEvent(a, "touchstart");
  }, _onTouchEnd: function(a) {
    this._map._loaded && this._touchEvent(a, "touchend");
  }, _onTouchCancel: function(a) {
    if (this._map._loaded) {
      var l = "touchcancel";
      this._detectIE() && (l = "pointercancel"), this._touchEvent(a, l);
    }
  }, _onTouchLeave: function(a) {
    this._map._loaded && this._touchEvent(a, "touchleave");
  }, _onTouchMove: function(a) {
    this._map._loaded && this._touchEvent(a, "touchmove");
  }, _detectIE: function() {
    var a = t.navigator.userAgent, l = a.indexOf("MSIE ");
    if (l > 0)
      return parseInt(a.substring(l + 5, a.indexOf(".", l)), 10);
    if (a.indexOf("Trident/") > 0) {
      var f = a.indexOf("rv:");
      return parseInt(a.substring(f + 3, a.indexOf(".", f)), 10);
    }
    var m = a.indexOf("Edge/");
    return m > 0 && parseInt(a.substring(m + 5, a.indexOf(".", m)), 10);
  } }), L.Map.addInitHook("addHandler", "touchExtend", L.Map.TouchExtend), L.Marker.Touch = L.Marker.extend({ _initInteraction: function() {
    return this.addInteractiveTarget ? L.Marker.prototype._initInteraction.apply(this) : this._initInteractionLegacy();
  }, _initInteractionLegacy: function() {
    if (this.options.clickable) {
      var a = this._icon, l = ["dblclick", "mousedown", "mouseover", "mouseout", "contextmenu", "touchstart", "touchend", "touchmove"];
      this._detectIE ? l.concat(["MSPointerDown", "MSPointerUp", "MSPointerMove", "MSPointerCancel"]) : l.concat(["touchcancel"]), L.DomUtil.addClass(a, "leaflet-clickable"), L.DomEvent.on(a, "click", this._onMouseClick, this), L.DomEvent.on(a, "keypress", this._onKeyPress, this);
      for (var f = 0; f < l.length; f++)
        L.DomEvent.on(a, l[f], this._fireMouseEvent, this);
      L.Handler.MarkerDrag && (this.dragging = new L.Handler.MarkerDrag(this), this.options.draggable && this.dragging.enable());
    }
  }, _detectIE: function() {
    var a = t.navigator.userAgent, l = a.indexOf("MSIE ");
    if (l > 0)
      return parseInt(a.substring(l + 5, a.indexOf(".", l)), 10);
    if (a.indexOf("Trident/") > 0) {
      var f = a.indexOf("rv:");
      return parseInt(a.substring(f + 3, a.indexOf(".", f)), 10);
    }
    var m = a.indexOf("Edge/");
    return m > 0 && parseInt(a.substring(m + 5, a.indexOf(".", m)), 10);
  } }), L.LatLngUtil = { cloneLatLngs: function(a) {
    for (var l = [], f = 0, m = a.length; f < m; f++)
      Array.isArray(a[f]) ? l.push(L.LatLngUtil.cloneLatLngs(a[f])) : l.push(this.cloneLatLng(a[f]));
    return l;
  }, cloneLatLng: function(a) {
    return L.latLng(a.lat, a.lng);
  } }, function() {
    var a = { km: 2, ha: 2, m: 0, mi: 2, ac: 2, yd: 0, ft: 0, nm: 2 };
    L.GeometryUtil = L.extend(L.GeometryUtil || {}, { geodesicArea: function(l) {
      var f, m, y = l.length, v = 0, C = Math.PI / 180;
      if (y > 2) {
        for (var M = 0; M < y; M++)
          f = l[M], m = l[(M + 1) % y], v += (m.lng - f.lng) * C * (2 + Math.sin(f.lat * C) + Math.sin(m.lat * C));
        v = 6378137 * v * 6378137 / 2;
      }
      return Math.abs(v);
    }, formattedNumber: function(l, f) {
      var m = parseFloat(l).toFixed(f), y = L.drawLocal.format && L.drawLocal.format.numeric, v = y && y.delimiters, C = v && v.thousands, M = v && v.decimal;
      if (C || M) {
        var N = m.split(".");
        m = C ? N[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + C) : N[0], M = M || ".", N.length > 1 && (m = m + M + N[1]);
      }
      return m;
    }, readableArea: function(l, f, C) {
      var y, v, C = L.Util.extend({}, a, C);
      return f ? (v = ["ha", "m"], type = typeof f, type === "string" ? v = [f] : type !== "boolean" && (v = f), y = l >= 1e6 && v.indexOf("km") !== -1 ? L.GeometryUtil.formattedNumber(1e-6 * l, C.km) + " km²" : l >= 1e4 && v.indexOf("ha") !== -1 ? L.GeometryUtil.formattedNumber(1e-4 * l, C.ha) + " ha" : L.GeometryUtil.formattedNumber(l, C.m) + " m²") : (l /= 0.836127, y = l >= 3097600 ? L.GeometryUtil.formattedNumber(l / 3097600, C.mi) + " mi²" : l >= 4840 ? L.GeometryUtil.formattedNumber(l / 4840, C.ac) + " acres" : L.GeometryUtil.formattedNumber(l, C.yd) + " yd²"), y;
    }, readableDistance: function(l, f, m, y, M) {
      var C, M = L.Util.extend({}, a, M);
      switch (f ? typeof f == "string" ? f : "metric" : m ? "feet" : y ? "nauticalMile" : "yards") {
        case "metric":
          C = l > 1e3 ? L.GeometryUtil.formattedNumber(l / 1e3, M.km) + " km" : L.GeometryUtil.formattedNumber(l, M.m) + " m";
          break;
        case "feet":
          l *= 3.28083, C = L.GeometryUtil.formattedNumber(l, M.ft) + " ft";
          break;
        case "nauticalMile":
          l *= 0.53996, C = L.GeometryUtil.formattedNumber(l / 1e3, M.nm) + " nm";
          break;
        case "yards":
        default:
          l *= 1.09361, C = l > 1760 ? L.GeometryUtil.formattedNumber(l / 1760, M.mi) + " miles" : L.GeometryUtil.formattedNumber(l, M.yd) + " yd";
      }
      return C;
    }, isVersion07x: function() {
      var l = L.version.split(".");
      return parseInt(l[0], 10) === 0 && parseInt(l[1], 10) === 7;
    } });
  }(), L.Util.extend(L.LineUtil, { segmentsIntersect: function(a, l, f, m) {
    return this._checkCounterclockwise(a, f, m) !== this._checkCounterclockwise(l, f, m) && this._checkCounterclockwise(a, l, f) !== this._checkCounterclockwise(a, l, m);
  }, _checkCounterclockwise: function(a, l, f) {
    return (f.y - a.y) * (l.x - a.x) > (l.y - a.y) * (f.x - a.x);
  } }), L.Polyline.include({ intersects: function() {
    var a, l, f, m = this._getProjectedPoints(), y = m ? m.length : 0;
    if (this._tooFewPointsForIntersection())
      return !1;
    for (a = y - 1; a >= 3; a--)
      if (l = m[a - 1], f = m[a], this._lineSegmentsIntersectsRange(l, f, a - 2))
        return !0;
    return !1;
  }, newLatLngIntersects: function(a, l) {
    return !!this._map && this.newPointIntersects(this._map.latLngToLayerPoint(a), l);
  }, newPointIntersects: function(a, l) {
    var f = this._getProjectedPoints(), m = f ? f.length : 0, y = f ? f[m - 1] : null, v = m - 2;
    return !this._tooFewPointsForIntersection(1) && this._lineSegmentsIntersectsRange(y, a, v, l ? 1 : 0);
  }, _tooFewPointsForIntersection: function(a) {
    var l = this._getProjectedPoints(), f = l ? l.length : 0;
    return f += a || 0, !l || f <= 3;
  }, _lineSegmentsIntersectsRange: function(a, l, f, m) {
    var y, v, C = this._getProjectedPoints();
    m = m || 0;
    for (var M = f; M > m; M--)
      if (y = C[M - 1], v = C[M], L.LineUtil.segmentsIntersect(a, l, y, v))
        return !0;
    return !1;
  }, _getProjectedPoints: function() {
    if (!this._defaultShape)
      return this._originalPoints;
    for (var a = [], l = this._defaultShape(), f = 0; f < l.length; f++)
      a.push(this._map.latLngToLayerPoint(l[f]));
    return a;
  } }), L.Polygon.include({ intersects: function() {
    var a, l, f, m, y = this._getProjectedPoints();
    return !this._tooFewPointsForIntersection() && (!!L.Polyline.prototype.intersects.call(this) || (a = y.length, l = y[0], f = y[a - 1], m = a - 2, this._lineSegmentsIntersectsRange(f, l, m, 1)));
  } }), L.Control.Draw = L.Control.extend({ options: { position: "topleft", draw: {}, edit: !1 }, initialize: function(a) {
    if (L.version < "0.7")
      throw new Error("Leaflet.draw 0.2.3+ requires Leaflet 0.7.0+. Download latest from https://github.com/Leaflet/Leaflet/");
    L.Control.prototype.initialize.call(this, a);
    var l;
    this._toolbars = {}, L.DrawToolbar && this.options.draw && (l = new L.DrawToolbar(this.options.draw), this._toolbars[L.DrawToolbar.TYPE] = l, this._toolbars[L.DrawToolbar.TYPE].on("enable", this._toolbarEnabled, this)), L.EditToolbar && this.options.edit && (l = new L.EditToolbar(this.options.edit), this._toolbars[L.EditToolbar.TYPE] = l, this._toolbars[L.EditToolbar.TYPE].on("enable", this._toolbarEnabled, this)), L.toolbar = this;
  }, onAdd: function(a) {
    var l, f = L.DomUtil.create("div", "leaflet-draw"), m = !1;
    for (var y in this._toolbars)
      this._toolbars.hasOwnProperty(y) && (l = this._toolbars[y].addToolbar(a)) && (m || (L.DomUtil.hasClass(l, "leaflet-draw-toolbar-top") || L.DomUtil.addClass(l.childNodes[0], "leaflet-draw-toolbar-top"), m = !0), f.appendChild(l));
    return f;
  }, onRemove: function() {
    for (var a in this._toolbars)
      this._toolbars.hasOwnProperty(a) && this._toolbars[a].removeToolbar();
  }, setDrawingOptions: function(a) {
    for (var l in this._toolbars)
      this._toolbars[l] instanceof L.DrawToolbar && this._toolbars[l].setOptions(a);
  }, _toolbarEnabled: function(a) {
    var l = a.target;
    for (var f in this._toolbars)
      this._toolbars[f] !== l && this._toolbars[f].disable();
  } }), L.Map.mergeOptions({ drawControlTooltips: !0, drawControl: !1 }), L.Map.addInitHook(function() {
    this.options.drawControl && (this.drawControl = new L.Control.Draw(), this.addControl(this.drawControl));
  }), L.Toolbar = L.Class.extend({ initialize: function(a) {
    L.setOptions(this, a), this._modes = {}, this._actionButtons = [], this._activeMode = null;
    var l = L.version.split(".");
    parseInt(l[0], 10) === 1 && parseInt(l[1], 10) >= 2 ? L.Toolbar.include(L.Evented.prototype) : L.Toolbar.include(L.Mixin.Events);
  }, enabled: function() {
    return this._activeMode !== null;
  }, disable: function() {
    this.enabled() && this._activeMode.handler.disable();
  }, addToolbar: function(a) {
    var l, f = L.DomUtil.create("div", "leaflet-draw-section"), m = 0, y = this._toolbarClass || "", v = this.getModeHandlers(a);
    for (this._toolbarContainer = L.DomUtil.create("div", "leaflet-draw-toolbar leaflet-bar"), this._map = a, l = 0; l < v.length; l++)
      v[l].enabled && this._initModeHandler(v[l].handler, this._toolbarContainer, m++, y, v[l].title);
    if (m)
      return this._lastButtonIndex = --m, this._actionsContainer = L.DomUtil.create("ul", "leaflet-draw-actions"), f.appendChild(this._toolbarContainer), f.appendChild(this._actionsContainer), f;
  }, removeToolbar: function() {
    for (var a in this._modes)
      this._modes.hasOwnProperty(a) && (this._disposeButton(this._modes[a].button, this._modes[a].handler.enable, this._modes[a].handler), this._modes[a].handler.disable(), this._modes[a].handler.off("enabled", this._handlerActivated, this).off("disabled", this._handlerDeactivated, this));
    this._modes = {};
    for (var l = 0, f = this._actionButtons.length; l < f; l++)
      this._disposeButton(this._actionButtons[l].button, this._actionButtons[l].callback, this);
    this._actionButtons = [], this._actionsContainer = null;
  }, _initModeHandler: function(a, l, f, m, y) {
    var v = a.type;
    this._modes[v] = {}, this._modes[v].handler = a, this._modes[v].button = this._createButton({ type: v, title: y, className: m + "-" + v, container: l, callback: this._modes[v].handler.enable, context: this._modes[v].handler }), this._modes[v].buttonIndex = f, this._modes[v].handler.on("enabled", this._handlerActivated, this).on("disabled", this._handlerDeactivated, this);
  }, _detectIOS: function() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !t.MSStream;
  }, _createButton: function(a) {
    var l = L.DomUtil.create("a", a.className || "", a.container), f = L.DomUtil.create("span", "sr-only", a.container);
    l.href = "#", l.appendChild(f), a.title && (l.title = a.title, f.innerHTML = a.title), a.text && (l.innerHTML = a.text, f.innerHTML = a.text);
    var m = this._detectIOS() ? "touchstart" : "click";
    return L.DomEvent.on(l, "click", L.DomEvent.stopPropagation).on(l, "mousedown", L.DomEvent.stopPropagation).on(l, "dblclick", L.DomEvent.stopPropagation).on(l, "touchstart", L.DomEvent.stopPropagation).on(l, "click", L.DomEvent.preventDefault).on(l, m, a.callback, a.context), l;
  }, _disposeButton: function(a, l) {
    var f = this._detectIOS() ? "touchstart" : "click";
    L.DomEvent.off(a, "click", L.DomEvent.stopPropagation).off(a, "mousedown", L.DomEvent.stopPropagation).off(a, "dblclick", L.DomEvent.stopPropagation).off(a, "touchstart", L.DomEvent.stopPropagation).off(a, "click", L.DomEvent.preventDefault).off(a, f, l);
  }, _handlerActivated: function(a) {
    this.disable(), this._activeMode = this._modes[a.handler], L.DomUtil.addClass(this._activeMode.button, "leaflet-draw-toolbar-button-enabled"), this._showActionsToolbar(), this.fire("enable");
  }, _handlerDeactivated: function() {
    this._hideActionsToolbar(), L.DomUtil.removeClass(this._activeMode.button, "leaflet-draw-toolbar-button-enabled"), this._activeMode = null, this.fire("disable");
  }, _createActions: function(a) {
    var l, f, m, y, v = this._actionsContainer, C = this.getActions(a), M = C.length;
    for (f = 0, m = this._actionButtons.length; f < m; f++)
      this._disposeButton(this._actionButtons[f].button, this._actionButtons[f].callback);
    for (this._actionButtons = []; v.firstChild; )
      v.removeChild(v.firstChild);
    for (var N = 0; N < M; N++)
      "enabled" in C[N] && !C[N].enabled || (l = L.DomUtil.create("li", "", v), y = this._createButton({ title: C[N].title, text: C[N].text, container: l, callback: C[N].callback, context: C[N].context }), this._actionButtons.push({ button: y, callback: C[N].callback }));
  }, _showActionsToolbar: function() {
    var a = this._activeMode.buttonIndex, l = this._lastButtonIndex, f = this._activeMode.button.offsetTop - 1;
    this._createActions(this._activeMode.handler), this._actionsContainer.style.top = f + "px", a === 0 && (L.DomUtil.addClass(this._toolbarContainer, "leaflet-draw-toolbar-notop"), L.DomUtil.addClass(this._actionsContainer, "leaflet-draw-actions-top")), a === l && (L.DomUtil.addClass(this._toolbarContainer, "leaflet-draw-toolbar-nobottom"), L.DomUtil.addClass(this._actionsContainer, "leaflet-draw-actions-bottom")), this._actionsContainer.style.display = "block", this._map.fire(L.Draw.Event.TOOLBAROPENED);
  }, _hideActionsToolbar: function() {
    this._actionsContainer.style.display = "none", L.DomUtil.removeClass(this._toolbarContainer, "leaflet-draw-toolbar-notop"), L.DomUtil.removeClass(this._toolbarContainer, "leaflet-draw-toolbar-nobottom"), L.DomUtil.removeClass(this._actionsContainer, "leaflet-draw-actions-top"), L.DomUtil.removeClass(this._actionsContainer, "leaflet-draw-actions-bottom"), this._map.fire(L.Draw.Event.TOOLBARCLOSED);
  } }), L.Draw = L.Draw || {}, L.Draw.Tooltip = L.Class.extend({ initialize: function(a) {
    this._map = a, this._popupPane = a._panes.popupPane, this._visible = !1, this._container = a.options.drawControlTooltips ? L.DomUtil.create("div", "leaflet-draw-tooltip", this._popupPane) : null, this._singleLineLabel = !1, this._map.on("mouseout", this._onMouseOut, this);
  }, dispose: function() {
    this._map.off("mouseout", this._onMouseOut, this), this._container && (this._popupPane.removeChild(this._container), this._container = null);
  }, updateContent: function(a) {
    return this._container ? (a.subtext = a.subtext || "", a.subtext.length !== 0 || this._singleLineLabel ? a.subtext.length > 0 && this._singleLineLabel && (L.DomUtil.removeClass(this._container, "leaflet-draw-tooltip-single"), this._singleLineLabel = !1) : (L.DomUtil.addClass(this._container, "leaflet-draw-tooltip-single"), this._singleLineLabel = !0), this._container.innerHTML = (a.subtext.length > 0 ? '<span class="leaflet-draw-tooltip-subtext">' + a.subtext + "</span><br />" : "") + "<span>" + a.text + "</span>", a.text || a.subtext ? (this._visible = !0, this._container.style.visibility = "inherit") : (this._visible = !1, this._container.style.visibility = "hidden"), this) : this;
  }, updatePosition: function(a) {
    var l = this._map.latLngToLayerPoint(a), f = this._container;
    return this._container && (this._visible && (f.style.visibility = "inherit"), L.DomUtil.setPosition(f, l)), this;
  }, showAsError: function() {
    return this._container && L.DomUtil.addClass(this._container, "leaflet-error-draw-tooltip"), this;
  }, removeError: function() {
    return this._container && L.DomUtil.removeClass(this._container, "leaflet-error-draw-tooltip"), this;
  }, _onMouseOut: function() {
    this._container && (this._container.style.visibility = "hidden");
  } }), L.DrawToolbar = L.Toolbar.extend({ statics: { TYPE: "draw" }, options: { polyline: {}, polygon: {}, rectangle: {}, circle: {}, marker: {}, circlemarker: {} }, initialize: function(a) {
    for (var l in this.options)
      this.options.hasOwnProperty(l) && a[l] && (a[l] = L.extend({}, this.options[l], a[l]));
    this._toolbarClass = "leaflet-draw-draw", L.Toolbar.prototype.initialize.call(this, a);
  }, getModeHandlers: function(a) {
    return [{ enabled: this.options.polyline, handler: new L.Draw.Polyline(a, this.options.polyline), title: L.drawLocal.draw.toolbar.buttons.polyline }, { enabled: this.options.polygon, handler: new L.Draw.Polygon(a, this.options.polygon), title: L.drawLocal.draw.toolbar.buttons.polygon }, { enabled: this.options.rectangle, handler: new L.Draw.Rectangle(a, this.options.rectangle), title: L.drawLocal.draw.toolbar.buttons.rectangle }, { enabled: this.options.circle, handler: new L.Draw.Circle(a, this.options.circle), title: L.drawLocal.draw.toolbar.buttons.circle }, { enabled: this.options.marker, handler: new L.Draw.Marker(a, this.options.marker), title: L.drawLocal.draw.toolbar.buttons.marker }, { enabled: this.options.circlemarker, handler: new L.Draw.CircleMarker(a, this.options.circlemarker), title: L.drawLocal.draw.toolbar.buttons.circlemarker }];
  }, getActions: function(a) {
    return [{ enabled: a.completeShape, title: L.drawLocal.draw.toolbar.finish.title, text: L.drawLocal.draw.toolbar.finish.text, callback: a.completeShape, context: a }, { enabled: a.deleteLastVertex, title: L.drawLocal.draw.toolbar.undo.title, text: L.drawLocal.draw.toolbar.undo.text, callback: a.deleteLastVertex, context: a }, { title: L.drawLocal.draw.toolbar.actions.title, text: L.drawLocal.draw.toolbar.actions.text, callback: this.disable, context: this }];
  }, setOptions: function(a) {
    L.setOptions(this, a);
    for (var l in this._modes)
      this._modes.hasOwnProperty(l) && a.hasOwnProperty(l) && this._modes[l].handler.setOptions(a[l]);
  } }), L.EditToolbar = L.Toolbar.extend({ statics: { TYPE: "edit" }, options: { edit: { selectedPathOptions: { dashArray: "10, 10", fill: !0, fillColor: "#fe57a1", fillOpacity: 0.1, maintainColor: !1 } }, remove: {}, poly: null, featureGroup: null }, initialize: function(a) {
    a.edit && (a.edit.selectedPathOptions === void 0 && (a.edit.selectedPathOptions = this.options.edit.selectedPathOptions), a.edit.selectedPathOptions = L.extend({}, this.options.edit.selectedPathOptions, a.edit.selectedPathOptions)), a.remove && (a.remove = L.extend({}, this.options.remove, a.remove)), a.poly && (a.poly = L.extend({}, this.options.poly, a.poly)), this._toolbarClass = "leaflet-draw-edit", L.Toolbar.prototype.initialize.call(this, a), this._selectedFeatureCount = 0;
  }, getModeHandlers: function(a) {
    var l = this.options.featureGroup;
    return [{ enabled: this.options.edit, handler: new L.EditToolbar.Edit(a, { featureGroup: l, selectedPathOptions: this.options.edit.selectedPathOptions, poly: this.options.poly }), title: L.drawLocal.edit.toolbar.buttons.edit }, { enabled: this.options.remove, handler: new L.EditToolbar.Delete(a, { featureGroup: l }), title: L.drawLocal.edit.toolbar.buttons.remove }];
  }, getActions: function(a) {
    var l = [{ title: L.drawLocal.edit.toolbar.actions.save.title, text: L.drawLocal.edit.toolbar.actions.save.text, callback: this._save, context: this }, { title: L.drawLocal.edit.toolbar.actions.cancel.title, text: L.drawLocal.edit.toolbar.actions.cancel.text, callback: this.disable, context: this }];
    return a.removeAllLayers && l.push({ title: L.drawLocal.edit.toolbar.actions.clearAll.title, text: L.drawLocal.edit.toolbar.actions.clearAll.text, callback: this._clearAllLayers, context: this }), l;
  }, addToolbar: function(a) {
    var l = L.Toolbar.prototype.addToolbar.call(this, a);
    return this._checkDisabled(), this.options.featureGroup.on("layeradd layerremove", this._checkDisabled, this), l;
  }, removeToolbar: function() {
    this.options.featureGroup.off("layeradd layerremove", this._checkDisabled, this), L.Toolbar.prototype.removeToolbar.call(this);
  }, disable: function() {
    this.enabled() && (this._activeMode.handler.revertLayers(), L.Toolbar.prototype.disable.call(this));
  }, _save: function() {
    this._activeMode.handler.save(), this._activeMode && this._activeMode.handler.disable();
  }, _clearAllLayers: function() {
    this._activeMode.handler.removeAllLayers(), this._activeMode && this._activeMode.handler.disable();
  }, _checkDisabled: function() {
    var a, l = this.options.featureGroup, f = l.getLayers().length !== 0;
    this.options.edit && (a = this._modes[L.EditToolbar.Edit.TYPE].button, f ? L.DomUtil.removeClass(a, "leaflet-disabled") : L.DomUtil.addClass(a, "leaflet-disabled"), a.setAttribute("title", f ? L.drawLocal.edit.toolbar.buttons.edit : L.drawLocal.edit.toolbar.buttons.editDisabled)), this.options.remove && (a = this._modes[L.EditToolbar.Delete.TYPE].button, f ? L.DomUtil.removeClass(a, "leaflet-disabled") : L.DomUtil.addClass(a, "leaflet-disabled"), a.setAttribute("title", f ? L.drawLocal.edit.toolbar.buttons.remove : L.drawLocal.edit.toolbar.buttons.removeDisabled));
  } }), L.EditToolbar.Edit = L.Handler.extend({ statics: { TYPE: "edit" }, initialize: function(a, l) {
    if (L.Handler.prototype.initialize.call(this, a), L.setOptions(this, l), this._featureGroup = l.featureGroup, !(this._featureGroup instanceof L.FeatureGroup))
      throw new Error("options.featureGroup must be a L.FeatureGroup");
    this._uneditedLayerProps = {}, this.type = L.EditToolbar.Edit.TYPE;
    var f = L.version.split(".");
    parseInt(f[0], 10) === 1 && parseInt(f[1], 10) >= 2 ? L.EditToolbar.Edit.include(L.Evented.prototype) : L.EditToolbar.Edit.include(L.Mixin.Events);
  }, enable: function() {
    !this._enabled && this._hasAvailableLayers() && (this.fire("enabled", { handler: this.type }), this._map.fire(L.Draw.Event.EDITSTART, { handler: this.type }), L.Handler.prototype.enable.call(this), this._featureGroup.on("layeradd", this._enableLayerEdit, this).on("layerremove", this._disableLayerEdit, this));
  }, disable: function() {
    this._enabled && (this._featureGroup.off("layeradd", this._enableLayerEdit, this).off("layerremove", this._disableLayerEdit, this), L.Handler.prototype.disable.call(this), this._map.fire(L.Draw.Event.EDITSTOP, { handler: this.type }), this.fire("disabled", { handler: this.type }));
  }, addHooks: function() {
    var a = this._map;
    a && (a.getContainer().focus(), this._featureGroup.eachLayer(this._enableLayerEdit, this), this._tooltip = new L.Draw.Tooltip(this._map), this._tooltip.updateContent({ text: L.drawLocal.edit.handlers.edit.tooltip.text, subtext: L.drawLocal.edit.handlers.edit.tooltip.subtext }), a._editTooltip = this._tooltip, this._updateTooltip(), this._map.on("mousemove", this._onMouseMove, this).on("touchmove", this._onMouseMove, this).on("MSPointerMove", this._onMouseMove, this).on(L.Draw.Event.EDITVERTEX, this._updateTooltip, this));
  }, removeHooks: function() {
    this._map && (this._featureGroup.eachLayer(this._disableLayerEdit, this), this._uneditedLayerProps = {}, this._tooltip.dispose(), this._tooltip = null, this._map.off("mousemove", this._onMouseMove, this).off("touchmove", this._onMouseMove, this).off("MSPointerMove", this._onMouseMove, this).off(L.Draw.Event.EDITVERTEX, this._updateTooltip, this));
  }, revertLayers: function() {
    this._featureGroup.eachLayer(function(a) {
      this._revertLayer(a);
    }, this);
  }, save: function() {
    var a = new L.LayerGroup();
    this._featureGroup.eachLayer(function(l) {
      l.edited && (a.addLayer(l), l.edited = !1);
    }), this._map.fire(L.Draw.Event.EDITED, { layers: a });
  }, _backupLayer: function(a) {
    var l = L.Util.stamp(a);
    this._uneditedLayerProps[l] || (a instanceof L.Polyline || a instanceof L.Polygon || a instanceof L.Rectangle ? this._uneditedLayerProps[l] = { latlngs: L.LatLngUtil.cloneLatLngs(a.getLatLngs()) } : a instanceof L.Circle ? this._uneditedLayerProps[l] = { latlng: L.LatLngUtil.cloneLatLng(a.getLatLng()), radius: a.getRadius() } : (a instanceof L.Marker || a instanceof L.CircleMarker) && (this._uneditedLayerProps[l] = { latlng: L.LatLngUtil.cloneLatLng(a.getLatLng()) }));
  }, _getTooltipText: function() {
    return { text: L.drawLocal.edit.handlers.edit.tooltip.text, subtext: L.drawLocal.edit.handlers.edit.tooltip.subtext };
  }, _updateTooltip: function() {
    this._tooltip.updateContent(this._getTooltipText());
  }, _revertLayer: function(a) {
    var l = L.Util.stamp(a);
    a.edited = !1, this._uneditedLayerProps.hasOwnProperty(l) && (a instanceof L.Polyline || a instanceof L.Polygon || a instanceof L.Rectangle ? a.setLatLngs(this._uneditedLayerProps[l].latlngs) : a instanceof L.Circle ? (a.setLatLng(this._uneditedLayerProps[l].latlng), a.setRadius(this._uneditedLayerProps[l].radius)) : (a instanceof L.Marker || a instanceof L.CircleMarker) && a.setLatLng(this._uneditedLayerProps[l].latlng), a.fire("revert-edited", { layer: a }));
  }, _enableLayerEdit: function(a) {
    var l, f, m = a.layer || a.target || a;
    this._backupLayer(m), this.options.poly && (f = L.Util.extend({}, this.options.poly), m.options.poly = f), this.options.selectedPathOptions && (l = L.Util.extend({}, this.options.selectedPathOptions), l.maintainColor && (l.color = m.options.color, l.fillColor = m.options.fillColor), m.options.original = L.extend({}, m.options), m.options.editing = l), m instanceof L.Marker ? (m.editing && m.editing.enable(), m.dragging.enable(), m.on("dragend", this._onMarkerDragEnd).on("touchmove", this._onTouchMove, this).on("MSPointerMove", this._onTouchMove, this).on("touchend", this._onMarkerDragEnd, this).on("MSPointerUp", this._onMarkerDragEnd, this)) : m.editing.enable();
  }, _disableLayerEdit: function(a) {
    var l = a.layer || a.target || a;
    l.edited = !1, l.editing && l.editing.disable(), delete l.options.editing, delete l.options.original, this._selectedPathOptions && (l instanceof L.Marker ? this._toggleMarkerHighlight(l) : (l.setStyle(l.options.previousOptions), delete l.options.previousOptions)), l instanceof L.Marker ? (l.dragging.disable(), l.off("dragend", this._onMarkerDragEnd, this).off("touchmove", this._onTouchMove, this).off("MSPointerMove", this._onTouchMove, this).off("touchend", this._onMarkerDragEnd, this).off("MSPointerUp", this._onMarkerDragEnd, this)) : l.editing.disable();
  }, _onMouseMove: function(a) {
    this._tooltip.updatePosition(a.latlng);
  }, _onMarkerDragEnd: function(a) {
    var l = a.target;
    l.edited = !0, this._map.fire(L.Draw.Event.EDITMOVE, { layer: l });
  }, _onTouchMove: function(a) {
    var l = a.originalEvent.changedTouches[0], f = this._map.mouseEventToLayerPoint(l), m = this._map.layerPointToLatLng(f);
    a.target.setLatLng(m);
  }, _hasAvailableLayers: function() {
    return this._featureGroup.getLayers().length !== 0;
  } }), L.EditToolbar.Delete = L.Handler.extend({ statics: { TYPE: "remove" }, initialize: function(a, l) {
    if (L.Handler.prototype.initialize.call(this, a), L.Util.setOptions(this, l), this._deletableLayers = this.options.featureGroup, !(this._deletableLayers instanceof L.FeatureGroup))
      throw new Error("options.featureGroup must be a L.FeatureGroup");
    this.type = L.EditToolbar.Delete.TYPE;
    var f = L.version.split(".");
    parseInt(f[0], 10) === 1 && parseInt(f[1], 10) >= 2 ? L.EditToolbar.Delete.include(L.Evented.prototype) : L.EditToolbar.Delete.include(L.Mixin.Events);
  }, enable: function() {
    !this._enabled && this._hasAvailableLayers() && (this.fire("enabled", { handler: this.type }), this._map.fire(L.Draw.Event.DELETESTART, { handler: this.type }), L.Handler.prototype.enable.call(this), this._deletableLayers.on("layeradd", this._enableLayerDelete, this).on("layerremove", this._disableLayerDelete, this));
  }, disable: function() {
    this._enabled && (this._deletableLayers.off("layeradd", this._enableLayerDelete, this).off("layerremove", this._disableLayerDelete, this), L.Handler.prototype.disable.call(this), this._map.fire(L.Draw.Event.DELETESTOP, { handler: this.type }), this.fire("disabled", { handler: this.type }));
  }, addHooks: function() {
    var a = this._map;
    a && (a.getContainer().focus(), this._deletableLayers.eachLayer(this._enableLayerDelete, this), this._deletedLayers = new L.LayerGroup(), this._tooltip = new L.Draw.Tooltip(this._map), this._tooltip.updateContent({ text: L.drawLocal.edit.handlers.remove.tooltip.text }), this._map.on("mousemove", this._onMouseMove, this));
  }, removeHooks: function() {
    this._map && (this._deletableLayers.eachLayer(this._disableLayerDelete, this), this._deletedLayers = null, this._tooltip.dispose(), this._tooltip = null, this._map.off("mousemove", this._onMouseMove, this));
  }, revertLayers: function() {
    this._deletedLayers.eachLayer(function(a) {
      this._deletableLayers.addLayer(a), a.fire("revert-deleted", { layer: a });
    }, this);
  }, save: function() {
    this._map.fire(L.Draw.Event.DELETED, { layers: this._deletedLayers });
  }, removeAllLayers: function() {
    this._deletableLayers.eachLayer(function(a) {
      this._removeLayer({ layer: a });
    }, this), this.save();
  }, _enableLayerDelete: function(a) {
    (a.layer || a.target || a).on("click", this._removeLayer, this);
  }, _disableLayerDelete: function(a) {
    var l = a.layer || a.target || a;
    l.off("click", this._removeLayer, this), this._deletedLayers.removeLayer(l);
  }, _removeLayer: function(a) {
    var l = a.layer || a.target || a;
    this._deletableLayers.removeLayer(l), this._deletedLayers.addLayer(l), l.fire("deleted");
  }, _onMouseMove: function(a) {
    this._tooltip.updatePosition(a.latlng);
  }, _hasAvailableLayers: function() {
    return this._deletableLayers.getLayers().length !== 0;
  } });
})(window, document);
const Ao = new ni.FeatureGroup(), kP = he({
  mixins: [Bn],
  emits: ["update:model-value", "validate-field"],
  data() {
    return {
      map: null,
      draw: null
    };
  },
  computed: {
    drawOptions() {
      const { position: t, polygon: i, circle: r, rectangle: h } = this.properties;
      return {
        ...Qu,
        position: t || "topright",
        draw: {
          polygon: i ? Qu.draw.polygon : !1,
          polyline: !1,
          circle: !1,
          rectangle: h ? Qu.draw.rectangle : !1,
          marker: !1,
          circlemarker: !1
        },
        edit: i || r || h ? {
          featureGroup: Ao,
          remove: !1
        } : !1
      };
    }
  },
  mounted() {
    const t = this.$refs.mapContainer;
    if (this.map = gc({
      element: t,
      options: { fullscreenControl: !0 }
    }), Ao.addTo(this.map), this.draw = new ni.Control.Draw(this.drawOptions), this.draw.addTo(this.map), this.value) {
      const i = DP(this.value), { type: r, coordinates: h } = i;
      if (r === "Polygon") {
        const a = ni.GeoJSON.coordsToLatLngs(h, io.levelDeepPolygon), l = ni.polygon(a, { ...g0 });
        Ao.addLayer(l);
      }
      this.map.fitBounds(Ao.getBounds());
    }
    this.map.on(ni.Draw.Event.DRAWSTART, this.drawDrawStart), this.map.on(ni.Draw.Event.CREATED, this.drawCreated), this.map.on(ni.Draw.Event.EDITED, this.drawEdited);
  },
  unmounted() {
    Ao.clearLayers(), this.map.off(ni.Draw.Event.DRAWSTART, this.drawDrawStart), this.map.off(ni.Draw.Event.CREATED, this.drawCreated), this.map.off(ni.Draw.Event.EDITED, this.drawEdited);
  },
  methods: {
    drawDrawStart() {
      Ao.clearLayers(), this.model = null;
    },
    drawCreated(t) {
      Ao.addLayer(t.layer);
      const i = t.layer.toGeoJSON();
      this.model = hp(i), this.$emit("validate-field", this.scope);
    },
    drawEdited(t) {
      const [i] = t.layers.getLayers();
      if (i) {
        const r = i.toGeoJSON();
        this.model = hp(r);
      }
      this.$emit("validate-field", this.scope);
    }
  },
  components: {
    DialogComponent: Uc
  }
}), AP = "_component_1ybsz_1", IP = "_component__map_1ybsz_4", NP = {
  component: AP,
  component__map: IP
};
function RP(t, i, r, h, a, l) {
  const f = q("control-label-component"), m = q("control-error-component"), y = q("el-form-item");
  return pe(), Ae(y, {
    class: Ze(t.$style.component),
    prop: t.scope,
    rules: t.rules
  }, $n({
    error: Y(({ error: v }) => [
      ee(m, {
        error: v[t.locale]
      }, null, 8, ["error"])
    ]),
    default: Y(() => [
      Mt("div", {
        class: Ze(t.$style.component__map),
        ref: "mapContainer"
      }, null, 2)
    ]),
    _: 2
  }, [
    t.label ? {
      name: "label",
      fn: Y(() => [
        ee(f, {
          label: t.label,
          rules: t.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["class", "prop", "rules"]);
}
const $P = {
  $style: NP
}, zP = /* @__PURE__ */ Re(kP, [["render", RP], ["__cssModules", $P]]), BP = he({
  mixins: [Bn],
  methods: {
    onInput(t) {
      this.model = t;
    }
  }
}), UP = {
  "hide-controls": "_hide-controls_mcv3q_1"
};
function FP(t, i, r, h, a, l) {
  const f = q("control-label-component"), m = q("el-input-number"), y = q("control-error-component"), v = q("el-form-item");
  return pe(), Ae(v, {
    prop: t.scope,
    rules: t.rules
  }, $n({
    error: Y(({ error: C }) => [
      ee(y, {
        error: C[t.locale]
      }, null, 8, ["error"])
    ]),
    default: Y(() => {
      var C;
      return [
        ee(m, {
          "model-value": t.model,
          class: Ze({ [t.$style["hide-controls"]]: t.properties.hideControls }),
          placeholder: (C = t.properties.placeholder) == null ? void 0 : C[t.locale],
          min: t.properties.min,
          max: t.properties.max,
          controls: !t.properties.hideControls,
          onInput: t.onInput
        }, null, 8, ["model-value", "class", "placeholder", "min", "max", "controls", "onInput"])
      ];
    }),
    _: 2
  }, [
    t.label ? {
      name: "label",
      fn: Y(() => [
        ee(f, {
          label: t.label,
          rules: t.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["prop", "rules"]);
}
const HP = {
  $style: UP
}, ZP = /* @__PURE__ */ Re(BP, [["render", FP], ["__cssModules", HP]]), VP = he({
  mixins: [Bn]
}), WP = ["innerHTML"];
function jP(t, i, r, h, a, l) {
  const f = q("control-label-component"), m = q("el-radio"), y = q("el-radio-group"), v = q("control-error-component"), C = q("el-form-item");
  return pe(), Ae(C, {
    prop: t.scope,
    rules: t.rules
  }, $n({
    error: Y(({ error: M }) => [
      ee(v, {
        error: M[t.locale]
      }, null, 8, ["error"])
    ]),
    default: Y(() => [
      ee(y, {
        modelValue: t.model,
        "onUpdate:modelValue": i[0] || (i[0] = (M) => t.model = M)
      }, {
        default: Y(() => [
          (pe(!0), Tt(si, null, ar(t.properties.enum, (M, N) => (pe(), Ae(m, {
            key: N,
            label: M.value,
            size: "default"
          }, {
            default: Y(() => [
              Mt("span", {
                innerHTML: M.text[t.locale]
              }, null, 8, WP)
            ]),
            _: 2
          }, 1032, ["label"]))), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 2
  }, [
    t.label ? {
      name: "label",
      fn: Y(() => [
        ee(f, {
          label: t.label,
          rules: t.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["prop", "rules"]);
}
const GP = /* @__PURE__ */ Re(VP, [["render", jP]]), qP = he({
  mixins: [Bn],
  computed: {
    model: {
      get() {
        return this.properties.multiple ? Array.isArray(this.value) ? this.value : [] : this.value;
      },
      set(t) {
        t && this.$emit("update:model-value", dt.set(this.modelValue, this.path, t));
      }
    }
  },
  methods: {
    onClearClick() {
      this.$emit("update:model-value", dt.set(this.modelValue, this.path, null));
    }
  }
});
function YP(t, i, r, h, a, l) {
  const f = q("control-label-component"), m = q("el-option"), y = q("el-select"), v = q("control-error-component"), C = q("el-form-item");
  return pe(), Ae(C, {
    prop: t.scope,
    rules: t.rules
  }, $n({
    error: Y(({ error: M }) => [
      ee(v, {
        error: M[t.locale]
      }, null, 8, ["error"])
    ]),
    default: Y(() => {
      var M;
      return [
        ee(y, {
          modelValue: t.model,
          "onUpdate:modelValue": i[0] || (i[0] = (N) => t.model = N),
          placeholder: ((M = t.properties.placeholder) == null ? void 0 : M[t.locale]) || " ",
          multiple: t.properties.multiple,
          clearable: t.properties.clearable,
          onClear: t.onClearClick
        }, {
          default: Y(() => [
            (pe(!0), Tt(si, null, ar(t.properties.enum, (N, I) => (pe(), Ae(m, {
              key: I,
              label: N.text[t.locale],
              value: N.value
            }, null, 8, ["label", "value"]))), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "multiple", "clearable", "onClear"])
      ];
    }),
    _: 2
  }, [
    t.label ? {
      name: "label",
      fn: Y(() => [
        ee(f, {
          label: t.label,
          rules: t.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["prop", "rules"]);
}
const KP = /* @__PURE__ */ Re(qP, [["render", YP]]);
var JP = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var i = {}, r = Symbol("test"), h = Object(r);
  if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(h) !== "[object Symbol]")
    return !1;
  var a = 42;
  i[r] = a;
  for (r in i)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(i).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(i).length !== 0)
    return !1;
  var l = Object.getOwnPropertySymbols(i);
  if (l.length !== 1 || l[0] !== r || !Object.prototype.propertyIsEnumerable.call(i, r))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var f = Object.getOwnPropertyDescriptor(i, r);
    if (f.value !== a || f.enumerable !== !0)
      return !1;
  }
  return !0;
}, pp = typeof Symbol < "u" && Symbol, XP = JP, QP = function() {
  return typeof pp != "function" || typeof Symbol != "function" || typeof pp("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : XP();
}, eM = "Function.prototype.bind called on incompatible ", ic = Array.prototype.slice, tM = Object.prototype.toString, nM = "[object Function]", iM = function(i) {
  var r = this;
  if (typeof r != "function" || tM.call(r) !== nM)
    throw new TypeError(eM + r);
  for (var h = ic.call(arguments, 1), a, l = function() {
    if (this instanceof a) {
      var C = r.apply(
        this,
        h.concat(ic.call(arguments))
      );
      return Object(C) === C ? C : this;
    } else
      return r.apply(
        i,
        h.concat(ic.call(arguments))
      );
  }, f = Math.max(0, r.length - h.length), m = [], y = 0; y < f; y++)
    m.push("$" + y);
  if (a = Function("binder", "return function (" + m.join(",") + "){ return binder.apply(this,arguments); }")(l), r.prototype) {
    var v = function() {
    };
    v.prototype = r.prototype, a.prototype = new v(), v.prototype = null;
  }
  return a;
}, rM = iM, Wc = Function.prototype.bind || rM, oM = Wc, sM = oM.call(Function.call, Object.prototype.hasOwnProperty), at, Ms = SyntaxError, Om = Function, Cs = TypeError, rc = function(t) {
  try {
    return Om('"use strict"; return (' + t + ").constructor;")();
  } catch {
  }
}, $o = Object.getOwnPropertyDescriptor;
if ($o)
  try {
    $o({}, "");
  } catch {
    $o = null;
  }
var oc = function() {
  throw new Cs();
}, aM = $o ? function() {
  try {
    return arguments.callee, oc;
  } catch {
    try {
      return $o(arguments, "callee").get;
    } catch {
      return oc;
    }
  }
}() : oc, Ls = QP(), to = Object.getPrototypeOf || function(t) {
  return t.__proto__;
}, bs = {}, lM = typeof Uint8Array > "u" ? at : to(Uint8Array), Ts = {
  "%AggregateError%": typeof AggregateError > "u" ? at : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? at : ArrayBuffer,
  "%ArrayIteratorPrototype%": Ls ? to([][Symbol.iterator]()) : at,
  "%AsyncFromSyncIteratorPrototype%": at,
  "%AsyncFunction%": bs,
  "%AsyncGenerator%": bs,
  "%AsyncGeneratorFunction%": bs,
  "%AsyncIteratorPrototype%": bs,
  "%Atomics%": typeof Atomics > "u" ? at : Atomics,
  "%BigInt%": typeof BigInt > "u" ? at : BigInt,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? at : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? at : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? at : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? at : FinalizationRegistry,
  "%Function%": Om,
  "%GeneratorFunction%": bs,
  "%Int8Array%": typeof Int8Array > "u" ? at : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? at : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? at : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": Ls ? to(to([][Symbol.iterator]())) : at,
  "%JSON%": typeof JSON == "object" ? JSON : at,
  "%Map%": typeof Map > "u" ? at : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !Ls ? at : to((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? at : Promise,
  "%Proxy%": typeof Proxy > "u" ? at : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? at : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? at : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !Ls ? at : to((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? at : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": Ls ? to(""[Symbol.iterator]()) : at,
  "%Symbol%": Ls ? Symbol : at,
  "%SyntaxError%": Ms,
  "%ThrowTypeError%": aM,
  "%TypedArray%": lM,
  "%TypeError%": Cs,
  "%Uint8Array%": typeof Uint8Array > "u" ? at : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? at : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? at : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? at : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap > "u" ? at : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? at : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? at : WeakSet
}, uM = function t(i) {
  var r;
  if (i === "%AsyncFunction%")
    r = rc("async function () {}");
  else if (i === "%GeneratorFunction%")
    r = rc("function* () {}");
  else if (i === "%AsyncGeneratorFunction%")
    r = rc("async function* () {}");
  else if (i === "%AsyncGenerator%") {
    var h = t("%AsyncGeneratorFunction%");
    h && (r = h.prototype);
  } else if (i === "%AsyncIteratorPrototype%") {
    var a = t("%AsyncGenerator%");
    a && (r = to(a.prototype));
  }
  return Ts[i] = r, r;
}, mp = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, Ta = Wc, kl = sM, cM = Ta.call(Function.call, Array.prototype.concat), hM = Ta.call(Function.apply, Array.prototype.splice), _p = Ta.call(Function.call, String.prototype.replace), Al = Ta.call(Function.call, String.prototype.slice), fM = Ta.call(Function.call, RegExp.prototype.exec), dM = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, pM = /\\(\\)?/g, mM = function(i) {
  var r = Al(i, 0, 1), h = Al(i, -1);
  if (r === "%" && h !== "%")
    throw new Ms("invalid intrinsic syntax, expected closing `%`");
  if (h === "%" && r !== "%")
    throw new Ms("invalid intrinsic syntax, expected opening `%`");
  var a = [];
  return _p(i, dM, function(l, f, m, y) {
    a[a.length] = m ? _p(y, pM, "$1") : f || l;
  }), a;
}, _M = function(i, r) {
  var h = i, a;
  if (kl(mp, h) && (a = mp[h], h = "%" + a[0] + "%"), kl(Ts, h)) {
    var l = Ts[h];
    if (l === bs && (l = uM(h)), typeof l > "u" && !r)
      throw new Cs("intrinsic " + i + " exists, but is not available. Please file an issue!");
    return {
      alias: a,
      name: h,
      value: l
    };
  }
  throw new Ms("intrinsic " + i + " does not exist!");
}, jc = function(i, r) {
  if (typeof i != "string" || i.length === 0)
    throw new Cs("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof r != "boolean")
    throw new Cs('"allowMissing" argument must be a boolean');
  if (fM(/^%?[^%]*%?$/, i) === null)
    throw new Ms("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var h = mM(i), a = h.length > 0 ? h[0] : "", l = _M("%" + a + "%", r), f = l.name, m = l.value, y = !1, v = l.alias;
  v && (a = v[0], hM(h, cM([0, 1], v)));
  for (var C = 1, M = !0; C < h.length; C += 1) {
    var N = h[C], I = Al(N, 0, 1), D = Al(N, -1);
    if ((I === '"' || I === "'" || I === "`" || D === '"' || D === "'" || D === "`") && I !== D)
      throw new Ms("property names with quotes must have matching quotes");
    if ((N === "constructor" || !M) && (y = !0), a += "." + N, f = "%" + a + "%", kl(Ts, f))
      m = Ts[f];
    else if (m != null) {
      if (!(N in m)) {
        if (!r)
          throw new Cs("base intrinsic for " + i + " exists, but the property is not available.");
        return;
      }
      if ($o && C + 1 >= h.length) {
        var B = $o(m, N);
        M = !!B, M && "get" in B && !("originalValue" in B.get) ? m = B.get : m = m[N];
      } else
        M = kl(m, N), m = m[N];
      M && !y && (Ts[f] = m);
    }
  }
  return m;
}, Tc = {}, gM = {
  get exports() {
    return Tc;
  },
  set exports(t) {
    Tc = t;
  }
};
(function(t) {
  var i = Wc, r = jc, h = r("%Function.prototype.apply%"), a = r("%Function.prototype.call%"), l = r("%Reflect.apply%", !0) || i.call(a, h), f = r("%Object.getOwnPropertyDescriptor%", !0), m = r("%Object.defineProperty%", !0), y = r("%Math.max%");
  if (m)
    try {
      m({}, "a", { value: 1 });
    } catch {
      m = null;
    }
  t.exports = function(M) {
    var N = l(i, a, arguments);
    if (f && m) {
      var I = f(N, "length");
      I.configurable && m(
        N,
        "length",
        { value: 1 + y(0, M.length - (arguments.length - 1)) }
      );
    }
    return N;
  };
  var v = function() {
    return l(i, h, arguments);
  };
  m ? m(t.exports, "apply", { value: v }) : t.exports.apply = v;
})(gM);
var xm = jc, Dm = Tc, vM = Dm(xm("String.prototype.indexOf")), yM = function(i, r) {
  var h = xm(i, !!r);
  return typeof h == "function" && vM(i, ".prototype.") > -1 ? Dm(h) : h;
};
const LM = {}, wM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: LM
}, Symbol.toStringTag, { value: "Module" })), bM = /* @__PURE__ */ b0(wM);
var Gc = typeof Map == "function" && Map.prototype, sc = Object.getOwnPropertyDescriptor && Gc ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, Il = Gc && sc && typeof sc.get == "function" ? sc.get : null, SM = Gc && Map.prototype.forEach, qc = typeof Set == "function" && Set.prototype, ac = Object.getOwnPropertyDescriptor && qc ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, Nl = qc && ac && typeof ac.get == "function" ? ac.get : null, CM = qc && Set.prototype.forEach, TM = typeof WeakMap == "function" && WeakMap.prototype, va = TM ? WeakMap.prototype.has : null, EM = typeof WeakSet == "function" && WeakSet.prototype, ya = EM ? WeakSet.prototype.has : null, PM = typeof WeakRef == "function" && WeakRef.prototype, gp = PM ? WeakRef.prototype.deref : null, MM = Boolean.prototype.valueOf, OM = Object.prototype.toString, xM = Function.prototype.toString, DM = String.prototype.match, Yc = String.prototype.slice, ro = String.prototype.replace, kM = String.prototype.toUpperCase, vp = String.prototype.toLowerCase, km = RegExp.prototype.test, yp = Array.prototype.concat, or = Array.prototype.join, AM = Array.prototype.slice, Lp = Math.floor, Ec = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, lc = Object.getOwnPropertySymbols, Pc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, Os = typeof Symbol == "function" && typeof Symbol.iterator == "object", Cn = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === Os || "symbol") ? Symbol.toStringTag : null, Am = Object.prototype.propertyIsEnumerable, wp = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(t) {
  return t.__proto__;
} : null);
function bp(t, i) {
  if (t === 1 / 0 || t === -1 / 0 || t !== t || t && t > -1e3 && t < 1e3 || km.call(/e/, i))
    return i;
  var r = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof t == "number") {
    var h = t < 0 ? -Lp(-t) : Lp(t);
    if (h !== t) {
      var a = String(h), l = Yc.call(i, a.length + 1);
      return ro.call(a, r, "$&_") + "." + ro.call(ro.call(l, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return ro.call(i, r, "$&_");
}
var Mc = bM, Sp = Mc.custom, Cp = Nm(Sp) ? Sp : null, IM = function t(i, r, h, a) {
  var l = r || {};
  if (no(l, "quoteStyle") && l.quoteStyle !== "single" && l.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (no(l, "maxStringLength") && (typeof l.maxStringLength == "number" ? l.maxStringLength < 0 && l.maxStringLength !== 1 / 0 : l.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var f = no(l, "customInspect") ? l.customInspect : !0;
  if (typeof f != "boolean" && f !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (no(l, "indent") && l.indent !== null && l.indent !== "	" && !(parseInt(l.indent, 10) === l.indent && l.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (no(l, "numericSeparator") && typeof l.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var m = l.numericSeparator;
  if (typeof i > "u")
    return "undefined";
  if (i === null)
    return "null";
  if (typeof i == "boolean")
    return i ? "true" : "false";
  if (typeof i == "string")
    return $m(i, l);
  if (typeof i == "number") {
    if (i === 0)
      return 1 / 0 / i > 0 ? "0" : "-0";
    var y = String(i);
    return m ? bp(i, y) : y;
  }
  if (typeof i == "bigint") {
    var v = String(i) + "n";
    return m ? bp(i, v) : v;
  }
  var C = typeof l.depth > "u" ? 5 : l.depth;
  if (typeof h > "u" && (h = 0), h >= C && C > 0 && typeof i == "object")
    return Oc(i) ? "[Array]" : "[Object]";
  var M = XM(l, h);
  if (typeof a > "u")
    a = [];
  else if (Rm(a, i) >= 0)
    return "[Circular]";
  function N(_n, Dt, gn) {
    if (Dt && (a = AM.call(a), a.push(Dt)), gn) {
      var It = {
        depth: l.depth
      };
      return no(l, "quoteStyle") && (It.quoteStyle = l.quoteStyle), t(_n, It, h + 1, a);
    }
    return t(_n, l, h + 1, a);
  }
  if (typeof i == "function" && !Tp(i)) {
    var I = ZM(i), D = yl(i, N);
    return "[Function" + (I ? ": " + I : " (anonymous)") + "]" + (D.length > 0 ? " { " + or.call(D, ", ") + " }" : "");
  }
  if (Nm(i)) {
    var B = Os ? ro.call(String(i), /^(Symbol\(.*\))_[^)]*$/, "$1") : Pc.call(i);
    return typeof i == "object" && !Os ? ma(B) : B;
  }
  if (YM(i)) {
    for (var X = "<" + vp.call(String(i.nodeName)), le = i.attributes || [], Q = 0; Q < le.length; Q++)
      X += " " + le[Q].name + "=" + Im(NM(le[Q].value), "double", l);
    return X += ">", i.childNodes && i.childNodes.length && (X += "..."), X += "</" + vp.call(String(i.nodeName)) + ">", X;
  }
  if (Oc(i)) {
    if (i.length === 0)
      return "[]";
    var re = yl(i, N);
    return M && !JM(re) ? "[" + xc(re, M) + "]" : "[ " + or.call(re, ", ") + " ]";
  }
  if ($M(i)) {
    var ve = yl(i, N);
    return !("cause" in Error.prototype) && "cause" in i && !Am.call(i, "cause") ? "{ [" + String(i) + "] " + or.call(yp.call("[cause]: " + N(i.cause), ve), ", ") + " }" : ve.length === 0 ? "[" + String(i) + "]" : "{ [" + String(i) + "] " + or.call(ve, ", ") + " }";
  }
  if (typeof i == "object" && f) {
    if (Cp && typeof i[Cp] == "function" && Mc)
      return Mc(i, { depth: C - h });
    if (f !== "symbol" && typeof i.inspect == "function")
      return i.inspect();
  }
  if (VM(i)) {
    var Le = [];
    return SM.call(i, function(_n, Dt) {
      Le.push(N(Dt, i, !0) + " => " + N(_n, i));
    }), Ep("Map", Il.call(i), Le, M);
  }
  if (GM(i)) {
    var Ce = [];
    return CM.call(i, function(_n) {
      Ce.push(N(_n, i));
    }), Ep("Set", Nl.call(i), Ce, M);
  }
  if (WM(i))
    return uc("WeakMap");
  if (qM(i))
    return uc("WeakSet");
  if (jM(i))
    return uc("WeakRef");
  if (BM(i))
    return ma(N(Number(i)));
  if (FM(i))
    return ma(N(Ec.call(i)));
  if (UM(i))
    return ma(MM.call(i));
  if (zM(i))
    return ma(N(String(i)));
  if (!RM(i) && !Tp(i)) {
    var se = yl(i, N), Me = wp ? wp(i) === Object.prototype : i instanceof Object || i.constructor === Object, rt = i instanceof Object ? "" : "null prototype", Et = !Me && Cn && Object(i) === i && Cn in i ? Yc.call(oo(i), 8, -1) : rt ? "Object" : "", Pt = Me || typeof i.constructor != "function" ? "" : i.constructor.name ? i.constructor.name + " " : "", xt = Pt + (Et || rt ? "[" + or.call(yp.call([], Et || [], rt || []), ": ") + "] " : "");
    return se.length === 0 ? xt + "{}" : M ? xt + "{" + xc(se, M) + "}" : xt + "{ " + or.call(se, ", ") + " }";
  }
  return String(i);
};
function Im(t, i, r) {
  var h = (r.quoteStyle || i) === "double" ? '"' : "'";
  return h + t + h;
}
function NM(t) {
  return ro.call(String(t), /"/g, "&quot;");
}
function Oc(t) {
  return oo(t) === "[object Array]" && (!Cn || !(typeof t == "object" && Cn in t));
}
function RM(t) {
  return oo(t) === "[object Date]" && (!Cn || !(typeof t == "object" && Cn in t));
}
function Tp(t) {
  return oo(t) === "[object RegExp]" && (!Cn || !(typeof t == "object" && Cn in t));
}
function $M(t) {
  return oo(t) === "[object Error]" && (!Cn || !(typeof t == "object" && Cn in t));
}
function zM(t) {
  return oo(t) === "[object String]" && (!Cn || !(typeof t == "object" && Cn in t));
}
function BM(t) {
  return oo(t) === "[object Number]" && (!Cn || !(typeof t == "object" && Cn in t));
}
function UM(t) {
  return oo(t) === "[object Boolean]" && (!Cn || !(typeof t == "object" && Cn in t));
}
function Nm(t) {
  if (Os)
    return t && typeof t == "object" && t instanceof Symbol;
  if (typeof t == "symbol")
    return !0;
  if (!t || typeof t != "object" || !Pc)
    return !1;
  try {
    return Pc.call(t), !0;
  } catch {
  }
  return !1;
}
function FM(t) {
  if (!t || typeof t != "object" || !Ec)
    return !1;
  try {
    return Ec.call(t), !0;
  } catch {
  }
  return !1;
}
var HM = Object.prototype.hasOwnProperty || function(t) {
  return t in this;
};
function no(t, i) {
  return HM.call(t, i);
}
function oo(t) {
  return OM.call(t);
}
function ZM(t) {
  if (t.name)
    return t.name;
  var i = DM.call(xM.call(t), /^function\s*([\w$]+)/);
  return i ? i[1] : null;
}
function Rm(t, i) {
  if (t.indexOf)
    return t.indexOf(i);
  for (var r = 0, h = t.length; r < h; r++)
    if (t[r] === i)
      return r;
  return -1;
}
function VM(t) {
  if (!Il || !t || typeof t != "object")
    return !1;
  try {
    Il.call(t);
    try {
      Nl.call(t);
    } catch {
      return !0;
    }
    return t instanceof Map;
  } catch {
  }
  return !1;
}
function WM(t) {
  if (!va || !t || typeof t != "object")
    return !1;
  try {
    va.call(t, va);
    try {
      ya.call(t, ya);
    } catch {
      return !0;
    }
    return t instanceof WeakMap;
  } catch {
  }
  return !1;
}
function jM(t) {
  if (!gp || !t || typeof t != "object")
    return !1;
  try {
    return gp.call(t), !0;
  } catch {
  }
  return !1;
}
function GM(t) {
  if (!Nl || !t || typeof t != "object")
    return !1;
  try {
    Nl.call(t);
    try {
      Il.call(t);
    } catch {
      return !0;
    }
    return t instanceof Set;
  } catch {
  }
  return !1;
}
function qM(t) {
  if (!ya || !t || typeof t != "object")
    return !1;
  try {
    ya.call(t, ya);
    try {
      va.call(t, va);
    } catch {
      return !0;
    }
    return t instanceof WeakSet;
  } catch {
  }
  return !1;
}
function YM(t) {
  return !t || typeof t != "object" ? !1 : typeof HTMLElement < "u" && t instanceof HTMLElement ? !0 : typeof t.nodeName == "string" && typeof t.getAttribute == "function";
}
function $m(t, i) {
  if (t.length > i.maxStringLength) {
    var r = t.length - i.maxStringLength, h = "... " + r + " more character" + (r > 1 ? "s" : "");
    return $m(Yc.call(t, 0, i.maxStringLength), i) + h;
  }
  var a = ro.call(ro.call(t, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, KM);
  return Im(a, "single", i);
}
function KM(t) {
  var i = t.charCodeAt(0), r = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[i];
  return r ? "\\" + r : "\\x" + (i < 16 ? "0" : "") + kM.call(i.toString(16));
}
function ma(t) {
  return "Object(" + t + ")";
}
function uc(t) {
  return t + " { ? }";
}
function Ep(t, i, r, h) {
  var a = h ? xc(r, h) : or.call(r, ", ");
  return t + " (" + i + ") {" + a + "}";
}
function JM(t) {
  for (var i = 0; i < t.length; i++)
    if (Rm(t[i], `
`) >= 0)
      return !1;
  return !0;
}
function XM(t, i) {
  var r;
  if (t.indent === "	")
    r = "	";
  else if (typeof t.indent == "number" && t.indent > 0)
    r = or.call(Array(t.indent + 1), " ");
  else
    return null;
  return {
    base: r,
    prev: or.call(Array(i + 1), r)
  };
}
function xc(t, i) {
  if (t.length === 0)
    return "";
  var r = `
` + i.prev + i.base;
  return r + or.call(t, "," + r) + `
` + i.prev;
}
function yl(t, i) {
  var r = Oc(t), h = [];
  if (r) {
    h.length = t.length;
    for (var a = 0; a < t.length; a++)
      h[a] = no(t, a) ? i(t[a], t) : "";
  }
  var l = typeof lc == "function" ? lc(t) : [], f;
  if (Os) {
    f = {};
    for (var m = 0; m < l.length; m++)
      f["$" + l[m]] = l[m];
  }
  for (var y in t)
    no(t, y) && (r && String(Number(y)) === y && y < t.length || Os && f["$" + y] instanceof Symbol || (km.call(/[^\w$]/, y) ? h.push(i(y, t) + ": " + i(t[y], t)) : h.push(y + ": " + i(t[y], t))));
  if (typeof lc == "function")
    for (var v = 0; v < l.length; v++)
      Am.call(t, l[v]) && h.push("[" + i(l[v]) + "]: " + i(t[l[v]], t));
  return h;
}
var Kc = jc, Is = yM, QM = IM, eO = Kc("%TypeError%"), Ll = Kc("%WeakMap%", !0), wl = Kc("%Map%", !0), tO = Is("WeakMap.prototype.get", !0), nO = Is("WeakMap.prototype.set", !0), iO = Is("WeakMap.prototype.has", !0), rO = Is("Map.prototype.get", !0), oO = Is("Map.prototype.set", !0), sO = Is("Map.prototype.has", !0), Jc = function(t, i) {
  for (var r = t, h; (h = r.next) !== null; r = h)
    if (h.key === i)
      return r.next = h.next, h.next = t.next, t.next = h, h;
}, aO = function(t, i) {
  var r = Jc(t, i);
  return r && r.value;
}, lO = function(t, i, r) {
  var h = Jc(t, i);
  h ? h.value = r : t.next = {
    key: i,
    next: t.next,
    value: r
  };
}, uO = function(t, i) {
  return !!Jc(t, i);
}, cO = function() {
  var i, r, h, a = {
    assert: function(l) {
      if (!a.has(l))
        throw new eO("Side channel does not contain " + QM(l));
    },
    get: function(l) {
      if (Ll && l && (typeof l == "object" || typeof l == "function")) {
        if (i)
          return tO(i, l);
      } else if (wl) {
        if (r)
          return rO(r, l);
      } else if (h)
        return aO(h, l);
    },
    has: function(l) {
      if (Ll && l && (typeof l == "object" || typeof l == "function")) {
        if (i)
          return iO(i, l);
      } else if (wl) {
        if (r)
          return sO(r, l);
      } else if (h)
        return uO(h, l);
      return !1;
    },
    set: function(l, f) {
      Ll && l && (typeof l == "object" || typeof l == "function") ? (i || (i = new Ll()), nO(i, l, f)) : wl ? (r || (r = new wl()), oO(r, l, f)) : (h || (h = { key: {}, next: null }), lO(h, l, f));
    }
  };
  return a;
}, hO = String.prototype.replace, fO = /%20/g, cc = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, Xc = {
  default: cc.RFC3986,
  formatters: {
    RFC1738: function(t) {
      return hO.call(t, fO, "+");
    },
    RFC3986: function(t) {
      return String(t);
    }
  },
  RFC1738: cc.RFC1738,
  RFC3986: cc.RFC3986
}, dO = Xc, hc = Object.prototype.hasOwnProperty, No = Array.isArray, rr = function() {
  for (var t = [], i = 0; i < 256; ++i)
    t.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
  return t;
}(), pO = function(i) {
  for (; i.length > 1; ) {
    var r = i.pop(), h = r.obj[r.prop];
    if (No(h)) {
      for (var a = [], l = 0; l < h.length; ++l)
        typeof h[l] < "u" && a.push(h[l]);
      r.obj[r.prop] = a;
    }
  }
}, zm = function(i, r) {
  for (var h = r && r.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, a = 0; a < i.length; ++a)
    typeof i[a] < "u" && (h[a] = i[a]);
  return h;
}, mO = function t(i, r, h) {
  if (!r)
    return i;
  if (typeof r != "object") {
    if (No(i))
      i.push(r);
    else if (i && typeof i == "object")
      (h && (h.plainObjects || h.allowPrototypes) || !hc.call(Object.prototype, r)) && (i[r] = !0);
    else
      return [i, r];
    return i;
  }
  if (!i || typeof i != "object")
    return [i].concat(r);
  var a = i;
  return No(i) && !No(r) && (a = zm(i, h)), No(i) && No(r) ? (r.forEach(function(l, f) {
    if (hc.call(i, f)) {
      var m = i[f];
      m && typeof m == "object" && l && typeof l == "object" ? i[f] = t(m, l, h) : i.push(l);
    } else
      i[f] = l;
  }), i) : Object.keys(r).reduce(function(l, f) {
    var m = r[f];
    return hc.call(l, f) ? l[f] = t(l[f], m, h) : l[f] = m, l;
  }, a);
}, _O = function(i, r) {
  return Object.keys(r).reduce(function(h, a) {
    return h[a] = r[a], h;
  }, i);
}, gO = function(t, i, r) {
  var h = t.replace(/\+/g, " ");
  if (r === "iso-8859-1")
    return h.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(h);
  } catch {
    return h;
  }
}, vO = function(i, r, h, a, l) {
  if (i.length === 0)
    return i;
  var f = i;
  if (typeof i == "symbol" ? f = Symbol.prototype.toString.call(i) : typeof i != "string" && (f = String(i)), h === "iso-8859-1")
    return escape(f).replace(/%u[0-9a-f]{4}/gi, function(C) {
      return "%26%23" + parseInt(C.slice(2), 16) + "%3B";
    });
  for (var m = "", y = 0; y < f.length; ++y) {
    var v = f.charCodeAt(y);
    if (v === 45 || v === 46 || v === 95 || v === 126 || v >= 48 && v <= 57 || v >= 65 && v <= 90 || v >= 97 && v <= 122 || l === dO.RFC1738 && (v === 40 || v === 41)) {
      m += f.charAt(y);
      continue;
    }
    if (v < 128) {
      m = m + rr[v];
      continue;
    }
    if (v < 2048) {
      m = m + (rr[192 | v >> 6] + rr[128 | v & 63]);
      continue;
    }
    if (v < 55296 || v >= 57344) {
      m = m + (rr[224 | v >> 12] + rr[128 | v >> 6 & 63] + rr[128 | v & 63]);
      continue;
    }
    y += 1, v = 65536 + ((v & 1023) << 10 | f.charCodeAt(y) & 1023), m += rr[240 | v >> 18] + rr[128 | v >> 12 & 63] + rr[128 | v >> 6 & 63] + rr[128 | v & 63];
  }
  return m;
}, yO = function(i) {
  for (var r = [{ obj: { o: i }, prop: "o" }], h = [], a = 0; a < r.length; ++a)
    for (var l = r[a], f = l.obj[l.prop], m = Object.keys(f), y = 0; y < m.length; ++y) {
      var v = m[y], C = f[v];
      typeof C == "object" && C !== null && h.indexOf(C) === -1 && (r.push({ obj: f, prop: v }), h.push(C));
    }
  return pO(r), i;
}, LO = function(i) {
  return Object.prototype.toString.call(i) === "[object RegExp]";
}, wO = function(i) {
  return !i || typeof i != "object" ? !1 : !!(i.constructor && i.constructor.isBuffer && i.constructor.isBuffer(i));
}, bO = function(i, r) {
  return [].concat(i, r);
}, SO = function(i, r) {
  if (No(i)) {
    for (var h = [], a = 0; a < i.length; a += 1)
      h.push(r(i[a]));
    return h;
  }
  return r(i);
}, Bm = {
  arrayToObject: zm,
  assign: _O,
  combine: bO,
  compact: yO,
  decode: gO,
  encode: vO,
  isBuffer: wO,
  isRegExp: LO,
  maybeMap: SO,
  merge: mO
}, Um = cO, Dc = Bm, La = Xc, CO = Object.prototype.hasOwnProperty, Pp = {
  brackets: function(i) {
    return i + "[]";
  },
  comma: "comma",
  indices: function(i, r) {
    return i + "[" + r + "]";
  },
  repeat: function(i) {
    return i;
  }
}, Dr = Array.isArray, TO = String.prototype.split, EO = Array.prototype.push, Fm = function(t, i) {
  EO.apply(t, Dr(i) ? i : [i]);
}, PO = Date.prototype.toISOString, Mp = La.default, mn = {
  addQueryPrefix: !1,
  allowDots: !1,
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encoder: Dc.encode,
  encodeValuesOnly: !1,
  format: Mp,
  formatter: La.formatters[Mp],
  indices: !1,
  serializeDate: function(i) {
    return PO.call(i);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, MO = function(i) {
  return typeof i == "string" || typeof i == "number" || typeof i == "boolean" || typeof i == "symbol" || typeof i == "bigint";
}, fc = {}, OO = function t(i, r, h, a, l, f, m, y, v, C, M, N, I, D, B, X) {
  for (var le = i, Q = X, re = 0, ve = !1; (Q = Q.get(fc)) !== void 0 && !ve; ) {
    var Le = Q.get(i);
    if (re += 1, typeof Le < "u") {
      if (Le === re)
        throw new RangeError("Cyclic object value");
      ve = !0;
    }
    typeof Q.get(fc) > "u" && (re = 0);
  }
  if (typeof y == "function" ? le = y(r, le) : le instanceof Date ? le = M(le) : h === "comma" && Dr(le) && (le = Dc.maybeMap(le, function(gi) {
    return gi instanceof Date ? M(gi) : gi;
  })), le === null) {
    if (l)
      return m && !D ? m(r, mn.encoder, B, "key", N) : r;
    le = "";
  }
  if (MO(le) || Dc.isBuffer(le)) {
    if (m) {
      var Ce = D ? r : m(r, mn.encoder, B, "key", N);
      if (h === "comma" && D) {
        for (var se = TO.call(String(le), ","), Me = "", rt = 0; rt < se.length; ++rt)
          Me += (rt === 0 ? "" : ",") + I(m(se[rt], mn.encoder, B, "value", N));
        return [I(Ce) + (a && Dr(le) && se.length === 1 ? "[]" : "") + "=" + Me];
      }
      return [I(Ce) + "=" + I(m(le, mn.encoder, B, "value", N))];
    }
    return [I(r) + "=" + I(String(le))];
  }
  var Et = [];
  if (typeof le > "u")
    return Et;
  var Pt;
  if (h === "comma" && Dr(le))
    Pt = [{ value: le.length > 0 ? le.join(",") || null : void 0 }];
  else if (Dr(y))
    Pt = y;
  else {
    var xt = Object.keys(le);
    Pt = v ? xt.sort(v) : xt;
  }
  for (var _n = a && Dr(le) && le.length === 1 ? r + "[]" : r, Dt = 0; Dt < Pt.length; ++Dt) {
    var gn = Pt[Dt], It = typeof gn == "object" && typeof gn.value < "u" ? gn.value : le[gn];
    if (!(f && It === null)) {
      var Kt = Dr(le) ? typeof h == "function" ? h(_n, gn) : _n : _n + (C ? "." + gn : "[" + gn + "]");
      X.set(i, re);
      var we = Um();
      we.set(fc, X), Fm(Et, t(
        It,
        Kt,
        h,
        a,
        l,
        f,
        m,
        y,
        v,
        C,
        M,
        N,
        I,
        D,
        B,
        we
      ));
    }
  }
  return Et;
}, xO = function(i) {
  if (!i)
    return mn;
  if (i.encoder !== null && typeof i.encoder < "u" && typeof i.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var r = i.charset || mn.charset;
  if (typeof i.charset < "u" && i.charset !== "utf-8" && i.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var h = La.default;
  if (typeof i.format < "u") {
    if (!CO.call(La.formatters, i.format))
      throw new TypeError("Unknown format option provided.");
    h = i.format;
  }
  var a = La.formatters[h], l = mn.filter;
  return (typeof i.filter == "function" || Dr(i.filter)) && (l = i.filter), {
    addQueryPrefix: typeof i.addQueryPrefix == "boolean" ? i.addQueryPrefix : mn.addQueryPrefix,
    allowDots: typeof i.allowDots > "u" ? mn.allowDots : !!i.allowDots,
    charset: r,
    charsetSentinel: typeof i.charsetSentinel == "boolean" ? i.charsetSentinel : mn.charsetSentinel,
    delimiter: typeof i.delimiter > "u" ? mn.delimiter : i.delimiter,
    encode: typeof i.encode == "boolean" ? i.encode : mn.encode,
    encoder: typeof i.encoder == "function" ? i.encoder : mn.encoder,
    encodeValuesOnly: typeof i.encodeValuesOnly == "boolean" ? i.encodeValuesOnly : mn.encodeValuesOnly,
    filter: l,
    format: h,
    formatter: a,
    serializeDate: typeof i.serializeDate == "function" ? i.serializeDate : mn.serializeDate,
    skipNulls: typeof i.skipNulls == "boolean" ? i.skipNulls : mn.skipNulls,
    sort: typeof i.sort == "function" ? i.sort : null,
    strictNullHandling: typeof i.strictNullHandling == "boolean" ? i.strictNullHandling : mn.strictNullHandling
  };
}, DO = function(t, i) {
  var r = t, h = xO(i), a, l;
  typeof h.filter == "function" ? (l = h.filter, r = l("", r)) : Dr(h.filter) && (l = h.filter, a = l);
  var f = [];
  if (typeof r != "object" || r === null)
    return "";
  var m;
  i && i.arrayFormat in Pp ? m = i.arrayFormat : i && "indices" in i ? m = i.indices ? "indices" : "repeat" : m = "indices";
  var y = Pp[m];
  if (i && "commaRoundTrip" in i && typeof i.commaRoundTrip != "boolean")
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  var v = y === "comma" && i && i.commaRoundTrip;
  a || (a = Object.keys(r)), h.sort && a.sort(h.sort);
  for (var C = Um(), M = 0; M < a.length; ++M) {
    var N = a[M];
    h.skipNulls && r[N] === null || Fm(f, OO(
      r[N],
      N,
      y,
      v,
      h.strictNullHandling,
      h.skipNulls,
      h.encode ? h.encoder : null,
      h.filter,
      h.sort,
      h.allowDots,
      h.serializeDate,
      h.format,
      h.formatter,
      h.encodeValuesOnly,
      h.charset,
      C
    ));
  }
  var I = f.join(h.delimiter), D = h.addQueryPrefix === !0 ? "?" : "";
  return h.charsetSentinel && (h.charset === "iso-8859-1" ? D += "utf8=%26%2310003%3B&" : D += "utf8=%E2%9C%93&"), I.length > 0 ? D + I : "";
}, xs = Bm, kc = Object.prototype.hasOwnProperty, kO = Array.isArray, dn = {
  allowDots: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decoder: xs.decode,
  delimiter: "&",
  depth: 5,
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictNullHandling: !1
}, AO = function(t) {
  return t.replace(/&#(\d+);/g, function(i, r) {
    return String.fromCharCode(parseInt(r, 10));
  });
}, Hm = function(t, i) {
  return t && typeof t == "string" && i.comma && t.indexOf(",") > -1 ? t.split(",") : t;
}, IO = "utf8=%26%2310003%3B", NO = "utf8=%E2%9C%93", RO = function(i, r) {
  var h = {}, a = r.ignoreQueryPrefix ? i.replace(/^\?/, "") : i, l = r.parameterLimit === 1 / 0 ? void 0 : r.parameterLimit, f = a.split(r.delimiter, l), m = -1, y, v = r.charset;
  if (r.charsetSentinel)
    for (y = 0; y < f.length; ++y)
      f[y].indexOf("utf8=") === 0 && (f[y] === NO ? v = "utf-8" : f[y] === IO && (v = "iso-8859-1"), m = y, y = f.length);
  for (y = 0; y < f.length; ++y)
    if (y !== m) {
      var C = f[y], M = C.indexOf("]="), N = M === -1 ? C.indexOf("=") : M + 1, I, D;
      N === -1 ? (I = r.decoder(C, dn.decoder, v, "key"), D = r.strictNullHandling ? null : "") : (I = r.decoder(C.slice(0, N), dn.decoder, v, "key"), D = xs.maybeMap(
        Hm(C.slice(N + 1), r),
        function(B) {
          return r.decoder(B, dn.decoder, v, "value");
        }
      )), D && r.interpretNumericEntities && v === "iso-8859-1" && (D = AO(D)), C.indexOf("[]=") > -1 && (D = kO(D) ? [D] : D), kc.call(h, I) ? h[I] = xs.combine(h[I], D) : h[I] = D;
    }
  return h;
}, $O = function(t, i, r, h) {
  for (var a = h ? i : Hm(i, r), l = t.length - 1; l >= 0; --l) {
    var f, m = t[l];
    if (m === "[]" && r.parseArrays)
      f = [].concat(a);
    else {
      f = r.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var y = m.charAt(0) === "[" && m.charAt(m.length - 1) === "]" ? m.slice(1, -1) : m, v = parseInt(y, 10);
      !r.parseArrays && y === "" ? f = { 0: a } : !isNaN(v) && m !== y && String(v) === y && v >= 0 && r.parseArrays && v <= r.arrayLimit ? (f = [], f[v] = a) : y !== "__proto__" && (f[y] = a);
    }
    a = f;
  }
  return a;
}, zO = function(i, r, h, a) {
  if (i) {
    var l = h.allowDots ? i.replace(/\.([^.[]+)/g, "[$1]") : i, f = /(\[[^[\]]*])/, m = /(\[[^[\]]*])/g, y = h.depth > 0 && f.exec(l), v = y ? l.slice(0, y.index) : l, C = [];
    if (v) {
      if (!h.plainObjects && kc.call(Object.prototype, v) && !h.allowPrototypes)
        return;
      C.push(v);
    }
    for (var M = 0; h.depth > 0 && (y = m.exec(l)) !== null && M < h.depth; ) {
      if (M += 1, !h.plainObjects && kc.call(Object.prototype, y[1].slice(1, -1)) && !h.allowPrototypes)
        return;
      C.push(y[1]);
    }
    return y && C.push("[" + l.slice(y.index) + "]"), $O(C, r, h, a);
  }
}, BO = function(i) {
  if (!i)
    return dn;
  if (i.decoder !== null && i.decoder !== void 0 && typeof i.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof i.charset < "u" && i.charset !== "utf-8" && i.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var r = typeof i.charset > "u" ? dn.charset : i.charset;
  return {
    allowDots: typeof i.allowDots > "u" ? dn.allowDots : !!i.allowDots,
    allowPrototypes: typeof i.allowPrototypes == "boolean" ? i.allowPrototypes : dn.allowPrototypes,
    allowSparse: typeof i.allowSparse == "boolean" ? i.allowSparse : dn.allowSparse,
    arrayLimit: typeof i.arrayLimit == "number" ? i.arrayLimit : dn.arrayLimit,
    charset: r,
    charsetSentinel: typeof i.charsetSentinel == "boolean" ? i.charsetSentinel : dn.charsetSentinel,
    comma: typeof i.comma == "boolean" ? i.comma : dn.comma,
    decoder: typeof i.decoder == "function" ? i.decoder : dn.decoder,
    delimiter: typeof i.delimiter == "string" || xs.isRegExp(i.delimiter) ? i.delimiter : dn.delimiter,
    depth: typeof i.depth == "number" || i.depth === !1 ? +i.depth : dn.depth,
    ignoreQueryPrefix: i.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof i.interpretNumericEntities == "boolean" ? i.interpretNumericEntities : dn.interpretNumericEntities,
    parameterLimit: typeof i.parameterLimit == "number" ? i.parameterLimit : dn.parameterLimit,
    parseArrays: i.parseArrays !== !1,
    plainObjects: typeof i.plainObjects == "boolean" ? i.plainObjects : dn.plainObjects,
    strictNullHandling: typeof i.strictNullHandling == "boolean" ? i.strictNullHandling : dn.strictNullHandling
  };
}, UO = function(t, i) {
  var r = BO(i);
  if (t === "" || t === null || typeof t > "u")
    return r.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var h = typeof t == "string" ? RO(t, r) : t, a = r.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, l = Object.keys(h), f = 0; f < l.length; ++f) {
    var m = l[f], y = zO(m, h[m], r, typeof t == "string");
    a = xs.merge(a, y, r);
  }
  return r.allowSparse === !0 ? a : xs.compact(a);
}, FO = DO, HO = UO, ZO = Xc, Op = {
  formats: ZO,
  parse: HO,
  stringify: FO
};
function Zm(t, i) {
  return function() {
    return t.apply(i, arguments);
  };
}
const { toString: Vm } = Object.prototype, { getPrototypeOf: Qc } = Object, eh = ((t) => (i) => {
  const r = Vm.call(i);
  return t[r] || (t[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Ar = (t) => (t = t.toLowerCase(), (i) => eh(i) === t), Fl = (t) => (i) => typeof i === t, { isArray: Ns } = Array, ba = Fl("undefined");
function VO(t) {
  return t !== null && !ba(t) && t.constructor !== null && !ba(t.constructor) && Bo(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const Wm = Ar("ArrayBuffer");
function WO(t) {
  let i;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? i = ArrayBuffer.isView(t) : i = t && t.buffer && Wm(t.buffer), i;
}
const jO = Fl("string"), Bo = Fl("function"), jm = Fl("number"), th = (t) => t !== null && typeof t == "object", GO = (t) => t === !0 || t === !1, Sl = (t) => {
  if (eh(t) !== "object")
    return !1;
  const i = Qc(t);
  return (i === null || i === Object.prototype || Object.getPrototypeOf(i) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}, qO = Ar("Date"), YO = Ar("File"), KO = Ar("Blob"), JO = Ar("FileList"), XO = (t) => th(t) && Bo(t.pipe), QO = (t) => {
  const i = "[object FormData]";
  return t && (typeof FormData == "function" && t instanceof FormData || Vm.call(t) === i || Bo(t.toString) && t.toString() === i);
}, ex = Ar("URLSearchParams"), tx = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Ea(t, i, { allOwnKeys: r = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let h, a;
  if (typeof t != "object" && (t = [t]), Ns(t))
    for (h = 0, a = t.length; h < a; h++)
      i.call(null, t[h], h, t);
  else {
    const l = r ? Object.getOwnPropertyNames(t) : Object.keys(t), f = l.length;
    let m;
    for (h = 0; h < f; h++)
      m = l[h], i.call(null, t[m], m, t);
  }
}
function Gm(t, i) {
  i = i.toLowerCase();
  const r = Object.keys(t);
  let h = r.length, a;
  for (; h-- > 0; )
    if (a = r[h], i === a.toLowerCase())
      return a;
  return null;
}
const qm = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), Ym = (t) => !ba(t) && t !== qm;
function Ac() {
  const { caseless: t } = Ym(this) && this || {}, i = {}, r = (h, a) => {
    const l = t && Gm(i, a) || a;
    Sl(i[l]) && Sl(h) ? i[l] = Ac(i[l], h) : Sl(h) ? i[l] = Ac({}, h) : Ns(h) ? i[l] = h.slice() : i[l] = h;
  };
  for (let h = 0, a = arguments.length; h < a; h++)
    arguments[h] && Ea(arguments[h], r);
  return i;
}
const nx = (t, i, r, { allOwnKeys: h } = {}) => (Ea(i, (a, l) => {
  r && Bo(a) ? t[l] = Zm(a, r) : t[l] = a;
}, { allOwnKeys: h }), t), ix = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), rx = (t, i, r, h) => {
  t.prototype = Object.create(i.prototype, h), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: i.prototype
  }), r && Object.assign(t.prototype, r);
}, ox = (t, i, r, h) => {
  let a, l, f;
  const m = {};
  if (i = i || {}, t == null)
    return i;
  do {
    for (a = Object.getOwnPropertyNames(t), l = a.length; l-- > 0; )
      f = a[l], (!h || h(f, t, i)) && !m[f] && (i[f] = t[f], m[f] = !0);
    t = r !== !1 && Qc(t);
  } while (t && (!r || r(t, i)) && t !== Object.prototype);
  return i;
}, sx = (t, i, r) => {
  t = String(t), (r === void 0 || r > t.length) && (r = t.length), r -= i.length;
  const h = t.indexOf(i, r);
  return h !== -1 && h === r;
}, ax = (t) => {
  if (!t)
    return null;
  if (Ns(t))
    return t;
  let i = t.length;
  if (!jm(i))
    return null;
  const r = new Array(i);
  for (; i-- > 0; )
    r[i] = t[i];
  return r;
}, lx = ((t) => (i) => t && i instanceof t)(typeof Uint8Array < "u" && Qc(Uint8Array)), ux = (t, i) => {
  const h = (t && t[Symbol.iterator]).call(t);
  let a;
  for (; (a = h.next()) && !a.done; ) {
    const l = a.value;
    i.call(t, l[0], l[1]);
  }
}, cx = (t, i) => {
  let r;
  const h = [];
  for (; (r = t.exec(i)) !== null; )
    h.push(r);
  return h;
}, hx = Ar("HTMLFormElement"), fx = (t) => t.toLowerCase().replace(
  /[_-\s]([a-z\d])(\w*)/g,
  function(r, h, a) {
    return h.toUpperCase() + a;
  }
), xp = (({ hasOwnProperty: t }) => (i, r) => t.call(i, r))(Object.prototype), dx = Ar("RegExp"), Km = (t, i) => {
  const r = Object.getOwnPropertyDescriptors(t), h = {};
  Ea(r, (a, l) => {
    i(a, l, t) !== !1 && (h[l] = a);
  }), Object.defineProperties(t, h);
}, px = (t) => {
  Km(t, (i, r) => {
    if (Bo(t) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const h = t[r];
    if (Bo(h)) {
      if (i.enumerable = !1, "writable" in i) {
        i.writable = !1;
        return;
      }
      i.set || (i.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, mx = (t, i) => {
  const r = {}, h = (a) => {
    a.forEach((l) => {
      r[l] = !0;
    });
  };
  return Ns(t) ? h(t) : h(String(t).split(i)), r;
}, _x = () => {
}, gx = (t, i) => (t = +t, Number.isFinite(t) ? t : i), vx = (t) => {
  const i = new Array(10), r = (h, a) => {
    if (th(h)) {
      if (i.indexOf(h) >= 0)
        return;
      if (!("toJSON" in h)) {
        i[a] = h;
        const l = Ns(h) ? [] : {};
        return Ea(h, (f, m) => {
          const y = r(f, a + 1);
          !ba(y) && (l[m] = y);
        }), i[a] = void 0, l;
      }
    }
    return h;
  };
  return r(t, 0);
}, te = {
  isArray: Ns,
  isArrayBuffer: Wm,
  isBuffer: VO,
  isFormData: QO,
  isArrayBufferView: WO,
  isString: jO,
  isNumber: jm,
  isBoolean: GO,
  isObject: th,
  isPlainObject: Sl,
  isUndefined: ba,
  isDate: qO,
  isFile: YO,
  isBlob: KO,
  isRegExp: dx,
  isFunction: Bo,
  isStream: XO,
  isURLSearchParams: ex,
  isTypedArray: lx,
  isFileList: JO,
  forEach: Ea,
  merge: Ac,
  extend: nx,
  trim: tx,
  stripBOM: ix,
  inherits: rx,
  toFlatObject: ox,
  kindOf: eh,
  kindOfTest: Ar,
  endsWith: sx,
  toArray: ax,
  forEachEntry: ux,
  matchAll: cx,
  isHTMLForm: hx,
  hasOwnProperty: xp,
  hasOwnProp: xp,
  reduceDescriptors: Km,
  freezeMethods: px,
  toObjectSet: mx,
  toCamelCase: fx,
  noop: _x,
  toFiniteNumber: gx,
  findKey: Gm,
  global: qm,
  isContextDefined: Ym,
  toJSONObject: vx
};
function ut(t, i, r, h, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", i && (this.code = i), r && (this.config = r), h && (this.request = h), a && (this.response = a);
}
te.inherits(ut, Error, {
  toJSON: function() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: te.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const Jm = ut.prototype, Xm = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
].forEach((t) => {
  Xm[t] = { value: t };
});
Object.defineProperties(ut, Xm);
Object.defineProperty(Jm, "isAxiosError", { value: !0 });
ut.from = (t, i, r, h, a, l) => {
  const f = Object.create(Jm);
  return te.toFlatObject(t, f, function(y) {
    return y !== Error.prototype;
  }, (m) => m !== "isAxiosError"), ut.call(f, t.message, i, r, h, a), f.cause = t, f.name = t.name, l && Object.assign(f, l), f;
};
var yx = typeof self == "object" ? self.FormData : window.FormData;
const Lx = yx;
function Ic(t) {
  return te.isPlainObject(t) || te.isArray(t);
}
function Qm(t) {
  return te.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function Dp(t, i, r) {
  return t ? t.concat(i).map(function(a, l) {
    return a = Qm(a), !r && l ? "[" + a + "]" : a;
  }).join(r ? "." : "") : i;
}
function wx(t) {
  return te.isArray(t) && !t.some(Ic);
}
const bx = te.toFlatObject(te, {}, null, function(i) {
  return /^is[A-Z]/.test(i);
});
function Sx(t) {
  return t && te.isFunction(t.append) && t[Symbol.toStringTag] === "FormData" && t[Symbol.iterator];
}
function Hl(t, i, r) {
  if (!te.isObject(t))
    throw new TypeError("target must be an object");
  i = i || new (Lx || FormData)(), r = te.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(B, X) {
    return !te.isUndefined(X[B]);
  });
  const h = r.metaTokens, a = r.visitor || C, l = r.dots, f = r.indexes, y = (r.Blob || typeof Blob < "u" && Blob) && Sx(i);
  if (!te.isFunction(a))
    throw new TypeError("visitor must be a function");
  function v(D) {
    if (D === null)
      return "";
    if (te.isDate(D))
      return D.toISOString();
    if (!y && te.isBlob(D))
      throw new ut("Blob is not supported. Use a Buffer instead.");
    return te.isArrayBuffer(D) || te.isTypedArray(D) ? y && typeof Blob == "function" ? new Blob([D]) : Buffer.from(D) : D;
  }
  function C(D, B, X) {
    let le = D;
    if (D && !X && typeof D == "object") {
      if (te.endsWith(B, "{}"))
        B = h ? B : B.slice(0, -2), D = JSON.stringify(D);
      else if (te.isArray(D) && wx(D) || te.isFileList(D) || te.endsWith(B, "[]") && (le = te.toArray(D)))
        return B = Qm(B), le.forEach(function(re, ve) {
          !(te.isUndefined(re) || re === null) && i.append(
            f === !0 ? Dp([B], ve, l) : f === null ? B : B + "[]",
            v(re)
          );
        }), !1;
    }
    return Ic(D) ? !0 : (i.append(Dp(X, B, l), v(D)), !1);
  }
  const M = [], N = Object.assign(bx, {
    defaultVisitor: C,
    convertValue: v,
    isVisitable: Ic
  });
  function I(D, B) {
    if (!te.isUndefined(D)) {
      if (M.indexOf(D) !== -1)
        throw Error("Circular reference detected in " + B.join("."));
      M.push(D), te.forEach(D, function(le, Q) {
        (!(te.isUndefined(le) || le === null) && a.call(
          i,
          le,
          te.isString(Q) ? Q.trim() : Q,
          B,
          N
        )) === !0 && I(le, B ? B.concat(Q) : [Q]);
      }), M.pop();
    }
  }
  if (!te.isObject(t))
    throw new TypeError("data must be an object");
  return I(t), i;
}
function kp(t) {
  const i = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(h) {
    return i[h];
  });
}
function nh(t, i) {
  this._pairs = [], t && Hl(t, this, i);
}
const e_ = nh.prototype;
e_.append = function(i, r) {
  this._pairs.push([i, r]);
};
e_.toString = function(i) {
  const r = i ? function(h) {
    return i.call(this, h, kp);
  } : kp;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function Cx(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function t_(t, i, r) {
  if (!i)
    return t;
  const h = r && r.encode || Cx, a = r && r.serialize;
  let l;
  if (a ? l = a(i, r) : l = te.isURLSearchParams(i) ? i.toString() : new nh(i, r).toString(h), l) {
    const f = t.indexOf("#");
    f !== -1 && (t = t.slice(0, f)), t += (t.indexOf("?") === -1 ? "?" : "&") + l;
  }
  return t;
}
class Tx {
  constructor() {
    this.handlers = [];
  }
  use(i, r, h) {
    return this.handlers.push({
      fulfilled: i,
      rejected: r,
      synchronous: h ? h.synchronous : !1,
      runWhen: h ? h.runWhen : null
    }), this.handlers.length - 1;
  }
  eject(i) {
    this.handlers[i] && (this.handlers[i] = null);
  }
  clear() {
    this.handlers && (this.handlers = []);
  }
  forEach(i) {
    te.forEach(this.handlers, function(h) {
      h !== null && i(h);
    });
  }
}
const Ap = Tx, n_ = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Ex = typeof URLSearchParams < "u" ? URLSearchParams : nh, Px = FormData, Mx = (() => {
  let t;
  return typeof navigator < "u" && ((t = navigator.product) === "ReactNative" || t === "NativeScript" || t === "NS") ? !1 : typeof window < "u" && typeof document < "u";
})(), Ox = (() => typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), sr = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Ex,
    FormData: Px,
    Blob
  },
  isStandardBrowserEnv: Mx,
  isStandardBrowserWebWorkerEnv: Ox,
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
function xx(t, i) {
  return Hl(t, new sr.classes.URLSearchParams(), Object.assign({
    visitor: function(r, h, a, l) {
      return sr.isNode && te.isBuffer(r) ? (this.append(h, r.toString("base64")), !1) : l.defaultVisitor.apply(this, arguments);
    }
  }, i));
}
function Dx(t) {
  return te.matchAll(/\w+|\[(\w*)]/g, t).map((i) => i[0] === "[]" ? "" : i[1] || i[0]);
}
function kx(t) {
  const i = {}, r = Object.keys(t);
  let h;
  const a = r.length;
  let l;
  for (h = 0; h < a; h++)
    l = r[h], i[l] = t[l];
  return i;
}
function i_(t) {
  function i(r, h, a, l) {
    let f = r[l++];
    const m = Number.isFinite(+f), y = l >= r.length;
    return f = !f && te.isArray(a) ? a.length : f, y ? (te.hasOwnProp(a, f) ? a[f] = [a[f], h] : a[f] = h, !m) : ((!a[f] || !te.isObject(a[f])) && (a[f] = []), i(r, h, a[f], l) && te.isArray(a[f]) && (a[f] = kx(a[f])), !m);
  }
  if (te.isFormData(t) && te.isFunction(t.entries)) {
    const r = {};
    return te.forEachEntry(t, (h, a) => {
      i(Dx(h), a, r, 0);
    }), r;
  }
  return null;
}
const Ax = {
  "Content-Type": void 0
};
function Ix(t, i, r) {
  if (te.isString(t))
    try {
      return (i || JSON.parse)(t), te.trim(t);
    } catch (h) {
      if (h.name !== "SyntaxError")
        throw h;
    }
  return (r || JSON.stringify)(t);
}
const Zl = {
  transitional: n_,
  adapter: ["xhr", "http"],
  transformRequest: [function(i, r) {
    const h = r.getContentType() || "", a = h.indexOf("application/json") > -1, l = te.isObject(i);
    if (l && te.isHTMLForm(i) && (i = new FormData(i)), te.isFormData(i))
      return a && a ? JSON.stringify(i_(i)) : i;
    if (te.isArrayBuffer(i) || te.isBuffer(i) || te.isStream(i) || te.isFile(i) || te.isBlob(i))
      return i;
    if (te.isArrayBufferView(i))
      return i.buffer;
    if (te.isURLSearchParams(i))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), i.toString();
    let m;
    if (l) {
      if (h.indexOf("application/x-www-form-urlencoded") > -1)
        return xx(i, this.formSerializer).toString();
      if ((m = te.isFileList(i)) || h.indexOf("multipart/form-data") > -1) {
        const y = this.env && this.env.FormData;
        return Hl(
          m ? { "files[]": i } : i,
          y && new y(),
          this.formSerializer
        );
      }
    }
    return l || a ? (r.setContentType("application/json", !1), Ix(i)) : i;
  }],
  transformResponse: [function(i) {
    const r = this.transitional || Zl.transitional, h = r && r.forcedJSONParsing, a = this.responseType === "json";
    if (i && te.isString(i) && (h && !this.responseType || a)) {
      const f = !(r && r.silentJSONParsing) && a;
      try {
        return JSON.parse(i);
      } catch (m) {
        if (f)
          throw m.name === "SyntaxError" ? ut.from(m, ut.ERR_BAD_RESPONSE, this, null, this.response) : m;
      }
    }
    return i;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: sr.classes.FormData,
    Blob: sr.classes.Blob
  },
  validateStatus: function(i) {
    return i >= 200 && i < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
te.forEach(["delete", "get", "head"], function(i) {
  Zl.headers[i] = {};
});
te.forEach(["post", "put", "patch"], function(i) {
  Zl.headers[i] = te.merge(Ax);
});
const ih = Zl, Nx = te.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Rx = (t) => {
  const i = {};
  let r, h, a;
  return t && t.split(`
`).forEach(function(f) {
    a = f.indexOf(":"), r = f.substring(0, a).trim().toLowerCase(), h = f.substring(a + 1).trim(), !(!r || i[r] && Nx[r]) && (r === "set-cookie" ? i[r] ? i[r].push(h) : i[r] = [h] : i[r] = i[r] ? i[r] + ", " + h : h);
  }), i;
}, Ip = Symbol("internals");
function _a(t) {
  return t && String(t).trim().toLowerCase();
}
function Cl(t) {
  return t === !1 || t == null ? t : te.isArray(t) ? t.map(Cl) : String(t);
}
function $x(t) {
  const i = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let h;
  for (; h = r.exec(t); )
    i[h[1]] = h[2];
  return i;
}
function zx(t) {
  return /^[-_a-zA-Z]+$/.test(t.trim());
}
function Np(t, i, r, h) {
  if (te.isFunction(h))
    return h.call(this, i, r);
  if (te.isString(i)) {
    if (te.isString(h))
      return i.indexOf(h) !== -1;
    if (te.isRegExp(h))
      return h.test(i);
  }
}
function Bx(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (i, r, h) => r.toUpperCase() + h);
}
function Ux(t, i) {
  const r = te.toCamelCase(" " + i);
  ["get", "set", "has"].forEach((h) => {
    Object.defineProperty(t, h + r, {
      value: function(a, l, f) {
        return this[h].call(this, i, a, l, f);
      },
      configurable: !0
    });
  });
}
class Vl {
  constructor(i) {
    i && this.set(i);
  }
  set(i, r, h) {
    const a = this;
    function l(m, y, v) {
      const C = _a(y);
      if (!C)
        throw new Error("header name must be a non-empty string");
      const M = te.findKey(a, C);
      (!M || a[M] === void 0 || v === !0 || v === void 0 && a[M] !== !1) && (a[M || y] = Cl(m));
    }
    const f = (m, y) => te.forEach(m, (v, C) => l(v, C, y));
    return te.isPlainObject(i) || i instanceof this.constructor ? f(i, r) : te.isString(i) && (i = i.trim()) && !zx(i) ? f(Rx(i), r) : i != null && l(r, i, h), this;
  }
  get(i, r) {
    if (i = _a(i), i) {
      const h = te.findKey(this, i);
      if (h) {
        const a = this[h];
        if (!r)
          return a;
        if (r === !0)
          return $x(a);
        if (te.isFunction(r))
          return r.call(this, a, h);
        if (te.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(i, r) {
    if (i = _a(i), i) {
      const h = te.findKey(this, i);
      return !!(h && (!r || Np(this, this[h], h, r)));
    }
    return !1;
  }
  delete(i, r) {
    const h = this;
    let a = !1;
    function l(f) {
      if (f = _a(f), f) {
        const m = te.findKey(h, f);
        m && (!r || Np(h, h[m], m, r)) && (delete h[m], a = !0);
      }
    }
    return te.isArray(i) ? i.forEach(l) : l(i), a;
  }
  clear() {
    return Object.keys(this).forEach(this.delete.bind(this));
  }
  normalize(i) {
    const r = this, h = {};
    return te.forEach(this, (a, l) => {
      const f = te.findKey(h, l);
      if (f) {
        r[f] = Cl(a), delete r[l];
        return;
      }
      const m = i ? Bx(l) : String(l).trim();
      m !== l && delete r[l], r[m] = Cl(a), h[m] = !0;
    }), this;
  }
  concat(...i) {
    return this.constructor.concat(this, ...i);
  }
  toJSON(i) {
    const r = /* @__PURE__ */ Object.create(null);
    return te.forEach(this, (h, a) => {
      h != null && h !== !1 && (r[a] = i && te.isArray(h) ? h.join(", ") : h);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([i, r]) => i + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(i) {
    return i instanceof this ? i : new this(i);
  }
  static concat(i, ...r) {
    const h = new this(i);
    return r.forEach((a) => h.set(a)), h;
  }
  static accessor(i) {
    const h = (this[Ip] = this[Ip] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function l(f) {
      const m = _a(f);
      h[m] || (Ux(a, f), h[m] = !0);
    }
    return te.isArray(i) ? i.forEach(l) : l(i), this;
  }
}
Vl.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent"]);
te.freezeMethods(Vl.prototype);
te.freezeMethods(Vl);
const kr = Vl;
function dc(t, i) {
  const r = this || ih, h = i || r, a = kr.from(h.headers);
  let l = h.data;
  return te.forEach(t, function(m) {
    l = m.call(r, l, a.normalize(), i ? i.status : void 0);
  }), a.normalize(), l;
}
function r_(t) {
  return !!(t && t.__CANCEL__);
}
function Pa(t, i, r) {
  ut.call(this, t ?? "canceled", ut.ERR_CANCELED, i, r), this.name = "CanceledError";
}
te.inherits(Pa, ut, {
  __CANCEL__: !0
});
const Fx = null;
function Hx(t, i, r) {
  const h = r.config.validateStatus;
  !r.status || !h || h(r.status) ? t(r) : i(new ut(
    "Request failed with status code " + r.status,
    [ut.ERR_BAD_REQUEST, ut.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
const Zx = sr.isStandardBrowserEnv ? function() {
  return {
    write: function(r, h, a, l, f, m) {
      const y = [];
      y.push(r + "=" + encodeURIComponent(h)), te.isNumber(a) && y.push("expires=" + new Date(a).toGMTString()), te.isString(l) && y.push("path=" + l), te.isString(f) && y.push("domain=" + f), m === !0 && y.push("secure"), document.cookie = y.join("; ");
    },
    read: function(r) {
      const h = document.cookie.match(new RegExp("(^|;\\s*)(" + r + ")=([^;]*)"));
      return h ? decodeURIComponent(h[3]) : null;
    },
    remove: function(r) {
      this.write(r, "", Date.now() - 864e5);
    }
  };
}() : function() {
  return {
    write: function() {
    },
    read: function() {
      return null;
    },
    remove: function() {
    }
  };
}();
function Vx(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function Wx(t, i) {
  return i ? t.replace(/\/+$/, "") + "/" + i.replace(/^\/+/, "") : t;
}
function o_(t, i) {
  return t && !Vx(i) ? Wx(t, i) : i;
}
const jx = sr.isStandardBrowserEnv ? function() {
  const i = /(msie|trident)/i.test(navigator.userAgent), r = document.createElement("a");
  let h;
  function a(l) {
    let f = l;
    return i && (r.setAttribute("href", f), f = r.href), r.setAttribute("href", f), {
      href: r.href,
      protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
      host: r.host,
      search: r.search ? r.search.replace(/^\?/, "") : "",
      hash: r.hash ? r.hash.replace(/^#/, "") : "",
      hostname: r.hostname,
      port: r.port,
      pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
    };
  }
  return h = a(window.location.href), function(f) {
    const m = te.isString(f) ? a(f) : f;
    return m.protocol === h.protocol && m.host === h.host;
  };
}() : function() {
  return function() {
    return !0;
  };
}();
function Gx(t) {
  const i = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return i && i[1] || "";
}
function qx(t, i) {
  t = t || 10;
  const r = new Array(t), h = new Array(t);
  let a = 0, l = 0, f;
  return i = i !== void 0 ? i : 1e3, function(y) {
    const v = Date.now(), C = h[l];
    f || (f = v), r[a] = y, h[a] = v;
    let M = l, N = 0;
    for (; M !== a; )
      N += r[M++], M = M % t;
    if (a = (a + 1) % t, a === l && (l = (l + 1) % t), v - f < i)
      return;
    const I = C && v - C;
    return I ? Math.round(N * 1e3 / I) : void 0;
  };
}
function Rp(t, i) {
  let r = 0;
  const h = qx(50, 250);
  return (a) => {
    const l = a.loaded, f = a.lengthComputable ? a.total : void 0, m = l - r, y = h(m), v = l <= f;
    r = l;
    const C = {
      loaded: l,
      total: f,
      progress: f ? l / f : void 0,
      bytes: m,
      rate: y || void 0,
      estimated: y && f && v ? (f - l) / y : void 0,
      event: a
    };
    C[i ? "download" : "upload"] = !0, t(C);
  };
}
const Yx = typeof XMLHttpRequest < "u", Kx = Yx && function(t) {
  return new Promise(function(r, h) {
    let a = t.data;
    const l = kr.from(t.headers).normalize(), f = t.responseType;
    let m;
    function y() {
      t.cancelToken && t.cancelToken.unsubscribe(m), t.signal && t.signal.removeEventListener("abort", m);
    }
    te.isFormData(a) && (sr.isStandardBrowserEnv || sr.isStandardBrowserWebWorkerEnv) && l.setContentType(!1);
    let v = new XMLHttpRequest();
    if (t.auth) {
      const I = t.auth.username || "", D = t.auth.password ? unescape(encodeURIComponent(t.auth.password)) : "";
      l.set("Authorization", "Basic " + btoa(I + ":" + D));
    }
    const C = o_(t.baseURL, t.url);
    v.open(t.method.toUpperCase(), t_(C, t.params, t.paramsSerializer), !0), v.timeout = t.timeout;
    function M() {
      if (!v)
        return;
      const I = kr.from(
        "getAllResponseHeaders" in v && v.getAllResponseHeaders()
      ), B = {
        data: !f || f === "text" || f === "json" ? v.responseText : v.response,
        status: v.status,
        statusText: v.statusText,
        headers: I,
        config: t,
        request: v
      };
      Hx(function(le) {
        r(le), y();
      }, function(le) {
        h(le), y();
      }, B), v = null;
    }
    if ("onloadend" in v ? v.onloadend = M : v.onreadystatechange = function() {
      !v || v.readyState !== 4 || v.status === 0 && !(v.responseURL && v.responseURL.indexOf("file:") === 0) || setTimeout(M);
    }, v.onabort = function() {
      v && (h(new ut("Request aborted", ut.ECONNABORTED, t, v)), v = null);
    }, v.onerror = function() {
      h(new ut("Network Error", ut.ERR_NETWORK, t, v)), v = null;
    }, v.ontimeout = function() {
      let D = t.timeout ? "timeout of " + t.timeout + "ms exceeded" : "timeout exceeded";
      const B = t.transitional || n_;
      t.timeoutErrorMessage && (D = t.timeoutErrorMessage), h(new ut(
        D,
        B.clarifyTimeoutError ? ut.ETIMEDOUT : ut.ECONNABORTED,
        t,
        v
      )), v = null;
    }, sr.isStandardBrowserEnv) {
      const I = (t.withCredentials || jx(C)) && t.xsrfCookieName && Zx.read(t.xsrfCookieName);
      I && l.set(t.xsrfHeaderName, I);
    }
    a === void 0 && l.setContentType(null), "setRequestHeader" in v && te.forEach(l.toJSON(), function(D, B) {
      v.setRequestHeader(B, D);
    }), te.isUndefined(t.withCredentials) || (v.withCredentials = !!t.withCredentials), f && f !== "json" && (v.responseType = t.responseType), typeof t.onDownloadProgress == "function" && v.addEventListener("progress", Rp(t.onDownloadProgress, !0)), typeof t.onUploadProgress == "function" && v.upload && v.upload.addEventListener("progress", Rp(t.onUploadProgress)), (t.cancelToken || t.signal) && (m = (I) => {
      v && (h(!I || I.type ? new Pa(null, t, v) : I), v.abort(), v = null);
    }, t.cancelToken && t.cancelToken.subscribe(m), t.signal && (t.signal.aborted ? m() : t.signal.addEventListener("abort", m)));
    const N = Gx(C);
    if (N && sr.protocols.indexOf(N) === -1) {
      h(new ut("Unsupported protocol " + N + ":", ut.ERR_BAD_REQUEST, t));
      return;
    }
    v.send(a || null);
  });
}, Tl = {
  http: Fx,
  xhr: Kx
};
te.forEach(Tl, (t, i) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: i });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: i });
  }
});
const Jx = {
  getAdapter: (t) => {
    t = te.isArray(t) ? t : [t];
    const { length: i } = t;
    let r, h;
    for (let a = 0; a < i && (r = t[a], !(h = te.isString(r) ? Tl[r.toLowerCase()] : r)); a++)
      ;
    if (!h)
      throw h === !1 ? new ut(
        `Adapter ${r} is not supported by the environment`,
        "ERR_NOT_SUPPORT"
      ) : new Error(
        te.hasOwnProp(Tl, r) ? `Adapter '${r}' is not available in the build` : `Unknown adapter '${r}'`
      );
    if (!te.isFunction(h))
      throw new TypeError("adapter is not a function");
    return h;
  },
  adapters: Tl
};
function pc(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new Pa(null, t);
}
function $p(t) {
  return pc(t), t.headers = kr.from(t.headers), t.data = dc.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), Jx.getAdapter(t.adapter || ih.adapter)(t).then(function(h) {
    return pc(t), h.data = dc.call(
      t,
      t.transformResponse,
      h
    ), h.headers = kr.from(h.headers), h;
  }, function(h) {
    return r_(h) || (pc(t), h && h.response && (h.response.data = dc.call(
      t,
      t.transformResponse,
      h.response
    ), h.response.headers = kr.from(h.response.headers))), Promise.reject(h);
  });
}
const zp = (t) => t instanceof kr ? t.toJSON() : t;
function Ds(t, i) {
  i = i || {};
  const r = {};
  function h(v, C, M) {
    return te.isPlainObject(v) && te.isPlainObject(C) ? te.merge.call({ caseless: M }, v, C) : te.isPlainObject(C) ? te.merge({}, C) : te.isArray(C) ? C.slice() : C;
  }
  function a(v, C, M) {
    if (te.isUndefined(C)) {
      if (!te.isUndefined(v))
        return h(void 0, v, M);
    } else
      return h(v, C, M);
  }
  function l(v, C) {
    if (!te.isUndefined(C))
      return h(void 0, C);
  }
  function f(v, C) {
    if (te.isUndefined(C)) {
      if (!te.isUndefined(v))
        return h(void 0, v);
    } else
      return h(void 0, C);
  }
  function m(v, C, M) {
    if (M in i)
      return h(v, C);
    if (M in t)
      return h(void 0, v);
  }
  const y = {
    url: l,
    method: l,
    data: l,
    baseURL: f,
    transformRequest: f,
    transformResponse: f,
    paramsSerializer: f,
    timeout: f,
    timeoutMessage: f,
    withCredentials: f,
    adapter: f,
    responseType: f,
    xsrfCookieName: f,
    xsrfHeaderName: f,
    onUploadProgress: f,
    onDownloadProgress: f,
    decompress: f,
    maxContentLength: f,
    maxBodyLength: f,
    beforeRedirect: f,
    transport: f,
    httpAgent: f,
    httpsAgent: f,
    cancelToken: f,
    socketPath: f,
    responseEncoding: f,
    validateStatus: m,
    headers: (v, C) => a(zp(v), zp(C), !0)
  };
  return te.forEach(Object.keys(t).concat(Object.keys(i)), function(C) {
    const M = y[C] || a, N = M(t[C], i[C], C);
    te.isUndefined(N) && M !== m || (r[C] = N);
  }), r;
}
const s_ = "1.2.2", rh = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, i) => {
  rh[t] = function(h) {
    return typeof h === t || "a" + (i < 1 ? "n " : " ") + t;
  };
});
const Bp = {};
rh.transitional = function(i, r, h) {
  function a(l, f) {
    return "[Axios v" + s_ + "] Transitional option '" + l + "'" + f + (h ? ". " + h : "");
  }
  return (l, f, m) => {
    if (i === !1)
      throw new ut(
        a(f, " has been removed" + (r ? " in " + r : "")),
        ut.ERR_DEPRECATED
      );
    return r && !Bp[f] && (Bp[f] = !0, console.warn(
      a(
        f,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), i ? i(l, f, m) : !0;
  };
};
function Xx(t, i, r) {
  if (typeof t != "object")
    throw new ut("options must be an object", ut.ERR_BAD_OPTION_VALUE);
  const h = Object.keys(t);
  let a = h.length;
  for (; a-- > 0; ) {
    const l = h[a], f = i[l];
    if (f) {
      const m = t[l], y = m === void 0 || f(m, l, t);
      if (y !== !0)
        throw new ut("option " + l + " must be " + y, ut.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new ut("Unknown option " + l, ut.ERR_BAD_OPTION);
  }
}
const Nc = {
  assertOptions: Xx,
  validators: rh
}, eo = Nc.validators;
class Rl {
  constructor(i) {
    this.defaults = i, this.interceptors = {
      request: new Ap(),
      response: new Ap()
    };
  }
  request(i, r) {
    typeof i == "string" ? (r = r || {}, r.url = i) : r = i || {}, r = Ds(this.defaults, r);
    const { transitional: h, paramsSerializer: a, headers: l } = r;
    h !== void 0 && Nc.assertOptions(h, {
      silentJSONParsing: eo.transitional(eo.boolean),
      forcedJSONParsing: eo.transitional(eo.boolean),
      clarifyTimeoutError: eo.transitional(eo.boolean)
    }, !1), a !== void 0 && Nc.assertOptions(a, {
      encode: eo.function,
      serialize: eo.function
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let f;
    f = l && te.merge(
      l.common,
      l[r.method]
    ), f && te.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (D) => {
        delete l[D];
      }
    ), r.headers = kr.concat(f, l);
    const m = [];
    let y = !0;
    this.interceptors.request.forEach(function(B) {
      typeof B.runWhen == "function" && B.runWhen(r) === !1 || (y = y && B.synchronous, m.unshift(B.fulfilled, B.rejected));
    });
    const v = [];
    this.interceptors.response.forEach(function(B) {
      v.push(B.fulfilled, B.rejected);
    });
    let C, M = 0, N;
    if (!y) {
      const D = [$p.bind(this), void 0];
      for (D.unshift.apply(D, m), D.push.apply(D, v), N = D.length, C = Promise.resolve(r); M < N; )
        C = C.then(D[M++], D[M++]);
      return C;
    }
    N = m.length;
    let I = r;
    for (M = 0; M < N; ) {
      const D = m[M++], B = m[M++];
      try {
        I = D(I);
      } catch (X) {
        B.call(this, X);
        break;
      }
    }
    try {
      C = $p.call(this, I);
    } catch (D) {
      return Promise.reject(D);
    }
    for (M = 0, N = v.length; M < N; )
      C = C.then(v[M++], v[M++]);
    return C;
  }
  getUri(i) {
    i = Ds(this.defaults, i);
    const r = o_(i.baseURL, i.url);
    return t_(r, i.params, i.paramsSerializer);
  }
}
te.forEach(["delete", "get", "head", "options"], function(i) {
  Rl.prototype[i] = function(r, h) {
    return this.request(Ds(h || {}, {
      method: i,
      url: r,
      data: (h || {}).data
    }));
  };
});
te.forEach(["post", "put", "patch"], function(i) {
  function r(h) {
    return function(l, f, m) {
      return this.request(Ds(m || {}, {
        method: i,
        headers: h ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: l,
        data: f
      }));
    };
  }
  Rl.prototype[i] = r(), Rl.prototype[i + "Form"] = r(!0);
});
const El = Rl;
class oh {
  constructor(i) {
    if (typeof i != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(l) {
      r = l;
    });
    const h = this;
    this.promise.then((a) => {
      if (!h._listeners)
        return;
      let l = h._listeners.length;
      for (; l-- > 0; )
        h._listeners[l](a);
      h._listeners = null;
    }), this.promise.then = (a) => {
      let l;
      const f = new Promise((m) => {
        h.subscribe(m), l = m;
      }).then(a);
      return f.cancel = function() {
        h.unsubscribe(l);
      }, f;
    }, i(function(l, f, m) {
      h.reason || (h.reason = new Pa(l, f, m), r(h.reason));
    });
  }
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  subscribe(i) {
    if (this.reason) {
      i(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(i) : this._listeners = [i];
  }
  unsubscribe(i) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(i);
    r !== -1 && this._listeners.splice(r, 1);
  }
  static source() {
    let i;
    return {
      token: new oh(function(a) {
        i = a;
      }),
      cancel: i
    };
  }
}
const Qx = oh;
function eD(t) {
  return function(r) {
    return t.apply(null, r);
  };
}
function tD(t) {
  return te.isObject(t) && t.isAxiosError === !0;
}
const Rc = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Rc).forEach(([t, i]) => {
  Rc[i] = t;
});
const nD = Rc;
function a_(t) {
  const i = new El(t), r = Zm(El.prototype.request, i);
  return te.extend(r, El.prototype, i, { allOwnKeys: !0 }), te.extend(r, i, null, { allOwnKeys: !0 }), r.create = function(a) {
    return a_(Ds(t, a));
  }, r;
}
const ln = a_(ih);
ln.Axios = El;
ln.CanceledError = Pa;
ln.CancelToken = Qx;
ln.isCancel = r_;
ln.VERSION = s_;
ln.toFormData = Hl;
ln.AxiosError = ut;
ln.Cancel = ln.CanceledError;
ln.all = function(i) {
  return Promise.all(i);
};
ln.spread = eD;
ln.isAxiosError = tD;
ln.mergeConfig = Ds;
ln.AxiosHeaders = kr;
ln.formToJSON = (t) => i_(te.isHTMLForm(t) ? new FormData(t) : t);
ln.HttpStatusCode = nD;
ln.default = ln;
const iD = ln, rD = {
  api: "/formapi"
}, Up = iD.create({
  baseURL: rD.api,
  headers: {
    Pragma: "no-cache",
    "X-Requested-With": "XMLHttpRequest"
  }
});
class l_ {
  static getEnumSelectRemote(i) {
    const r = Op.stringify({ query: i.query });
    return Up.get(`${i.url}?${r}`, {
      headers: {
        "x-selected-language": i.locale
      }
    }).then(({ data: h }) => h);
  }
  static httpWatcher(i) {
    const r = Op.stringify(i.query);
    return Up.get(`${i.url}?${r}`, {
      headers: {
        "x-selected-language": i.locale
      }
    }).then(({ data: h }) => h);
  }
}
const oD = 350, sD = he({
  mixins: [Bn],
  data() {
    return {
      DebounceTime: oD,
      loading: !1,
      isVisible: !1,
      selectedOption: null,
      options: []
    };
  },
  computed: {
    optionsLocale() {
      return this.options.map((t) => ({
        label: t.text[this.locale],
        value: t.value
      }));
    },
    model: {
      get() {
        return this.properties.multiple ? Array.isArray(this.value) ? this.value : [] : this.value;
      },
      set(t) {
        t && this.$emit("update:model-value", dt.set(this.modelValue, this.path, t));
      }
    }
  },
  mounted() {
    this.properties.value && this.properties.text && (this.selectedOption = {
      text: this.properties.text,
      value: this.properties.value
    }, this.options = [this.selectedOption]);
  },
  methods: {
    debounce: dt.debounce,
    onOptionsVisibleChange(t) {
      this.isVisible = t;
    },
    onOptionChange(t) {
      const i = this.options.find((r) => r.value === t);
      i && (this.selectedOption = i);
    },
    async filterRemoteMethod(t) {
      if (t) {
        this.loading = !0;
        try {
          this.options = await l_.getEnumSelectRemote({
            url: this.properties.url,
            query: t,
            locale: this.locale
          });
        } catch (i) {
          throw this.options = [], i;
        } finally {
          this.loading = !1;
        }
      } else
        this.options = [];
    },
    onClearClick() {
      this.$emit("update:model-value", dt.set(this.modelValue, this.path, null));
    }
  },
  watch: {
    locale() {
      this.options = this.selectedOption ? [this.selectedOption] : [];
    }
  }
});
function aD(t, i, r, h, a, l) {
  const f = q("control-label-component"), m = q("el-option"), y = q("el-select"), v = q("control-error-component"), C = q("el-form-item");
  return pe(), Ae(C, {
    prop: t.scope,
    rules: t.rules
  }, $n({
    error: Y(({ error: M }) => [
      ee(v, {
        error: M[t.locale]
      }, null, 8, ["error"])
    ]),
    default: Y(() => {
      var M;
      return [
        ee(y, {
          modelValue: t.model,
          "onUpdate:modelValue": i[0] || (i[0] = (N) => t.model = N),
          placeholder: ((M = t.properties.placeholder) == null ? void 0 : M[t.locale]) || " ",
          multiple: t.properties.multiple,
          clearable: t.properties.clearable,
          remote: t.isVisible,
          "filter-method": t.debounce(t.filterRemoteMethod, t.DebounceTime),
          loading: t.loading,
          "value-key": "value",
          filterable: "",
          onClear: t.onClearClick,
          onChange: t.onOptionChange,
          onVisibleChange: t.onOptionsVisibleChange
        }, {
          default: Y(() => [
            (pe(!0), Tt(si, null, ar(t.optionsLocale, (N) => (pe(), Ae(m, {
              key: N.value,
              value: N.value,
              label: N.label
            }, null, 8, ["value", "label"]))), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "multiple", "clearable", "remote", "filter-method", "loading", "onClear", "onChange", "onVisibleChange"])
      ];
    }),
    _: 2
  }, [
    t.label ? {
      name: "label",
      fn: Y(() => [
        ee(f, {
          label: t.label,
          rules: t.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["prop", "rules"]);
}
const lD = /* @__PURE__ */ Re(sD, [["render", aD]]), uD = he({
  mixins: [Bn],
  computed: {
    model: {
      get() {
        return this.properties.multiple ? Array.isArray(this.value) ? this.value : [] : this.value;
      },
      set(t) {
        t && this.$emit("update:model-value", dt.set(this.modelValue, this.path, t));
      }
    }
  },
  methods: {
    onClearClick() {
      this.$emit("update:model-value", dt.set(this.modelValue, this.path, null));
    }
  }
});
function cD(t, i, r, h, a, l) {
  const f = q("control-label-component"), m = q("el-option"), y = q("el-select"), v = q("control-error-component"), C = q("el-form-item");
  return pe(), Ae(C, {
    prop: t.scope,
    rules: t.rules
  }, $n({
    error: Y(({ error: M }) => [
      ee(v, {
        error: M[t.locale]
      }, null, 8, ["error"])
    ]),
    default: Y(() => {
      var M;
      return [
        ee(y, {
          modelValue: t.model,
          "onUpdate:modelValue": i[0] || (i[0] = (N) => t.model = N),
          placeholder: ((M = t.properties.placeholder) == null ? void 0 : M[t.locale]) || " ",
          multiple: t.properties.multiple,
          clearable: t.properties.clearable,
          filterable: "",
          onClear: t.onClearClick
        }, {
          default: Y(() => [
            (pe(!0), Tt(si, null, ar(t.properties.enum, (N, I) => (pe(), Ae(m, {
              key: I,
              label: N.text[t.locale],
              value: N.value
            }, null, 8, ["label", "value"]))), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "multiple", "clearable", "onClear"])
      ];
    }),
    _: 2
  }, [
    t.label ? {
      name: "label",
      fn: Y(() => [
        ee(f, {
          label: t.label,
          rules: t.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["prop", "rules"]);
}
const hD = /* @__PURE__ */ Re(uD, [["render", cD]]), fD = he({
  mixins: [Bn],
  computed: {
    model: {
      get() {
        return this.properties.multiple ? Array.isArray(this.value) ? this.value : [] : this.value;
      },
      set(t) {
        t && this.$emit("update:model-value", dt.set(this.modelValue, this.path, t));
      }
    }
  },
  methods: {
    filterNodeMethod(t, i) {
      const r = t.toLowerCase();
      return i.text[this.locale].toLowerCase().includes(r);
    },
    onClearClick() {
      this.$emit("update:model-value", dt.set(this.modelValue, this.path, null));
    }
  }
}), dD = "_label_1hbvh_1", pD = "_option_1hbvh_5", mD = {
  label: dD,
  option: pD
}, _D = ["innerHTML"];
function gD(t, i, r, h, a, l) {
  const f = q("control-label-component"), m = q("el-option"), y = q("el-tree-select"), v = q("control-error-component"), C = q("el-form-item");
  return pe(), Ae(C, {
    prop: t.scope,
    rules: t.rules
  }, $n({
    error: Y(({ error: M }) => [
      ee(v, {
        error: M[t.locale]
      }, null, 8, ["error"])
    ]),
    default: Y(() => {
      var M;
      return [
        ee(y, {
          modelValue: t.model,
          "onUpdate:modelValue": i[0] || (i[0] = (N) => t.model = N),
          placeholder: ((M = t.properties.placeholder) == null ? void 0 : M[t.locale]) || " ",
          data: t.properties.tree,
          multiple: t.properties.multiple,
          clearable: t.properties.clearable,
          "check-strictly": t.properties.checkStrictly,
          "filter-node-method": t.filterNodeMethod,
          filterable: "",
          onClear: t.onClearClick
        }, {
          default: Y(({ data: N }) => [
            !t.properties.checkStrictly && N.children ? (pe(), Tt("div", {
              key: 0,
              class: Ze(t.$style.label)
            }, [
              Mt("span", {
                innerHTML: N.text[t.locale]
              }, null, 8, _D)
            ], 2)) : (pe(), Ae(m, {
              key: 1,
              label: N.text[t.locale],
              value: N.value,
              class: Ze(t.$style.option)
            }, null, 8, ["label", "value", "class"]))
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "data", "multiple", "clearable", "check-strictly", "filter-node-method", "onClear"])
      ];
    }),
    _: 2
  }, [
    t.label ? {
      name: "label",
      fn: Y(() => [
        ee(f, {
          label: t.label,
          rules: t.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["prop", "rules"]);
}
const vD = {
  $style: mD
}, yD = /* @__PURE__ */ Re(fD, [["render", gD], ["__cssModules", vD]]), LD = he({
  mixins: [Bn]
});
function wD(t, i, r, h, a, l) {
  const f = q("control-label-component"), m = q("el-input"), y = q("control-error-component"), v = q("el-form-item");
  return pe(), Ae(v, {
    prop: t.scope,
    rules: t.rules
  }, $n({
    error: Y(({ error: C }) => [
      ee(y, {
        error: C[t.locale]
      }, null, 8, ["error"])
    ]),
    default: Y(() => {
      var C;
      return [
        ee(m, {
          modelValue: t.model,
          "onUpdate:modelValue": i[0] || (i[0] = (M) => t.model = M),
          placeholder: (C = t.properties.placeholder) == null ? void 0 : C[t.locale],
          maxlength: t.properties.maxlength,
          "show-word-limit": ""
        }, null, 8, ["modelValue", "placeholder", "maxlength"])
      ];
    }),
    _: 2
  }, [
    t.label ? {
      name: "label",
      fn: Y(() => [
        ee(f, {
          label: t.label,
          rules: t.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["prop", "rules"]);
}
const bD = /* @__PURE__ */ Re(LD, [["render", wD]]), SD = he({
  mixins: [Bn],
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(t) {
        this.$emit("update:model-value", dt.set(this.modelValue, this.path, t || null));
      }
    }
  }
});
function CD(t, i, r, h, a, l) {
  const f = q("el-switch"), m = q("el-form-item");
  return pe(), Ae(m, null, {
    default: Y(() => [
      ee(f, {
        modelValue: t.model,
        "onUpdate:modelValue": i[0] || (i[0] = (y) => t.model = y),
        "active-text": t.label || "",
        size: "default"
      }, null, 8, ["modelValue", "active-text"])
    ]),
    _: 1
  });
}
const TD = /* @__PURE__ */ Re(SD, [["render", CD]]), Fp = {
  min: 3,
  max: 9
}, ED = he({
  mixins: [Bn],
  data() {
    return {
      minRows: Fp.min,
      maxRows: Fp.max
    };
  }
});
function PD(t, i, r, h, a, l) {
  const f = q("control-label-component"), m = q("el-input"), y = q("control-error-component"), v = q("el-form-item");
  return pe(), Ae(v, {
    prop: t.scope,
    rules: t.rules
  }, $n({
    error: Y(({ error: C }) => [
      ee(y, {
        error: C[t.locale]
      }, null, 8, ["error"])
    ]),
    default: Y(() => {
      var C;
      return [
        ee(m, {
          modelValue: t.model,
          "onUpdate:modelValue": i[0] || (i[0] = (M) => t.model = M),
          placeholder: (C = t.properties.placeholder) == null ? void 0 : C[t.locale],
          maxlength: t.properties.maxlength,
          autosize: { minRows: t.minRows, maxRows: t.maxRows },
          "show-word-limit": "",
          type: "textarea"
        }, null, 8, ["modelValue", "placeholder", "maxlength", "autosize"])
      ];
    }),
    _: 2
  }, [
    t.label ? {
      name: "label",
      fn: Y(() => [
        ee(f, {
          label: t.label,
          rules: t.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["prop", "rules"]);
}
const MD = /* @__PURE__ */ Re(ED, [["render", PD]]), OD = "HH:mm:ss", xD = he({
  mixins: [Bn],
  data() {
    return {
      format: OD
    };
  }
});
function DD(t, i, r, h, a, l) {
  const f = q("control-label-component"), m = q("el-time-picker"), y = q("control-error-component"), v = q("el-form-item");
  return pe(), Ae(v, {
    prop: t.scope,
    rules: t.rules
  }, $n({
    error: Y(({ error: C }) => [
      ee(y, {
        error: C[t.locale]
      }, null, 8, ["error"])
    ]),
    default: Y(() => {
      var C, M, N;
      return [
        ee(m, {
          modelValue: t.model,
          "onUpdate:modelValue": i[0] || (i[0] = (I) => t.model = I),
          placeholder: (C = t.properties.placeholder) == null ? void 0 : C[t.locale],
          "start-placeholder": (M = t.properties.startPlaceholder) == null ? void 0 : M[t.locale],
          "end-placeholder": (N = t.properties.endPlaceholder) == null ? void 0 : N[t.locale],
          "is-range": t.properties.range,
          format: t.properties.format,
          "value-format": t.properties.format || t.format
        }, null, 8, ["modelValue", "placeholder", "start-placeholder", "end-placeholder", "is-range", "format", "value-format"])
      ];
    }),
    _: 2
  }, [
    t.label ? {
      name: "label",
      fn: Y(() => [
        ee(f, {
          label: t.label,
          rules: t.rules
        }, null, 8, ["label", "rules"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["prop", "rules"]);
}
const kD = /* @__PURE__ */ Re(xD, [["render", DD]]), AD = he({
  mixins: [Sa],
  emits: ["update:model-value", "validate-field"],
  data() {
    return {
      ControlComponent: {
        [Nn.arrayStrings]: Ge(kb),
        [Nn.checkbox]: Ge(Nb),
        [Nn.date]: Ge(Bb),
        [Nn.editor]: Ge(OP),
        [Nn.mapDraw]: Ge(zP),
        [Nn.number]: Ge(ZP),
        [Nn.radio]: Ge(GP),
        [Nn.select]: Ge(KP),
        [Nn.selectRemote]: Ge(lD),
        [Nn.selectSearch]: Ge(hD),
        [Nn.selectTree]: Ge(yD),
        [Nn.string]: Ge(bD),
        [Nn.switch]: Ge(TD),
        [Nn.textarea]: Ge(MD),
        [Nn.time]: Ge(kD)
      }
    };
  },
  computed: {
    key() {
      return JSON.stringify(this.schema);
    },
    properties() {
      return this.schema.properties;
    },
    model: {
      get() {
        return this.modelValue;
      },
      set(t) {
        this.$emit("update:model-value", t);
      }
    }
  },
  methods: {
    validateField(t) {
      this.$emit("validate-field", t);
    }
  }
});
function ID(t, i, r, h, a, l) {
  return t.isShown ? (pe(), Ae(zo(t.ControlComponent[t.properties.type]), {
    modelValue: t.model,
    "onUpdate:modelValue": i[0] || (i[0] = (f) => t.model = f),
    id: t.schema.id,
    scope: t.schema.scope,
    properties: t.properties,
    locale: t.locale,
    key: t.key,
    onValidateField: t.validateField
  }, null, 40, ["modelValue", "id", "scope", "properties", "locale", "onValidateField"])) : _i("", !0);
}
const u_ = /* @__PURE__ */ Re(AD, [["render", ID]]), Wl = he({
  props: {
    modelValue: {},
    properties: {
      type: Object,
      required: !0
    },
    locale: {
      type: String,
      required: !0
    }
  },
  computed: {
    text() {
      return this.properties.text[this.locale];
    }
  }
}), ND = he({
  mixins: [Wl],
  components: {
    UseDark: jC
  }
}), RD = ["innerHTML"];
function $D(t, i, r, h, a, l) {
  const f = q("el-alert"), m = q("use-dark"), y = q("el-form-item");
  return pe(), Ae(y, null, {
    default: Y(() => [
      ee(m, null, {
        default: Y(({ isDark: v }) => [
          ee(f, {
            effect: v ? "dark" : "light",
            type: "info",
            "show-icon": ""
          }, {
            default: Y(() => [
              Mt("span", { innerHTML: t.text }, null, 8, RD)
            ]),
            _: 2
          }, 1032, ["effect"])
        ]),
        _: 1
      })
    ]),
    _: 1
  });
}
const zD = /* @__PURE__ */ Re(ND, [["render", $D]]), BD = he({
  mixins: [Wl]
}), UD = ["innerHTML"];
function FD(t, i, r, h, a, l) {
  const f = q("el-form-item");
  return pe(), Ae(f, null, {
    default: Y(() => [
      Mt("p", { innerHTML: t.text }, null, 8, UD)
    ]),
    _: 1
  });
}
const HD = /* @__PURE__ */ Re(BD, [["render", FD]]), ZD = he({
  mixins: [Wl]
}), VD = ["innerHTML"];
function WD(t, i, r, h, a, l) {
  const f = q("el-form-item");
  return pe(), Ae(f, null, {
    default: Y(() => [
      Mt("h3", { innerHTML: t.text }, null, 8, VD)
    ]),
    _: 1
  });
}
const jD = /* @__PURE__ */ Re(ZD, [["render", WD]]), GD = he({
  mixins: [Wl]
}), qD = "_component_12mk6_1", YD = {
  component: qD
}, KD = ["innerHTML"];
function JD(t, i, r, h, a, l) {
  const f = q("el-divider"), m = q("el-form-item");
  return pe(), Ae(m, {
    class: Ze(t.$style.component)
  }, {
    default: Y(() => [
      Mt("h6", { innerHTML: t.text }, null, 8, KD),
      ee(f)
    ]),
    _: 1
  }, 8, ["class"]);
}
const XD = {
  $style: YD
}, QD = /* @__PURE__ */ Re(GD, [["render", JD], ["__cssModules", XD]]), ek = he({
  mixins: [Sa],
  data() {
    return {
      TextComponent: {
        [dl.alert]: Ge(zD),
        [dl.description]: Ge(HD),
        [dl.headline]: Ge(jD),
        [dl.label]: Ge(QD)
      }
    };
  },
  computed: {
    properties() {
      return this.schema.properties;
    }
  }
});
function tk(t, i, r, h, a, l) {
  return t.isShown ? (pe(), Ae(zo(t.TextComponent[t.properties.type]), {
    key: 0,
    id: t.schema.id,
    properties: t.properties,
    locale: t.locale
  }, null, 8, ["id", "properties", "locale"])) : _i("", !0);
}
const c_ = /* @__PURE__ */ Re(ek, [["render", tk]]), nk = he({
  name: ii.tabs,
  mixins: [Sa],
  emits: ["update:model-value", "submit", "validate-field"],
  props: {
    errorScopes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      elementComponent: {
        [ii.button]: Ge(Jp),
        [ii.control]: Ge(u_),
        [ii.text]: Ge(c_)
      }
    };
  },
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(t) {
        this.$emit("update:model-value", t);
      }
    }
  },
  methods: {
    isError(t) {
      return t.filter((h) => h.type === ii.control).map((h) => h.scope).some((h) => this.errorScopes.includes(h));
    },
    submit() {
      this.$emit("submit");
    },
    validateField(t) {
      this.$emit("validate-field", t);
    }
  }
}), ik = "_component_1ixfk_1", rk = "_alert_1ixfk_4", ok = "_component__tabs_1ixfk_13", sk = {
  component: ik,
  alert: rk,
  "component__label-error": "_component__label-error_1ixfk_7",
  component__tabs: ok
}, ak = ["id"];
function lk(t, i, r, h, a, l) {
  const f = q("icon-warning-filled"), m = q("el-tab-pane"), y = q("el-tabs");
  return t.isShown ? (pe(), Tt("div", {
    key: 0,
    id: t.schema.id,
    class: Ze(t.$style.component)
  }, [
    ee(y, {
      class: Ze(t.$style.component__tabs),
      type: "border-card"
    }, {
      default: Y(() => [
        (pe(!0), Tt(si, null, ar(t.schema.elements, (v, C) => (pe(), Ae(m, {
          key: `${C}-${v.id}`,
          id: v.id
        }, {
          label: Y(() => [
            t.isError(v.elements) ? (pe(), Ae(f, {
              key: 0,
              class: Ze(t.$style["component__label-error"])
            }, null, 8, ["class"])) : _i("", !0),
            Mt("span", null, Ss(v.title[t.locale]), 1)
          ]),
          default: Y(() => [
            (pe(!0), Tt(si, null, ar(v.elements, (M, N) => (pe(), Ae(zo(t.elementComponent[M.type]), {
              modelValue: t.model,
              "onUpdate:modelValue": i[0] || (i[0] = (I) => t.model = I),
              key: `element${N}`,
              schema: M,
              "error-scopes": t.errorScopes,
              locale: t.locale,
              onSubmit: t.submit,
              onValidateField: t.validateField
            }, null, 40, ["modelValue", "schema", "error-scopes", "locale", "onSubmit", "onValidateField"]))), 128))
          ]),
          _: 2
        }, 1032, ["id"]))), 128))
      ]),
      _: 1
    }, 8, ["class"])
  ], 10, ak)) : _i("", !0);
}
const uk = {
  $style: sk
}, ck = /* @__PURE__ */ Re(nk, [["render", lk], ["__cssModules", uk]]);
process.env.NODE_ENV !== "production" && Object.freeze({});
process.env.NODE_ENV !== "production" && Object.freeze([]);
const h_ = (t) => typeof t == "string", f_ = (t) => t !== null && typeof t == "object", d_ = (t) => {
  const i = /* @__PURE__ */ Object.create(null);
  return (r) => i[r] || (i[r] = t(r));
}, hk = /-(\w)/g, fk = d_((t) => t.replace(hk, (i, r) => r ? r.toUpperCase() : "")), dk = /\B([A-Z])/g, pk = d_((t) => t.replace(dk, "-$1").toLowerCase()), p_ = (t = "") => t.split(" ").filter((i) => !!i.trim()), Hp = (t, i) => {
  !t || !i.trim() || t.classList.add(...p_(i));
}, $l = (t, i) => {
  !t || !i.trim() || t.classList.remove(...p_(i));
}, ga = (t, i) => {
  var r;
  if (!Ei || !t || !i)
    return "";
  let h = fk(i);
  h === "float" && (h = "cssFloat");
  try {
    const a = t.style[h];
    if (a)
      return a;
    const l = (r = document.defaultView) == null ? void 0 : r.getComputedStyle(t, "");
    return l ? l[h] : "";
  } catch {
    return t.style[h];
  }
}, mk = Symbol(), Zp = J();
function m_(t, i = void 0) {
  const r = Yp() ? c0(mk, Zp) : Zp;
  return t ? ht(() => {
    var h, a;
    return (a = (h = r.value) == null ? void 0 : h[t]) != null ? a : i;
  }) : r;
}
const _k = "el", gk = "is-", Io = (t, i, r, h, a) => {
  let l = `${t}-${i}`;
  return r && (l += `-${r}`), h && (l += `__${h}`), a && (l += `--${a}`), l;
}, __ = (t) => {
  const i = m_("namespace", _k);
  return {
    namespace: i,
    b: (D = "") => Io(i.value, t, D, "", ""),
    e: (D) => D ? Io(i.value, t, "", D, "") : "",
    m: (D) => D ? Io(i.value, t, "", "", D) : "",
    be: (D, B) => D && B ? Io(i.value, t, D, B, "") : "",
    em: (D, B) => D && B ? Io(i.value, t, "", D, B) : "",
    bm: (D, B) => D && B ? Io(i.value, t, D, "", B) : "",
    bem: (D, B, X) => D && B && X ? Io(i.value, t, D, B, X) : "",
    is: (D, ...B) => {
      const X = B.length >= 1 ? B[0] : !0;
      return D && X ? `${gk}${D}` : "";
    },
    cssVar: (D) => {
      const B = {};
      for (const X in D)
        D[X] && (B[`--${i.value}-${X}`] = D[X]);
      return B;
    },
    cssVarName: (D) => `--${i.value}-${D}`,
    cssVarBlock: (D) => {
      const B = {};
      for (const X in D)
        D[X] && (B[`--${i.value}-${t}-${X}`] = D[X]);
      return B;
    },
    cssVarBlockName: (D) => `--${i.value}-${t}-${D}`
  };
}, Vp = J(0), vk = () => {
  const t = m_("zIndex", 2e3), i = ht(() => t.value + Vp.value);
  return {
    initialZIndex: t,
    currentZIndex: i,
    nextZIndex: () => (Vp.value++, i.value)
  };
};
function yk(t) {
  let i;
  const r = __("loading"), h = J(!1), a = Ue({
    ...t,
    originalPosition: "",
    originalOverflow: "",
    visible: !1
  });
  function l(I) {
    a.text = I;
  }
  function f() {
    const I = a.parent;
    if (!I.vLoadingAddClassList) {
      let D = I.getAttribute("loading-number");
      D = Number.parseInt(D) - 1, D ? I.setAttribute("loading-number", D.toString()) : ($l(I, r.bm("parent", "relative")), I.removeAttribute("loading-number")), $l(I, r.bm("parent", "hidden"));
    }
    m(), M.unmount();
  }
  function m() {
    var I, D;
    (D = (I = N.$el) == null ? void 0 : I.parentNode) == null || D.removeChild(N.$el);
  }
  function y() {
    var I;
    t.beforeClose && !t.beforeClose() || (h.value = !0, clearTimeout(i), i = window.setTimeout(v, 400), a.visible = !1, (I = t.closed) == null || I.call(t));
  }
  function v() {
    if (!h.value)
      return;
    const I = a.parent;
    h.value = !1, I.vLoadingAddClassList = void 0, f();
  }
  const M = h0({
    name: "ElLoading",
    setup() {
      return () => {
        const I = a.spinner || a.svg, D = sn("svg", {
          class: "circular",
          viewBox: a.svgViewBox ? a.svgViewBox : "0 0 50 50",
          ...I ? { innerHTML: I } : {}
        }, [
          sn("circle", {
            class: "path",
            cx: "25",
            cy: "25",
            r: "20",
            fill: "none"
          })
        ]), B = a.text ? sn("p", { class: r.b("text") }, [a.text]) : void 0;
        return sn(f0, {
          name: r.b("fade"),
          onAfterLeave: v
        }, {
          default: Y(() => [
            d0(ee("div", {
              style: {
                backgroundColor: a.background || ""
              },
              class: [
                r.b("mask"),
                a.customClass,
                a.fullscreen ? "is-fullscreen" : ""
              ]
            }, [
              sn("div", {
                class: r.b("spinner")
              }, [D, B])
            ]), [[p0, a.visible]])
          ])
        });
      };
    }
  }), N = M.mount(document.createElement("div"));
  return {
    ...Bc(a),
    setText: l,
    removeElLoadingChild: m,
    close: y,
    handleAfterLeave: v,
    vm: N,
    get $el() {
      return N.$el;
    }
  };
}
let bl;
const $c = function(t = {}) {
  if (!Ei)
    return;
  const i = Lk(t);
  if (i.fullscreen && bl)
    return bl;
  const r = yk({
    ...i,
    closed: () => {
      var a;
      (a = i.closed) == null || a.call(i), i.fullscreen && (bl = void 0);
    }
  });
  wk(i, i.parent, r), Wp(i, i.parent, r), i.parent.vLoadingAddClassList = () => Wp(i, i.parent, r);
  let h = i.parent.getAttribute("loading-number");
  return h ? h = `${Number.parseInt(h) + 1}` : h = "1", i.parent.setAttribute("loading-number", h), i.parent.appendChild(r.$el), ks(() => r.visible.value = i.visible), i.fullscreen && (bl = r), r;
}, Lk = (t) => {
  var i, r, h, a;
  let l;
  return h_(t.target) ? l = (i = document.querySelector(t.target)) != null ? i : document.body : l = t.target || document.body, {
    parent: l === document.body || t.body ? document.body : l,
    background: t.background || "",
    svg: t.svg || "",
    svgViewBox: t.svgViewBox || "",
    spinner: t.spinner || !1,
    text: t.text || "",
    fullscreen: l === document.body && ((r = t.fullscreen) != null ? r : !0),
    lock: (h = t.lock) != null ? h : !1,
    customClass: t.customClass || "",
    visible: (a = t.visible) != null ? a : !0,
    target: l
  };
}, wk = async (t, i, r) => {
  const { nextZIndex: h } = vk(), a = {};
  if (t.fullscreen)
    r.originalPosition.value = ga(document.body, "position"), r.originalOverflow.value = ga(document.body, "overflow"), a.zIndex = h();
  else if (t.parent === document.body) {
    r.originalPosition.value = ga(document.body, "position"), await ks();
    for (const l of ["top", "left"]) {
      const f = l === "top" ? "scrollTop" : "scrollLeft";
      a[l] = `${t.target.getBoundingClientRect()[l] + document.body[f] + document.documentElement[f] - Number.parseInt(ga(document.body, `margin-${l}`), 10)}px`;
    }
    for (const l of ["height", "width"])
      a[l] = `${t.target.getBoundingClientRect()[l]}px`;
  } else
    r.originalPosition.value = ga(i, "position");
  for (const [l, f] of Object.entries(a))
    r.$el.style[l] = f;
}, Wp = (t, i, r) => {
  const h = __("loading");
  ["absolute", "fixed", "sticky"].includes(r.originalPosition.value) ? $l(i, h.bm("parent", "relative")) : Hp(i, h.bm("parent", "relative")), t.fullscreen && t.lock ? Hp(i, h.bm("parent", "hidden")) : $l(i, h.bm("parent", "hidden"));
}, zc = Symbol("ElLoading"), jp = (t, i) => {
  var r, h, a, l;
  const f = i.instance, m = (N) => f_(i.value) ? i.value[N] : void 0, y = (N) => {
    const I = h_(N) && (f == null ? void 0 : f[N]) || N;
    return I && J(I);
  }, v = (N) => y(m(N) || t.getAttribute(`element-loading-${pk(N)}`)), C = (r = m("fullscreen")) != null ? r : i.modifiers.fullscreen, M = {
    text: v("text"),
    svg: v("svg"),
    svgViewBox: v("svgViewBox"),
    spinner: v("spinner"),
    background: v("background"),
    customClass: v("customClass"),
    fullscreen: C,
    target: (h = m("target")) != null ? h : C ? void 0 : t,
    body: (a = m("body")) != null ? a : i.modifiers.body,
    lock: (l = m("lock")) != null ? l : i.modifiers.lock
  };
  t[zc] = {
    options: M,
    instance: $c(M)
  };
}, bk = (t, i) => {
  for (const r of Object.keys(i))
    Ps(i[r]) && (i[r].value = t[r]);
}, Gp = {
  mounted(t, i) {
    i.value && jp(t, i);
  },
  updated(t, i) {
    const r = t[zc];
    i.oldValue !== i.value && (i.value && !i.oldValue ? jp(t, i) : i.value && i.oldValue ? f_(i.value) && bk(i.value, r.options) : r == null || r.instance.close());
  },
  unmounted(t) {
    var i;
    (i = t[zc]) == null || i.instance.close();
  }
}, Sk = {
  install(t) {
    t.directive("loading", Gp), t.config.globalProperties.$loading = $c;
  },
  directive: Gp,
  service: $c
}, Ck = he({
  name: ii.watcher,
  emits: ["update:model-value"],
  props: {
    modelValue: {
      type: Object,
      required: !0
    },
    schema: {
      type: Object,
      required: !0
    },
    locale: {
      type: String,
      required: !0
    }
  },
  render() {
    return null;
  },
  computed: {
    watchingScope() {
      return dt.get(this.modelValue, this.schema.properties.watchingScope);
    }
  },
  watch: {
    async watchingScope(t) {
      if (t) {
        const i = Sk.service({
          lock: !0
        }), { url: r, queryKey: h, responseScope: a } = this.schema.properties;
        try {
          const l = await l_.httpWatcher({
            url: r,
            query: { [h]: t },
            locale: this.locale
          });
          this.$emit("update:model-value", dt.set(this.modelValue, a, l));
        } finally {
          i.close();
        }
      }
    }
  }
}), Tk = he({
  name: ii.layout,
  mixins: [Sa],
  emits: ["update:model-value", "submit", "validate-field"],
  props: {
    errorScopes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      LayoutComponent: {
        [Hf.horizontal]: Ge(D0),
        [Hf.vertical]: Ge($0)
      },
      elementComponent: {
        [ii.button]: Ge(Jp),
        [ii.control]: Ge(u_),
        [ii.layout]: ii.layout,
        [ii.tabs]: Ge(ck),
        [ii.text]: Ge(c_),
        [ii.watcher]: Ge(Ck)
      }
    };
  },
  computed: {
    properties() {
      return this.schema.properties;
    },
    model: {
      get() {
        return this.modelValue;
      },
      set(t) {
        this.$emit("update:model-value", t);
      }
    }
  },
  methods: {
    submit() {
      this.$emit("submit");
    },
    validateField(t) {
      this.$emit("validate-field", t);
    }
  }
});
function Ek(t, i, r, h, a, l) {
  return t.isShown ? (pe(), Ae(zo(t.LayoutComponent[t.properties.type]), {
    key: 0,
    modelValue: t.model,
    "onUpdate:modelValue": i[1] || (i[1] = (f) => t.model = f),
    id: t.schema.id
  }, {
    default: Y(({ className: f }) => [
      (pe(!0), Tt(si, null, ar(t.schema.elements, (m, y) => (pe(), Ae(zo(t.elementComponent[m.type]), {
        modelValue: t.model,
        "onUpdate:modelValue": i[0] || (i[0] = (v) => t.model = v),
        key: m.id || y,
        class: Ze(f),
        schema: m,
        "error-scopes": t.errorScopes,
        locale: t.locale,
        onSubmit: t.submit,
        onValidateField: t.validateField
      }, null, 40, ["modelValue", "class", "schema", "error-scopes", "locale", "onSubmit", "onValidateField"]))), 128))
    ]),
    _: 1
  }, 8, ["modelValue", "id"])) : _i("", !0);
}
const Pk = /* @__PURE__ */ Re(Tk, [["render", Ek]]), Mk = he({
  emits: ["update:model-value", "submit"],
  props: {
    modelValue: {
      type: Object,
      required: !0
    },
    schema: {
      type: Object,
      required: !0
    },
    locale: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      showError: !1,
      errorScopes: []
    };
  },
  computed: {
    valueFields() {
      return this.errorScopes.map((t) => {
        const i = t.split(".");
        return dt.get(this.modelValue, i);
      });
    },
    errorAllRequired() {
      return this.valueFields.every((t) => !t);
    },
    errorUnexpectedFormat() {
      return this.valueFields.every((t) => t);
    },
    model: {
      get() {
        return this.modelValue;
      },
      set(t) {
        this.$emit("update:model-value", t);
      }
    }
  },
  methods: {
    validateField(t) {
      this.$refs.elForm.validateField(t, () => null);
    },
    resetFields(t) {
      this.$refs.elForm.resetFields(t);
    },
    async onSubmitForm() {
      const t = this.$refs.elForm;
      await t.validate((i) => {
        i && this.$emit("submit"), this.showError = !i, t.$el.scrollIntoView({ behavior: "smooth" });
      });
    },
    onValidate(t, i) {
      this.errorScopes = this.errorScopes.filter((r) => r !== t), i || (this.errorScopes = this.errorScopes.concat(t));
    }
  },
  components: {
    LayoutComponent: Pk
  }
});
function Ok(t, i, r, h, a, l) {
  const f = q("el-form-item"), m = q("layout-component"), y = q("el-form");
  return pe(), Ae(y, {
    model: t.model,
    "hide-required-asterisk": "",
    "label-position": "top",
    "inline-message": "",
    ref: "elForm",
    onValidate: t.onValidate
  }, {
    default: Y(() => [
      t.showError ? (pe(), Ae(f, { key: 0 }, {
        default: Y(() => [
          ri(t.$slots, "error", {
            errorAllRequired: t.errorAllRequired,
            errorUnexpectedFormat: t.errorUnexpectedFormat
          })
        ]),
        _: 3
      })) : _i("", !0),
      ee(m, {
        modelValue: t.model,
        "onUpdate:modelValue": i[0] || (i[0] = (v) => t.model = v),
        schema: t.schema,
        "error-scopes": t.errorScopes,
        locale: t.locale,
        onValidateField: t.validateField,
        onResetFields: t.resetFields,
        onSubmit: t.onSubmitForm
      }, null, 8, ["modelValue", "schema", "error-scopes", "locale", "onValidateField", "onResetFields", "onSubmit"])
    ]),
    _: 3
  }, 8, ["model", "onValidate"]);
}
const xk = /* @__PURE__ */ Re(Mk, [["render", Ok]]), Dk = he({
  props: {
    href: {
      type: String,
      default: ""
    },
    target: {
      type: String
    },
    underline: {
      type: Boolean
    },
    style: {
      type: Object
    },
    icon: {
      type: String
    },
    hover: {
      type: Boolean
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  }
}), kk = "_component_15esb_1", Ak = "_component__prepend_15esb_7", Ik = "_component__apend_15esb_11", Nk = "_underline_15esb_19", Rk = {
  component: kk,
  component__prepend: Ak,
  component__apend: Ik,
  underline: Nk
};
function $k(t, i, r, h, a, l) {
  const f = q("el-link");
  return pe(), Ae(f, {
    class: Ze([t.$style.component, { [t.$style.underline]: t.underline }]),
    href: t.href,
    target: t.target,
    icon: t.icon,
    underline: !1,
    style: _c(t.style),
    disabled: t.disabled
  }, {
    default: Y(() => [
      t.$slots.prepend ? (pe(), Tt("span", {
        key: 0,
        class: Ze(t.$style.component__prepend)
      }, [
        ri(t.$slots, "prepend")
      ], 2)) : _i("", !0),
      ri(t.$slots, "default"),
      t.$slots.append ? (pe(), Tt("span", {
        key: 1,
        class: Ze(t.$style.component__append)
      }, [
        ri(t.$slots, "append")
      ], 2)) : _i("", !0)
    ]),
    _: 3
  }, 8, ["class", "href", "target", "icon", "style", "disabled"]);
}
const zk = {
  $style: Rk
}, Bk = /* @__PURE__ */ Re(Dk, [["render", $k], ["__cssModules", zk]]), Hk = {
  install: (t) => {
    t.component("HelperDialog", Uc);
  }
}, Zk = {
  install: (t) => {
    t.component("HelperFormSchema", xk);
  }
}, Vk = {
  install: (t) => {
    t.component("HelperLink", Bk);
  }
};
export {
  Hk as HelperDialog,
  Zk as HelperFormSchema,
  Vk as HelperLink
};
